import Bs, { createContext as Ct, useContext as at, useMemo as D, useCallback as L, useState as M, useEffect as B, forwardRef as ps, useRef as Ae, useImperativeHandle as yr, Children as vl, useLayoutEffect as yl, Fragment as jr, Component as jl, Suspense as Vt } from "react";
import { cx as He, cva as Ht } from "class-variance-authority";
import Cl from "clsx";
import { twMerge as Nl } from "tailwind-merge";
import { useTranslation as Cr, Trans as nr } from "next-i18next";
import { Typography as k, Box as $, Input as Q, Button as X, Card as ke, Steps as vn, Banner as ge, LoadingButton as De, HeadingNumber as wl, Grid as Ue, Select as xe, ReadOnlyField as ct, Spinner as nn, Label as rr, InputError as Ys, RadioGroup as Ft, Link as En, Well as kl, Accordion as da, RadioGroupExpander as ar } from "@oresundsbron/bridge-ui";
import { useForm as he, useSubscribe as Ee, submitWithValidation as Nt, FormStoreProvider as ut, useStepForm as Nr, withFormStore as Pl, useFormStore as or, Steps as Tl, Selectors as ma } from "@oresundsbron/use-form";
import { Close as rn, ErrorNotFilled as Sl, MessageInfo as Ml, ThumbsUp as zl, InfoPay as to, Download as Rs, Open as so, Information as no, Plus as cs, CheckmarkFilled as wr, CheckCircle as Al, CloseOutlined as kr, Edit as ua, ArrowUpStroked as yn, OpenLinkInNew as Ol, CarSideView as Dn, BizzKmtoll as Pr, Card as El, Photo as Dl, CheckmarkOutlined as Fl, Bizz as Ll, ArrowUp as Tr, ArrowRightLeft as Vl, Bankcard as Rl, Success as $l, Error as ro, Customer as Bl, Warning as ao, InfoFilled as Il, Chain as _l, Undo as ha, Car as oo, Check as an, Info as Wl, Calendar as ql, Upload as Hl, Trash as Ul, Search as Gl, ArrowRight as Kl, OpenInNewIcon as Zl } from "@oresundsbron/icons";
import * as vt from "@radix-ui/react-dialog";
import * as Qt from "@radix-ui/react-alert-dialog";
import ys from "next/link";
import { Link as Yl } from "@radix-ui/react-navigation-menu";
import { Trans as Ql } from "react-i18next";
import { constants as Z, commuterVehicleParser as Xl, commuterInformationParser as Jl, createPeriodCardParser as ec, CustomerType as ds, isPrivateContract as tc, addReceiptFormParser as sc, termsOfAgreement as nc, addContractParser as rc, licensePlateParser as ac, businessCommuterStringDate as oc, addRecognitionParser as ic, editRecognitionFormParser as lc, changePasswordParser as io, externalIssuerData as cc, WeightCategory as $e, VehicleTypeId as ir, singleBizzOrderFlowParser as dc, Co2VehicleGroup as Ie, tollCollectVehicleInfoHGVParser as lo, tollCollectVehicleInfoHGVParserWithOptionalVinNo as co, tollCollectVehicleInfoParser as mo, Co2VehicleSubgroup as uo, Co2EmissionClass as Ne, summaryParser as ho, businessAccountContactInformationParser as mc, privateContactInformationParserV2 as po, isBusiness as uc, newPassword as hc, paymentEntryParser as fo, termsOfAgreementParser as pc, businessContactInformationParser as fc, invoiceParser as xc } from "@oresundsbron/validators";
import { useTypeSafeQuery as ye, BackendQueryKeys as ee, useTypeSafeMutation as fe, ApiProvider as gc, useTypeSafePrefetch as pa, useContentfulQuery as bc, ContentfulQueryKeys as vc } from "@oresundsbron/api";
import { subMonths as yc, isAfter as jc, format as Lt, isBefore as Cc, addDays as Nc, subYears as wc } from "date-fns";
import { useQueryClient as Le, QueryClientProvider as kc, useMutation as Pc } from "@tanstack/react-query";
import { Grid as rs, RadioButtons as Tc, Field as jt, Input as es, Modal as on, ModalHeader as ln, Typography as Y, Form as Fn, ModalContent as Ut, Notice as zt, ModalAction as Rt, useMultiStepModalContext as Cs, Step as cn, MultiStepModalButtons as fs, Spinner as At, Column as Fs, Dropdown as jn, Option as Cn, ThemeProvider as Sc, InputAdornment as Mc, Button as _t, MultiStepModal as xo, FilterableTable as Sr, Collapsable as zc, Pagination as Ln, MultiStepPanel as Ac, MultiStepProvider as Oc, Box as Je, BannerCard as Ec, DisplayInput as bs } from "@oresundsbron/design-system";
import { Issuer as Qs } from "@oresundsbron/type-safeguards";
import * as Xe from "@radix-ui/react-dropdown-menu";
import { constants as ls } from "@oresundsbron/utilities";
import Dc from "react-gtm-module";
import { useTheme as Fc } from "@emotion/react";
import Mr from "next/script";
import Ns from "zustand";
import * as Xs from "@radix-ui/react-accordion";
import { debounce as Lc } from "lodash";
import { z as Vc } from "zod";
import { appendErrors as Rc, useForm as ws } from "react-hook-form";
import { validateFieldsNatively as $c, toNestErrors as Bc } from "@hookform/resolvers";
import Ic from "next/image";
import { defaultCO2EmissionClassValue as Vs, numberOfAxelsOptions as go, Co2CutoffDate as Nn } from "@oresundsbron/vehicle-info-service";
import { DayPicker as _c } from "react-day-picker";
import { Lens as it } from "monocle-ts";
var mr = { exports: {} }, Hs = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fa;
function Wc() {
  if (fa) return Hs;
  fa = 1;
  var t = Bs, s = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(d, l, c) {
    var m, u = {}, h = null, p = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (m in l) r.call(l, m) && !o.hasOwnProperty(m) && (u[m] = l[m]);
    if (d && d.defaultProps) for (m in l = d.defaultProps, l) u[m] === void 0 && (u[m] = l[m]);
    return { $$typeof: s, type: d, key: h, ref: p, props: u, _owner: a.current };
  }
  return Hs.Fragment = n, Hs.jsx = i, Hs.jsxs = i, Hs;
}
var Us = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xa;
function qc() {
  return xa || (xa = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Bs, s = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), d = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), f = Symbol.iterator, x = "@@iterator";
    function g(j) {
      if (j === null || typeof j != "object")
        return null;
      var W = f && j[f] || j[x];
      return typeof W == "function" ? W : null;
    }
    var N = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(j) {
      {
        for (var W = arguments.length, te = new Array(W > 1 ? W - 1 : 0), ue = 1; ue < W; ue++)
          te[ue - 1] = arguments[ue];
        v("error", j, te);
      }
    }
    function v(j, W, te) {
      {
        var ue = N.ReactDebugCurrentFrame, Pe = ue.getStackAddendum();
        Pe !== "" && (W += "%s", te = te.concat([Pe]));
        var Me = te.map(function(Ce) {
          return String(Ce);
        });
        Me.unshift("Warning: " + W), Function.prototype.apply.call(console[j], console, Me);
      }
    }
    var S = !1, y = !1, w = !1, z = !1, C = !1, E;
    E = Symbol.for("react.module.reference");
    function A(j) {
      return !!(typeof j == "string" || typeof j == "function" || j === r || j === o || C || j === a || j === c || j === m || z || j === p || S || y || w || typeof j == "object" && j !== null && (j.$$typeof === h || j.$$typeof === u || j.$$typeof === i || j.$$typeof === d || j.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      j.$$typeof === E || j.getModuleId !== void 0));
    }
    function F(j, W, te) {
      var ue = j.displayName;
      if (ue)
        return ue;
      var Pe = W.displayName || W.name || "";
      return Pe !== "" ? te + "(" + Pe + ")" : te;
    }
    function R(j) {
      return j.displayName || "Context";
    }
    function T(j) {
      if (j == null)
        return null;
      if (typeof j.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof j == "function")
        return j.displayName || j.name || null;
      if (typeof j == "string")
        return j;
      switch (j) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof j == "object")
        switch (j.$$typeof) {
          case d:
            var W = j;
            return R(W) + ".Consumer";
          case i:
            var te = j;
            return R(te._context) + ".Provider";
          case l:
            return F(j, j.render, "ForwardRef");
          case u:
            var ue = j.displayName || null;
            return ue !== null ? ue : T(j.type) || "Memo";
          case h: {
            var Pe = j, Me = Pe._payload, Ce = Pe._init;
            try {
              return T(Ce(Me));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, V = 0, I, _, ne, K, U, re, ie;
    function le() {
    }
    le.__reactDisabledLog = !0;
    function me() {
      {
        if (V === 0) {
          I = console.log, _ = console.info, ne = console.warn, K = console.error, U = console.group, re = console.groupCollapsed, ie = console.groupEnd;
          var j = {
            configurable: !0,
            enumerable: !0,
            value: le,
            writable: !0
          };
          Object.defineProperties(console, {
            info: j,
            log: j,
            warn: j,
            error: j,
            group: j,
            groupCollapsed: j,
            groupEnd: j
          });
        }
        V++;
      }
    }
    function ce() {
      {
        if (V--, V === 0) {
          var j = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, j, {
              value: I
            }),
            info: P({}, j, {
              value: _
            }),
            warn: P({}, j, {
              value: ne
            }),
            error: P({}, j, {
              value: K
            }),
            group: P({}, j, {
              value: U
            }),
            groupCollapsed: P({}, j, {
              value: re
            }),
            groupEnd: P({}, j, {
              value: ie
            })
          });
        }
        V < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var q = N.ReactCurrentDispatcher, de;
    function ae(j, W, te) {
      {
        if (de === void 0)
          try {
            throw Error();
          } catch (Pe) {
            var ue = Pe.stack.trim().match(/\n( *(at )?)/);
            de = ue && ue[1] || "";
          }
        return `
` + de + j;
      }
    }
    var je = !1, pe;
    {
      var Ve = typeof WeakMap == "function" ? WeakMap : Map;
      pe = new Ve();
    }
    function ft(j, W) {
      if (!j || je)
        return "";
      {
        var te = pe.get(j);
        if (te !== void 0)
          return te;
      }
      var ue;
      je = !0;
      var Pe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Me;
      Me = q.current, q.current = null, me();
      try {
        if (W) {
          var Ce = function() {
            throw Error();
          };
          if (Object.defineProperty(Ce.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ce, []);
            } catch (Yt) {
              ue = Yt;
            }
            Reflect.construct(j, [], Ce);
          } else {
            try {
              Ce.call();
            } catch (Yt) {
              ue = Yt;
            }
            j.call(Ce.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Yt) {
            ue = Yt;
          }
          j();
        }
      } catch (Yt) {
        if (Yt && ue && typeof Yt.stack == "string") {
          for (var ve = Yt.stack.split(`
`), st = ue.stack.split(`
`), Re = ve.length - 1, Be = st.length - 1; Re >= 1 && Be >= 0 && ve[Re] !== st[Be]; )
            Be--;
          for (; Re >= 1 && Be >= 0; Re--, Be--)
            if (ve[Re] !== st[Be]) {
              if (Re !== 1 || Be !== 1)
                do
                  if (Re--, Be--, Be < 0 || ve[Re] !== st[Be]) {
                    var Mt = `
` + ve[Re].replace(" at new ", " at ");
                    return j.displayName && Mt.includes("<anonymous>") && (Mt = Mt.replace("<anonymous>", j.displayName)), typeof j == "function" && pe.set(j, Mt), Mt;
                  }
                while (Re >= 1 && Be >= 0);
              break;
            }
        }
      } finally {
        je = !1, q.current = Me, ce(), Error.prepareStackTrace = Pe;
      }
      var Es = j ? j.displayName || j.name : "", ca = Es ? ae(Es) : "";
      return typeof j == "function" && pe.set(j, ca), ca;
    }
    function os(j, W, te) {
      return ft(j, !1);
    }
    function It(j) {
      var W = j.prototype;
      return !!(W && W.isReactComponent);
    }
    function xt(j, W, te) {
      if (j == null)
        return "";
      if (typeof j == "function")
        return ft(j, It(j));
      if (typeof j == "string")
        return ae(j);
      switch (j) {
        case c:
          return ae("Suspense");
        case m:
          return ae("SuspenseList");
      }
      if (typeof j == "object")
        switch (j.$$typeof) {
          case l:
            return os(j.render);
          case u:
            return xt(j.type, W, te);
          case h: {
            var ue = j, Pe = ue._payload, Me = ue._init;
            try {
              return xt(Me(Pe), W, te);
            } catch {
            }
          }
        }
      return "";
    }
    var gt = Object.prototype.hasOwnProperty, Dt = {}, oe = N.ReactDebugCurrentFrame;
    function be(j) {
      if (j) {
        var W = j._owner, te = xt(j.type, j._source, W ? W.type : null);
        oe.setExtraStackFrame(te);
      } else
        oe.setExtraStackFrame(null);
    }
    function we(j, W, te, ue, Pe) {
      {
        var Me = Function.call.bind(gt);
        for (var Ce in j)
          if (Me(j, Ce)) {
            var ve = void 0;
            try {
              if (typeof j[Ce] != "function") {
                var st = Error((ue || "React class") + ": " + te + " type `" + Ce + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof j[Ce] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw st.name = "Invariant Violation", st;
              }
              ve = j[Ce](W, Ce, ue, te, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Re) {
              ve = Re;
            }
            ve && !(ve instanceof Error) && (be(Pe), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ue || "React class", te, Ce, typeof ve), be(null)), ve instanceof Error && !(ve.message in Dt) && (Dt[ve.message] = !0, be(Pe), b("Failed %s type: %s", te, ve.message), be(null));
          }
      }
    }
    var et = Array.isArray;
    function Ge(j) {
      return et(j);
    }
    function Tt(j) {
      {
        var W = typeof Symbol == "function" && Symbol.toStringTag, te = W && j[Symbol.toStringTag] || j.constructor.name || "Object";
        return te;
      }
    }
    function Qe(j) {
      try {
        return tt(j), !1;
      } catch {
        return !0;
      }
    }
    function tt(j) {
      return "" + j;
    }
    function J(j) {
      if (Qe(j))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Tt(j)), tt(j);
    }
    var H = N.ReactCurrentOwner, Se = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, bt, St, Zt;
    Zt = {};
    function xs(j) {
      if (gt.call(j, "ref")) {
        var W = Object.getOwnPropertyDescriptor(j, "ref").get;
        if (W && W.isReactWarning)
          return !1;
      }
      return j.ref !== void 0;
    }
    function qs(j) {
      if (gt.call(j, "key")) {
        var W = Object.getOwnPropertyDescriptor(j, "key").get;
        if (W && W.isReactWarning)
          return !1;
      }
      return j.key !== void 0;
    }
    function ol(j, W) {
      if (typeof j.ref == "string" && H.current && W && H.current.stateNode !== W) {
        var te = T(H.current.type);
        Zt[te] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', T(H.current.type), j.ref), Zt[te] = !0);
      }
    }
    function il(j, W) {
      {
        var te = function() {
          bt || (bt = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", W));
        };
        te.isReactWarning = !0, Object.defineProperty(j, "key", {
          get: te,
          configurable: !0
        });
      }
    }
    function ll(j, W) {
      {
        var te = function() {
          St || (St = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", W));
        };
        te.isReactWarning = !0, Object.defineProperty(j, "ref", {
          get: te,
          configurable: !0
        });
      }
    }
    var cl = function(j, W, te, ue, Pe, Me, Ce) {
      var ve = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: s,
        // Built-in properties that belong on the element
        type: j,
        key: W,
        ref: te,
        props: Ce,
        // Record the component responsible for creating this element.
        _owner: Me
      };
      return ve._store = {}, Object.defineProperty(ve._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ve, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ue
      }), Object.defineProperty(ve, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Pe
      }), Object.freeze && (Object.freeze(ve.props), Object.freeze(ve)), ve;
    };
    function dl(j, W, te, ue, Pe) {
      {
        var Me, Ce = {}, ve = null, st = null;
        te !== void 0 && (J(te), ve = "" + te), qs(W) && (J(W.key), ve = "" + W.key), xs(W) && (st = W.ref, ol(W, Pe));
        for (Me in W)
          gt.call(W, Me) && !Se.hasOwnProperty(Me) && (Ce[Me] = W[Me]);
        if (j && j.defaultProps) {
          var Re = j.defaultProps;
          for (Me in Re)
            Ce[Me] === void 0 && (Ce[Me] = Re[Me]);
        }
        if (ve || st) {
          var Be = typeof j == "function" ? j.displayName || j.name || "Unknown" : j;
          ve && il(Ce, Be), st && ll(Ce, Be);
        }
        return cl(j, ve, st, Pe, ue, H.current, Ce);
      }
    }
    var er = N.ReactCurrentOwner, na = N.ReactDebugCurrentFrame;
    function Os(j) {
      if (j) {
        var W = j._owner, te = xt(j.type, j._source, W ? W.type : null);
        na.setExtraStackFrame(te);
      } else
        na.setExtraStackFrame(null);
    }
    var tr;
    tr = !1;
    function sr(j) {
      return typeof j == "object" && j !== null && j.$$typeof === s;
    }
    function ra() {
      {
        if (er.current) {
          var j = T(er.current.type);
          if (j)
            return `

Check the render method of \`` + j + "`.";
        }
        return "";
      }
    }
    function ml(j) {
      return "";
    }
    var aa = {};
    function ul(j) {
      {
        var W = ra();
        if (!W) {
          var te = typeof j == "string" ? j : j.displayName || j.name;
          te && (W = `

Check the top-level render call using <` + te + ">.");
        }
        return W;
      }
    }
    function oa(j, W) {
      {
        if (!j._store || j._store.validated || j.key != null)
          return;
        j._store.validated = !0;
        var te = ul(W);
        if (aa[te])
          return;
        aa[te] = !0;
        var ue = "";
        j && j._owner && j._owner !== er.current && (ue = " It was passed a child from " + T(j._owner.type) + "."), Os(j), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', te, ue), Os(null);
      }
    }
    function ia(j, W) {
      {
        if (typeof j != "object")
          return;
        if (Ge(j))
          for (var te = 0; te < j.length; te++) {
            var ue = j[te];
            sr(ue) && oa(ue, W);
          }
        else if (sr(j))
          j._store && (j._store.validated = !0);
        else if (j) {
          var Pe = g(j);
          if (typeof Pe == "function" && Pe !== j.entries)
            for (var Me = Pe.call(j), Ce; !(Ce = Me.next()).done; )
              sr(Ce.value) && oa(Ce.value, W);
        }
      }
    }
    function hl(j) {
      {
        var W = j.type;
        if (W == null || typeof W == "string")
          return;
        var te;
        if (typeof W == "function")
          te = W.propTypes;
        else if (typeof W == "object" && (W.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        W.$$typeof === u))
          te = W.propTypes;
        else
          return;
        if (te) {
          var ue = T(W);
          we(te, j.props, "prop", ue, j);
        } else if (W.PropTypes !== void 0 && !tr) {
          tr = !0;
          var Pe = T(W);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Pe || "Unknown");
        }
        typeof W.getDefaultProps == "function" && !W.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function pl(j) {
      {
        for (var W = Object.keys(j.props), te = 0; te < W.length; te++) {
          var ue = W[te];
          if (ue !== "children" && ue !== "key") {
            Os(j), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ue), Os(null);
            break;
          }
        }
        j.ref !== null && (Os(j), b("Invalid attribute `ref` supplied to `React.Fragment`."), Os(null));
      }
    }
    function la(j, W, te, ue, Pe, Me) {
      {
        var Ce = A(j);
        if (!Ce) {
          var ve = "";
          (j === void 0 || typeof j == "object" && j !== null && Object.keys(j).length === 0) && (ve += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var st = ml();
          st ? ve += st : ve += ra();
          var Re;
          j === null ? Re = "null" : Ge(j) ? Re = "array" : j !== void 0 && j.$$typeof === s ? (Re = "<" + (T(j.type) || "Unknown") + " />", ve = " Did you accidentally export a JSX literal instead of a component?") : Re = typeof j, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Re, ve);
        }
        var Be = dl(j, W, te, Pe, Me);
        if (Be == null)
          return Be;
        if (Ce) {
          var Mt = W.children;
          if (Mt !== void 0)
            if (ue)
              if (Ge(Mt)) {
                for (var Es = 0; Es < Mt.length; Es++)
                  ia(Mt[Es], j);
                Object.freeze && Object.freeze(Mt);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ia(Mt, j);
        }
        return j === r ? pl(Be) : hl(Be), Be;
      }
    }
    function fl(j, W, te) {
      return la(j, W, te, !0);
    }
    function xl(j, W, te) {
      return la(j, W, te, !1);
    }
    var gl = xl, bl = fl;
    Us.Fragment = r, Us.jsx = gl, Us.jsxs = bl;
  }()), Us;
}
process.env.NODE_ENV === "production" ? mr.exports = Wc() : mr.exports = qc();
var e = mr.exports;
const Vn = Ct(
  void 0
), se = () => {
  const t = at(Vn);
  if (!t)
    throw new Error("useNextContext must be used within a NextProvider");
  return t;
}, zr = Ct(void 0), O = (t, s) => {
  const n = at(zr);
  if (!n)
    throw new Error(
      "useTranslation must be used within an TranslationProvider"
    );
  const { i18n: r } = n;
  return Cr(t, { ...s, i18n: r });
};
function wt() {
  const { locale: t } = se(), { t: s } = O(["common"], {
    nsMode: "fallback"
  }), { data: n } = ye(
    ee.ClimateList({ locale: t }),
    (d) => d.Climate.list(t || ""),
    { staleTime: 1 / 0 }
  ), r = D(
    () => (n == null ? void 0 : n.fuelTypeHybridIDs) || [],
    [n == null ? void 0 : n.fuelTypeHybridIDs]
  ), a = D(
    () => ((n == null ? void 0 : n.fuelTypes) || []).map((d) => ({
      label: s(`fuelTypes.${d.key}`),
      value: d.value,
      tariffClassification: d.tariffClassification
    })),
    [n == null ? void 0 : n.fuelTypes, s]
  ), o = D(
    () => ((n == null ? void 0 : n.emissionClasses) || []).map((d) => ({
      label: s(`emissionClasses.${d.key}`),
      value: d.value
    })),
    [n == null ? void 0 : n.emissionClasses, s]
  ), i = D(
    () => ((n == null ? void 0 : n.co2EmissionClasses) || []).map(({ key: d, value: l }) => ({
      label: s(`co2EmissionClass.${d}`),
      value: l
    })),
    [n == null ? void 0 : n.co2EmissionClasses, s]
  );
  return {
    fuelTypes: a,
    fuelTypeHybridIDs: r,
    emissionClasses: o,
    co2EmissionClasses: i
  };
}
function bo() {
  const { locale: t } = se(), s = D(
    () => new Intl.DisplayNames([t || ""], { type: "region", style: "short" }),
    [t]
  );
  return L(
    (n) => {
      try {
        return s.of(n) || void 0;
      } catch {
        return;
      }
    },
    [s]
  );
}
function Ke(t = !1, s, n) {
  const { data: r, error: a, refetch: o } = ye(
    ee.Agreements(
      s ? {
        contractNo: s
      } : {}
    ),
    ({ Contract: i }) => s ? i.byContractNo(s) : i.contractList,
    { suspense: t, enabled: !n || !!s }
  );
  return { data: r, error: a, refetch: o };
}
function as() {
  var r;
  const { data: t } = Ke(), { query: s } = se(), n = s.contract;
  return n || ((r = t == null ? void 0 : t.paymentAgreement) == null ? void 0 : r.contractNo);
}
function dn(t) {
  const s = as(), n = t || s;
  return ye(
    ee.PeriodCard({
      contractNo: n
    }),
    ({ PeriodCard: r }) => r.byContract(n),
    {
      enabled: !!n,
      retry: 0,
      onError: () => {
      }
    }
  );
}
function Ar(t) {
  return ye(
    ee.PeriodCard({
      contractNo: t
    }),
    ({ PeriodCard: s }) => s.byContract(t),
    {
      enabled: !!t,
      retry: 0,
      onError: () => {
      }
    }
  );
}
function Or(t = !1, s, n) {
  const { data: r, error: a, refetch: o } = ye(
    ee.BusinessContractsList,
    ({ Contract: i }) => i.businessContracts({ hideClosedVehicles: n }),
    {
      suspense: t,
      onSuccess(i) {
        s == null || s(i);
      }
    }
  );
  return { data: r, error: a, refetch: o };
}
const vo = Ct(
  void 0
), Ng = ({
  children: t
}) => {
  const [s, n] = M(!0), r = at(Vn);
  return B(() => {
    const a = () => {
      n(!0);
    };
    return r == null || r.events.on("routeChangeStart", a), () => {
      r == null || r.events.off("routeChangeStart", a);
    };
  }, [r == null ? void 0 : r.events]), /* @__PURE__ */ e.jsx(vo.Provider, { value: { isBannerVisible: s, setBannerVisible: n }, children: t });
}, Er = () => {
  const t = at(vo), s = at(Vn);
  if (!t)
    throw new Error(
      `useBanner must be used within a BannerVisibilityProvider. Route: ${s == null ? void 0 : s.pathname}`
    );
  return t;
}, Hc = {
  sv: "SE",
  da: "DK",
  de: "DE"
}, ms = (t) => Hc[t] ?? "DK", Ls = ["DK", "SE", "DE", "NO"], yo = (t) => ({
  compare: (s, n) => {
    const r = Ls.indexOf(t(s) || ""), a = Ls.indexOf(t(n) || ""), o = r !== -1, i = a !== -1;
    return o && i ? r - a : o ? -1 : i ? 1 : 0;
  }
}), jo = (t) => (s) => ({
  compare: (n, r) => {
    const a = t(n) === ms(s), o = t(r) === ms(s);
    return a === o ? 0 : a ? -1 : 1;
  }
}), Co = (t) => ({
  compare: (s, n) => {
    const r = t(s), a = t(n);
    return r.localeCompare(a);
  }
}), No = (t, s) => (n, r) => {
  const a = yo(
    (d) => d.value
  ).compare(n, r);
  if (a !== 0) return a;
  const o = jo(
    (d) => d.value
  )(t).compare(n, r);
  return o !== 0 ? o : Co(
    (d) => s ? d.value : d.key
  ).compare(n, r);
};
function kt(t = !1) {
  const { locale: s } = se(), { data: n } = ye(
    ee.CountryList({ locale: s }),
    (r) => r.Country.list(s || ""),
    { staleTime: 1 / 0 }
  );
  return D(() => {
    const r = No(s || "", t);
    return (n || []).slice().sort(r);
  }, [n, s, t]);
}
const Uc = (t) => t.map((s) => ({ ...s, label: s.key }));
function wo() {
  const { locale: t } = se(), { data: s } = ye(
    ee.CountryList({ locale: t }),
    (n) => n.Country.list(t || ""),
    { staleTime: 1 / 0 }
  );
  return D(() => {
    const n = No(t || "", !1), r = (s || []).slice().sort(n), a = Uc(r), o = a.filter((d) => Ls.includes(d.value)).sort(
      (d, l) => Ls.indexOf(d.value) - Ls.indexOf(l.value)
    ), i = a.filter(
      (d) => !Ls.includes(d.value)
    );
    return [
      {
        children: o,
        group: { label: "form.labels.popular" }
      },
      {
        children: i,
        group: { label: "form.labels.countries" }
      }
    ];
  }, [s, t]);
}
function Dr() {
  const { data: t } = ye(
    ee.CountryListBvSupported(),
    (s) => s.VehicleInfo.getBilvEnableCountries()
  );
  return t;
}
function Oe({ suspense: t } = { suspense: !0 }) {
  const s = Le(), n = as(), { data: r, isLoading: a } = ye(
    ee.CustomerInformation(),
    ({ Customer: l }) => l.get,
    { suspense: t, staleTime: 1 / 0 }
  ), { mutateAsync: o, isLoading: i } = fe(
    ["customerInformationMutation"],
    ({ Customer: l }) => l.updateCustomer,
    {
      onSuccess: () => {
        const l = n;
        s.invalidateQueries(ee.CustomerInformation()), s.invalidateQueries(ee.Agreements({})), s.invalidateQueries(
          ee.Agreements({ contractNo: l })
        ), s.invalidateQueries(ee.BusinessCommutersList), s.invalidateQueries(ee.PaymentAgreementList), s.invalidateQueries(ee.BusinessContractsList), s.invalidateQueries(ee.Recognitions({}));
      }
    }
  ), d = L(
    async (l) => {
      try {
        return await o({ ...r, ...l }), { success: !0 };
      } catch (c) {
        return { success: !1, error: c.error ?? "Unknown Error" };
      }
    },
    [r, o]
  );
  return {
    customerInformation: r,
    updateCustomer: d,
    isLoading: a,
    isUpdating: i
  };
}
function Gc() {
  const { data: t, isLoading: s } = ye(
    ee.InvoiceStatuses(),
    ({ Customer: n }) => n.invoiceStatuses(),
    { keepPreviousData: !0 }
  );
  return {
    data: t,
    isLoading: s
  };
}
function Rn(t = !1, s) {
  const { customerInformation: n } = Oe(), r = (n == null ? void 0 : n.customerType) === "business-commuter", {
    data: a,
    error: o,
    refetch: i
  } = ye(
    ee.PaymentAgreementList,
    ({ Contract: d }) => d.paymentAgreementList,
    {
      suspense: t,
      onSuccess(d) {
        s == null || s(d);
      },
      enabled: !r
    }
  );
  return { contracts: a, error: o, refetch: i };
}
function ks() {
  const { mutateAsync: t } = fe(
    ["validate", "alpr"],
    (s) => s.Alpr.validate
  );
  return L(
    (s) => async (n) => {
      try {
        await t(n);
        return;
      } catch {
        return s;
      }
    },
    [t]
  );
}
function $n(t) {
  const { country: s, licensePlate: n } = t || {};
  return ye(
    ee.VehicleInfo(t),
    ({ VehicleInfo: r }) => r.getBilvVehicleInfo(s, n),
    {
      enabled: !!t && !!s && !!n,
      retry: 0
    }
  );
}
function Fr() {
  const { data: t, isLoading: s } = ye(
    ["getVerifyContactDetailsDate"],
    ({ Customer: a }) => a.getVerifyContactDetailsDate()
  );
  let n = !1;
  if (!s && t) {
    const a = t == null ? void 0 : t.verifiedContactDetailsDate, o = yc(/* @__PURE__ */ new Date(), 6);
    n = !(a && jc(new Date(a), o));
  }
  const { mutateAsync: r } = fe(
    ["setVerifyContactDetailsDate"],
    (a) => a.Customer.setVerifyContactDetailsDate
  );
  return { contactDetailsNeedsValidation: n, setVerifyContactDetailsDate: r };
}
const Kc = (t) => ye(
  ee.RecognitionsRegisteredPassageVehicles(t),
  ({ Recognitions: s }) => s.registeredPassageVehicles(t),
  { enabled: !!t }
), ko = Ct(
  void 0
), Ot = () => {
  const t = at(ko);
  if (!t)
    throw new Error("useAuthStore must be used within an AuthStoreProvider");
  const { getCustomerType: s, resetAuthentication: n, getAuthToken: r } = t, a = s(), o = r();
  return { customerType: a, resetAuthentication: n, authToken: o };
};
function Zc() {
  const t = se(), { resetAuthentication: s } = Ot();
  return L(async () => {
    s(), await t.replace("/api/auth/logout");
  }, [s, t]);
}
function Po() {
  const { tokens: t } = Fc(), [s, n] = M({
    isMobile: !1,
    isTablet: !1,
    isDesktop: !1
  });
  return B(() => {
    function r() {
      var a;
      n({
        isMobile: window.matchMedia("screen and (max-width: 639px)").matches,
        isTablet: window.matchMedia(
          `screen and (min-width: ${(a = t == null ? void 0 : t.breakpoints) == null ? void 0 : a.sm})`
        ).matches,
        isDesktop: window.matchMedia("screen and (max-width: 1200px)").matches
      });
    }
    return window.addEventListener("resize", r), r(), () => window.removeEventListener("resize", r);
  }, [n, t]), s;
}
function Lr(t = 20, {
  searchText: s,
  agreements: n,
  status: r,
  productType: a,
  hideCommuter: o
} = {}) {
  const [i, d] = M(1), l = as(), c = {
    page: i,
    pageSize: t,
    searchText: s,
    status: r,
    productType: a,
    hideCommuter: o,
    ...n ? { contractNo: n } : l ? { contractNo: l } : {}
  }, { data: m, isLoading: u } = ye(
    ee.Recognitions({ ...c }),
    ({ Recognitions: g }) => g.list(c),
    { keepPreviousData: !0 }
  ), h = bo(), { emissionClasses: p, fuelTypes: f } = wt();
  return !m || u ? {
    loading: u,
    recognitions: [],
    totalRecognitions: 0,
    page: i,
    pages: 1,
    setPage: d
  } : {
    loading: !1,
    recognitions: m.recognitions.map(
      ({ fuelType: g, emissionClass: N, ...b }) => ({
        ...b,
        fuelType: f.find(({ value: v }) => Number(v) === g),
        emissionClass: p.find(
          ({ value: v }) => Number(v) === N
        ),
        country: h(b.countryCode) ?? "-"
      })
    ),
    page: i,
    pages: m.pages,
    totalRecognitions: m.totalRecognitions,
    setPage: d
  };
}
const ze = ({
  colorMode: t,
  id: s,
  children: n,
  dismiss: r = !1,
  size: a = "small",
  hideIcon: o = !1,
  className: i,
  title: d
}) => {
  const l = `userFeedbackDismissed-${s}`, [c, m] = M(() => r && s ? sessionStorage.getItem(l) !== "true" : !0), u = () => {
    s && sessionStorage.setItem(l, "true"), m(!1);
  };
  if (!c)
    return null;
  const h = (b = "information") => {
    switch (b) {
      case "information":
        return "bg-blue-100 text-black";
      case "success":
        return "bg-green-200 text-black ";
      case "warning":
        return "bg-yellow-300 text-black";
      case "error":
        return "bg-red-300 text-black";
    }
  }, p = (b) => {
    switch (b) {
      case "big":
        return {
          container: "gap-8 ",
          textAndTitle: "text-base flex flex-col gap-4",
          iconSize: 48,
          titleSize: "text-[30px]",
          padding: "p-8"
        };
      default:
        return {
          container: "gap-4",
          textAndTitle: "text-sm",
          iconSize: 16,
          titleSize: "",
          padding: "p-4"
        };
    }
  }, f = (b = "information") => {
    switch (b) {
      case "information":
        return /* @__PURE__ */ e.jsx(to, { width: x.iconSize, height: x.iconSize });
      case "success":
        return /* @__PURE__ */ e.jsx(
          zl,
          {
            width: x.iconSize,
            height: x.iconSize
          }
        );
      case "warning":
        return /* @__PURE__ */ e.jsx(
          Ml,
          {
            width: x.iconSize,
            height: x.iconSize
          }
        );
      case "error":
        return /* @__PURE__ */ e.jsx(
          Sl,
          {
            width: x.iconSize,
            height: x.iconSize
          }
        );
    }
  }, x = p(a), g = h(t), N = f(t);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flex justify-between ${x.padding} )} 
        rounded-xl  ${g} ${x.container} ${i}`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: `flex gap-4 ${x.container}`, children: [
          !o && /* @__PURE__ */ e.jsx("div", { children: N }),
          /* @__PURE__ */ e.jsxs("div", { className: `max-w-prose  ${x.textAndTitle}`, children: [
            /* @__PURE__ */ e.jsxs("span", { className: `font-semibold ${x.titleSize}`, children: [
              d,
              " "
            ] }),
            n
          ] })
        ] }),
        r ? /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
          rn,
          {
            height: 16,
            width: 16,
            className: "cursor-pointer self-end",
            onClick: u
          }
        ) }) : null
      ]
    }
  ) });
}, G = ({
  ns: t,
  children: s,
  ...n
}) => {
  const { t: r, ready: a } = O(t), o = at(zr);
  if (!o)
    throw new Error(
      "useTranslation must be used within an TranslationProvider"
    );
  const { i18n: i } = o;
  return !i || !a ? /* @__PURE__ */ e.jsx(e.Fragment, { children: n.i18nKey || s }) : /* @__PURE__ */ e.jsx(Ql, { ...n, t: r, i18n: i, children: s });
}, ga = ({ mode: t, pageType: s = "kmtoll" }) => {
  const n = s === "kmtoll";
  return /* @__PURE__ */ e.jsx(ze, { className: "mt-6", colorMode: "information", children: /* @__PURE__ */ e.jsx(
    G,
    {
      i18nKey: t === "newBizz" && s == "kmtoll" ? "kmtoll.userFeedBack.information.newBizz" : "kmtoll.userFeedBack.information.emptyBizzList",
      ns: "account",
      components: n ? [
        /* @__PURE__ */ e.jsx(
          ys,
          {
            className: "font-semibold underline",
            href: "./bizz/order"
          }
        )
      ] : []
    }
  ) });
}, Yc = (t, s, n, r) => t ? "loading" : (
  // We don't have any filters active but still 0 recognitions
  s === 0 && !n && r === "kmtoll" ? "newBizz" : (
    // We have 0 recognitions due to our filters
    s === 0 && n ? "emptyBizzList" : "displayBizzList"
  )
), Qc = (t) => t >= 12e3 ? "kmtoll.landing.bizzList.vehicle.weight.above12000" : t > 3500 ? "kmtoll.landing.bizzList.vehicle.weight.above3500" : "kmtoll.landing.bizzList.vehicle.weight.below3500", Xc = (t) => [Z.OresundPendler, Z.OresundBusinessPendler].includes(
  t
), ur = (t) => t === "Storebelt", Jc = (t) => t === "OresundPAY" || t === "OresundPAYBusiness", ed = (t) => t === Z.OresundBusinessPendler, To = (t, s) => !!s && Xc(t.agreementType), td = (t, s) => (n, r) => To(n, r) ? t(n) : s(n), sd = (t) => t ? {} : {
  borderTopColor: "colors.neutral.400",
  borderTopStyle: "solid",
  borderTopWidth: "1px"
}, nd = ({
  children: t,
  template: s = "two-column",
  gridTemplateColumns: n,
  noBorder: r
}) => /* @__PURE__ */ e.jsx(
  rs,
  {
    template: s,
    py: "spacing.400",
    sx: {
      gridTemplateColumns: n,
      ...sd(r)
    },
    children: t
  }
), rd = (t, s) => Lt(t, "yyyy-MM-dd, HH:mm", {
  locale: s
}), Js = (t, s) => `${t} ${s}`, ad = (t, s) => {
  const n = new Date(t);
  return isNaN(n.getTime()) ? "-" : rd(n, s);
}, hr = (t) => (t ? new Date(t) : /* @__PURE__ */ new Date()).toLocaleDateString("sv-SE", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric"
});
var Gs = /* @__PURE__ */ ((t) => (t.internal = "internal", t.external = "external", t))(Gs || {});
const od = ({
  props: t,
  condition: s,
  wrapper: n,
  children: r
}) => /* @__PURE__ */ e.jsx(e.Fragment, { children: s ? n(r, t) : r }), id = ps(function({ children: s, className: n, color: r, underline: a, href: o, full: i, ...d }, l) {
  return /* @__PURE__ */ e.jsx(
    k,
    {
      as: "a",
      ref: l,
      target: "_blank",
      href: o,
      ...d,
      className: He(
        So({ color: r, full: i, underline: a }),
        n,
        d.intent ? void 0 : "font-size-inherit"
      ),
      children: s
    }
  );
}), ld = ps(function({ children: s, className: n, color: r, underline: a, href: o, full: i, active: d, ...l }, c) {
  return /* @__PURE__ */ e.jsx(ys, { href: o, passHref: !0, legacyBehavior: !0, children: /* @__PURE__ */ e.jsx(
    k,
    {
      as: "a",
      active: d ? "true" : void 0,
      "data-active": d,
      ref: c,
      ...l,
      className: He(
        So({ color: r, full: i, underline: a }),
        n,
        l.intent ? void 0 : "font-size-inherit"
      ),
      children: s
    }
  ) });
}), cd = (t) => /* @__PURE__ */ e.jsx(Yl, { ...t, asChild: !0, children: t.children }), So = Ht(["underline", "hover:underline", "cursor-pointer"], {
  variants: {
    color: {
      inherit: ["text-inherit"],
      default: [
        "text-primary-600",
        "active:text-primary-700",
        "focus:text-primary-700",
        "hover:text-primary-700"
      ],
      primaryHover: [
        "text-type-heading",
        "active:text-primary-600",
        "focus:text-primary-600",
        "hover:text-primary-600"
      ],
      white: [
        "text-white",
        "active:text-white",
        "focus:text-white",
        "hover:text-white"
      ],
      neutral: [
        "text-type-secondary",
        "active:text-type-secondary",
        "focus:text-type-secondary",
        "hover:text-type-secondary"
      ]
    },
    full: {
      true: [
        "after:z-[1]",
        'after:content-[" "]',
        "after:absolute",
        "after:inset-0"
      ],
      false: []
    },
    underline: {
      true: [],
      false: ["no-underline"]
    }
  },
  defaultVariants: {
    color: "default"
  }
}), mt = ps(function({
  navLinkWrapper: s,
  children: n,
  href: r,
  color: a,
  full: o,
  underline: i,
  className: d,
  ...l
}, c) {
  if (!r) return /* @__PURE__ */ e.jsx(e.Fragment, {});
  const u = ((f) => f[0] === "/" ? Gs.internal : Gs.external)(r), h = (f) => {
    switch (f) {
      case Gs.internal:
        return /* @__PURE__ */ e.jsx(
          ld,
          {
            href: r,
            ref: c,
            color: a,
            className: He(d),
            ...l,
            children: n
          }
        );
      case Gs.external:
        return /* @__PURE__ */ e.jsx(
          id,
          {
            href: r,
            ref: c,
            color: a,
            className: He(d),
            ...l,
            children: n
          }
        );
    }
  }, p = {
    children: n,
    href: r,
    color: a,
    full: o,
    underline: i,
    className: d,
    ...l
  };
  return /* @__PURE__ */ e.jsx(
    od,
    {
      condition: !!s,
      wrapper: (f) => /* @__PURE__ */ e.jsx(cd, { ...p, children: f }),
      children: h(u)
    }
  );
}), dd = ({
  value: t,
  label: s,
  isMobile: n
}) => /* @__PURE__ */ e.jsxs("div", { className: "mb-4 flex flex-col", children: [
  /* @__PURE__ */ e.jsx(
    "label",
    {
      className: `text-sm ${n ? "text-neutral-800" : "text-neutral-600"}`,
      children: s
    }
  ),
  /* @__PURE__ */ e.jsx("span", { className: "text-base", children: t })
] }), md = ({
  trip: t,
  showColumns: s,
  t: n,
  downloadTrip: r
}) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  (s == null ? void 0 : s.includes("tripPaymentStation")) && /* @__PURE__ */ e.jsxs("div", { className: "mb-4 flex flex-col", children: [
    /* @__PURE__ */ e.jsxs("span", { className: "text-neutral-800", children: [
      n("form.labels.station"),
      ":"
    ] }),
    /* @__PURE__ */ e.jsx("span", { className: "text-base", children: t.station })
  ] }),
  (s == null ? void 0 : s.includes("tripRoute")) && /* @__PURE__ */ e.jsxs("div", { className: "mb-4 flex flex-col ", children: [
    /* @__PURE__ */ e.jsx("span", { className: "text-neutral-800", children: n("trips.columns.tripRoute") }),
    t.route === "-" ? "-" : /* @__PURE__ */ e.jsx(
      mt,
      {
        href: t.route,
        className: "text-primary-600 py-2",
        as: "a",
        onClick: (a) => {
          a.stopPropagation();
        },
        children: n("trips.labels.viewTripRoute")
      }
    )
  ] }),
  /* @__PURE__ */ e.jsx(
    "button",
    {
      onClick: (a) => {
        a.stopPropagation(), r(
          t.dateTime,
          t.listId,
          t.id,
          t.type,
          ls.PDF
        );
      },
      children: /* @__PURE__ */ e.jsx(Rs, { className: "text-neutral-800" })
    }
  )
] }), ud = ({
  trip: t,
  isMobile: s,
  showColumns: n,
  downloadTrip: r
}) => {
  const { t: a } = O(["account", "common"], {
    nsMode: "fallback"
  }), o = [
    {
      label: a("form.labels.licensePlate"),
      value: t.alpr,
      className: "col-span-2"
    },
    {
      label: a("form.labels.bizzNumber"),
      value: t.bizzNr,
      className: "col-span-2"
    },
    {
      label: a("form.labels.direction"),
      value: a(t.direction),
      className: "col-span-2"
    },
    {
      label: a("form.labels.priceExclVAT"),
      value: Js(t.price.amount, t.price.currencyCode),
      className: "col-span-2"
    },
    {
      label: a("form.labels.priceInclVAT"),
      value: Js(t.price.amountInclVAT, t.price.currencyCode),
      className: "col-span-2"
    },
    {
      label: a("form.labels.contract"),
      value: t.contract ? a(`agreementTypes.${t.contract}.label`) : "-",
      className: "col-span-2"
    },
    {
      label: a("form.labels.paymentProvider"),
      value: t.actor === "OresundPAY" ? a("agreementProviders.A40001.label") : t.actor,
      className: "col-span-2"
    },
    {
      label: a("form.labels.invoice"),
      value: t.invoiceNr,
      className: "col-span-2"
    }
  ];
  return /* @__PURE__ */ e.jsx("div", { className: "text-sm", children: /* @__PURE__ */ e.jsxs(
    nd,
    {
      gridTemplateColumns: {
        xs: "repeat(1, 1fr)",
        sm: "repeat(2, 1fr)",
        md: "repeat(4, 1fr)"
      },
      noBorder: !0,
      children: [
        o.map((i, d) => /* @__PURE__ */ e.jsx(
          dd,
          {
            ...i,
            isMobile: s,
            t: a
          },
          `${d}${i.value}`
        )),
        s && /* @__PURE__ */ e.jsx(
          md,
          {
            trip: t,
            showColumns: n,
            t: a,
            downloadTrip: r
          }
        )
      ]
    }
  ) });
};
function Vr() {
  var s;
  const { data: t } = Ke();
  return (s = t == null ? void 0 : t.paymentAgreement) == null ? void 0 : s.contractNo;
}
function hd(t = !1, s) {
  const { customerInformation: n } = Oe(), r = (n == null ? void 0 : n.customerType) === "business-commuter", {
    data: a,
    error: o,
    refetch: i
  } = ye(
    ee.PaymentAgreementList,
    ({ Contract: d }) => d.paymentAgreementList,
    {
      suspense: t,
      onSuccess(d) {
      },
      enabled: !r
    }
  );
  return { contracts: a, error: o, refetch: i };
}
const pd = [
  Z.OresundBusinessPendler,
  Z.OresundPendler
], fd = [Qs.ORESUNDPAY], xd = (t, s) => t ? s ? t.filter((n) => !pd.includes(n.agreementType)) : t : [], gd = (t, s) => t ? s ? t.filter(
  (n) => fd.includes(n.providerId)
) : t : [], bd = (t, s) => t || [], vd = ({
  paymentAgreement: {
    agreementType: t,
    contractNo: s,
    paymentType: n,
    provider: r,
    status: a
  }
}) => ({
  agreementType: t,
  contractNo: s,
  paymentType: n,
  providerId: r.id,
  providerName: r.name,
  status: a
}), Mo = (t) => (s) => ({
  label: `${t == null ? void 0 : t(`agreementProviders.${s == null ? void 0 : s.providerId}.label`)} - ${s.contractNo}`,
  value: s.contractNo
}), zo = (t, s, n, r, a) => {
  let o = xd(s, n);
  return o = gd(o, r), o = bd(o), o.map(Mo(t));
}, wn = ({ status: t }) => {
  const { t: s } = O("account"), n = (r) => {
    switch (r) {
      case "blocked":
        return "bg-red-50 text-red-700";
      case "closed":
        return "bg-red-50 text-red-700";
      case "open":
        return "bg-green-50 text-green-800";
      case "pending":
        return "bg-yellow-50 text-yellow-800";
      default:
        return "Missing string";
    }
  };
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: `flex w-fit items-center justify-center rounded-xl px-2 text-xs font-medium ${n(
        t
      )}`,
      children: s(`kmtoll.landing.bizzList.bizzStatus.${t}`)
    }
  );
}, Ks = "showAll";
function yd({
  option: t,
  selectedOptions: s,
  handleOptionClick: n,
  handleCheckBox: r,
  mode: a
}) {
  return t != null && t.label ? /* @__PURE__ */ e.jsx(
    "div",
    {
      className: "flex items-center gap-3 border-b-2 px-3 py-4 last:border-b-0 ",
      children: /* @__PURE__ */ e.jsxs("label", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ e.jsx(
          "input",
          {
            className: "border-1 hover:ring-inset-2 hover:border-1 h-4 w-4 flex-shrink-0 cursor-pointer appearance-none rounded-sm border border-neutral-500 checked:border-2 checked:border-white checked:bg-blue-800 checked:ring-2 checked:ring-blue-400 hover:border-blue-500 hover:checked:border-white ",
            type: "checkbox",
            checked: s.some(
              (o) => o.value === t.value
            ),
            onChange: (o) => n(o, t),
            onKeyDown: (o) => r(o, t)
          }
        ),
        a === "bizzStatus" && t.value !== Ks ? /* @__PURE__ */ e.jsx(wn, { status: t.value }) : t.label
      ] })
    },
    t.value
  ) : null;
}
function jd({
  label: t,
  options: s,
  className: n,
  onChange: r,
  mode: a = "default",
  showAll: o
}, i) {
  const [d, l] = M(!1), { t: c, ready: m } = O(["account", "common"]), u = D(() => {
    const b = c("filter.showAll");
    return b !== "filter.showAll" ? {
      value: Ks,
      label: b
    } : null;
  }, [m]), h = D(() => o ? [u, ...s] : s, [o, u, s]), [p, f] = M(o && u ? [u] : []);
  B(() => {
    o && u && f([u]);
  }, [u]);
  const x = Ae(null);
  yr(i, () => ({
    resetSelection() {
      f(o && u ? [u] : []), r([]);
    }
  })), B(() => {
    const b = (v) => {
      x.current && !x.current.contains(v.target) && l(!1);
    };
    return document.addEventListener("mousedown", b), () => {
      document.removeEventListener("mousedown", b);
    };
  }, []);
  const g = (b, v) => {
    b.stopPropagation();
    const S = p.some(
      (w) => w.value === v.value
    );
    let y;
    S ? y = p.filter(
      (w) => w.value !== v.value
    ) : v.value === Ks ? y = [v] : y = [
      ...p.filter((w) => w.value !== Ks),
      v
    ], y.length === 0 && (y = o && u ? [u] : []), f(y), r(
      y.filter((w) => w.value !== Ks).map((w) => w.value)
    );
  }, N = (b, v) => {
    b.key === "Enter" && g(b, v);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: `${n}`, ref: x, children: [
    /* @__PURE__ */ e.jsx("label", { className: "block text-sm font-medium text-neutral-950", children: t }),
    /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ e.jsxs(
        "button",
        {
          tabIndex: 0,
          className: `border-1 active-visible:ring mt-2 flex h-12 w-full cursor-pointer items-center justify-between rounded-sm border border-neutral-500 bg-white py-2 pl-3 focus:border-neutral-950 focus:outline-neutral-900 focus:ring-offset-2 focus-visible:ring active:border-neutral-500 active:outline-neutral-900 active:ring-offset-2 ${d ? "border-2 border-neutral-950 outline-neutral-950 ring ring-offset-2" : ""}`,
          onClick: () => l(!d),
          children: [
            /* @__PURE__ */ e.jsx("div", { className: "flex overflow-hidden", children: p.length > 1 ? /* @__PURE__ */ e.jsxs("div", { className: "flex items-center truncate", children: [
              /* @__PURE__ */ e.jsx("span", { children: p.slice(0, 2).map((b) => b.label).join(", ") }),
              /* @__PURE__ */ e.jsx("span", { children: `...(${p.length}st)` })
            ] }) : p.map((b, v) => /* @__PURE__ */ e.jsxs(
              "div",
              {
                className: `${v < p.length - 1 ? "mr-1" : ""}`,
                children: [
                  b.label,
                  v < p.length - 1 && ","
                ]
              },
              b.value
            )) }),
            /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
              so,
              {
                role: "button",
                className: "pointer-events-none flex h-6 w-6 items-center pr-3 align-middle text-neutral-500"
              }
            ) })
          ]
        }
      ),
      d && /* @__PURE__ */ e.jsx("div", { className: "absolute left-0 top-12 z-10 mt-1 w-full rounded-md border-2 border-neutral-950 bg-white", children: h == null ? void 0 : h.map((b, v) => /* @__PURE__ */ e.jsx(
        yd,
        {
          option: b,
          handleCheckBox: N,
          handleOptionClick: g,
          selectedOptions: p,
          mode: a
        },
        v
      )) })
    ] })
  ] });
}
const Rr = Bs.forwardRef(jd), Cd = ({
  onAgreementChange: t,
  hideCommuter: s
}) => {
  const { contracts: n } = hd(), {
    query: { contract: r }
  } = se();
  B(() => {
    t(r ? [r] : []);
  }, [r, t]);
  const { t: a } = O(["common"], {
    nsMode: "fallback"
  }), o = zo(
    a,
    n,
    s
  );
  return r ? /* @__PURE__ */ e.jsxs("div", { className: "w-full  md:self-start ", children: [
    /* @__PURE__ */ e.jsx("label", { className: "block text-sm font-medium text-neutral-950", children: a("form.labels.contract") }),
    /* @__PURE__ */ e.jsx("div", { className: "md:pt-2", children: r })
  ] }) : !r && (o == null ? void 0 : o.length) > 1 ? /* @__PURE__ */ e.jsx(
    Rr,
    {
      className: "w-full ",
      label: a("form.labels.contract"),
      options: o,
      onChange: t,
      showAll: !0
    }
  ) : null;
}, $r = ({ status: t }) => {
  const { t: s } = O("account");
  return t ? /* @__PURE__ */ e.jsxs(
    $,
    {
      className: He(
        "flex flex-col items-center gap-2 rounded px-3 py-2 text-center md:px-5 md:py-5",
        t.backgroundColor
      ),
      children: [
        /* @__PURE__ */ e.jsx(no, { height: "30px", width: "30px" }),
        /* @__PURE__ */ e.jsx(k, { intent: "body", children: s(`${t.translationKey}.title`) }),
        /* @__PURE__ */ e.jsx(k, { intent: "body", children: s(`${t.translationKey}.description`) })
      ]
    }
  ) : null;
}, Nd = (t) => {
  if (t)
    switch (t.status) {
      case Z.customerStatus.inactive:
        return {
          backgroundColor: "bg-red-300",
          translationKey: "dashboard.inactive"
        };
      case Z.customerStatus.pending:
        return {
          backgroundColor: "bg-yellow-200",
          translationKey: "dashboard.pending"
        };
      case Z.customerStatus.pendingInvoice:
        return {
          backgroundColor: "bg-yellow-200",
          translationKey: "dashboard.pending_invoice"
        };
      case Z.customerStatus.cardExpired:
      case Z.customerStatus.blocked:
        return {
          backgroundColor: "bg-red-300",
          translationKey: "dashboard.blocked"
        };
      default:
        return;
    }
}, wd = (t) => t === "email", kd = ({
  labels: t,
  namespace: s,
  defaultValues: n,
  helpTexts: r
}) => {
  const { registerField: a, getError: o } = he({
    namespace: s,
    defaultValues: n
  }), [i] = Ee(s, "addressType");
  return /* @__PURE__ */ e.jsxs("div", { className: "xs:w-full md:65ch", children: [
    /* @__PURE__ */ e.jsx(
      Tc,
      {
        ...a("addressType"),
        choices: [
          {
            label: t.address,
            value: "address",
            helpText: r.address
          },
          {
            label: t.email,
            value: "email",
            helpText: r.email
          }
        ],
        error: o("addressType"),
        sx: {
          flexDirection: "column",
          maxWidth: "65ch",
          "label span": {
            fontWeight: "fontWeights.medium",
            lineHeight: "lineHeights.500"
          }
        },
        singleColumn: !0
      }
    ),
    wd(i) ? /* @__PURE__ */ e.jsx(rs, { template: "two-column", children: /* @__PURE__ */ e.jsx(jt, { children: /* @__PURE__ */ e.jsx(
      es,
      {
        type: "email",
        label: t.email,
        error: o("email"),
        ...a("email")
      }
    ) }) }) : null
  ] });
}, Pd = (t, { addressType: s, email: n }) => s === "address" ? { contractNo: t } : { contractNo: t, email: n }, Td = ({
  contract: t,
  onClose: s
}) => {
  const n = Le(), r = Ae(null), { t: a } = O(["account", "common"], {
    nsMode: "fallback"
  }), [o, i] = M(!1), { mutateAsync: d, isLoading: l } = fe(
    ["change", "specification"],
    ({ Contract: x }) => x.changeSpecification,
    {
      onError: () => i(!0),
      onSuccess: () => {
        n.invalidateQueries(ee.Agreements()), s();
      }
    }
  ), { handleSubmit: c, resetData: m, validate: u, isDirty: h, isValid: p } = he(
    {
      namespace: "editBillingAddress",
      onSubmit: async (x) => {
        const g = Pd(t.contractNo, x);
        await d(g);
      },
      onValidate: (x) => {
        if (x.addressType === "email" && !x.email)
          return { email: a("form.validations.email.required") };
      }
    }
  ), f = D(
    () => !h || !p || l,
    [h, p, l]
  );
  return B(
    () => () => {
      i(!1), m();
    },
    [i, m]
  ), /* @__PURE__ */ e.jsxs(on, { ariaLabelledBy: "title", ariaDescribedBy: "description", open: !0, children: [
    /* @__PURE__ */ e.jsx(ln, { closeLabel: a("action.close"), onClose: s, children: /* @__PURE__ */ e.jsx(
      Y,
      {
        id: "title",
        variant: "paragraph",
        mt: "spacing.200",
        mb: "spacing.100",
        as: "h2",
        sx: { color: "colors.neutral.100" },
        children: a("agreement.action.editBillingAddress")
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      Fn,
      {
        onSubmit: Nt(u, c),
        onReset: s,
        ref: r,
        children: /* @__PURE__ */ e.jsxs(Ut, { children: [
          o && /* @__PURE__ */ e.jsx(zt, { variant: "error", children: a("errors.generic") }),
          /* @__PURE__ */ e.jsx(
            kd,
            {
              namespace: "editBillingAddress",
              labels: {
                address: a("form.labels.postalAddress"),
                email: a("form.labels.email")
              },
              helpTexts: {
                address: a("agreement.invoice.helpTexts.postalAddress"),
                email: a("agreement.invoice.helpTexts.email")
              },
              defaultValues: {
                addressType: t.billingAddressType,
                email: t.billingAddressType === "email" ? t.contractEmail : void 0
              }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Rt,
            {
              actionButtonType: "submit",
              cancelButtonType: "reset",
              actionLabel: a("action.update"),
              cancelLabel: a("action.cancel"),
              loadingLabel: a("action.loading"),
              isLoading: l,
              disabled: f,
              loadingButton: !0
            }
          )
        ] })
      }
    )
  ] });
}, Sd = ({ text: t }) => /* @__PURE__ */ e.jsx(
  Y,
  {
    id: "title",
    as: "h2",
    variant: "paragraph",
    sx: { color: "colors.white" },
    children: t
  }
);
function Ps() {
  const { t } = O("common"), { isOnLastStep: s, close: n } = Cs();
  return {
    actionLabel: D(
      () => t(s ? "action.complete" : "action.continue"),
      [t, s]
    ),
    cancelLabel: t("action.cancel"),
    close: n
  };
}
const Md = ({
  formattedPrice: t,
  agreementType: s
}) => {
  const { t: n } = O("common"), { actionLabel: r, cancelLabel: a, close: o } = Ps(), i = D(
    () => n(`agreementTypes.${s}.badge`),
    [n, s]
  );
  return /* @__PURE__ */ e.jsxs(cn, { children: [
    /* @__PURE__ */ e.jsx(Y, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: /* @__PURE__ */ e.jsx(G, { ns: "common", i18nKey: `agreementTypes.${s}.badge`, children: /* @__PURE__ */ e.jsx(
      Y,
      {
        as: "span",
        variant: "small",
        sx: { fontWeight: "fontWeights.bold" }
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(Y, { variant: "small", children: /* @__PURE__ */ e.jsxs(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.introductionStep.description",
        values: {
          agreementType: i
        },
        children: [
          /* @__PURE__ */ e.jsx(
            Y,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Y,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsxs("div", { className: "my-3 flex flex-col", children: [
      /* @__PURE__ */ e.jsx(Y, { as: "span", mt: 0, sx: { fontSize: "fontSizes.100" }, children: n("form.labels.price") }),
      /* @__PURE__ */ e.jsx(
        Y,
        {
          variant: "h3",
          mt: 0,
          sx: { color: "colors.primary.600", fontSize: "fontSizes.300" },
          children: t
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      fs,
      {
        actionLabel: r,
        cancelLabel: a,
        onClose: o
      }
    )
  ] });
}, zd = () => {
  const { t } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Y, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: t("agreement.addAgreementModal.recognitionStep.label") }),
    /* @__PURE__ */ e.jsx(Y, { variant: "small", children: t("agreement.addAgreementModal.recognitionStep.recognitionsLoading") }),
    /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center p-6", children: /* @__PURE__ */ e.jsx("div", { className: " w-6", children: /* @__PURE__ */ e.jsx(At, { "aria-label": t("action.loading") }) }) })
  ] });
}, Ad = ({
  agreementTypeLabel: t
}) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Y, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: s("agreement.addAgreementModal.recognitionStep.noRecognitions") }),
    /* @__PURE__ */ e.jsx(zt, { variant: "inform", children: /* @__PURE__ */ e.jsx(Y, { variant: "small", children: /* @__PURE__ */ e.jsxs(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.recognitionStep.recognitionsRequired",
        values: {
          agreementType: t
        },
        children: [
          /* @__PURE__ */ e.jsx(
            Y,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Y,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Y,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          )
        ]
      }
    ) }) })
  ] });
}, ba = ({
  contractLineNo: t,
  registrationNo: s,
  serialNo: n,
  reference: r,
  recognitionType: a
}) => a === "bizz" ? { key: t, value: r || n } : { key: t, value: r || s }, Od = ({
  agreementTypeLabel: t,
  oneRecognitionOnly: s,
  recognitions: n
}) => {
  const { t: r } = O(["account", "common"], {
    nsMode: "fallback"
  }), { registerField: a, getError: o, lookupFieldData: i } = he({
    namespace: "add-contract"
  }), d = D(() => s ? r("form.labels.recognition") : r("form.labels.multipleRecognitions", { replace: { number: 1 } }), [s, r]);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Y, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: r("agreement.addAgreementModal.recognitionStep.label") }),
    /* @__PURE__ */ e.jsx(Y, { variant: "small", children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.recognitionStep.description",
        values: {
          agreementType: t
        },
        children: /* @__PURE__ */ e.jsx(
          Y,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.medium" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsxs(rs, { template: "two-column", children: [
      /* @__PURE__ */ e.jsx(Fs, { column: "1", children: /* @__PURE__ */ e.jsx(
        jn,
        {
          ...a("recognitions.recognition1"),
          label: d,
          error: o("recognitions.recognition1"),
          children: n.filter(
            (l) => String(l.contractLineNo) !== i("recognitions.recognition2")
          ).map((l) => {
            const { key: c, value: m } = ba(l);
            return /* @__PURE__ */ e.jsx(Cn, { value: c, children: m }, c);
          })
        }
      ) }),
      !s && /* @__PURE__ */ e.jsx(Fs, { column: { xs: "1", md: "3" }, children: /* @__PURE__ */ e.jsx(
        jn,
        {
          ...a("recognitions.recognition2"),
          label: r("form.labels.multipleRecognitions", {
            replace: { number: 2 }
          }),
          error: o("recognitions.recognition2"),
          children: n.filter(
            (l) => String(l.contractLineNo) !== i("recognitions.recognition1")
          ).map((l) => {
            const { key: c, value: m } = ba(l);
            return /* @__PURE__ */ e.jsx(Cn, { value: c, children: m }, c);
          })
        }
      ) })
    ] })
  ] });
}, Ao = (t) => t === Z.OresundGo, Ed = (t) => t === Z.OresundBusiness, Dd = (t) => !t || t.length < 2, va = (t) => t === Z.OresundBusinessPendler, Oo = (t) => t === Z.OresundPendler, pr = (t) => Ao(t) || Oo(t), Fd = (t) => Ao(t) || Ed(t), ya = ["open", "closed", "blocked", "pending"], Ld = (t, s) => {
  const n = ya.indexOf(t), r = ya.indexOf(s);
  return n - r;
}, Vd = (t, s) => Number(s.isOSB) - Number(t.isOSB);
function Rd() {
  const { recognitions: t, loading: s } = Lr(20);
  return !t || s ? {
    loading: s,
    recognitions: []
  } : {
    loading: !1,
    recognitions: [...t].sort((r, a) => {
      const o = Ld(r.lineStatus, a.lineStatus);
      return o !== 0 ? o : Vd(r, a);
    })
  };
}
const $d = ({
  agreementTypeLabel: t,
  oneRecognitionOnly: s,
  recognitions: n,
  namespace: r
}) => !n || n.length === 0 ? /* @__PURE__ */ e.jsx(Ad, { agreementTypeLabel: t }) : /* @__PURE__ */ e.jsx(
  Od,
  {
    recognitions: n,
    agreementTypeLabel: t,
    namespace: r,
    oneRecognitionOnly: s
  }
), Bd = ({
  onValidate: t,
  agreementType: s,
  namespace: n
}) => {
  const { t: r } = O(["account", "common"], {
    nsMode: "fallback"
  }), { validate: a, isValid: o } = he({
    namespace: "add-contract",
    onValidate: t
  }), i = D(
    () => r(`agreementTypes.${s}.label`),
    [s, r]
  ), { recognitions: d, loading: l } = Rd(), c = D(() => {
    const p = Oo(s), f = Dd(d);
    return p || f;
  }, [d, s]), { actionLabel: m, cancelLabel: u, close: h } = Ps();
  return /* @__PURE__ */ e.jsxs(cn, { children: [
    l ? /* @__PURE__ */ e.jsx(zd, {}) : $d({
      agreementTypeLabel: i,
      recognitions: d,
      oneRecognitionOnly: c,
      namespace: n
    }),
    /* @__PURE__ */ e.jsx(
      fs,
      {
        actionLabel: m,
        cancelLabel: u,
        action: a,
        disabled: !o,
        onClose: h
      }
    )
  ] });
}, Id = ({ onValidate: t }) => {
  const { t: s } = O("account"), { registerField: n, validate: r, getError: a, isValid: o } = he({
    namespace: "add-contract",
    onValidate: t
  }), { actionLabel: i, cancelLabel: d, close: l } = Ps();
  return /* @__PURE__ */ e.jsxs(cn, { children: [
    /* @__PURE__ */ e.jsx(Y, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.newsLetterStep.label",
        children: /* @__PURE__ */ e.jsx(
          Y,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.bold" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(Y, { variant: "small", children: /* @__PURE__ */ e.jsxs(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.newsLetterStep.description",
        children: [
          /* @__PURE__ */ e.jsx(
            Y,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Y,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx("div", { className: "my-3", children: /* @__PURE__ */ e.jsx(
      es,
      {
        label: s("agreement.addAgreementModal.newsLetterStep.subscribe"),
        ...n("subscribe", { type: "checkbox", value: "true" }),
        error: a("subscribe")
      }
    ) }),
    /* @__PURE__ */ e.jsx(Y, { variant: "small", children: s("agreement.addAgreementModal.newsLetterStep.unsubscribe") }),
    /* @__PURE__ */ e.jsx(
      fs,
      {
        actionLabel: i,
        cancelLabel: d,
        action: r,
        disabled: !o,
        onClose: l
      }
    )
  ] });
}, _d = {
  sv: "SEK",
  da: "DKK"
}, Wd = {
  sv: "sv-SE",
  da: "da-DK",
  de: "de-DE",
  en: "en-UK"
}, ss = (t) => _d[t] || "DKK", Bn = (t, s, n) => new Intl.NumberFormat(Wd[s || ""] || "sv-SE", {
  style: "currency",
  currency: n || ss(s || ""),
  currencyDisplay: "code"
}).format(t), qd = {
  sv: {
    place: "stallen",
    order: "bestall",
    help: "hjalp",
    about: "om",
    guides: "hjalp/guide",
    licensPlate: "hjalp/guide/betaling-med-registreringsnummer",
    payWithBizz: "hjalp/guide/betalning-med-bizz",
    termsAndConditions: "om/villkor-och-regler",
    faq: "hjalp/faq",
    orderContract: "bestall",
    privacyPolicy: "om/villkor-och-regler/personuppgiftspolicy",
    cookiePolicy: "om/villkor-och-regler/cookie-policy",
    customerService: "hjalp/kontakt",
    whistleBlower: "hjalp/whistleblower",
    kmToll: "vagavgift",
    prePaid: "vagskatt-danmark/ruttbiljett",
    privatePayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/5Zlvr5TZAOyy8xxQNMcxSt/5057c90316f81b12dda650e1e22364cb/8573_OresundPay_Aftalevilkar_SE2.pdf",
    businessPayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/2XYUULaLgWBzd34QC3lLtt/92d542c9e227f26f05c48fad4902344c/8573_OresundPay_Business_SE2.pdf",
    installationGuide: "vagavgift/manualer5310"
  },
  en: {
    place: "places",
    order: "order",
    help: "help",
    about: "about",
    guides: "help/guide",
    licensPlate: "help/guide/payment-by-number-plate",
    payWithBizz: "help/guide/paying-with-bizz",
    termsAndConditions: "about/terms-and-conditions",
    faq: "help/faq",
    orderContract: "order",
    privacyPolicy: "about/terms-and-conditions/personal-data-policy",
    cookiePolicy: "about/terms-and-conditions/cookie-policy",
    customerService: "help/contact",
    whistleBlower: "help/whistleblower",
    kmToll: "roadtoll",
    prePaid: "roadtax-denmark/routeticket",
    privatePayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/5Zlvr5TZAOyy8xxQNMcxSt/3c7d44c95048dd501177cfb484979e27/8573_OresundPay_Aftalevilkar_UK2.pdf",
    businessPayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/2XYUULaLgWBzd34QC3lLtt/19ce0287810a50c05c43dffef069599e/8573_OresundPay_Business_UK2.pdf",
    installationGuide: "roadtoll/usermanuals5310"
  },
  da: {
    place: "steder",
    order: "bestil",
    help: "hjaelp",
    about: "om",
    guides: "hjaelp/guide",
    licensPlate: "hjaelp/guide/betaling-med-nummerplade",
    payWithBizz: "hjaelp/guide/betaling-med-bizz",
    termsAndConditions: "om/vilkaar-og-betingelser",
    faq: "hjaelp/faq",
    orderContract: "bestil",
    privacyPolicy: "om/vilkaar-og-betingelser/persondatapolitik",
    cookiePolicy: "om/vilkaar-og-betingelser/cookie-policy",
    customerService: "hjaelp/kontakt",
    whistleBlower: "hjaelp/whistleblower",
    kmToll: "vejafgift",
    prePaid: "vejskat-danmark/rutebillet",
    privatePayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/5Zlvr5TZAOyy8xxQNMcxSt/e8e3b52314424ecbc8ab46403694e1ee/8573_OresundPay_Aftalevilkar_DK2.pdf",
    businessPayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/2XYUULaLgWBzd34QC3lLtt/18d7353a09351f5b4c3f19bd0a04e789/8573_OresundPay_Business_DK2.pdf",
    installationGuide: "vejafgift/manualer5310"
  },
  no: {
    place: "steder",
    order: "bestill",
    help: "hjelp",
    about: "om",
    guides: "hjelp/guide",
    licensPlate: "hjelp/guide/betaling-med-registreringsnummer",
    payWithBizz: "hjelp/guide/betaling-med-bizz",
    termsAndConditions: "om/vilkar-og-betingelser",
    faq: "hjelp/faq",
    orderContract: "bestill",
    privacyPolicy: "om/vilkar-og-betingelser/personopplysningspolicy",
    cookiePolicy: "om/vilkar-og-betingelser/cookie-policy",
    customerService: "hjelp/kontakt",
    whistleBlower: "hjelp/whistleblowser",
    kmToll: "veiavgift",
    prePaid: "veiskatt-danmark/rutebillett",
    privatePayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/5Zlvr5TZAOyy8xxQNMcxSt/c9abce08d0b81605141084bcc798aca2/8573_OresundPay_Aftalevilkar_UK2.pdf",
    businessPayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/2XYUULaLgWBzd34QC3lLtt/7ac594a7f25dfe267960caa70d3f3827/8573_OresundPay_Business_UK2.pdf",
    installationGuide: "roadtoll/usermanuals5310"
  }
}, Hd = {
  en: {
    goTerms: "terms-info/agreement-oresundgo-oresundcommuter",
    businessTerms: "terms-info/agreement-oresundbusiness-oresundcommuter-for-business",
    faq: "customerservice/faq",
    howOresundGoWorks: "kundeservice/faq/oresundgo/hvordan-fungerer-oresundgo"
  },
  sv: {
    goTerms: "avtalsvillkor-info/agreement-oresundgo-oresundcommuter",
    businessTerms: "avtalsvillkor-info/avtal-oresundbusiness-oresundpendlare-for-foretag",
    faq: "kundservice/faq",
    howOresundGoWorks: "kundservice/faq/oresundgo/hur-fungerar-oresundgo"
  },
  da: {
    goTerms: "aftalevilkar-info/fftalevilkar-oresundgo-oresundpendler",
    businessTerms: "aftalevilkar-info/aftale-oresundbusiness-oresundpendler-for-virksomheder",
    faq: "kundeservice/faq",
    howOresundGoWorks: "kundeservice/faq/oresundgo/hvordan-fungerer-oresundgo"
  }
};
function kn(t, s, n) {
  const r = Hd[t][s];
  return `${n}/${t}/${r}`;
}
function Jt(t) {
  const { locale: s, key: n } = t, r = qd[s][n];
  return "url" in t ? `${t.url}/${s}/${r}` : r;
}
const Ud = {
  sv: "https://storebaelt.dk/en/privacy-policy-for-storebaelt-dk/",
  da: "https://storebaelt.dk/privatlivspolitik-for-storebaelt-dk/",
  en: "https://storebaelt.dk/en/privacy-policy-for-storebaelt-dk/"
}, In = ({
  type: t,
  ...s
}) => {
  const { locale: n } = se(), r = D(() => t === Z.Storebelt ? Ud[n] : Jt({
    locale: n,
    key: "privacyPolicy",
    skipBase: !0
  }), [n, t]);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: r && /* @__PURE__ */ e.jsx(mt, { ...s, href: r, target: "_blank" }) });
}, Eo = Ct(
  void 0
), Do = Ct(
  void 0
), Fo = Ct(
  {}
), Lo = Ct(void 0), Vo = Ct(void 0), Gd = Ct(void 0);
var ot = /* @__PURE__ */ ((t) => (t.Oresundsbron = "oresundsbron.com", t.OresundPay = "oresundpay.com", t.InternalTools = "tools.oresundsbron.com", t))(ot || {});
const wg = ({
  appData: t,
  i18n: s,
  router: n,
  api: r,
  contentful: a,
  children: o,
  queryClient: i,
  context: d,
  authStore: l,
  contractsStore: c,
  localeStore: { getDateLocale: m },
  flags: u,
  contentRequest: h,
  signUpStore: p
}) => /* @__PURE__ */ e.jsx(Eo.Provider, { value: { appData: t }, children: /* @__PURE__ */ e.jsx(zr.Provider, { value: { i18n: s, lng: (s == null ? void 0 : s.language) || "en" }, children: /* @__PURE__ */ e.jsx(Vn.Provider, { value: n, children: /* @__PURE__ */ e.jsx(gc, { contentful: a, api: r, children: /* @__PURE__ */ e.jsx(kc, { client: i, children: /* @__PURE__ */ e.jsx(Sc, { context: d, children: /* @__PURE__ */ e.jsx(ko.Provider, { value: l, children: /* @__PURE__ */ e.jsx(Vo.Provider, { value: c, children: /* @__PURE__ */ e.jsx(Do.Provider, { value: { getDateLocale: m }, children: /* @__PURE__ */ e.jsx(Gd.Provider, { value: p, children: /* @__PURE__ */ e.jsx(Fo.Provider, { value: u, children: /* @__PURE__ */ e.jsx(
  Lo.Provider,
  {
    value: { contentRequest: h },
    children: o
  }
) }) }) }) }) }) }) }) }) }) }) }), Ye = () => {
  const t = at(Eo);
  if (!t)
    throw new Error("useAppCommon must be used within an AppCommonProvider");
  const {
    appData: { app: s, baseURL: n, apiUrl: r, apiSecret: a, oresundPayBase: o }
  } = t;
  return {
    app: s,
    baseURL: n || "",
    apiUrl: r || "",
    apiSecret: a || "",
    oresundPayBase: o || ""
  };
}, Kd = {
  sv: "https://storebaelt.dk/en/terms-and-conditions/",
  da: "https://storebaelt.dk/vilkar-og-betingelser/",
  en: "https://storebaelt.dk/en/terms-and-conditions/"
}, _n = ({
  type: t,
  children: s,
  isOresundPay: n,
  ...r
}) => {
  const { locale: a } = se(), { baseURL: o } = Ye(), i = D(() => {
    if (t === Z.Storebelt)
      return Kd[a] || void 0;
    if (n)
      switch (t) {
        case Z.OresundGo:
        case Z.OresundPendler:
          return Jt({
            locale: a,
            key: "privatePayTerms",
            skipBase: !0
          });
        case Z.OresundBusiness:
        case Z.OresundPAYBusiness:
          return Jt({
            locale: a,
            key: "businessPayTerms",
            skipBase: !0
          });
      }
    switch (t) {
      case Z.OresundGo:
        return kn(a, "goTerms", o);
      case Z.OresundBusiness:
        return kn(a, "businessTerms", o);
      case Z.OresundPAY:
        return Jt({
          locale: a,
          key: "privatePayTerms",
          skipBase: !0
        });
      case Z.OresundPAYBusiness:
        return Jt({
          locale: a,
          key: "businessPayTerms",
          skipBase: !0
        });
    }
  }, [a, t, n]);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: i && /* @__PURE__ */ e.jsx(mt, { ...r, href: i, target: "_blank", children: s }) });
}, Ro = { status: "initial" }, mn = Ns(() => Ro), Zd = (t) => mn.setState({ status: "success", contractNo: t }), Yd = (t) => mn.setState({ status: "error", error: t }), Qd = () => mn.setState(Ro), Xd = ({
  formattedPrice: t,
  updatePrice: s,
  onValidate: n,
  contract: r
}) => {
  const { t: a } = O(["account", "common"], {
    nsMode: "fallback"
  }), { status: o } = mn(), { locale: i } = se(), d = D(() => ss(i || ""), [i]), l = Le(), { mutateAsync: c } = fe(
    ["price", "signup", "validate"],
    ({ Price: A }) => A.signup,
    {
      onSuccess: (A, F) => {
        l.setQueryData(
          ee.PriceSignup(F),
          () => A
        );
      }
    }
  ), { mutateAsync: m, isLoading: u } = fe(
    ["contract", "convert"],
    ({ Contract: A }) => A.convert,
    {
      onError: () => {
        Yd(a("errors.generic"));
      },
      onSuccess: (A) => {
        l.invalidateQueries(ee.CustomerInformation()), l.invalidateQueries({
          queryKey: ee.AllContracts()
        }), l.invalidateQueries(ee.AllAgreements), Zd(A.contractNo);
      }
    }
  ), h = L(
    async (A) => {
      const F = {
        locale: i || "",
        currency: d,
        contractType: r.agreementType,
        campaignCode: A
      };
      return await c(F);
    },
    [c, d, i, r.agreementType]
  ), {
    registerField: p,
    validate: f,
    getError: x,
    isValid: g,
    setFieldErrors: N,
    setFieldData: b,
    getData: v
  } = he({
    namespace: "add-contract",
    onValidate: n
  }), [S] = Ee(
    "add-contract",
    "campaignCode"
  ), y = L(
    async (A) => {
      try {
        const F = await h(A);
        if (!F) {
          N({
            campaignCode: a("form.validations.campaignCode.invalid")
          });
          return;
        }
        const [R] = F;
        s(
          Js(R.priceInclVAT, R.currency)
        ), b("campaignCode", A, "");
      } catch {
        N({
          campaignCode: a("form.validations.campaignCode.invalid")
        });
      }
    },
    [h, b, N, a, s]
  ), w = L(async () => {
    try {
      if (!f())
        throw new Error("Validation failed");
      const {
        recognitions: F = {},
        subscribe: R = "",
        campaignCode: T = ""
      } = v(), P = {
        attachRecognitions: Object.values(F).map(Number),
        contractNo: r.contractNo,
        newAgreementType: r.agreementType,
        subscribe: R === "true",
        campaignCode: T,
        commuterName: "",
        commuterEmail: "",
        startDate: void 0
      };
      return await m(P), !0;
    } catch {
      return !1;
    }
  }, [
    f,
    r.contractNo,
    r.agreementType,
    m,
    v
  ]), { actionLabel: z, cancelLabel: C, close: E } = Ps();
  return /* @__PURE__ */ e.jsxs(cn, { children: [
    /* @__PURE__ */ e.jsx(Y, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: a("agreement.addAgreementModal.termsOfAgreementStep.label") }),
    /* @__PURE__ */ e.jsx(Y, { variant: "small", children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.termsOfAgreementStep.billing",
        children: /* @__PURE__ */ e.jsx(
          Y,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.medium" }
          }
        )
      }
    ) }),
    pr(r.agreementType) ? /* @__PURE__ */ e.jsx(rs, { template: "two-column", children: /* @__PURE__ */ e.jsx(jt, { children: /* @__PURE__ */ e.jsx(
      es,
      {
        label: a("action.campaignCode"),
        error: x("campaignCode"),
        adornment: /* @__PURE__ */ e.jsx(Mc, { children: /* @__PURE__ */ e.jsx(
          _t,
          {
            type: "button",
            icon: cs,
            variant: "text",
            onClick: () => y(S),
            disabled: !S || !g
          }
        ) }),
        ...p("campaignCode")
      }
    ) }) }) : null,
    /* @__PURE__ */ e.jsxs("div", { className: "my-3 flex flex-col", children: [
      /* @__PURE__ */ e.jsx(Y, { as: "span", mt: 0, sx: { fontSize: "fontSizes.100" }, children: a("agreement.addAgreementModal.labels.price") }),
      /* @__PURE__ */ e.jsx(
        Y,
        {
          variant: "h3",
          mt: 0,
          sx: { color: "colors.primary.400", fontSize: "fontSizes.300" },
          children: t
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "my-3", children: /* @__PURE__ */ e.jsx(
      es,
      {
        label: a(
          "agreement.addAgreementModal.termsOfAgreementStep.termsOfAgreement"
        ),
        ...p("termsOfAgreement", {
          type: "checkbox",
          value: "true"
        }),
        error: x("termsOfAgreement")
      }
    ) }),
    /* @__PURE__ */ e.jsx(Y, { variant: "small", children: /* @__PURE__ */ e.jsxs(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.termsOfAgreementStep.readMore",
        children: [
          /* @__PURE__ */ e.jsx(
            _n,
            {
              type: pr(r.agreementType) ? Z.OresundGo : Z.OresundBusiness
            }
          ),
          /* @__PURE__ */ e.jsx(In, {})
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      fs,
      {
        actionLabel: z,
        cancelLabel: C,
        action: () => w,
        onClose: E,
        disabled: !g || u || o === "error",
        loadingLabel: a("action.loading"),
        isLoading: u,
        loadingButton: !0
      }
    )
  ] });
}, Jd = (t) => !!t && typeof t == "object" && t.success === !1, em = (t) => t.path.join("."), tm = (t) => (s) => {
  const n = {};
  for (const r of s.issues) {
    const a = em(r), o = t(r.message);
    if (!n[a])
      n[a] = o;
    else {
      const i = n[a];
      n[a] = Array.isArray(i) ? [...i, o] : [i, o];
    }
  }
  return n;
}, $t = (t, s = (n) => n) => async (n) => {
  try {
    const r = await t(n);
    if (Jd(r)) {
      const a = tm(s)(r.error) || {};
      return Object.keys(a).length > 0 ? a : void 0;
    }
    return;
  } catch {
    return;
  }
}, Ts = (t, s = (n) => n) => (n) => $t(t, s)(n), sm = (t, s = "") => {
  var a, o;
  const n = {}, r = Object.entries(t.shape());
  for (const [i, d] of r) {
    const l = s ? `${s}.${i}` : i, c = (o = (a = d._def) == null ? void 0 : a.schema) == null ? void 0 : o._def;
    c != null && c.shape ? Object.assign(n, sm(c, i)) : n[l] = !d.isOptional();
  }
  return n;
}, Gt = () => (...t) => (s) => Object.entries(s).filter(
  ([r]) => t.includes(r)
).reduce((r, [a, o]) => ({ ...r, [a]: o }), {}), ja = Gt()("licensePlate", "country"), nm = ({ namespace: t }) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  }), n = kt(), r = ks(), a = L(
    (p) => {
      const f = ja(p);
      return r({
        licensePlate: s("form.validations.licensePlate.exist")
      })(f);
    },
    [s, r]
  ), o = L(
    async (p) => {
      try {
        const f = await $t(
          Xl.spa,
          s
        )(p), x = ja(p);
        return await a(x), f;
      } catch {
        return;
      }
    },
    [s, a]
  ), { registerField: i, getError: d, isValid: l, validate: c } = he({
    namespace: t,
    onValidate: o
  }), { actionLabel: m, cancelLabel: u, close: h } = Ps();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Y, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: s("agreement.addAgreementModal.commuterVehicleStep.label") }),
    /* @__PURE__ */ e.jsx(Y, { variant: "small", sx: { maxWidth: "65ch" }, children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.commuterVehicleStep.description",
        children: /* @__PURE__ */ e.jsx(
          Y,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.medium" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsxs(rs, { template: "two-column", children: [
      /* @__PURE__ */ e.jsx(jt, { children: /* @__PURE__ */ e.jsx(
        jn,
        {
          label: s("form.labels.country"),
          error: d("country"),
          ...i("country"),
          children: n.map(({ key: p, value: f }) => /* @__PURE__ */ e.jsx(Cn, { children: f }, p))
        }
      ) }),
      /* @__PURE__ */ e.jsx(jt, { odd: !0, children: /* @__PURE__ */ e.jsx(
        es,
        {
          label: s("form.labels.licensePlate"),
          error: d("licensePlate"),
          ...i("licensePlate")
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(
      fs,
      {
        actionLabel: m,
        cancelLabel: u,
        action: c,
        disabled: !l,
        onClose: h
      }
    )
  ] });
}, rm = ({
  namespace: t
}) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  }), { registerField: n, getError: r, isValid: a, validate: o } = he({
    namespace: t,
    onValidate: (c) => $t(Jl.spa, s)(c)
  }), { actionLabel: i, cancelLabel: d, close: l } = Ps();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Y, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: s("agreement.addAgreementModal.businessCommuterStep.label") }),
    /* @__PURE__ */ e.jsx(Y, { variant: "small", children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.businessCommuterStep.description",
        children: /* @__PURE__ */ e.jsx(
          Y,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.medium" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsxs(rs, { template: "two-column", children: [
      /* @__PURE__ */ e.jsx(jt, { children: /* @__PURE__ */ e.jsx(
        es,
        {
          label: s("form.labels.firstName"),
          error: r("firstName"),
          ...n("firstName")
        }
      ) }),
      /* @__PURE__ */ e.jsx(jt, { odd: !0, children: /* @__PURE__ */ e.jsx(
        es,
        {
          label: s("form.labels.lastName"),
          error: r("lastName"),
          ...n("lastName")
        }
      ) }),
      /* @__PURE__ */ e.jsx(jt, { full: !0, children: /* @__PURE__ */ e.jsx(
        es,
        {
          label: s("form.labels.email"),
          error: r("email"),
          ...n("email")
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(
      fs,
      {
        actionLabel: i,
        cancelLabel: d,
        action: o,
        disabled: !a,
        onClose: l
      }
    )
  ] });
}, am = ({
  agreementType: t
}) => {
  const { t: s } = O("common"), { actionLabel: n, cancelLabel: r } = Ps();
  return /* @__PURE__ */ e.jsxs(cn, { children: [
    /* @__PURE__ */ e.jsx(Y, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.confirmationStep.label",
        values: {
          agreementType: s(`agreementTypes.${t}.label`)
        },
        children: /* @__PURE__ */ e.jsx(
          Y,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.bold" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(Y, { variant: "small", children: /* @__PURE__ */ e.jsxs(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.confirmationStep.description",
        values: {
          agreementType: s(`agreementTypes.${t}.label`)
        },
        children: [
          /* @__PURE__ */ e.jsx(
            Y,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Y,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Y,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      fs,
      {
        actionLabel: n,
        cancelLabel: r,
        removeCancelButton: !0
      }
    )
  ] });
}, om = ({
  onClose: t,
  contract: s,
  onSuccess: n
}) => {
  const r = mn(), [a, o] = M(""), { t: i } = O(["account", "common"], { nsMode: "fallback" }), { locale: d } = se(), { resetData: l } = he({ namespace: "add-contract" }), { customerInformation: c } = Oe(), m = D(
    () => ({
      close: i("action.close"),
      cancel: i("action.cancel"),
      continue: i("action.continue"),
      complete: i("action.complete")
    }),
    [i]
  ), { data: u } = ye(
    ee.PriceSignup({ agreementType: s.agreementType }),
    ({ Price: p }) => {
      var f, x;
      return p.signup({
        campaignCode: "",
        contractType: s.agreementType,
        currency: ((f = s.price) == null ? void 0 : f.currency) ?? "",
        locale: d || "",
        contractNumber: ((x = s.contractNo) == null ? void 0 : x.slice(0, 10)) ?? "",
        customerNo: c.customerNo ?? ""
      });
    }
  ), h = L(() => {
    r.status === "success" && n(), t();
  }, [r, t, n]);
  return B(() => {
    if (!u)
      return;
    const p = Array.isArray(u) && u.length > 0 ? u[0] : void 0;
    if (!p)
      return o(i("agreement.labels.free"));
    o(Js(p.priceInclVAT, p.currency));
  }, [u, i]), B(() => () => {
    l(), Qd();
  }, [l]), /* @__PURE__ */ e.jsxs(
    xo,
    {
      ariaLabelledBy: "title",
      open: !0,
      labels: m,
      onClose: h,
      title: /* @__PURE__ */ e.jsx(Sd, { text: i("agreement.addAgreementModal.title") }),
      error: r.status === "error" ? r.error : void 0,
      hideProgress: r.status === "error" ? !0 : void 0,
      children: [
        /* @__PURE__ */ e.jsx(
          Md,
          {
            formattedPrice: a,
            agreementType: s.agreementType
          }
        ),
        pr(s.agreementType) ? /* @__PURE__ */ e.jsx(
          Bd,
          {
            namespace: "recognitions",
            agreementType: s.agreementType,
            onValidate: (p) => {
              var f;
              if (!((f = p.recognitions) != null && f.recognition1))
                return {
                  "recognitions.recognition1": i(
                    "form.validations.recognition.required"
                  )
                };
            }
          }
        ) : null,
        va(s.agreementType) ? /* @__PURE__ */ e.jsx(rm, { namespace: "commuter" }) : null,
        va(s.agreementType) ? /* @__PURE__ */ e.jsx(nm, { namespace: "commuterVehicle" }) : null,
        Fd(s.agreementType) ? /* @__PURE__ */ e.jsx(Id, { namespace: "newsletter" }) : null,
        /* @__PURE__ */ e.jsx(
          Xd,
          {
            namespace: "termsOfAgreement",
            formattedPrice: a,
            updatePrice: o,
            contract: s,
            contractNo: s.contractNo,
            onValidate: (p) => {
              if (!p.termsOfAgreement)
                return {
                  termsOfAgreement: i("form.validations.termsOfAgreement.required")
                };
            }
          }
        ),
        /* @__PURE__ */ e.jsx(am, { agreementType: s.agreementType })
      ]
    }
  );
}, Ca = ({
  translationKey: t,
  ns: s,
  ...n
}) => {
  const { t: r } = O([s, "common"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsx(mt, { ...n, href: r(t), target: "_blank" });
}, $o = ({
  getError: t,
  registerField: s,
  manualInputChecked: n,
  customError: r
}) => {
  const { t: a } = O(["account", "common"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(k, { intent: "title", className: "mb-4", children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.storebeltIntroductionsStep.title"
      }
    ) }),
    /* @__PURE__ */ e.jsx(k, { intent: "body", as: "p", className: "mb-4", children: /* @__PURE__ */ e.jsxs(
      G,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.storebeltIntroductionsStep.description",
        children: [
          /* @__PURE__ */ e.jsx(
            Ca,
            {
              ns: "account",
              translationKey: "agreement.addAgreementModal.storebeltIntroductionsStep.readMoreLink1"
            }
          ),
          /* @__PURE__ */ e.jsx(
            Ca,
            {
              ns: "account",
              translationKey: "agreement.addAgreementModal.storebeltIntroductionsStep.readMoreLink2"
            }
          )
        ]
      }
    ) }),
    s ? /* @__PURE__ */ e.jsx(
      Q,
      {
        type: "checkbox",
        label: a(
          "agreement.addAgreementModal.storebeltIntroductionsStep.termsOfAgreement"
        ),
        ...s("termsOfAgreement", {
          type: "checkbox",
          value: "true"
        }),
        error: t && t("termsOfAgreement"),
        className: "mb-4"
      }
    ) : /* @__PURE__ */ e.jsx(
      Q,
      {
        onChange: n ? (o) => n(o.target.checked) : () => ({}),
        type: "checkbox",
        label: a(
          "agreement.addAgreementModal.storebeltIntroductionsStep.termsOfAgreement"
        ),
        name: "termsOfAgreement",
        value: "true",
        error: r && a(r),
        className: "mb-4"
      }
    ),
    /* @__PURE__ */ e.jsx(k, { size: "sm", className: "mb-4", children: /* @__PURE__ */ e.jsxs(G, { ns: "common", i18nKey: "termsOfAgreement", children: [
      /* @__PURE__ */ e.jsx(_n, { type: Z.Storebelt }),
      /* @__PURE__ */ e.jsx(In, { type: Z.Storebelt })
    ] }) })
  ] });
}, im = () => {
  const { registerField: t, getError: s } = he({
    namespace: "add-sbf"
  });
  return /* @__PURE__ */ e.jsx($o, { getError: s, registerField: t });
}, Br = ({
  open: t,
  className: s,
  onOpenChange: n,
  trigger: r,
  title: a,
  content: o,
  cancelText: i,
  confirmText: d,
  onAction: l,
  confirmColor: c = "negative",
  titleWrapperClassName: m
}) => /* @__PURE__ */ e.jsxs(Qt.Root, { open: t, onOpenChange: n, children: [
  r && /* @__PURE__ */ e.jsx(Qt.Trigger, { asChild: !0, children: r }),
  /* @__PURE__ */ e.jsxs(Qt.Portal, { children: [
    /* @__PURE__ */ e.jsx(
      Qt.Overlay,
      {
        className: "fixed inset-0 z-40 bg-black/75",
        forceMount: !0
      }
    ),
    /* @__PURE__ */ e.jsxs(
      Qt.Content,
      {
        className: He(
          "fixed inset-1/2 z-40 h-screen w-[100vw] translate-x-[-50%] translate-y-[-50%] bg-white sm:h-min sm:max-w-lg sm:rounded-2xl",
          s
        ),
        children: [
          /* @__PURE__ */ e.jsx("div", { className: He("rounded-t-2xl", m), children: /* @__PURE__ */ e.jsx(Qt.Title, { asChild: !0, children: /* @__PURE__ */ e.jsx(k, { intent: "title", children: a }) }) }),
          /* @__PURE__ */ e.jsx(Qt.Description, { asChild: !0, children: /* @__PURE__ */ e.jsx("div", { className: "p-6", children: o }) }),
          /* @__PURE__ */ e.jsx("hr", { className: "mb-3 mt-6" }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end gap-4 px-6 pb-6", children: [
            /* @__PURE__ */ e.jsx(Qt.Cancel, { asChild: !0, children: /* @__PURE__ */ e.jsx(
              X,
              {
                intent: "text",
                color: "neutral",
                onClick: () => l(!1),
                children: i
              }
            ) }),
            /* @__PURE__ */ e.jsx(Qt.Action, { asChild: !0, children: /* @__PURE__ */ e.jsx(X, { color: c, onClick: () => l(!0), children: d }) })
          ] })
        ]
      }
    )
  ] })
] }), ht = ps(function({
  className: s,
  title: n,
  footer: r,
  children: a,
  trigger: o,
  open: i,
  defaultOpen: d,
  onOpenChange: l,
  preventClose: c,
  contentWrapper: m
}, u) {
  const h = Ae(null), p = Ae(!1), [f, x] = M(
    () => i || d || !1
  ), [g, N] = M(!1), b = L(() => {
    h.current && h.current.click();
  }, []);
  return yr(u, () => ({
    close: b
  })), B(() => {
    i !== void 0 && x(i);
  }, [i]), B(() => {
    c ? p.current = !0 : p.current = !1;
  }, [c]), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      vt.Root,
      {
        onOpenChange: (v) => {
          if (!v && p.current) {
            N(!0);
            return;
          }
          l && l(v), x(v);
        },
        open: f,
        children: [
          o ? /* @__PURE__ */ e.jsx(vt.Trigger, { asChild: !0, onClick: () => x(!0), children: o }) : /* @__PURE__ */ e.jsx(vt.Trigger, {}),
          /* @__PURE__ */ e.jsx(vt.Portal, { children: /* @__PURE__ */ e.jsx(vt.Overlay, { className: "fixed inset-0 z-40 grid place-content-center overflow-y-auto bg-black/75", children: /* @__PURE__ */ e.jsxs(
            ke.Root,
            {
              as: vt.Content,
              className: He(
                "max-h-screen w-[100vw] max-w-3xl overflow-y-auto p-6 shadow-md sm:my-4 sm:h-min sm:rounded-2xl",
                s
              ),
              rounded: !1,
              children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flex justify-between", children: [
                  /* @__PURE__ */ e.jsx(k, { as: "h2", intent: "title", className: "mb-4 text-xl", children: n }),
                  /* @__PURE__ */ e.jsx(vt.Close, { asChild: !0, children: /* @__PURE__ */ e.jsx(
                    X,
                    {
                      intent: "text",
                      startIcon: /* @__PURE__ */ e.jsx(rn, {}),
                      color: "primary",
                      iconSize: "lg",
                      ref: h
                    }
                  ) })
                ] }),
                m ? /* @__PURE__ */ e.jsxs(m, { children: [
                  a,
                  r ? /* @__PURE__ */ e.jsx(ke.Footer, { children: r(b) }) : null
                ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  a,
                  r ? /* @__PURE__ */ e.jsx(ke.Footer, { children: r(b) }) : null
                ] })
              ]
            }
          ) }) })
        ]
      }
    ),
    c ? /* @__PURE__ */ e.jsx(
      Br,
      {
        open: g,
        onOpenChange: N,
        ...c,
        onAction: (v) => {
          v && h.current && (p.current = !1, setTimeout(() => {
            b();
          }, 100));
        }
      }
    ) : null
  ] });
}), Bo = Ct({
  currentStep: 0,
  isOnLastStep: !0,
  nextStep: () => {
  },
  close: () => {
  },
  steps: 0,
  setSteps: () => {
  },
  prevStep: () => {
  }
});
function Is() {
  return at(Bo);
}
const lm = ({ onClose: t, children: s }) => {
  const [n, r] = M(() => 0), [a, o] = M(() => 0), i = L(() => {
    t && t(), r(0);
  }, [t, r]), d = D(
    () => n === a - 1,
    [n, a]
  ), l = L(() => d ? i() : r((m) => m + 1), [d, r, i]), c = L(() => r((m) => m - 1), [r]);
  return /* @__PURE__ */ e.jsx(
    Bo.Provider,
    {
      value: {
        currentStep: n,
        isOnLastStep: d,
        steps: a,
        setSteps: o,
        close: i,
        nextStep: l,
        prevStep: c
      },
      children: s
    }
  );
}, cm = (t) => vl.toArray(t).filter(Boolean), dm = ({
  hideProgress: t,
  children: s
}) => {
  const { currentStep: n, setSteps: r } = Is(), a = D(() => cm(s), [s]);
  B(() => {
    r(a.length);
  }, [a, r]);
  const o = D(
    () => a[n] ?? a[0],
    [a, n]
  ), i = D(
    () => a.map((d, l) => /* @__PURE__ */ e.jsx(
      vn.Item,
      {
        nr: l + 1,
        active: n >= l,
        completed: n > l
      },
      l
    )),
    [a, n]
  );
  return /* @__PURE__ */ e.jsx(ut, { children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    t ? null : /* @__PURE__ */ e.jsx(vn.Root, { direction: "horizontal", className: "mb-8", children: i }),
    o
  ] }) });
}, mm = ({
  hideProgress: t,
  children: s,
  ...n
}) => {
  const { close: r } = Is();
  return /* @__PURE__ */ e.jsx(
    ht,
    {
      ...n,
      onOpenChange: (a) => {
        a || r();
      },
      children: /* @__PURE__ */ e.jsx(dm, { hideProgress: t, children: s })
    }
  );
}, um = ({ onClose: t, ...s }) => /* @__PURE__ */ e.jsx(lm, { onClose: t, children: /* @__PURE__ */ e.jsx(mm, { ...s }) }), hm = ({
  handleOpenChange: t,
  error: s,
  validate: n,
  handleSubmit: r,
  success: a,
  state: o,
  isLoading: i,
  customSubmit: d
}) => {
  const { t: l } = O(["account", "common"], { nsMode: "fallback" }), c = Ae(null), [m, u] = M(!1), [h, p] = M(void 0), f = () => {
    d || p(m ? void 0 : "form.validations.termsOfAgreement.required");
  };
  return B(() => p(void 0), [m]), /* @__PURE__ */ e.jsxs(
    ht,
    {
      open: !0,
      title: l("agreement.addAgreementModal.title"),
      onOpenChange: t,
      children: [
        s && /* @__PURE__ */ e.jsx(ge, { color: "negative", className: "col-span-full", children: s.error ?? l("errors.generic") }),
        /* @__PURE__ */ e.jsxs(
          "form",
          {
            onSubmit: n && r ? Nt(n, r) : f,
            onReset: () => t(!1),
            ref: c,
            children: [
              o === "success" ? a : d ? /* @__PURE__ */ e.jsx($o, { manualInputChecked: u, customError: h }) : /* @__PURE__ */ e.jsx(im, {}),
              /* @__PURE__ */ e.jsx("div", { className: "flex flex-row justify-end", children: o === "success" || o === "error" ? /* @__PURE__ */ e.jsx(X, { intent: "solid", onClick: () => t(!1), children: l("action.complete") }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                /* @__PURE__ */ e.jsx(X, { intent: "text", type: "reset", children: l("action.cancel") }),
                /* @__PURE__ */ e.jsx(
                  De,
                  {
                    intent: "solid",
                    type: "submit",
                    isLoading: i,
                    loadingLabel: l("action.loading"),
                    children: l("action.save")
                  }
                )
              ] }) })
            ]
          }
        )
      ]
    }
  );
}, pm = ({
  onClose: t,
  onSuccess: s,
  contract: n
}) => {
  const { t: r } = O(["account", "common"], { nsMode: "fallback" }), [a, o] = M(), [i, d] = M(
    void 0
  ), l = (v) => {
    d("error"), o(v);
  }, c = Le(), m = L(
    (v) => v.termsOfAgreement ? void 0 : { termsOfAgreement: r("form.validations.termsOfAgreement.required") },
    [r]
  ), { mutateAsync: u, isLoading: h } = fe(
    ["contract", "activateSbf"],
    (v) => v.Contract.toggleSbf(n.contractNo),
    {
      onError: (v) => {
        l({ ...v, error: r("errors.generic") });
      },
      onSuccess: () => {
        d("success"), c.refetchQueries(ee.Agreements()), c.invalidateQueries({
          queryKey: ee.AllContracts()
        });
      }
    }
  ), p = L(async () => u({ sbfActive: !0 }), [u]), { validate: f, resetData: x, handleSubmit: g } = he({
    namespace: "add-sbf",
    onValidate: m,
    onSubmit: p
  }), N = L(
    (v) => {
      v || (i === "success" && s(), x(), t());
    },
    [t, s, x, i]
  ), b = D(
    () => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center py-6", children: [
      /* @__PURE__ */ e.jsx(wr, { className: "mb-8 h-12 w-12 text-green-500" }),
      /* @__PURE__ */ e.jsx(k, { intent: "title", className: "text-primary-900 mb-6", children: /* @__PURE__ */ e.jsx(
        G,
        {
          ns: "account",
          i18nKey: "agreement.addAgreementModal.storebeltConfirmationStep.title"
        }
      ) }),
      /* @__PURE__ */ e.jsx(k, { intent: "body", children: /* @__PURE__ */ e.jsx(
        G,
        {
          ns: "account",
          i18nKey: "agreement.addAgreementModal.storebeltConfirmationStep.description"
        }
      ) })
    ] }),
    []
  );
  return /* @__PURE__ */ e.jsx(
    hm,
    {
      success: b,
      handleOpenChange: N,
      error: a,
      validate: f,
      handleSubmit: g,
      state: i,
      isLoading: h
    }
  );
}, fm = ({
  contract: t,
  ...s
}) => t.agreementType === "Storebelt" ? /* @__PURE__ */ e.jsx(pm, { contract: t, ...s }) : /* @__PURE__ */ e.jsx(om, { contract: t, ...s }), Io = {
  showConfirmation: !1,
  success: !1,
  loading: !1,
  contractNo: void 0
}, Ss = Ns(
  () => Io
), xm = () => Ss.setState(Io), Na = () => Ss.setState({ loading: !0 }), wa = (t) => Ss.setState({
  success: !0,
  showConfirmation: !0,
  loading: !1,
  contractNo: t
}), ka = () => Ss.setState({ showConfirmation: !0, loading: !1 }), gm = ({
  agreementType: t
}) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  }), { success: n } = Ss(), r = D(() => n ? "success" : "error", [n]), a = D(() => s(t === "Storebelt" && r === "success" ? "agreement.modal.confirmation.storebelt_success" : `agreement.modal.confirmation.${r}.description`), [t, r, s]);
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center", children: [
    /* @__PURE__ */ e.jsx("div", { className: " my-4", children: n ? /* @__PURE__ */ e.jsx(Al, { className: "text-green-600", width: "50px", height: "50px" }) : /* @__PURE__ */ e.jsx(kr, { width: "50px", height: "50px" }) }),
    /* @__PURE__ */ e.jsx(k, { className: "max-w-[65ch] pb-1 pt-2 text-center", children: a })
  ] });
}, bm = ({
  agreementType: t
}) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  }), { data: n } = Ke(!0);
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        size: "sm",
        className: He(
          "flex",
          "flex-col",
          "gap-3",
          ur(t) ? "text-center" : "text-left"
        ),
        children: /* @__PURE__ */ e.jsxs(
          G,
          {
            ns: "account",
            i18nKey: `agreement.modal.description.${t}`,
            values: {
              agreementType: n == null ? void 0 : n.paymentAgreement.provider.name
            },
            children: [
              /* @__PURE__ */ e.jsx(k, { as: "span" }),
              /* @__PURE__ */ e.jsx(k, { as: "span" }),
              /* @__PURE__ */ e.jsx(k, { weight: "medium", as: "span" }),
              /* @__PURE__ */ e.jsx(k, { as: "span" })
            ]
          }
        )
      }
    ),
    !ur(t) && !ed(t) && Jc(t) ? /* @__PURE__ */ e.jsx(ge, { color: "inform", children: s("agreement.modal.disclaimer") }) : null
  ] });
}, vm = ({ close: t, onCancel: s }) => {
  const { t: n } = O(["account", "common"], {
    nsMode: "fallback"
  }), { loading: r } = Ss();
  return /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end", children: [
    /* @__PURE__ */ e.jsx(X, { intent: "text", onClick: t, children: n("action.cancel") }),
    /* @__PURE__ */ e.jsx(
      De,
      {
        intent: "solid",
        onClick: s,
        isLoading: r,
        loadingLabel: n("actions.loading"),
        children: n("agreement.modal.action.save")
      }
    )
  ] });
}, ym = ({ close: t }) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ e.jsx(X, { intent: "text", onClick: t, children: s("action.complete") }) });
}, _o = ({
  contract: t,
  onSuccess: s,
  onClose: n,
  periodCard: r,
  paymentContract: a
}) => {
  const o = Le(), { t: i } = O(["account", "common"], {
    nsMode: "fallback"
  }), { push: d } = se(), { showConfirmation: l, success: c } = Ss(), { mutateAsync: m } = fe(
    ["contract", "cancel"],
    ({ Contract: v }) => v.cancel(t.contractNo),
    {
      onMutate: Na,
      onError: ka,
      onSuccess: (v) => {
        o.invalidateQueries(ee.Agreements()), o.invalidateQueries(ee.CustomerInformation()), o.invalidateQueries({
          queryKey: ee.AllContracts()
        }), d("/account/agreement"), wa(v.contractNo);
      }
    }
  ), { mutateAsync: u } = fe(
    ["contract", "cancel"],
    ({ Contract: v }) => v.toggleSbf((a == null ? void 0 : a.contractNo) ?? t.contractNo),
    {
      onMutate: Na,
      onError: ka,
      onSuccess: () => {
        o.invalidateQueries(ee.Agreements()), o.invalidateQueries(ee.CustomerInformation()), o.invalidateQueries({
          queryKey: ee.AllContracts()
        }), wa((a == null ? void 0 : a.contractNo) ?? t.contractNo);
      }
    }
  ), h = D(
    () => l ? `agreement.modal.confirmation.${c ? "success" : "error"}.title` : "agreement.modal.title",
    [l, c]
  ), p = L(() => {
    xm(), c && s && s(), n();
  }, [s, c, n]), g = td(
    () => /* @__PURE__ */ e.jsx("div", { className: "flex flex-col gap-3", children: /* @__PURE__ */ e.jsx(
      k,
      {
        size: "md",
        className: He("flex", "flex-col", "gap-3", "text-left"),
        children: /* @__PURE__ */ e.jsx(
          G,
          {
            ns: "account",
            i18nKey: "agreement.modal.preventCancel.description",
            children: /* @__PURE__ */ e.jsx(k, { as: "span" })
          }
        )
      }
    ) }),
    () => l ? /* @__PURE__ */ e.jsx(gm, { agreementType: t.agreementType }) : /* @__PURE__ */ e.jsx(bm, { agreementType: t.agreementType })
  ), N = L(async () => {
    t.agreementType === "Storebelt" ? await u({ sbfActive: !1 }) : await m({ closeInFuture: !1 });
  }, [u, t.agreementType, m]), b = (v) => l ? /* @__PURE__ */ e.jsx(ym, { close: v }) : To(t, r) ? null : /* @__PURE__ */ e.jsx(vm, { close: v, onCancel: N });
  return /* @__PURE__ */ e.jsx(
    ht,
    {
      footer: b,
      title: /* @__PURE__ */ e.jsx(
        k,
        {
          as: "h1",
          intent: "title",
          size: "lg",
          className: "text-neutral-900",
          children: /* @__PURE__ */ e.jsx(
            G,
            {
              ns: "account",
              i18nKey: h,
              values: {
                agreementType: i(
                  `agreementTypes.${t.agreementType}.badge`
                )
              },
              children: /* @__PURE__ */ e.jsx(k, { as: "span", weight: "bold" })
            }
          )
        }
      ),
      onOpenChange: (v) => {
        v || p();
      },
      open: !0,
      children: g(t, r)
    }
  );
}, jm = (t) => t.paymentType === "invoice", Cm = ({
  startDateTime: t,
  endDateTime: s,
  active: n
}) => {
  const r = new Date(t), a = new Date(s);
  return {
    status: n ? "active" : "cancelled",
    date: Lt(r, "yyyy-MM-dd"),
    endDate: Lt(a, "yyyy-MM-dd")
  };
}, Nm = (t) => ({
  contractNo: t,
  agreementType: "Storebelt"
}), wm = Ht(
  "flex flex-col sm:flex-row sm:justify-between gap-2 py-4 px-5 items-center",
  {
    variants: {
      status: {
        active: ["bg-white-200", "text-neutral-800"],
        cancelled: ["bg-red-300", "text-red-600"],
        pending: ["bg-blue-200", "text-blue-800"]
      }
    },
    defaultVariants: {
      status: "pending"
    }
  }
), Ir = ({
  status: t,
  date: s,
  endDate: n,
  children: r,
  disableCancel: a,
  futureStartDate: o
}) => {
  const { t: i } = O("account");
  return /* @__PURE__ */ e.jsxs("div", { className: wm({ status: t }), children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex-[2]", children: [
      /* @__PURE__ */ e.jsx(k, { size: "md", children: /* @__PURE__ */ e.jsx(
        G,
        {
          ns: "account",
          i18nKey: `agreement.periodCard.${t}.label`,
          values: { date: o ? s : n },
          context: o ? "startDate" : n ? void 0 : "with-date",
          children: /* @__PURE__ */ e.jsx(k, { size: "md", weight: "bold", as: "span" })
        }
      ) }),
      t !== "cancelled" && /* @__PURE__ */ e.jsx(k, { size: "md", weight: "light", className: "mt-2", children: i(`agreement.periodCard.${t}.description`, { endDate: n }) })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-1 flex-col items-end justify-center", children: [
      r,
      a ? /* @__PURE__ */ e.jsx(k, { size: "sm", weight: "light", className: "text-right", children: i("agreement.periodCard.cancelDisabled") }) : null
    ] })
  ] });
}, Ze = ({ contract: t, ns: s = "common" }) => /* @__PURE__ */ e.jsx(G, { ns: s, i18nKey: t, children: /* @__PURE__ */ e.jsx($, { as: "span", className: "font-bold text-inherit" }) });
function km({ onError: t }) {
  const [s, n] = M(!1), { data: r } = Ke(), { data: a, refetch: o } = dn(), { mutateAsync: i } = fe(
    ["periodcard", "cancel"],
    (l) => l.PeriodCard.cancel,
    {
      onError: t
    }
  );
  return {
    cancelPeriodCard: L(async () => {
      if (a) {
        n(!0);
        try {
          await i({
            periodCardId: a.id,
            contractNo: a.contractNo
          }), await o();
        } catch {
          t();
        } finally {
          n(!1);
        }
      }
    }, [a, i, o, t]),
    isCancelling: s,
    agreements: r
  };
}
const Wo = ({ className: t, disabled: s }) => {
  const [n, r] = M(!1), a = Ae(null), { t: o } = O(["account", "common"], { nsMode: "fallback" }), { cancelPeriodCard: i, isCancelling: d, agreements: l } = km({
    onError: () => r(!0)
  }), c = () => {
    a.current && a.current.close();
  }, m = (l == null ? void 0 : l.paymentAgreement.agreementType) === "Oresund_Business" ? "oresundBusinessCommuter" : "oresundCommuter";
  return /* @__PURE__ */ e.jsx(
    ht,
    {
      ref: a,
      title: /* @__PURE__ */ e.jsx(G, { ns: "account", i18nKey: "periodCard.modals.cancel.title", children: /* @__PURE__ */ e.jsx("span", { className: "font-bold" }) }),
      trigger: /* @__PURE__ */ e.jsx(
        X,
        {
          iconSize: "lg",
          className: t,
          intent: "text",
          color: "positive",
          disabled: s,
          children: o("periodCard.modals.cancel.action")
        }
      ),
      children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-8", children: [
        /* @__PURE__ */ e.jsx(k, { children: /* @__PURE__ */ e.jsx(G, { ns: "account", i18nKey: "periodCard.modals.cancel.description", children: /* @__PURE__ */ e.jsx(Ze, { contract: m }) }) }),
        n ? /* @__PURE__ */ e.jsx(ge, { color: "negative", children: /* @__PURE__ */ e.jsx(k, { size: "md", children: o("periodCard.modals.cancel.errors.generic") }) }) : null,
        /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end gap-4", children: [
          /* @__PURE__ */ e.jsx(X, { as: "button", intent: "text", onClick: c, children: o("action.cancel") }),
          /* @__PURE__ */ e.jsx(
            De,
            {
              loadingLabel: o("action.loading"),
              isLoading: d,
              onClick: i,
              children: o("periodCard.modals.cancel.action")
            }
          )
        ] })
      ] })
    }
  );
}, Ms = ({ onClick: t, namespace: s, loadingLabel: n, ...r }) => {
  const [a, o] = M(!1), { labels: i, isLast: d, nextStep: l } = Nr(), c = D(
    () => d(s) ? i.submitLabel : i.nextLabel,
    [d, i.submitLabel, i.nextLabel, s]
  ), m = L(async () => {
    o(!0);
    try {
      await t() && l();
    } finally {
      o(!1);
    }
  }, [t, l]);
  return /* @__PURE__ */ e.jsx($, { className: "col-span-full mt-2 flex justify-end", children: /* @__PURE__ */ e.jsx(
    De,
    {
      ...r,
      onClick: m,
      isLoading: a,
      loadingLabel: n,
      type: d(s) ? "submit" : "button",
      intent: "solid",
      children: c
    }
  ) });
}, Pm = ({ namespace: t, ...s }) => {
  const { labels: n, isLast: r, enableStep: a } = Nr();
  return r(t) ? null : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      X,
      {
        ...s,
        onClick: () => a(t),
        intent: "text",
        color: "neutral",
        type: "button",
        startIcon: /* @__PURE__ */ e.jsx(ua, {}),
        className: "ml-auto sm:hidden",
        "aria-label": n.editLabel,
        iconSize: "lg"
      }
    ),
    /* @__PURE__ */ e.jsx(
      X,
      {
        ...s,
        onClick: () => a(t),
        intent: "text",
        type: "button",
        color: "neutral",
        startIcon: /* @__PURE__ */ e.jsx(ua, {}),
        className: "ml-auto hidden sm:flex",
        children: n.editLabel
      }
    )
  ] });
}, Bt = ({
  nr: t,
  title: s,
  children: n,
  id: r,
  editButton: a = !0,
  full: o = !0,
  className: i,
  titleIntent: d = "headline",
  titleSize: l = "sm"
}) => /* @__PURE__ */ e.jsxs(
  $,
  {
    as: "fieldset",
    className: He(o ? "min-h-screen" : void 0, "pb-8", i),
    children: [
      /* @__PURE__ */ e.jsxs("div", { className: "mb-4 flex flex-row items-center", children: [
        t ? /* @__PURE__ */ e.jsx(wl, { className: "mr-4", children: t }) : null,
        /* @__PURE__ */ e.jsx(
          k,
          {
            as: "legend",
            intent: d,
            size: l,
            id: r,
            className: "scroll-mt-[10vh]",
            children: s
          }
        ),
        a ? /* @__PURE__ */ e.jsx(Pm, { namespace: r }) : null
      ] }),
      /* @__PURE__ */ e.jsx(Ue, { className: "gap-4", children: n })
    ]
  }
), Wn = ({ type: t, isOresundPay: s }) => /* @__PURE__ */ e.jsxs(G, { i18nKey: "termsOfAgreement", ns: "common", children: [
  /* @__PURE__ */ e.jsx(_n, { type: t, isOresundPay: s }),
  /* @__PURE__ */ e.jsx(In, { type: t })
] }), Et = (t) => Dc.dataLayer({ dataLayer: t }), kg = (t) => Et({
  event: "PageView",
  action: t
}), Pg = ({ name: t, label: s, value: n }, r, a) => Et({
  event: t,
  eventCategory: s === "web-vital" ? "Web Vitals" : "Next.js custom metric",
  eventValue: Math.round(t === "CLS" ? n * 1e3 : n),
  eventLabel: `/${r}${a}`,
  nonInteraction: !0
}), _r = (t, s) => {
  Et({
    event: "purchase",
    ecommerce: t,
    userData: s
  });
}, Wr = () => Et({
  ecommerce: null
}), Tg = (t) => {
  Et({
    event: "contactUs",
    pagePath: document.location.href,
    loginMethod: t || ""
  });
}, Sg = (t) => {
  Et({
    event: "corporateForm",
    pagePath: document.location.href,
    subject: t
  });
}, Mg = (t, s) => {
  Et({
    event: "voucherDownload",
    locale: s,
    discountPercent: t.discount,
    voucherName: t.voucherName
  });
}, Tm = (t) => {
  Et({
    event: "newsletterSignup",
    pagePath: document.location.href.replace(location.hash, ""),
    // Exclude hash from url, else it will be http://www.oresundsbron.com/sv/pendlare/oresund-pendlare-business/registrera#termsOfAgreement
    serviceType: t
  });
}, lr = (t, s) => {
  Et({
    event: "click_replace_bizz",
    button_text: t,
    country: s
  });
}, Pa = (t, s) => {
  Et({
    event: "locations_replace_bizz",
    button_text: t,
    country: s
  });
}, Ta = (t, s) => {
  Et({
    event: "numberplate_replace_bizz",
    choice: t,
    country: s
  });
}, Sm = (t) => {
  Et({
    event: "confirm_adress_replace_bizz",
    country: t
  });
};
var un = /* @__PURE__ */ ((t) => (t.blockCommercialVehicle = "commercialVehicle", t))(un || {});
function Mm() {
  const t = Le(), [s, n] = M(!1), { locale: r, query: a } = se(), { customerType: o } = Ot(), i = a.contract, d = as(), l = i || d, { customerInformation: c } = Oe(), { data: m, isLoading: u } = ye(
    ee.Recognitions({
      contractNo: l
    }),
    (w) => w.Recognitions.getByContractNo({
      contractNo: l
    }),
    {
      enabled: !!l,
      retry: 1
    }
  ), { data: h } = ye(
    ee.PeriodCardPrice(),
    (w) => w.Price.periodCard,
    {
      retry: 1
    }
  ), p = (w) => {
    var T;
    const { id: z, contractNo: C, currencyCode: E } = w, A = (T = h == null ? void 0 : h.find(
      (P) => P.currencyCode === E
    )) == null ? void 0 : T.fee, R = {
      private: "Private",
      business: "Business",
      iticket: "Private",
      "business-commuter": "Business"
    }[o];
    Wr(), _r(
      {
        transaction_id: z,
        value: `${A}`,
        currency: E,
        coupon: void 0,
        items: [
          {
            item_name: "OresundCommuterPlus",
            item_id: z,
            item_category: R,
            item_variant: "OperatorMyAccount",
            quantity: "1",
            price: `${A}`
          }
        ]
      },
      {
        email: c == null ? void 0 : c.email,
        firstName: c == null ? void 0 : c.firstName,
        lastName: c == null ? void 0 : c.lastName,
        phone: `+${c == null ? void 0 : c.phoneCode}${c == null ? void 0 : c.phone}`,
        city: c == null ? void 0 : c.city,
        address1: c == null ? void 0 : c.address,
        zipCode: c == null ? void 0 : c.zipCode,
        company: c.companyName ?? "",
        country: c == null ? void 0 : c.country
      }
    ), t.setQueryData(
      ee.PeriodCard({ contractNo: C }),
      w
    ), t.invalidateQueries(
      ee.RecognitionsUsageHistory(C)
    ), t.invalidateQueries(
      ee.Recognitions({ contractNo: C })
    );
  }, [f, x] = M(!1), { mutateAsync: g, error: N } = fe(
    ["periodcard"],
    (w) => w.PeriodCard.add,
    {
      onSuccess: p,
      onError: (w) => {
        x(
          w && w.code === 400 && w.error === un.blockCommercialVehicle
        );
      },
      onSettled: () => {
        n(!1);
      }
    }
  ), b = D(() => !m || !m.recognitions ? [] : m.recognitions.filter(
    (w) => w.recognitionType === "licensePlate"
  ), [m]), v = L(
    async (w) => {
      const z = {
        ...w,
        contractNo: l || ""
      };
      n(!0);
      try {
        await g(z);
      } finally {
        n(!1);
      }
    },
    [l, g]
  ), S = ss(r || ""), y = D(() => (h == null ? void 0 : h.find((w) => w.currencyCode === S)) ?? void 0, [S, h]);
  return {
    loading: s,
    loadingRecoginitions: u,
    onSubmit: v,
    validRecognitions: b,
    price: y,
    error: N,
    attemptToAddCommercialVehicle: f
  };
}
const us = (t) => !(t && t.id === Qs.ORESUNDPAY), zm = (t) => [Z.OresundPendler, Z.OresundBusinessPendler].includes(
  t
), Am = (t) => (s) => {
  if (s.length)
    return s.find(
      (n) => "value" in n ? n.value === t : n.serialNo === t
    );
};
function qr(t) {
  const s = as();
  let n = t;
  t || (n = s);
  const { data: r, isLoading: a } = ye(
    ee.ContractByNo(n),
    ({ Contract: o }) => o.byContractNo(n),
    { enabled: !!t, suspense: !0 }
  );
  return { data: r, isLoading: a };
}
const Om = ({ onClose: t }) => {
  const { locale: s } = se(), {
    loading: n,
    loadingRecoginitions: r,
    onSubmit: a,
    validRecognitions: o,
    price: i,
    error: d,
    attemptToAddCommercialVehicle: l
  } = Mm(), c = l, { t: m } = O(["account", "common", "recognitions"], {
    nsMode: "fallback"
  }), { data: u } = qr(), { customerType: h } = Ot(), p = D(() => {
    const A = o.length ? `${o[0].serialNo}` : void 0;
    let F = u == null ? void 0 : u.paymentAgreement.startDate;
    return new Date(F ?? "1970-01-01").getTime() < (/* @__PURE__ */ new Date()).getTime() && (F = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10)), {
      serialNo: A,
      startDateTime: F
    };
  }, [o, u]), f = D(() => {
    if (i) {
      const { fee: A, currencyCode: F } = i;
      return Bn(A, s, F);
    }
    return "";
  }, [i, s]), x = L(
    async (A) => {
      try {
        const F = await Ts(
          ec.spa,
          m
        )(A);
        return new Date(A.startDateTime).getTime() < new Date((u == null ? void 0 : u.paymentAgreement.startDate) ?? "1970-01-01").getTime() ? {
          startDateTime: m("form.validations.startDate.afterPendlerStart")
        } : F;
      } catch {
        return;
      }
    },
    [m, u]
  ), {
    registerField: g,
    getError: N,
    validate: b,
    handleSubmit: v,
    isValid: S
  } = he({
    namespace: "periodcard",
    defaultValues: p,
    onSubmit: a,
    onValidate: x
  }), [y, w] = Ee("periodcard", "agreement", "serialNo"), z = D(() => Am(w)(
    o
  ), [w, o]), C = D(
    () => !!(z != null && z.isCommercialVehicle),
    [z]
  ), E = D(() => y === "true", [y]);
  return /* @__PURE__ */ e.jsxs(
    "form",
    {
      className: "flex flex-col gap-8",
      onSubmit: Nt(b, v),
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4", children: [
          /* @__PURE__ */ e.jsx(
            Q,
            {
              ...g("startDateTime", { type: "date" }),
              className: "col-span-full",
              label: m("form.labels.startDate"),
              error: N("startDateTime"),
              required: !0
            }
          ),
          /* @__PURE__ */ e.jsx("p", { className: "col-span-full mt-[-8px]", children: m("periodCard.modals.add.startDateDescription") })
        ] }),
        /* @__PURE__ */ e.jsxs(
          Bt,
          {
            title: m("form.labels.connectedAlpr"),
            id: "vehicle",
            full: !1,
            titleIntent: "title",
            titleSize: "sm",
            className: "pb-0",
            editButton: !1,
            children: [
              (C || c) && /* @__PURE__ */ e.jsx(
                ge,
                {
                  color: "warn",
                  className: "col-span-full flex items-center justify-between",
                  children: /* @__PURE__ */ e.jsx(k, { size: "md", children: m("form.validations.periodCard.isCommercialVehicle") })
                }
              ),
              /* @__PURE__ */ e.jsx(
                xe,
                {
                  ...g("serialNo"),
                  label: m("form.labels.alpr"),
                  className: "col-span-2 sm:col-span-4 md:col-span-6",
                  options: o.length ? o.map((A) => ({
                    label: A.registrationNo,
                    value: `${A.serialNo}`
                  })) : [
                    {
                      label: m("periodCard.modals.add.errors.noAvailableAlpr"),
                      value: "",
                      disabled: !0
                    }
                  ],
                  helpText: m("form.helpTexts.periodCard"),
                  required: !0
                }
              ),
              !r && o.length === 0 ? /* @__PURE__ */ e.jsx(
                ge,
                {
                  color: "negative",
                  className: "col-span-full flex items-center justify-between",
                  children: /* @__PURE__ */ e.jsx(k, { size: "md", children: m("periodCard.modals.add.errors.noAlpr") })
                }
              ) : null,
              /* @__PURE__ */ e.jsx(k, { className: "col-span-full", weight: "light", children: m("periodCard.modals.add.disclaimers.alpr") })
            ]
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ e.jsx("hr", { className: "col-span-full mb-4" }),
          /* @__PURE__ */ e.jsx(ct, { label: m("periodCard.modals.add.price"), children: /* @__PURE__ */ e.jsx("span", { className: "text-2xl", children: f }) }),
          /* @__PURE__ */ e.jsx(k, { intent: "label", size: "lg", children: m("form.helpTexts.periodCardSpan") })
        ] }),
        /* @__PURE__ */ e.jsx(ge, { children: /* @__PURE__ */ e.jsx(k, { size: "md", children: m("periodCard.modals.add.disclaimers.product") }) }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4", children: [
          /* @__PURE__ */ e.jsx(
            Q,
            {
              ...g("agreement", { type: "checkbox", value: "true" }),
              className: "col-span-full",
              label: m("form.labels.termsOfAgreement"),
              required: !0
            }
          ),
          /* @__PURE__ */ e.jsx(k, { size: "sm", className: "col-span-full", children: /* @__PURE__ */ e.jsx(
            Wn,
            {
              type: h === "private" ? Z.OresundGo : Z.OresundBusiness
            }
          ) })
        ] }),
        d && !l ? /* @__PURE__ */ e.jsx(ge, { color: "negative", children: /* @__PURE__ */ e.jsx(k, { size: "md", children: m("periodCard.modals.add.errors.generic") }) }) : null,
        /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end gap-4", children: [
          /* @__PURE__ */ e.jsx(X, { as: "button", intent: "text", onClick: t, children: m("action.cancel") }),
          /* @__PURE__ */ e.jsx(
            De,
            {
              loadingLabel: m("action.loading"),
              disabled: !E || !o.length || !S || C || c,
              type: "submit",
              isLoading: n,
              children: m("periodCard.modals.add.action")
            }
          )
        ] })
      ]
    }
  );
}, qo = Pl(({ className: t, buttonProps: s = {} }) => {
  const { t: n } = O(["account", "common"], { nsMode: "fallback" }), r = Ae(null), a = as(), o = pa(
    ee.PeriodCardPrice(),
    (d) => d.Price.periodCard
  ), i = pa(
    ee.Recognitions({
      contractNo: a
    }),
    (d) => d.Recognitions.getByContractNo({
      contractNo: a
    })
  );
  return B(() => {
    a && (o(), i());
  }, [a, o, i]), /* @__PURE__ */ e.jsx(
    ht,
    {
      title: /* @__PURE__ */ e.jsx(G, { ns: "account", i18nKey: "periodCard.modals.add.title", children: /* @__PURE__ */ e.jsx($, { as: "span", className: "font-bold" }) }),
      trigger: /* @__PURE__ */ e.jsx(X, { className: t, ...s, children: n("periodCard.modals.add.action") }),
      ref: r,
      children: /* @__PURE__ */ e.jsx(Om, { onClose: () => {
        var d;
        return (d = r.current) == null ? void 0 : d.close();
      } })
    }
  );
}), Hr = ({
  translationKey: t
}) => /* @__PURE__ */ e.jsx(G, { ns: "common", i18nKey: t, children: /* @__PURE__ */ e.jsx(k, { as: "span", intent: "title", size: "md", weight: "bold" }) }), Em = (t, s) => (n) => n ? `${n.amount} ${n.currency} / ${t}` : s, fr = ({
  onCancel: t,
  onEditBillingAddress: s,
  contract: n,
  actionsDisabled: r,
  periodCard: a,
  hideBillingInfo: o = !1
}) => {
  const { t: i } = O(["account", "common"], {
    nsMode: "fallback"
  }), { customerInformation: d } = Oe(), l = d && d.contracts.length > 1, c = n.paymentType === "invoice", m = (d == null ? void 0 : d.customerType) === ds.affiliatePartner, u = D(
    () => [
      Z.OresundGo,
      Z.OresundBusiness,
      Z.OresundPendler,
      Z.OresundBusinessPendler
    ].includes(n.agreementType),
    [n.agreementType]
  ), h = (g) => {
    var N;
    return (N = g.split("-")) == null ? void 0 : N[0];
  }, p = `/account/vehicles${l ? `?contract=${h(n.contractNo)}` : ""}`, f = `/account/debit-card${l ? `?contract=${h(n.contractNo)}` : ""}`, { app: x } = Ye();
  return /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs(Ue, { className: "pt-2", children: [
    /* @__PURE__ */ e.jsx(
      ct,
      {
        label: i("form.labels.contractType"),
        className: "col-span-full sm:col-span-4 md:col-span-6",
        children: i(`agreement.type.${n.contractType}`)
      }
    ),
    /* @__PURE__ */ e.jsx(
      ct,
      {
        label: i("form.labels.contractNumber"),
        className: "col-span-full sm:col-span-4 md:col-span-6",
        children: h(n.contractNo)
      }
    ),
    n.agreementType !== Z.Storebelt && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        ct,
        {
          label: i("form.labels.startDate"),
          className: "col-span-full sm:col-span-4 md:col-span-6",
          children: n.startDate
        }
      ),
      /* @__PURE__ */ e.jsx(
        ct,
        {
          label: i("form.labels.nextPeriodDate"),
          className: "col-span-full sm:col-span-4 md:col-span-6",
          children: n.nextPeriod || "-"
        }
      ),
      /* @__PURE__ */ e.jsx(
        ct,
        {
          label: i("form.labels.price"),
          className: "col-span-full sm:col-span-4 md:col-span-6",
          children: Em(
            i("agreement.labels.year"),
            "-"
          )(u ? n.price : void 0)
        }
      ),
      c && !o ? /* @__PURE__ */ e.jsx(
        ct,
        {
          label: i("form.labels.paymentType"),
          className: "col-span-full sm:col-span-4 md:col-span-6",
          children: i(`paymentType.${n.paymentType}`)
        }
      ) : !o && /* @__PURE__ */ e.jsx(
        ct,
        {
          label: i("form.labels.connectedCard"),
          className: "col-span-full sm:col-span-4 md:col-span-6",
          children: n.cardNumber ?? "-"
        }
      )
    ] }),
    r ? null : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      n.agreementType !== Z.Storebelt ? /* @__PURE__ */ e.jsxs("div", { className: "col-span-full flex flex-col gap-2 border-t border-t-neutral-400 pt-4 md:pt-6", children: [
        /* @__PURE__ */ e.jsx(mt, { href: p, className: "font-normal", children: i("agreement.action.updateRecognition") }),
        !c && !m && !o && /* @__PURE__ */ e.jsx(mt, { className: "font-normal", href: f, children: i("agreement.action.updateCard") }),
        /* @__PURE__ */ e.jsx(
          _n,
          {
            isOresundPay: x === ot.OresundPay,
            type: tc(n.agreementType) ? Z.OresundGo : Z.OresundBusiness,
            children: i("agreement.action.termsOfAgreement")
          }
        )
      ] }) : null,
      /* @__PURE__ */ e.jsx("div", { className: "col-span-full flex items-center justify-end border-t border-t-neutral-400 py-2", children: n.cancelDate ? /* @__PURE__ */ e.jsx(k, { children: i("agreement.label.cancelled", {
        replace: { cancelDate: n.cancelDate }
      }) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        c && !o && /* @__PURE__ */ e.jsx(
          mt,
          {
            className: "mr-6 !text-sm !font-medium no-underline",
            href: f,
            children: i("agreement.action.changePaymentMethod")
          }
        ),
        s ? /* @__PURE__ */ e.jsx(
          X,
          {
            intent: "text",
            onClick: () => s(n),
            children: i("agreement.action.editBillingAddress")
          }
        ) : null,
        t ? /* @__PURE__ */ e.jsx(
          X,
          {
            intent: "text",
            onClick: () => t(n, a),
            children: i("agreement.action.cancelAgreement")
          }
        ) : null
      ] }) })
    ] })
  ] }) });
}, Dm = Ht("px-5", {
  variants: {
    intent: {
      primary: ["py-5"],
      secondary: ["first-of-type:pt-5", "pt-3", "last-of-type:pb-6", "pb-3"]
    },
    color: {
      primary: ["bg-blue-600"],
      secondary: ["bg-green-600"],
      tertiary: ["bg-white"],
      dim: ["bg-neutral-50"]
    }
  },
  defaultVariants: {
    color: "primary",
    intent: "primary"
  }
}), Fm = Ht("", {
  variants: {
    intent: {
      primary: ["text-base", "font-semibold", "uppercase", "tracking-widest"],
      secondary: ["text-sm", "font-normal"]
    },
    color: {
      primary: ["text-white"],
      secondary: ["text-white"],
      tertiary: ["text-neutral-700"],
      dim: ["text-neutral-700"]
    }
  },
  defaultVariants: {
    color: "primary",
    intent: "primary"
  }
}), Lm = Ht(
  "text-lg sm:text-2xl font-semibold leading-tight",
  {
    variants: {
      color: {
        primary: ["text-white"],
        secondary: ["text-white"],
        tertiary: ["text-neutral-700"],
        dim: ["text-neutral-800"]
      }
    },
    defaultVariants: {
      color: "primary"
    }
  }
), Ho = ({
  preTitle: t,
  color: s = "primary",
  intent: n = "primary",
  title: r,
  brandLogo: a,
  cancelled: o,
  bannerCancelledText: i
}) => /* @__PURE__ */ e.jsx("div", { className: Dm({ intent: n, color: s }), children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-7", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ e.jsx("p", { className: Fm({ intent: n, color: s }), children: t }),
    /* @__PURE__ */ e.jsx("p", { className: Lm({ color: s }), children: r })
  ] }),
  a ? a.src ? /* @__PURE__ */ e.jsx("div", { className: "ml-auto h-full", children: a.src }) : /* @__PURE__ */ e.jsx("div", { className: "ml-auto h-full", children: /* @__PURE__ */ e.jsx("p", { className: "h-full w-auto max-w-[120px]", children: a.alt }) }) : null,
  o ? /* @__PURE__ */ e.jsx("div", { className: "my-auto ml-auto max-w-[20ch] overflow-y-hidden rounded-lg bg-red-700 p-1", children: /* @__PURE__ */ e.jsx(
    k,
    {
      intent: "title",
      size: "sm",
      className: "truncate text-ellipsis text-white",
      children: i
    }
  ) }) : null
] }) });
function Vm(t) {
  return /* @__PURE__ */ e.jsxs(
    "svg",
    {
      width: "58",
      height: "35",
      viewBox: "0 0 58 35",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ e.jsx("path", { d: "M28.517 2.53173V0H0V2.53173H28.517Z", fill: "#82B3DB" }),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M28.494 34.9858V32.4541H18.9648V34.9858H28.494Z",
            fill: "#82B3DB"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M42.8616 34.9995V32.4678H33.3325V34.9995H42.8616Z",
            fill: "#82B3DB"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M57.2299 34.978V32.4463H47.7007V34.978H57.2299Z",
            fill: "#82B3DB"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M4.79045 17.728L2.64551 20.1543V23.1431H0.00830078V9.95703H2.64551V16.5676L8.55284 9.95703H11.7175L6.54858 15.7589L12.245 23.1431H8.86932L4.79045 17.728Z",
            fill: "#053E7C"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M28.4887 18.0102V23.1439H25.957V18.0102C25.957 16.5685 25.2186 15.9707 24.0933 15.9707C23.3901 15.9707 22.6868 16.2169 22.0891 16.9553C22.1242 17.2366 22.1594 17.5531 22.1594 17.8695V23.1439H19.6277V17.8695C19.6277 16.463 18.8892 16.0059 17.9047 16.0059C17.0959 16.0059 16.3927 16.3224 15.7949 17.096V23.1791H13.2632V13.9313H15.7949V14.5642C16.4278 14.0368 17.1311 13.7203 18.2212 13.7203C19.4518 13.7203 20.4716 14.1071 21.1748 14.8807C22.0891 14.1071 23.0385 13.7203 24.3043 13.7203C26.7657 13.6851 28.4887 15.2323 28.4887 18.0102Z",
            fill: "#053E7C"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M39.1438 12.4194H34.6781V23.1441H32.0408V12.4194H27.5752V9.99316H39.1438V12.4194Z",
            fill: "#053E7C"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M47.898 18.538C47.898 21.3862 45.8935 23.3905 43.0102 23.3905C40.0919 23.3905 38.0874 21.3862 38.0874 18.538C38.0874 15.6547 40.0919 13.6855 43.0102 13.6855C45.8935 13.6855 47.898 15.6547 47.898 18.538ZM45.3661 18.538C45.3661 17.026 44.3815 15.9711 43.0102 15.9711C41.6039 15.9711 40.6193 17.026 40.6193 18.538C40.6193 20.0148 41.6039 21.0697 43.0102 21.0697C44.3815 21.0697 45.3661 20.0148 45.3661 18.538Z",
            fill: "#053E7C"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M52.2952 9.39551V23.1442H49.7637V9.39551H52.2952Z",
            fill: "#053E7C"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M57.217 9.39551V23.1442H54.6851V9.39551H57.217Z",
            fill: "#053E7C"
          }
        )
      ]
    }
  );
}
function Rm(t) {
  return /* @__PURE__ */ e.jsxs(
    "svg",
    {
      width: "77",
      height: "35",
      viewBox: "0 0 77 35",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ e.jsxs("g", { "clip-path": "url(#clip0_7739_8267)", children: [
          /* @__PURE__ */ e.jsx(
            "path",
            {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M57.7583 20.0745H70.8103C72.3807 7.71008 76.6954 1.58203 76.6954 1.58203H71.6405C71.6405 1.58203 62.8671 6.1716 57.7583 20.0745Z",
              fill: "#3570AD"
            }
          ),
          /* @__PURE__ */ e.jsx(
            "path",
            {
              d: "M64.6546 1.58203H62.4974C62.4974 1.58203 49.3551 4.4706 38.957 20.0745H52.1353C54.7618 14.3604 58.1376 10.2206 61.2067 7.32325H54.9423C57.8707 4.92922 61.1454 2.99344 64.6546 1.58203Z",
              fill: "#3570AD"
            }
          ),
          /* @__PURE__ */ e.jsx(
            "path",
            {
              d: "M68.6444 0.303711C68.6444 0.303711 67.0649 0.627537 64.6547 1.58167C61.1455 2.99309 57.8708 4.92887 54.9424 7.32289H62.7501C67.2724 2.15719 71.9932 0.303711 71.9932 0.303711H68.6444Z",
              fill: "#80BB3D"
            }
          ),
          /* @__PURE__ */ e.jsx(
            "path",
            {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M21.3378 32.33C21.1394 32.204 20.8417 32.1139 20.5435 32.1139C19.7948 32.1139 19.4244 32.537 19.4244 32.978C19.4244 33.3018 19.6049 33.4728 19.9028 33.5897L20.2008 33.6978C20.4263 33.7879 20.5167 33.8688 20.5167 34.0307C20.5167 34.2468 20.3091 34.3996 20.0291 34.3996C19.7403 34.3996 19.4423 34.2915 19.2348 34.1476L19.0093 34.5527C19.271 34.7237 19.6049 34.8226 19.957 34.8226C20.7063 34.8226 21.1394 34.3996 21.1394 33.8688C21.1394 33.5718 20.9318 33.3919 20.6159 33.2659L20.318 33.1487C20.1104 33.0769 20.0383 32.9868 20.0383 32.852C20.0383 32.645 20.2367 32.537 20.5076 32.537C20.7063 32.537 20.9047 32.6 21.1214 32.7169L21.3378 32.33ZM23.5495 32.8517C23.5495 32.9597 23.5133 33.0407 23.4412 33.1037C23.3237 33.2297 23.1161 33.2747 22.8002 33.2747C22.719 33.2747 22.6106 33.2568 22.5835 33.2568C22.6919 32.7799 22.9448 32.5546 23.2336 32.5546C23.468 32.5546 23.5495 32.6806 23.5495 32.8517ZM24.1089 32.8158C24.1089 32.3656 23.8021 32.1407 23.3054 32.1407C22.9719 32.1407 22.6919 32.2399 22.4393 32.4828C22.0871 32.8246 21.8704 33.3736 21.8704 33.8776C21.8704 34.4894 22.2317 34.8135 22.7731 34.8135C23.2065 34.8135 23.5133 34.6963 23.8201 34.4535L23.6487 34.1117C23.4053 34.2915 23.1883 34.3905 22.9265 34.3905C22.6465 34.3905 22.4572 34.2374 22.4572 33.9135C22.4572 33.8326 22.4755 33.6975 22.4934 33.6527C22.5385 33.6527 22.656 33.6707 22.8002 33.6707C23.3237 33.6707 23.6758 33.5535 23.8834 33.3465C24.0277 33.2026 24.1089 33.0227 24.1089 32.8158ZM26.3927 32.1763C26.3267 32.1499 26.2559 32.1377 26.1849 32.1404C25.9323 32.1404 25.6523 32.3203 25.4179 32.6173C25.4538 32.4375 25.4359 32.2485 25.3726 32.1133L24.8582 32.3294C24.9124 32.5093 24.9212 32.6983 24.84 33.0492L24.479 34.7502H25.0299L25.3726 33.1122C25.5984 32.7975 25.7968 32.6624 25.9773 32.6624C26.0494 32.6624 26.1036 32.6715 26.149 32.6983L26.3927 32.1763ZM29.0555 32.2037L28.4507 32.1946L27.7194 33.5355C27.625 33.718 27.5376 33.9041 27.4577 34.0934C27.4577 33.9495 27.4485 33.7245 27.4217 33.5535L27.2592 32.1407L26.6904 32.2308L27.0784 34.7593H27.566L29.0555 32.2037ZM30.3191 32.1404L29.7323 32.2305L29.1997 34.7502H29.7683L30.3191 32.1404ZM30.5538 31.4565C30.5538 31.2496 30.3913 31.0877 30.1925 31.0877C29.985 31.0877 29.8224 31.2496 29.8224 31.4654C29.8224 31.6635 29.985 31.8254 30.1837 31.8254C30.3913 31.8254 30.5538 31.6635 30.5538 31.4565ZM32.9186 32.3927C32.7381 32.2129 32.5034 32.1319 32.2597 32.1319C31.9349 32.1319 31.682 32.2308 31.4473 32.4198C31.1043 32.7169 30.7976 33.3286 30.7976 33.9406C30.7976 34.4894 31.0864 34.8135 31.6549 34.8135C32.007 34.8135 32.2779 34.6963 32.5667 34.4714L32.3592 34.1205C32.1787 34.2915 31.9708 34.3905 31.7815 34.3905C31.5377 34.3905 31.4023 34.2374 31.4023 33.9406C31.4023 33.5447 31.5737 33.0136 31.7544 32.7887C31.8625 32.6539 32.0162 32.5817 32.1696 32.5817C32.323 32.5817 32.4763 32.6359 32.6118 32.7707L32.9186 32.3927ZM34.9224 32.8517C34.9224 32.9597 34.8773 33.0407 34.814 33.1037C34.6969 33.2297 34.4802 33.2747 34.1734 33.2747C34.083 33.2747 33.9838 33.2568 33.9476 33.2568C34.065 32.7799 34.3176 32.5546 34.6065 32.5546C34.8323 32.5546 34.9224 32.6806 34.9224 32.8517ZM35.4821 32.8158C35.4821 32.3656 35.1662 32.1407 34.6786 32.1407C34.3447 32.1407 34.065 32.2399 33.8121 32.4828C33.4603 32.8246 33.2345 33.3736 33.2345 33.8776C33.2345 34.4894 33.6046 34.8135 34.1463 34.8135C34.5794 34.8135 34.8773 34.6963 35.1933 34.4535L35.0216 34.1117C34.7781 34.2915 34.5614 34.3905 34.2997 34.3905C34.0197 34.3905 33.8304 34.2374 33.8304 33.9135C33.8304 33.8326 33.8483 33.6975 33.8575 33.6527C33.9025 33.6527 34.0288 33.6707 34.1734 33.6707C34.6969 33.6707 35.0399 33.5535 35.2563 33.3465C35.4008 33.2026 35.4821 33.0227 35.4821 32.8158ZM39.2006 33.0136C39.2006 33.6345 38.93 34.3905 38.4337 34.3905C38.1899 34.3905 38.0453 34.2556 38.0453 33.9495C38.0453 33.3645 38.307 32.5638 38.8126 32.5638C39.0384 32.5638 39.2006 32.6718 39.2006 33.0136ZM39.8053 33.0315C39.8053 32.4737 39.4806 32.1407 38.8938 32.1407C38.0453 32.1407 37.4497 32.9147 37.4497 33.8956C37.4497 34.4805 37.7656 34.8135 38.3341 34.8135C39.2819 34.8135 39.8053 33.9674 39.8053 33.0315ZM42.703 32.6444C42.703 32.3385 42.5134 32.1404 42.1975 32.1404C41.8454 32.1404 41.5206 32.3023 41.2769 32.5994C41.3131 32.4195 41.2769 32.2305 41.2318 32.1133L40.7172 32.3294C40.7713 32.5184 40.7622 32.6895 40.708 32.9862L40.3291 34.7502H40.8797L41.2318 33.0854C41.5024 32.7342 41.7462 32.6085 41.9358 32.6085C42.0712 32.6085 42.1342 32.6624 42.1342 32.8155C42.1342 32.8693 42.1254 32.9503 42.0983 33.0583L41.737 34.7502H42.2967L42.6848 32.9232C42.703 32.8422 42.703 32.7345 42.703 32.6444ZM46.3315 32.1949H45.7176C45.7749 31.9399 45.8442 31.6877 45.9252 31.4392L45.3296 31.574C45.2663 31.7722 45.2212 31.9612 45.167 32.1949H44.8782L44.797 32.5909H45.0858L44.779 34.0399C44.7553 34.1553 44.7432 34.2729 44.7428 34.3908C44.7428 34.6516 44.9324 34.8226 45.2754 34.8226C45.4559 34.8226 45.6275 34.7867 45.808 34.7146V34.3728C45.7267 34.4087 45.6275 34.4175 45.5463 34.4175C45.3926 34.4175 45.3116 34.3728 45.3116 34.2106C45.3116 34.1476 45.3204 34.0578 45.3387 33.9589L45.6275 32.5909H46.1239L46.3315 32.1949ZM48.913 32.6353C48.913 32.3294 48.7145 32.1313 48.3444 32.1313C48.0373 32.1313 47.6764 32.2844 47.4326 32.5723C47.4688 32.4825 47.5139 32.2844 47.541 32.1943L47.6134 31.8434C47.6855 31.5195 47.7035 31.1686 47.6493 31.0067L47.0896 31.1957C47.1258 31.3576 47.1258 31.5734 47.0446 31.9423L46.449 34.7502H46.9995L47.3513 33.0854C47.568 32.8063 47.8931 32.5994 48.1007 32.5994C48.254 32.5994 48.3353 32.6715 48.3353 32.8155C48.3353 32.8693 48.3265 32.9503 48.3082 33.0312L47.9381 34.7502H48.4887L48.877 32.9415C48.9041 32.8063 48.913 32.7074 48.913 32.6353ZM51.1785 32.8517C51.1785 32.9597 51.1426 33.0407 51.0702 33.1037C50.953 33.2297 50.7363 33.2747 50.4295 33.2747C50.3483 33.2747 50.2399 33.2568 50.2128 33.2568C50.3212 32.7799 50.5738 32.5546 50.8626 32.5546C51.0973 32.5546 51.1785 32.6806 51.1785 32.8517ZM51.7382 32.8158C51.7382 32.3656 51.4314 32.1407 50.9347 32.1407C50.6009 32.1407 50.3212 32.2399 50.0683 32.4828C49.7164 32.8246 49.4906 33.3736 49.4906 33.8776C49.4906 34.4894 49.8607 34.8135 50.4024 34.8135C50.8355 34.8135 51.1426 34.6963 51.4494 34.4535L51.2777 34.1117C51.0343 34.2915 50.8176 34.3905 50.5558 34.3905C50.2758 34.3905 50.0865 34.2374 50.0865 33.9135C50.0865 33.8326 50.1045 33.6975 50.1224 33.6527C50.1586 33.6527 50.285 33.6707 50.4295 33.6707C50.953 33.6707 51.296 33.5535 51.5127 33.3465C51.657 33.2026 51.7382 33.0227 51.7382 32.8158ZM55.4391 32.1763C55.37 32.15 55.2963 32.1378 55.2224 32.1404C54.9786 32.1404 54.6989 32.3203 54.4643 32.6173C54.5005 32.4375 54.4822 32.2485 54.4192 32.1133L53.9046 32.3294C53.9587 32.5093 53.9587 32.6983 53.8866 33.0492L53.5257 34.7502H54.0762L54.4192 33.1122C54.6447 32.7975 54.8435 32.6624 55.024 32.6624C55.0961 32.6624 55.1503 32.6715 55.1953 32.6983L55.4391 32.1763ZM57.2713 33.0136C57.2713 33.6345 57.0095 34.3905 56.5131 34.3905C56.2602 34.3905 56.116 34.2556 56.116 33.9495C56.116 33.3645 56.3777 32.5638 56.8832 32.5638C57.1087 32.5638 57.2713 32.6718 57.2713 33.0136ZM57.876 33.0315C57.876 32.4737 57.5601 32.1407 56.9733 32.1407C56.1248 32.1407 55.52 32.9147 55.52 33.8956C55.52 34.4805 55.8451 34.8135 56.4136 34.8135C57.3525 34.8135 57.876 33.9674 57.876 33.0315ZM60.1866 32.6271L59.9157 33.8779C59.7986 34.1299 59.5368 34.364 59.311 34.364C59.1217 34.364 59.0313 34.2648 59.0313 33.986C59.0313 33.6259 59.1397 33.1311 59.3652 32.8611C59.5639 32.6271 59.7264 32.5732 59.952 32.5732C60.0332 32.5732 60.1416 32.6 60.1866 32.6271ZM60.8093 32.3303C60.6109 32.1952 60.3129 32.1413 60.0153 32.1413C59.609 32.1413 59.2751 32.2762 58.9951 32.5552C58.6703 32.8882 58.4536 33.4369 58.4536 33.9948C58.4536 34.5439 58.7245 34.8138 59.1305 34.8138C59.4556 34.8138 59.7173 34.6607 59.8978 34.4179C59.8978 34.5798 59.952 34.7237 60.0874 34.8318L60.5387 34.4988C60.4124 34.364 60.3853 34.2289 60.4483 33.923L60.6559 32.915C60.6921 32.7351 60.7643 32.4743 60.8093 32.3303ZM63.129 32.708L62.8764 33.905C62.7139 34.1659 62.443 34.3548 62.2267 34.3548C62.0191 34.3548 61.9196 34.2109 61.9196 33.9321C61.9196 33.5809 62.055 33.086 62.2717 32.8432C62.3259 32.7721 62.3955 32.7141 62.4752 32.6736C62.5549 32.6331 62.6428 32.611 62.7322 32.6091C62.9215 32.6091 63.0298 32.6362 63.129 32.708ZM64.0229 31.1333L63.4903 31.0344L63.3098 31.8982C63.2916 31.9791 63.2465 32.2132 63.2465 32.2402C63.1561 32.1952 62.9848 32.1593 62.7501 32.1593C62.4613 32.1593 62.1363 32.2762 61.9016 32.519C61.5407 32.8702 61.3419 33.4102 61.3419 33.923C61.3419 34.4988 61.5766 34.7959 62.0912 34.7959C62.38 34.7959 62.6509 34.6699 62.8402 34.427C62.8314 34.5889 62.8764 34.7149 62.9397 34.7959L63.4182 34.679C63.3457 34.5618 63.3278 34.3999 63.445 33.86L64.0229 31.1333ZM3.8993 23.3222H0V24.0603H1.4353V28.3437H2.31974V24.0603H3.78213L3.8993 23.3222ZM8.18696 25.9138C8.18696 26.7958 8.00617 27.7584 6.88709 27.7584C6.38156 27.7584 6.00235 27.5965 5.82187 27.2727C5.62343 26.9306 5.50596 26.4357 5.50596 25.7698C5.50596 25.1848 5.58722 24.7709 5.7677 24.4739C5.96643 24.1409 6.35448 23.9431 6.81465 23.9431C8.03326 23.9431 8.18696 24.942 8.18696 25.9138ZM9.1977 25.8419C9.1977 24.3479 8.43956 23.2413 6.83291 23.2413C5.38878 23.2413 4.50404 24.2222 4.50404 25.824C4.50404 27.3265 5.33461 28.4243 6.88709 28.4243C8.52083 28.4243 9.1977 27.3536 9.1977 25.8419ZM13.3046 27.6059H11.4907V23.3219H10.5788V28.3437H13.1603L13.3046 27.6059ZM17.0505 27.6059H15.2363V23.3219H14.3244V28.3437H16.9059L17.0505 27.6059ZM24.1631 27.966L23.73 27.4169C23.405 27.6148 23.0799 27.7319 22.683 27.7319C22.2317 27.7319 21.8613 27.5789 21.5728 27.2459C21.2657 26.9132 21.1665 26.5441 21.1665 25.8422C21.1665 25.3112 21.2477 24.9423 21.4191 24.6452C21.6629 24.2045 22.1233 23.9434 22.6468 23.9434C23.0078 23.9434 23.3057 24.0426 23.6217 24.2225L24.0547 23.6284C23.7209 23.3764 23.1703 23.2236 22.6377 23.2236C21.1214 23.2236 20.1737 24.4836 20.1737 25.9049C20.1737 27.381 21.1032 28.4158 22.6018 28.4158C23.2245 28.4158 23.775 28.2719 24.1631 27.966ZM28.6763 25.9138C28.6763 26.7958 28.5046 27.7584 27.3855 27.7584C26.8803 27.7584 26.492 27.5965 26.3112 27.2727C26.1127 26.9306 25.9956 26.4357 25.9956 25.7698C25.9956 25.1848 26.0768 24.7709 26.2573 24.4739C26.4557 24.1409 26.8529 23.9431 27.3043 23.9431C28.5317 23.9431 28.6763 24.942 28.6763 25.9138ZM29.6961 25.8419C29.6961 24.3479 28.9292 23.2413 27.3313 23.2413C25.8781 23.2413 25.0025 24.2222 25.0025 25.824C25.0025 27.3265 25.8242 28.4243 27.3855 28.4243C29.0193 28.4243 29.6961 27.3536 29.6961 25.8419ZM33.8934 27.6059H32.0792V23.3219H31.1765V28.3437H33.758L33.8934 27.6059ZM37.7206 27.6059H35.9063V23.3219H34.9945V28.3437H37.5851L37.7206 27.6059ZM42.2155 28.3437V27.5788H39.8866V26.0851H41.647V25.3562H39.8778V24.0603H42.0079L42.1254 23.3222H38.9751V28.3437H42.2155ZM47.1438 27.966L46.7104 27.4169C46.3857 27.6148 46.0697 27.7319 45.6726 27.7319C45.2121 27.7319 44.8511 27.5789 44.5532 27.2459C44.2555 26.9132 44.156 26.5441 44.156 25.8422C44.156 25.3112 44.2373 24.9423 44.4089 24.6452C44.6527 24.2045 45.1129 23.9434 45.6363 23.9434C45.9976 23.9434 46.2953 24.0426 46.6023 24.2225L47.0446 23.6284C46.7016 23.3764 46.151 23.2236 45.6275 23.2236C44.1021 23.2236 43.1541 24.4836 43.1541 25.9049C43.1541 27.381 44.0839 28.4158 45.5913 28.4158C46.2052 28.4158 46.7646 28.2719 47.1438 27.966ZM51.8557 23.3222H47.9473V24.0603H49.3826V28.3437H50.2761V24.0603H51.7291L51.8557 23.3222Z",
              fill: "black"
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx("defs", { children: /* @__PURE__ */ e.jsx("clipPath", { id: "clip0_7739_8267", children: /* @__PURE__ */ e.jsx("rect", { width: "76.6957", height: "35", fill: "white" }) }) })
      ]
    }
  );
}
function $m(t) {
  return /* @__PURE__ */ e.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Layer_1",
      "data-name": "Layer 1",
      viewBox: "0 0 224 420",
      ...t,
      children: [
        /* @__PURE__ */ e.jsx("path", { d: "M0 0h224v420H0z", style: { fill: "#fff" } }),
        /* @__PURE__ */ e.jsx("path", { d: "m38.5 22.77-1.08 1.38c-.21.28-.39.46-.53.55-.14.08-.31.12-.51.12-.3 0-.56-.1-.77-.3-.21-.2-.32-.46-.32-.76 0-.23.15-.54.45-.93l1.17-1.5c-.95-1.23-1.42-2.65-1.42-4.27 0-2.06.71-3.73 2.13-5.03 1.13-1.03 2.4-1.55 3.8-1.55 1.14 0 2.2.34 3.17 1.03l.86-1.09c.22-.28.4-.47.54-.55.14-.09.31-.13.51-.13.29 0 .54.11.75.32s.32.47.32.77c0 .23-.15.53-.44.91l-1 1.29c.38.5.68 1.1.9 1.81.22.71.33 1.46.33 2.24 0 2-.68 3.65-2.04 4.94-1.14 1.07-2.44 1.61-3.88 1.61-1.02 0-1.99-.29-2.91-.86Zm4.77-9.58c-.6-.39-1.22-.59-1.86-.59-.99 0-1.87.42-2.65 1.26s-1.16 1.91-1.16 3.19c0 .95.22 1.79.67 2.53l5-6.39Zm-3.46 7.9c.54.28 1.07.42 1.6.42.98 0 1.87-.42 2.64-1.26s1.17-1.9 1.17-3.17c0-.82-.17-1.57-.51-2.26l-4.9 6.27ZM53.64 13.95v1.32c.89-.64 1.59-1.07 2.1-1.28.51-.21.99-.32 1.44-.32.69 0 1.36.25 2 .76.44.34.66.7.66 1.05 0 .3-.1.56-.31.77s-.46.31-.76.31c-.26 0-.54-.13-.83-.39-.29-.26-.55-.39-.77-.39-.3 0-.74.19-1.33.56-.59.37-1.32.93-2.2 1.67v3.19h3.02c.51 0 .87.1 1.09.29.22.2.33.45.33.77s-.11.56-.33.76c-.22.2-.58.29-1.09.29h-6.39c-.51 0-.87-.1-1.09-.29-.22-.2-.33-.45-.33-.77s.11-.56.33-.76c.22-.2.58-.29 1.09-.29h1.26v-5.14h-.76c-.51 0-.87-.1-1.09-.29s-.33-.45-.33-.77.11-.56.33-.76c.22-.2.58-.29 1.09-.29h2.88ZM72.08 19.71H63.4c.22.55.61.99 1.17 1.33.56.34 1.32.51 2.28.51.78 0 1.83-.17 3.13-.51.54-.14.91-.21 1.11-.21.28 0 .52.1.71.3.19.2.29.45.29.75 0 .28-.1.51-.31.7-.28.25-.95.5-2.01.73-1.07.23-2.09.35-3.08.35-1.69 0-3.05-.48-4.06-1.44-1.02-.96-1.52-2.13-1.52-3.53 0-1.49.55-2.7 1.65-3.63 1.1-.93 2.36-1.4 3.79-1.4.86 0 1.65.15 2.37.45.72.3 1.25.63 1.61.98.5.51.91 1.14 1.23 1.89.22.52.33 1.13.33 1.82v.9Zm-2.34-2.12c-.32-.61-.75-1.06-1.27-1.36s-1.15-.45-1.87-.45-1.34.15-1.86.45c-.52.3-.95.75-1.28 1.36h6.28ZM81.75 16.42c-.34-.21-.71-.37-1.08-.48-.38-.11-.77-.16-1.19-.16-.82 0-1.47.13-1.95.4-.21.12-.32.24-.32.38 0 .16.14.31.43.46.22.11.71.22 1.48.32 1.4.19 2.38.39 2.93.58.72.25 1.28.63 1.67 1.14.39.5.59 1.03.59 1.59 0 .76-.33 1.39-1 1.9-.96.74-2.2 1.1-3.73 1.1-.61 0-1.18-.05-1.7-.16s-1-.26-1.43-.47c-.1.09-.21.16-.33.21-.12.05-.24.07-.36.07-.33 0-.59-.11-.79-.33s-.29-.58-.29-1.09v-.71c0-.51.1-.87.29-1.09s.45-.33.77-.33c.25 0 .47.07.64.21.17.14.31.38.4.73.32.28.71.48 1.17.62.45.14.98.21 1.57.21.97 0 1.72-.15 2.26-.45.25-.15.38-.31.38-.47 0-.28-.18-.5-.55-.68-.37-.18-1.12-.33-2.26-.45-1.7-.18-2.84-.52-3.41-1.03-.57-.5-.86-1.12-.86-1.86s.32-1.39.96-1.89c.87-.69 2-1.03 3.41-1.03.49 0 .96.05 1.41.14.45.09.88.24 1.3.43.13-.1.25-.17.37-.22.11-.05.22-.07.31-.07.29 0 .53.11.72.33.19.22.29.58.29 1.09v.52c0 .46-.06.77-.17.94-.22.32-.52.47-.9.47-.25 0-.48-.08-.67-.24a1.07 1.07 0 0 1-.37-.63ZM96.65 13.95v7.26c.45 0 .78.1.99.3s.32.45.32.76-.11.56-.33.76c-.22.2-.58.29-1.09.29h-2.01v-.49c-.61.28-1.18.48-1.73.62s-1.07.21-1.57.21c-.7 0-1.3-.15-1.81-.44s-.91-.7-1.21-1.21c-.21-.37-.32-.84-.32-1.39v-4.55h-.36c-.51 0-.87-.1-1.09-.29-.22-.2-.33-.45-.33-.77s.11-.56.33-.76c.22-.2.58-.29 1.09-.29h2.48v6.3c0 .45.11.78.33.99s.55.31 1 .31.89-.08 1.38-.25c.49-.17 1.1-.47 1.82-.91v-4.32h-.76c-.51 0-.87-.1-1.09-.29s-.33-.45-.33-.77.11-.56.33-.76c.22-.2.58-.29 1.09-.29h2.88ZM102.7 13.95v.71c.39-.33.81-.58 1.27-.74.46-.17.97-.25 1.51-.25 1.25 0 2.24.39 2.97 1.17.58.62.87 1.43.87 2.44v3.93c.45 0 .78.1.99.29.21.2.32.45.32.77s-.11.56-.33.76c-.22.2-.58.29-1.09.29h-1.91c-.51 0-.87-.1-1.09-.29-.22-.2-.33-.45-.33-.77s.11-.56.32-.76c.21-.2.54-.29.99-.29v-4c0-.46-.12-.8-.37-1.01-.32-.28-.81-.41-1.46-.41-.49 0-.92.09-1.29.28-.37.19-.83.59-1.4 1.2v3.93c.54 0 .89.05 1.05.15.34.21.51.51.51.91 0 .31-.11.56-.33.76-.22.2-.58.29-1.09.29h-2.41c-.51 0-.87-.1-1.09-.29a.984.984 0 0 1-.33-.77c0-.39.17-.69.5-.9.17-.1.52-.15 1.06-.15v-5.14c-.45 0-.78-.1-.99-.3-.21-.2-.32-.45-.32-.76s.11-.56.33-.76c.22-.2.58-.29 1.09-.29h2.01ZM122.39 9.93v11.28h.36c.5 0 .86.1 1.08.29.22.2.33.45.33.77s-.11.56-.33.76c-.22.2-.58.29-1.09.29h-2.48v-.52c-.48.28-.99.5-1.51.64-.53.14-1.07.22-1.64.22-1.59 0-2.87-.46-3.84-1.38s-1.45-2.06-1.45-3.43.51-2.65 1.53-3.67c1.02-1.01 2.26-1.52 3.73-1.52.55 0 1.09.08 1.62.25.53.17 1.05.42 1.57.76v-2.63h-.36c-.51 0-.87-.1-1.09-.29s-.33-.45-.33-.76.11-.57.33-.77c.22-.2.58-.29 1.09-.29h2.48Zm-2.12 8.98c0-.87-.31-1.61-.92-2.22-.61-.61-1.36-.91-2.25-.91s-1.63.3-2.24.91-.92 1.34-.92 2.19c0 .78.28 1.42.83 1.92s1.33.75 2.33.75 1.78-.25 2.33-.75.84-1.13.84-1.88ZM132.51 16.42c-.34-.21-.71-.37-1.08-.48-.38-.11-.77-.16-1.19-.16-.82 0-1.47.13-1.95.4-.21.12-.32.24-.32.38 0 .16.14.31.43.46.22.11.71.22 1.48.32 1.4.19 2.38.39 2.93.58.72.25 1.28.63 1.67 1.14s.59 1.03.59 1.59c0 .76-.33 1.39-1 1.9-.96.74-2.2 1.1-3.73 1.1-.61 0-1.18-.05-1.7-.16s-1-.26-1.43-.47c-.1.09-.21.16-.33.21s-.24.07-.36.07c-.33 0-.59-.11-.79-.33s-.29-.58-.29-1.09v-.71c0-.51.1-.87.29-1.09s.45-.33.77-.33c.25 0 .47.07.64.21s.31.38.4.73c.32.28.71.48 1.17.62.46.14.98.21 1.57.21.97 0 1.72-.15 2.26-.45.25-.15.38-.31.38-.47 0-.28-.18-.5-.55-.68-.37-.18-1.12-.33-2.26-.45-1.7-.18-2.84-.52-3.41-1.03-.57-.5-.86-1.12-.86-1.86s.32-1.39.96-1.89c.87-.69 2-1.03 3.41-1.03.49 0 .96.05 1.41.14.45.09.88.24 1.3.43.13-.1.25-.17.37-.22.11-.05.22-.07.31-.07.29 0 .53.11.72.33s.29.58.29 1.09v.52c0 .46-.05.77-.17.94-.22.32-.52.47-.9.47-.25 0-.48-.08-.67-.24s-.32-.37-.37-.63ZM140.24 9.93v4.75c.52-.34 1.04-.59 1.58-.76.53-.17 1.07-.25 1.62-.25 1.47 0 2.71.51 3.73 1.52s1.53 2.23 1.53 3.67-.49 2.51-1.46 3.43-2.25 1.38-3.84 1.38c-.56 0-1.11-.07-1.63-.22a6.47 6.47 0 0 1-1.52-.64v.52h-2.48c-.51 0-.87-.1-1.09-.29-.22-.2-.33-.45-.33-.77s.11-.56.33-.76c.22-.2.58-.29 1.08-.29h.36v-9.16h-.36c-.51 0-.87-.1-1.09-.29s-.33-.45-.33-.77.11-.56.33-.76c.22-.2.58-.29 1.09-.29h2.48Zm6.33 8.98c0-.87-.31-1.61-.92-2.22-.61-.61-1.36-.91-2.25-.91s-1.63.3-2.24.91-.92 1.34-.92 2.19c0 .78.28 1.42.83 1.92s1.33.75 2.33.75 1.78-.25 2.34-.75c.55-.5.83-1.13.83-1.88ZM155.16 13.95v1.32c.89-.64 1.59-1.07 2.1-1.28.51-.21.99-.32 1.44-.32.69 0 1.36.25 2 .76.44.34.66.7.66 1.05 0 .3-.11.56-.32.77s-.46.31-.76.31c-.26 0-.54-.13-.83-.39-.29-.26-.55-.39-.77-.39-.3 0-.74.19-1.33.56-.59.37-1.32.93-2.2 1.67v3.19h3.01c.51 0 .87.1 1.09.29.22.2.33.45.33.77s-.11.56-.33.76c-.22.2-.58.29-1.09.29h-6.39c-.51 0-.87-.1-1.09-.29-.22-.2-.33-.45-.33-.77s.11-.56.33-.76c.22-.2.58-.29 1.09-.29h1.26v-5.14h-.76c-.51 0-.87-.1-1.09-.29-.22-.2-.33-.45-.33-.77s.11-.56.33-.76c.22-.2.58-.29 1.09-.29h2.88ZM173.79 18.81c0 .81-.23 1.6-.68 2.36s-1.12 1.37-2.01 1.82-1.82.68-2.79.68-1.89-.22-2.77-.67c-.88-.44-1.55-1.05-2.01-1.81-.46-.76-.69-1.56-.69-2.4s.23-1.68.7-2.49c.47-.82 1.14-1.46 2.02-1.93.88-.47 1.79-.7 2.75-.7s1.89.24 2.78.72c.89.48 1.56 1.12 2.02 1.93.45.81.68 1.64.68 2.49Zm-2.12.01c0-.68-.24-1.31-.73-1.88-.67-.77-1.54-1.16-2.63-1.16-.96 0-1.75.31-2.4.92-.64.61-.96 1.32-.96 2.13 0 .66.32 1.28.97 1.85.65.57 1.44.86 2.38.86s1.75-.29 2.4-.86c.65-.57.97-1.2.97-1.86ZM178.84 13.95v.71c.39-.33.81-.58 1.28-.74.46-.17.97-.25 1.51-.25 1.25 0 2.24.39 2.97 1.17.58.62.87 1.43.87 2.44v3.93c.45 0 .78.1.99.29.21.2.32.45.32.77s-.11.56-.33.76c-.22.2-.58.29-1.09.29h-1.91c-.51 0-.87-.1-1.09-.29-.22-.2-.33-.45-.33-.77s.11-.56.32-.76c.21-.2.54-.29.99-.29v-4c0-.46-.12-.8-.37-1.01-.32-.28-.81-.41-1.46-.41-.49 0-.92.09-1.29.28-.37.19-.83.59-1.4 1.2v3.93c.54 0 .9.05 1.05.15.34.21.51.51.51.91 0 .31-.11.56-.33.76-.22.2-.58.29-1.09.29h-2.41c-.51 0-.87-.1-1.09-.29a.984.984 0 0 1-.33-.77c0-.39.17-.69.5-.9.17-.1.52-.15 1.06-.15v-5.14c-.45 0-.78-.1-.99-.3-.21-.2-.32-.45-.32-.76s.11-.56.33-.76c.22-.2.58-.29 1.09-.29h2.01Z" }),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            style: { fill: "#ccc" },
            d: "M89.19 34h44v10h-44zM73.19 47h76v10h-76zM58.69 68h105v10h-105zM67.69 84h87v10h-87zM20 138h87v10H20zM28 166h106v10H28zM128 138h17v10h-17zM128 153h17v10h-17zM128 194h17v10h-17zM128 209h17v10h-17zM128 235h17v10h-17zM128 251h17v10h-17zM83 278h59v10H83zM95 294h35v10H95zM19 320h45v10H19zM78 320h55v10H78zM141 320h26v10h-26zM170 138h41v10h-41zM183 153h28v10h-28zM176 194h35v10h-35zM182 209h29v10h-29zM177 235h34v10h-34zM172 251h39v10h-39zM20 194h28v10H20zM20 209h66v10H20zM20 235h86v10H20zM20 251h39v10H20z"
          }
        ),
        /* @__PURE__ */ e.jsx("path", { d: "M20.83 341.97V343h.34c.22 0 .38.04.48.13.1.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-1.42c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.15-.33c.1-.09.26-.13.48-.13h.15v-3.65h-.15c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.34c.1-.09.26-.13.48-.13h1.42c.22 0 .38.05.48.13.1.08.14.2.14.34s-.05.25-.14.34c-.1.09-.26.13-.48.13h-.34v1.38l1.66-1.43a.629.629 0 0 1-.2-.2.379.379 0 0 1-.05-.22c0-.14.05-.26.14-.35.1-.09.26-.13.48-.13h.95c.22 0 .38.05.48.13.1.08.14.2.14.34s-.05.25-.14.34c-.1.09-.25.13-.45.13l-1.68 1.47c.31.18.61.45.88.82.27.37.52.82.73 1.37h.25c.22 0 .38.04.48.13.1.09.14.2.14.34s-.05.25-.14.33c-.09.09-.25.13-.48.13h-.85c-.19-.46-.41-.91-.64-1.33-.19-.34-.37-.59-.54-.75s-.37-.28-.6-.38l-.57.49ZM27.4 342.81l1.01-2.07c-.25 0-.41-.02-.48-.06a.454.454 0 0 1-.23-.41c0-.14.05-.25.14-.33.1-.09.26-.13.48-.13h1.28c.22 0 .38.04.48.13.1.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-.15l-1.56 3.2h-.97l-1.56-3.2h-.13c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h1.25c.22 0 .38.04.48.13.1.09.14.2.14.34 0 .17-.07.3-.22.4-.07.04-.24.07-.49.07l1.02 2.07ZM33.45 339.81v3.2h1.12c.22 0 .38.04.48.13.1.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13H31.4c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h1.12v-2.27h-.75c-.22 0-.38-.04-.48-.13-.1-.09-.15-.2-.15-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h1.68Zm-.13-1.77v.99h-1.11v-.99h1.11ZM38.35 340.74v1.87c0 .2.04.33.12.4.13.1.36.15.68.15.48 0 .92-.1 1.32-.3.15-.08.28-.12.36-.12.12 0 .23.04.32.14.09.09.13.2.13.33 0 .12-.05.23-.15.31-.15.14-.44.27-.88.39s-.81.18-1.11.18c-.58 0-1.01-.12-1.3-.38-.29-.25-.44-.56-.44-.92v-2.05h-.34c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h.34v-.84c0-.22.04-.38.13-.48s.2-.14.34-.14.25.05.33.14.13.26.13.48v.84h1.73c.22 0 .38.04.48.13.1.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-1.73ZM43.95 340.74v1.87c0 .2.04.33.12.4.13.1.36.15.68.15.48 0 .92-.1 1.32-.3.15-.08.28-.12.36-.12.12 0 .23.04.32.14.09.09.13.2.13.33 0 .12-.05.23-.15.31-.15.14-.44.27-.88.39s-.81.18-1.11.18c-.58 0-1.01-.12-1.3-.38-.29-.25-.44-.56-.44-.92v-2.05h-.34c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13H43v-.84c0-.22.04-.38.13-.48s.2-.14.34-.14.25.05.33.14.13.26.13.48v.84h1.73c.22 0 .38.04.48.13.1.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-1.73ZM52.2 341.95c0 .36-.1.71-.3 1.04s-.49.6-.89.8c-.39.2-.8.3-1.23.3s-.83-.1-1.22-.29c-.39-.2-.68-.46-.89-.8-.2-.34-.31-.69-.31-1.06s.1-.74.31-1.1c.21-.36.5-.64.89-.85.39-.21.79-.31 1.21-.31s.83.11 1.23.32.69.5.89.85.3.72.3 1.1Zm-.94.01c0-.3-.11-.58-.32-.83-.29-.34-.68-.51-1.16-.51-.42 0-.77.13-1.06.41-.28.27-.42.58-.42.94 0 .29.14.56.43.82.29.25.64.38 1.05.38s.77-.13 1.06-.38c.29-.25.43-.53.43-.82ZM54.42 339.81v.31c.17-.15.36-.25.56-.33.21-.07.43-.11.67-.11.55 0 .99.17 1.31.51.25.27.38.63.38 1.07v1.73c.2 0 .34.04.44.13.09.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-.84c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.09-.09.24-.13.44-.13v-1.76c0-.2-.05-.35-.16-.45-.14-.12-.36-.18-.64-.18-.22 0-.4.04-.57.12-.16.08-.37.26-.62.53v1.73c.24 0 .39.02.46.07.15.09.22.22.22.4 0 .14-.05.25-.14.33-.1.09-.26.13-.48.13h-1.06c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34 0-.17.07-.3.22-.4.07-.04.23-.07.47-.07v-2.27c-.2 0-.34-.04-.44-.13-.09-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h.89ZM62.95 339.81v3.2c.2 0 .34.04.44.13.09.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-.89v-.21c-.27.12-.52.21-.77.27-.24.06-.47.09-.69.09-.31 0-.57-.06-.8-.19s-.4-.31-.53-.54a1.25 1.25 0 0 1-.14-.61v-2.01h-.16c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h1.09v2.78c0 .2.05.34.14.43.1.09.24.14.44.14s.39-.04.61-.11.48-.21.8-.4v-1.9h-.34c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h1.27ZM65.12 339.81v.26c.15-.15.29-.25.41-.31s.27-.08.43-.08c.14 0 .27.03.41.1.13.07.26.17.39.3.16-.13.32-.23.49-.3s.33-.1.51-.1c.35 0 .63.09.84.28.29.24.43.56.43.96v2.09c.19 0 .34.04.43.13.09.09.14.2.14.34s-.05.25-.14.33c-.09.09-.25.13-.48.13h-.89v-2.95c0-.14-.03-.24-.08-.3s-.13-.08-.24-.08-.2.03-.29.08c-.11.08-.25.22-.41.43V343c.19 0 .34.04.43.13.09.09.14.2.14.34s-.05.25-.14.33c-.09.09-.25.13-.48.13h-.89v-2.95c0-.14-.03-.24-.08-.29-.05-.06-.13-.08-.24-.08s-.22.03-.32.1c-.11.07-.23.2-.38.41V343c.19 0 .34.04.43.13.1.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-.84c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.09-.09.24-.13.44-.13v-2.27c-.2 0-.34-.04-.44-.13-.09-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h.89Z" }),
        /* @__PURE__ */ e.jsx("path", { d: "M70.71 339.81v.26c.15-.15.29-.25.41-.31s.27-.08.43-.08c.14 0 .27.03.41.1.13.07.26.17.39.3.16-.13.32-.23.49-.3s.33-.1.51-.1c.35 0 .63.09.84.28.29.24.43.56.43.96v2.09c.19 0 .34.04.43.13.09.09.14.2.14.34s-.05.25-.14.33c-.09.09-.25.13-.48.13h-.89v-2.95c0-.14-.03-.24-.08-.3s-.13-.08-.24-.08-.2.03-.29.08c-.11.08-.25.22-.41.43V343c.19 0 .34.04.43.13.09.09.14.2.14.34s-.05.25-.14.33c-.09.09-.25.13-.48.13h-.89v-2.95c0-.14-.03-.24-.08-.29-.05-.06-.13-.08-.24-.08s-.22.03-.32.1c-.11.07-.23.2-.38.41V343c.19 0 .34.04.43.13.1.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-.84c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.09-.09.24-.13.44-.13v-2.27c-.2 0-.34-.04-.44-.13-.09-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h.89ZM80.09 342.35h-3.83c.1.24.27.44.52.59.25.15.58.22 1 .22.35 0 .81-.07 1.38-.22.24-.06.4-.09.49-.09.12 0 .23.04.31.13s.13.2.13.33c0 .12-.05.22-.14.31-.12.11-.42.22-.89.32-.47.1-.92.15-1.36.15-.75 0-1.34-.21-1.79-.63-.45-.42-.67-.94-.67-1.56 0-.66.24-1.19.73-1.6.48-.41 1.04-.62 1.67-.62.38 0 .73.07 1.04.2.32.13.55.28.71.43.22.22.4.5.54.83.1.23.15.5.15.8v.4Zm-1.03-.93a1.42 1.42 0 0 0-.56-.6c-.23-.13-.51-.2-.82-.2s-.59.07-.82.2c-.23.13-.42.33-.56.6h2.77ZM83.15 339.81v.58c.39-.28.7-.47.93-.56.23-.09.44-.14.63-.14.3 0 .6.11.88.34.19.15.29.31.29.46 0 .13-.05.25-.14.34-.09.09-.2.14-.33.14-.12 0-.24-.06-.36-.17s-.24-.17-.34-.17c-.13 0-.33.08-.58.25-.26.16-.58.41-.97.74v1.41h1.33c.22 0 .38.04.48.13.1.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-2.82c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h.56v-2.27h-.34c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h1.27ZM89.64 340.43c0 .18-.06.32-.19.44s-.3.18-.51.18-.39-.06-.51-.18-.19-.27-.19-.44.06-.32.19-.44c.12-.12.3-.18.51-.18s.39.06.51.18.19.27.19.44Zm.01 3.06c0 .18-.06.32-.19.44-.12.12-.3.18-.51.18s-.39-.06-.51-.18-.19-.27-.19-.44.06-.32.19-.44c.12-.12.3-.18.51-.18s.39.06.51.18.19.27.19.44ZM100.61 337.9v5.11h.94c.22 0 .38.04.48.13.1.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-2.82c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h.94v-3.89l-.83.22c-.13.04-.23.05-.3.05-.12 0-.22-.05-.31-.14a.475.475 0 0 1-.13-.35c0-.12.03-.22.1-.29.06-.07.2-.13.4-.19l2.01-.52ZM104.85 343.01h2.04c.11-.09.22-.14.32-.14.14 0 .26.05.34.14s.12.25.12.48v.45h-4.25v-.99c1.68-1.39 2.7-2.28 3.05-2.68.18-.2.26-.4.26-.58 0-.23-.1-.43-.3-.6-.2-.17-.46-.26-.79-.26s-.61.1-.83.29c-.12.1-.21.26-.28.46-.04.13-.1.22-.18.27-.07.05-.17.08-.28.08-.13 0-.24-.04-.33-.14a.448.448 0 0 1-.14-.32c0-.18.08-.41.25-.68.17-.27.41-.49.74-.66s.67-.25 1.05-.25c.59 0 1.07.18 1.45.53.38.36.56.79.56 1.3 0 .26-.05.5-.16.72-.11.22-.37.52-.78.91-.32.31-.95.86-1.88 1.65ZM112.65 340.82a2 2 0 0 1 .62.65c.14.25.21.52.21.83 0 .33-.09.64-.27.92-.18.28-.44.49-.79.64-.34.14-.79.22-1.35.22-.72 0-1.27-.11-1.63-.34-.2-.13-.3-.28-.3-.46 0-.13.04-.25.13-.34a.453.453 0 0 1 .6-.05c.13.09.26.15.38.18.18.04.43.06.75.06.54 0 .94-.07 1.18-.21.24-.14.36-.34.36-.6 0-.19-.07-.38-.21-.55-.14-.18-.33-.32-.57-.41-.14-.05-.37-.09-.69-.11-.15 0-.27-.06-.36-.14a.454.454 0 0 1-.12-.32.476.476 0 0 1 .49-.48h.5c.12-.01.24-.05.36-.12a.78.78 0 0 0 .4-.64c0-.2-.09-.37-.26-.51s-.44-.22-.78-.22c-.45 0-.79.13-1.03.39-.07.08-.13.12-.17.15-.06.03-.14.05-.21.05-.13 0-.24-.05-.33-.14a.46.46 0 0 1-.14-.34c0-.21.14-.41.42-.61.41-.29.92-.43 1.53-.43.58 0 1.04.16 1.39.49.35.33.52.72.52 1.18 0 .24-.05.46-.15.67s-.26.4-.46.58ZM118.29 338.05v3.65c.2 0 .34.04.44.13.09.09.14.2.14.33s-.05.25-.14.34-.24.13-.43.13v.37c.2 0 .34.04.44.13.09.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-1.25c-.22 0-.38-.04-.48-.13-.1-.09-.14-.2-.14-.34s.05-.25.14-.33c.1-.09.26-.13.48-.13h.36v-.37h-2.54v-.78l2.24-3.81h1.23Zm-.94 3.65v-2.29L116 341.7h1.35ZM121.73 338.98v1.11c.35-.11.66-.16.94-.16.57 0 1.05.2 1.43.59.38.39.57.9.57 1.52s-.19 1.14-.58 1.5c-.38.36-.97.54-1.76.54-.7 0-1.25-.13-1.66-.4-.24-.15-.36-.33-.36-.52 0-.12.05-.23.14-.33.09-.09.2-.14.33-.14.11 0 .22.05.35.15.12.1.25.17.39.21.19.06.44.09.75.09.56 0 .95-.09 1.16-.27.21-.18.31-.46.31-.83s-.1-.66-.3-.87c-.2-.21-.45-.31-.77-.31-.34 0-.72.11-1.15.33-.1.05-.18.08-.25.08-.13 0-.25-.05-.33-.15a.532.532 0 0 1-.13-.38v-2.7h2.85c.22 0 .38.04.48.13.1.09.14.2.14.34s-.05.25-.14.33c-.1.09-.26.13-.48.13h-1.92ZM127.23 340.75c.22-.19.44-.33.64-.41.2-.09.42-.13.65-.13.49 0 .92.19 1.28.58.37.39.55.88.55 1.46 0 .54-.17.98-.51 1.32-.34.33-.81.5-1.39.5-.49 0-.89-.11-1.21-.34s-.55-.58-.71-1.05-.24-1-.24-1.58c0-.7.16-1.28.48-1.74.32-.46.69-.82 1.12-1.08s.89-.38 1.37-.38c.38 0 .67.07.88.22.14.1.21.23.21.38 0 .14-.05.25-.14.34-.09.09-.2.14-.33.14-.07 0-.18-.04-.31-.11a.533.533 0 0 0-.24-.06c-.3 0-.61.08-.92.25-.32.17-.59.43-.83.78-.16.24-.28.55-.35.91Zm.14 1.45c.1.36.23.61.39.75.17.13.4.2.71.2s.54-.08.71-.24c.17-.16.25-.38.25-.66 0-.32-.09-.58-.28-.79-.19-.21-.4-.31-.64-.31-.19 0-.39.09-.6.28s-.39.44-.53.77ZM134.67 338.98h-2.14c-.01.18-.06.31-.14.39-.08.08-.19.12-.32.12s-.25-.05-.34-.14c-.09-.09-.13-.25-.13-.48v-.83h4.05v.93l-1.51 4.5c-.06.19-.13.31-.21.38-.08.06-.17.09-.28.09-.13 0-.24-.04-.33-.14a.444.444 0 0 1-.14-.31c0-.07.02-.17.07-.32l1.42-4.2Z" }),
        /* @__PURE__ */ e.jsx(
          "ellipse",
          {
            cx: "77.88",
            cy: "341.43",
            rx: "63.81",
            ry: "15.46",
            style: {
              fill: "none",
              stroke: "red",
              strokeMiterlimit: 10,
              strokeWidth: "2px"
            }
          }
        ),
        /* @__PURE__ */ e.jsx("path", { d: "m46.9 113.83-1.8-.58c-.43-.14-.7-.28-.81-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07s.45-.32.76-.32.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31s.3.45.3.73c0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74-.2.2-.45.31-.73.31-.21 0-.39-.04-.52-.13s-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.59s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54ZM59.42 113.83l-1.8-.58c-.43-.14-.7-.28-.81-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07s.45-.32.76-.32.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31s.3.45.3.73c0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74-.2.2-.45.31-.73.31-.21 0-.39-.04-.52-.13s-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.59s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54ZM71.93 113.83l-1.8-.58c-.43-.14-.7-.28-.81-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07s.45-.32.76-.32.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31s.3.45.3.73c0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74-.2.2-.45.31-.73.31-.21 0-.39-.04-.52-.13s-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.59s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54ZM83.98 117.33v2.31h.75c.5 0 .86.1 1.07.29s.32.45.32.76-.11.55-.32.75c-.21.19-.57.29-1.07.29h-3.17c-.5 0-.86-.1-1.07-.29-.21-.19-.32-.45-.32-.76s.11-.56.33-.75.57-.29 1.07-.29h.33v-8.17h-.33c-.5 0-.86-.1-1.07-.29s-.32-.45-.32-.76.11-.56.32-.76c.21-.19.57-.29 1.07-.29h3.17c.5.01.86.11 1.07.3s.32.44.32.75-.11.57-.32.76-.57.29-1.07.29h-.75v3.1l3.71-3.19c-.22-.16-.37-.3-.45-.44s-.12-.3-.12-.5c0-.32.11-.58.32-.77s.57-.3 1.07-.3h2.13c.5.01.86.11 1.07.3s.32.44.32.75-.11.56-.32.75c-.21.2-.55.29-1 .29l-3.75 3.28c.7.4 1.36 1.01 1.97 1.83.61.82 1.16 1.84 1.63 3.06h.56c.5 0 .85.1 1.06.29s.32.45.32.76-.11.55-.32.75c-.21.19-.57.29-1.07.29h-1.89c-.43-1.04-.91-2.03-1.43-2.97-.42-.77-.82-1.33-1.2-1.68-.38-.35-.83-.63-1.35-.84l-1.28 1.09ZM104.53 115.56c0 1.85-.59 3.4-1.77 4.63-1.18 1.23-2.54 1.85-4.09 1.85-1.39 0-2.65-.51-3.77-1.54-1.39-1.27-2.08-2.92-2.08-4.94s.69-3.67 2.08-4.95c1.12-1.03 2.38-1.54 3.77-1.54 1.55 0 2.91.62 4.09 1.85 1.18 1.23 1.77 2.78 1.77 4.64Zm-2.09 0c0-1.27-.38-2.32-1.15-3.15s-1.64-1.25-2.62-1.25-1.84.42-2.61 1.25-1.15 1.88-1.15 3.15.38 2.31 1.15 3.14c.77.83 1.64 1.25 2.61 1.25s1.85-.41 2.62-1.24 1.15-1.88 1.15-3.15ZM109.98 117.49v2.15h2.11c.5 0 .86.1 1.07.29s.32.45.32.76-.11.55-.32.75c-.21.19-.57.29-1.07.29h-4.52c-.5 0-.86-.1-1.07-.29-.21-.19-.32-.45-.32-.76s.11-.56.33-.75.57-.29 1.07-.29h.33v-8.17h-.33c-.5 0-.86-.1-1.07-.29s-.32-.45-.32-.76.11-.56.32-.76c.21-.19.57-.29 1.07-.29h4.81c1.41.01 2.53.4 3.35 1.17.83.77 1.24 1.71 1.24 2.82 0 .61-.14 1.19-.42 1.73-.21.41-.56.81-1.05 1.21-.49.4-1 .7-1.51.9s-1.19.3-2.03.3h-1.98Zm0-2.08h1.94c.91 0 1.63-.21 2.16-.62s.8-.9.8-1.48c0-.49-.22-.92-.65-1.28-.43-.37-1.05-.55-1.85-.55h-2.4v3.93ZM124.75 111.47v8.17h2.11c.5 0 .86.1 1.07.29s.32.45.32.76-.11.55-.32.75c-.21.19-.57.29-1.07.29h-6.3c-.5 0-.86-.1-1.07-.29-.21-.19-.32-.45-.32-.76s.11-.56.32-.75.57-.29 1.07-.29h2.11v-8.17h-2.11c-.5 0-.86-.1-1.07-.29s-.32-.45-.32-.76.11-.56.32-.76c.21-.19.57-.29 1.07-.29h6.3c.5.01.86.11 1.07.3s.32.44.32.75-.11.57-.32.76-.57.29-1.07.29h-2.11ZM138.77 118.37h-5.07l-.51 1.27h.51c.5 0 .86.1 1.07.29s.32.45.32.76-.11.55-.32.75c-.21.19-.57.29-1.07.29h-2.81c-.5 0-.86-.1-1.07-.29-.21-.19-.32-.45-.32-.76s.11-.57.34-.76c.22-.2.59-.29 1.11-.27l3.28-8.17h-1.36c-.5 0-.86-.1-1.08-.29s-.32-.45-.32-.76.11-.56.32-.76c.21-.19.57-.29 1.08-.29h4.51l4.16 10.27c.49 0 .81.05.97.16.31.22.47.52.47.89 0 .31-.11.55-.32.75-.21.19-.57.29-1.07.29h-2.81c-.5 0-.86-.1-1.07-.29-.21-.19-.32-.45-.32-.76s.11-.56.32-.75c.21-.19.57-.29 1.07-.29h.51l-.5-1.27Zm-.87-2.09-1.68-4.13-1.69 4.13h3.37ZM147.03 113.83l-1.8-.58c-.43-.14-.7-.28-.82-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07.19-.21.45-.32.76-.32s.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31s.3.45.3.73c0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74-.2.2-.45.31-.73.31-.21 0-.38-.04-.52-.13s-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.59s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54ZM159.54 113.83l-1.8-.58c-.43-.14-.7-.28-.82-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07.19-.21.45-.32.76-.32s.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31s.3.45.3.73c0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74-.2.2-.45.31-.73.31-.21 0-.38-.04-.52-.13s-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.59s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54ZM172.06 113.83l-1.8-.58c-.43-.14-.7-.28-.82-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07.19-.21.45-.32.76-.32s.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31s.3.45.3.73c0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74-.2.2-.45.31-.73.31-.21 0-.38-.04-.52-.13s-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.59s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54ZM47.4 392.73l-1.8-.58c-.43-.14-.7-.28-.81-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07s.45-.32.76-.32.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31.2.2.3.45.3.73 0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74-.2.2-.45.31-.73.31-.21 0-.39-.04-.52-.13-.14-.09-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.58s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54ZM59.92 392.73l-1.8-.58c-.43-.14-.7-.28-.81-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07s.45-.32.76-.32.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31.2.2.3.45.3.73 0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74-.2.2-.45.31-.73.31-.21 0-.39-.04-.52-.13-.14-.09-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.58s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54ZM72.44 392.73l-1.8-.58c-.43-.14-.7-.28-.81-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07s.45-.32.76-.32.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31.2.2.3.45.3.73 0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74-.2.2-.45.31-.73.31-.21 0-.39-.04-.52-.13-.14-.09-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.58s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54ZM84.48 396.24v2.31h.75c.5 0 .86.1 1.07.29s.32.45.32.76-.11.55-.32.75c-.21.19-.57.29-1.07.29h-3.17c-.5 0-.86-.1-1.07-.29-.21-.19-.32-.45-.32-.76s.11-.56.33-.75.57-.29 1.07-.29h.33v-8.17h-.33c-.5 0-.86-.1-1.07-.29s-.32-.45-.32-.76.11-.57.32-.76.57-.29 1.07-.29h3.17c.5 0 .86.11 1.07.29.21.19.32.44.32.75s-.11.57-.32.76-.57.29-1.07.29h-.75v3.1l3.71-3.19c-.22-.16-.37-.3-.45-.44s-.12-.3-.12-.5c0-.32.11-.58.32-.77.21-.2.57-.29 1.07-.29h2.13c.5 0 .86.11 1.07.29.21.19.32.44.32.75s-.11.56-.32.75c-.21.2-.55.29-1 .29l-3.75 3.28c.7.4 1.36 1.01 1.97 1.83.61.82 1.16 1.84 1.63 3.05h.56c.5 0 .85.1 1.06.29s.32.45.32.76-.11.55-.32.75c-.21.19-.57.29-1.07.29h-1.89c-.43-1.04-.91-2.03-1.43-2.97-.42-.77-.82-1.33-1.2-1.68-.38-.35-.83-.63-1.35-.84l-1.28 1.09ZM105.03 394.46c0 1.85-.59 3.4-1.77 4.63-1.18 1.23-2.54 1.85-4.09 1.85-1.39 0-2.65-.51-3.77-1.54-1.39-1.27-2.08-2.92-2.08-4.94s.69-3.67 2.08-4.95c1.12-1.03 2.38-1.54 3.77-1.54 1.55 0 2.91.62 4.09 1.85 1.18 1.23 1.77 2.78 1.77 4.64Zm-2.09 0c0-1.27-.38-2.32-1.15-3.15-.77-.83-1.64-1.25-2.62-1.25s-1.84.42-2.61 1.25-1.15 1.88-1.15 3.15.38 2.31 1.15 3.14c.77.83 1.64 1.25 2.61 1.25s1.85-.41 2.62-1.24 1.15-1.88 1.15-3.15ZM110.48 396.4v2.15h2.11c.5 0 .86.1 1.07.29s.32.45.32.76-.11.55-.32.75c-.21.19-.57.29-1.07.29h-4.52c-.5 0-.86-.1-1.07-.29-.21-.19-.32-.45-.32-.76s.11-.56.33-.75.57-.29 1.07-.29h.33v-8.17h-.33c-.5 0-.86-.1-1.07-.29s-.32-.45-.32-.76.11-.57.32-.76.57-.29 1.07-.29h4.81c1.41 0 2.53.4 3.35 1.17.83.77 1.24 1.71 1.24 2.82 0 .61-.14 1.19-.42 1.73-.21.41-.56.81-1.05 1.21-.49.4-1 .7-1.51.9s-1.19.3-2.03.3h-1.98Zm0-2.09h1.93c.91 0 1.63-.21 2.16-.62.53-.41.8-.9.8-1.48 0-.49-.22-.92-.65-1.28-.43-.37-1.05-.55-1.85-.55h-2.4v3.93ZM125.25 390.38v8.17h2.11c.5 0 .86.1 1.07.29s.32.45.32.76-.11.55-.32.75c-.21.19-.57.29-1.07.29h-6.3c-.5 0-.86-.1-1.07-.29-.21-.19-.32-.45-.32-.76s.11-.56.32-.75.57-.29 1.07-.29h2.11v-8.17h-2.11c-.5 0-.86-.1-1.07-.29s-.32-.45-.32-.76.11-.57.32-.76.57-.29 1.07-.29h6.3c.5 0 .86.11 1.07.29.21.19.32.44.32.75s-.11.57-.32.76-.57.29-1.07.29h-2.11ZM139.27 397.27h-5.07l-.51 1.27h.51c.5 0 .86.1 1.07.29s.32.45.32.76-.11.55-.32.75c-.21.19-.57.29-1.07.29h-2.81c-.5 0-.86-.1-1.07-.29-.21-.19-.32-.45-.32-.76s.11-.57.34-.76c.22-.2.59-.29 1.11-.28l3.28-8.17h-1.36c-.5 0-.86-.1-1.08-.29s-.32-.45-.32-.76.11-.57.32-.76.57-.29 1.08-.29h4.51l4.16 10.26c.49 0 .81.05.97.16.31.22.47.52.47.89 0 .31-.11.55-.32.75-.21.19-.57.29-1.07.29h-2.81c-.5 0-.86-.1-1.07-.29-.21-.19-.32-.45-.32-.76s.11-.56.32-.75c.21-.19.57-.29 1.07-.29h.51l-.5-1.27Zm-.87-2.08-1.68-4.13-1.69 4.13h3.37ZM147.53 392.73l-1.8-.58c-.43-.14-.7-.28-.82-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07.19-.21.45-.32.76-.32s.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31.2.2.3.45.3.73 0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74s-.45.31-.73.31c-.21 0-.38-.04-.52-.13s-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.58s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54ZM160.04 392.73l-1.8-.58c-.43-.14-.7-.28-.82-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07.19-.21.45-.32.76-.32s.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31.2.2.3.45.3.73 0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74s-.45.31-.73.31c-.21 0-.38-.04-.52-.13s-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.58s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54ZM172.56 392.73l-1.8-.58c-.43-.14-.7-.28-.82-.44-.16-.2-.24-.42-.24-.66 0-.29.1-.53.3-.74s.43-.31.68-.31c.16 0 .4.05.72.16l1.8.58v-1.89c0-.5.1-.86.29-1.07.19-.21.45-.32.76-.32s.56.11.75.32c.19.21.29.57.29 1.07v1.89l1.8-.58c.33-.11.56-.16.71-.16.26 0 .49.1.69.31.2.2.3.45.3.73 0 .25-.07.46-.21.64-.14.17-.42.33-.84.47l-1.8.58 1.11 1.54c.27.37.41.67.41.89 0 .29-.1.54-.31.74s-.45.31-.73.31c-.21 0-.38-.04-.52-.13s-.32-.28-.53-.58l-1.11-1.53-1.12 1.53c-.21.3-.39.49-.53.58s-.32.14-.52.14c-.29 0-.53-.1-.74-.31s-.31-.46-.31-.76c0-.21.14-.5.41-.88l1.12-1.54Z" })
      ]
    }
  );
}
const Bm = Ht(
  "flex flex-col border-2 rounded-xl overflow-hidden",
  {
    variants: {
      intent: {
        primary: [],
        secondary: []
      },
      color: {
        primary: ["border-blue-600"],
        secondary: ["border-green-600"],
        tertiary: ["border-white"],
        dim: ["border-neutral-50"]
      }
    },
    defaultVariants: {
      color: "primary",
      intent: "primary"
    }
  }
), Im = [Z.OresundGo], _m = ({
  agreements: t
}) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  }), n = [
    {
      condition: t == null ? void 0 : t.tollingAgreementSigned,
      preTitle: s("agreement.gnss.description"),
      title: s("agreement.gnss.label"),
      logoSrc: /* @__PURE__ */ e.jsx(Vm, {}),
      logoAlt: "kmToll"
    },
    {
      condition: t == null ? void 0 : t.tollCollectAgreementSigned,
      preTitle: s("agreement.tollcollect.description"),
      title: s("agreement.tollcollect.label"),
      logoSrc: /* @__PURE__ */ e.jsx(Rm, {}),
      logoAlt: "Toll Collect"
    }
  ];
  return /* @__PURE__ */ e.jsx("div", { className: "border-t border-neutral-300", children: /* @__PURE__ */ e.jsx("div", { className: "> * + * divide-y-[1px] border-neutral-200", children: n.map(
    ({ condition: r, preTitle: a, title: o, logoSrc: i, logoAlt: d }, l) => r && /* @__PURE__ */ e.jsx(
      Ho,
      {
        preTitle: a,
        title: o,
        color: "dim",
        intent: "secondary",
        brandLogo: {
          src: i,
          alt: d
        }
      },
      l
    )
  ) }) });
}, en = ({
  color: t,
  intent: s,
  title: n,
  preTitle: r,
  description: a,
  disabled: o,
  actionBanner: i,
  footNote: d,
  children: l,
  signedAgreements: c,
  cancelled: m,
  cancelledDescription: u,
  bannerCancelledText: h,
  onReactiveateClick: p,
  reactiveateButtonText: f,
  customerType: x
}) => {
  var S, y;
  const { customerInformation: g } = Oe(), N = (S = g == null ? void 0 : g.contracts[0]) == null ? void 0 : S.contractNo, { data: b } = Ke(!1, N), v = (y = b == null ? void 0 : b.paymentAgreement) == null ? void 0 : y.agreementType;
  return /* @__PURE__ */ e.jsxs("div", { className: Bm({ color: t, intent: s }), children: [
    /* @__PURE__ */ e.jsx(
      Ho,
      {
        preTitle: r,
        title: n,
        color: t,
        intent: s,
        cancelled: m,
        bannerCancelledText: h
      }
    ),
    /* @__PURE__ */ e.jsx(Xs.Root, { type: "single", collapsible: !0, children: m ? /* @__PURE__ */ e.jsxs("div", { className: "flex py-4", children: [
      /* @__PURE__ */ e.jsx("div", { className: "my-auto max-w-56 truncate text-ellipsis px-5", children: u }),
      v && Im.includes(v) ? /* @__PURE__ */ e.jsx(
        X,
        {
          className: "lg-bg ml-auto mr-2 max-w-56 truncate text-ellipsis",
          intent: "solid",
          color: "primary",
          "aria-label": "Re-activate agreement",
          onClick: () => {
            p && p(!0);
          },
          children: f
        }
      ) : null
    ] }) : /* @__PURE__ */ e.jsxs(Xs.Item, { value: "content", disabled: o, children: [
      /* @__PURE__ */ e.jsx(Uo, { disabled: o, children: a }),
      /* @__PURE__ */ e.jsx(Go, { children: l })
    ] }) }),
    c && Object.keys(c).length > 0 && /* @__PURE__ */ e.jsx(_m, { agreements: c }),
    d && /* @__PURE__ */ e.jsx(
      k,
      {
        intent: "body",
        size: "sm",
        className: "border-1-neutral-400 mt-2 border-t px-5 py-4 text-neutral-800",
        children: d
      }
    ),
    i
  ] });
}, Uo = Bs.forwardRef(
  ({
    children: t,
    disabled: s,
    className: n,
    ...r
  }, a) => /* @__PURE__ */ e.jsx(Xs.Header, { className: "flex", children: /* @__PURE__ */ e.jsxs(
    Xs.Trigger,
    {
      disabled: s,
      className: "group/trigger flex flex-1 items-center justify-between gap-2 px-5 py-4 text-left text-sm leading-normal",
      ...r,
      ref: a,
      children: [
        t,
        !s && /* @__PURE__ */ e.jsx(
          yn,
          {
            className: "h-auto w-3 flex-none rotate-180 transition-transform duration-150 ease-in-out group-data-[state=open]/trigger:rotate-0",
            "aria-hidden": !0
          }
        )
      ]
    }
  ) })
);
Uo.displayName = "AccordionTrigger";
const Go = Bs.forwardRef(
  ({
    children: t,
    className: s,
    ...n
  }, r) => /* @__PURE__ */ e.jsx(Xs.Content, { ...n, ref: r, className: "px-5", children: /* @__PURE__ */ e.jsx("div", { children: t }) })
);
Go.displayName = "AccordionContent";
en.displayName = "AgreementCard";
const Wt = {
  OresundGO: "oresundGo",
  OresundPendler: "oresundCommuter",
  Oresund_Business_Pendler: "oresundBusinessCommuter",
  Oresund_Business: "oresundBusiness",
  OresundPAY: "oresundPay",
  OresundPAYBusiness: "oresundPayBusiness",
  Storebelt: "storebelt",
  OresundPeriodCard: "oresundPeriodCard"
}, Ur = (t) => Wt[t], Wm = (t) => t === "business" ? Z.OresundPAYBusiness : Z.OresundPAY, Gr = (t, s) => (n) => n === t ? s() : null, qm = (t) => Gr("pending", () => /* @__PURE__ */ e.jsx(Ir, { ...t, children: /* @__PURE__ */ e.jsx(Wo, {}) }))(t.status), Hm = (t) => Gr("active", () => {
  const s = Cc(/* @__PURE__ */ new Date(), Nc(new Date(t.date), 1)), n = new Date(t.date).getTime() > (/* @__PURE__ */ new Date()).getTime();
  return /* @__PURE__ */ e.jsx(
    Ir,
    {
      ...t,
      disableCancel: s,
      futureStartDate: n,
      children: /* @__PURE__ */ e.jsx(Wo, { disabled: s })
    }
  );
})(t.status), Um = (t) => Gr("cancelled", () => /* @__PURE__ */ e.jsx(Ir, { ...t }))(t.status), Gm = () => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2 border-t border-t-neutral-300 px-5 py-4 sm:flex-row sm:items-center sm:justify-between", children: [
  /* @__PURE__ */ e.jsx(k, { size: "md", className: "max-w-[55ch] leading-relaxed", children: /* @__PURE__ */ e.jsx(G, { ns: "account", i18nKey: "agreement.periodCard.upgrade", children: /* @__PURE__ */ e.jsx(
    k,
    {
      as: "span",
      size: "md",
      weight: "medium",
      className: "bg-primary-400 rounded-sm px-1 py-1 text-white"
    }
  ) }) }),
  /* @__PURE__ */ e.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ e.jsx(qo, {}) })
] }), Km = (t) => {
  const s = Cm(t);
  return qm(s) || Hm(s) || Um(s);
}, Ko = (t) => t ? Km(t) : Gm(), Zm = ({
  agreements: t,
  onEditAgreement: s,
  onCancelAgreement: n,
  onReactiveateClick: r
}) => {
  const { t: a } = O(["account", "common"], {
    nsMode: "fallback"
  }), { customerType: o } = Ot();
  Oe();
  const { data: i } = dn(
    t == null ? void 0 : t.paymentAgreement.contractNo
  );
  if (!t)
    return null;
  const { tollingAgreementSigned: d, tollCollectAgreementSigned: l } = t || {};
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-12", children: [
    t.paymentAgreement ? /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx(
        k,
        {
          as: "h3",
          size: "lg",
          intent: "title",
          weight: "medium",
          className: "mb-1",
          children: a("agreement.exhibition.label")
        }
      ),
      /* @__PURE__ */ e.jsx("p", { className: "mb-6 leading-relaxed text-neutral-600", children: a("agreement.exhibition.description") }),
      /* @__PURE__ */ e.jsx("div", { className: "flex flex-col gap-4", children: /* @__PURE__ */ e.jsx(
        en,
        {
          preTitle: a("agreement.label.paymentAgreement"),
          description: a(
            `agreementProviders.${t.paymentAgreement.provider.id}.description`
          ),
          title: /* @__PURE__ */ e.jsx(
            Hr,
            {
              translationKey: `agreementProviders.${t.paymentAgreement.provider.id}.badge`
            }
          ),
          color: "secondary",
          signedAgreements: {
            tollingAgreementSigned: d,
            tollCollectAgreementSigned: l
          },
          cancelled: t.paymentAgreement.status === "closed",
          cancelledDescription: a(
            "reactivateContract.agreementCard.description"
          ),
          bannerCancelledText: a(
            "reactivateContract.agreementCard.header.cancelled"
          ),
          onReactiveateClick: r,
          reactiveateButtonText: a(
            "reactivateContract.agreementCard.content.reactivateButton"
          ),
          customerType: o,
          children: t.paymentAgreement.status !== "closed" ? /* @__PURE__ */ e.jsx(
            fr,
            {
              onEditBillingAddress: jm(t.paymentAgreement) ? s : void 0,
              onCancel: !i || !(i != null && i.active) ? n : void 0,
              contract: {
                ...t.paymentAgreement,
                contractType: "payment",
                agreementType: Wm(o)
              },
              actionsDisabled: us(
                t.paymentAgreement.provider
              )
            }
          ) : null
        }
      ) })
    ] }) : null,
    t.activeDiscountAgreements.length ? /* @__PURE__ */ e.jsxs("div", { className: "pt-4", children: [
      /* @__PURE__ */ e.jsx(
        k,
        {
          as: "h3",
          size: "lg",
          intent: "title",
          weight: "medium",
          className: "mb-1",
          children: a("agreement.discount.label")
        }
      ),
      /* @__PURE__ */ e.jsx("p", { className: "mb-2 leading-relaxed text-neutral-600", children: a("agreement.discount.activeDescription") }),
      /* @__PURE__ */ e.jsx("div", { className: "my-4 flex flex-col gap-4", children: t.activeDiscountAgreements.map((c, m) => /* @__PURE__ */ e.jsx(
        en,
        {
          preTitle: a("agreement.label.discountAgreement"),
          description: a(
            `agreementTypes.${c.agreementType}.description`
          ),
          title: /* @__PURE__ */ e.jsx(
            Ze,
            {
              contract: Ur(
                c.agreementType
              ) ?? Wt.OresundGO
            }
          ),
          actionBanner: zm(c.agreementType) ? Ko(i) : void 0,
          customerType: o,
          children: /* @__PURE__ */ e.jsx(
            fr,
            {
              onCancel: n,
              contract: c,
              actionsDisabled: !1,
              periodCard: i,
              hideBillingInfo: !0
            }
          )
        },
        `agreement-active-${m}`
      )) })
    ] }) : null
  ] });
}, Ym = ({
  agreements: t,
  onAddAgreement: s
}) => {
  const { t: n } = O(["account", "common"], {
    nsMode: "fallback"
  }), r = Ae(), a = se();
  yl(() => {
    var d;
    a.query.showSbf && ((d = r == null ? void 0 : r.current) == null || d.scrollIntoView({ behavior: "smooth" }));
  }, [a.query.showSbf]);
  const { customerType: o } = Ot(), i = D(() => {
    var h, p, f;
    const d = (h = t == null ? void 0 : t.paymentAgreement) == null ? void 0 : h.provider.id, l = (d === Qs.ORESUNDPAY || d === Qs.ORESUNDSBRON) && ((p = t == null ? void 0 : t.paymentAgreement) == null ? void 0 : p.status) === "active", c = !(t != null && t.activeDiscountAgreements.some(
      (x) => x.agreementType === "Storebelt"
    )), m = o === "private" && l && c, u = (t == null ? void 0 : t.availableDiscountAgreements) ?? [];
    return m ? [
      ...u,
      Nm(((f = t == null ? void 0 : t.paymentAgreement) == null ? void 0 : f.contractNo) ?? "")
    ] : u;
  }, [t, o]);
  return i.length === 0 ? null : /* @__PURE__ */ e.jsxs("div", { id: "available-agreements", children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        as: "h3",
        size: "lg",
        intent: "title",
        weight: "medium",
        className: "mb-1",
        children: n("agreement.discount.availableDiscountAgreements")
      }
    ),
    /* @__PURE__ */ e.jsx("p", { className: "mb-2 leading-relaxed text-neutral-600", children: n("agreement.discount.description") }),
    /* @__PURE__ */ e.jsx("div", { className: "my-4 flex flex-col gap-4", children: i.map((d) => /* @__PURE__ */ e.jsx(
      en,
      {
        color: "primary",
        preTitle: n("agreement.label.discountAgreement"),
        title: /* @__PURE__ */ e.jsx(
          Hr,
          {
            translationKey: `agreementTypes.${d == null ? void 0 : d.agreementType}.badge`
          }
        ),
        description: n(
          `agreementTypes.${d == null ? void 0 : d.agreementType}.description`
        ),
        footNote: (d == null ? void 0 : d.agreementType) === "Storebelt" && n(`agreementTypes.${d == null ? void 0 : d.agreementType}.footNote`),
        actionBanner: /* @__PURE__ */ e.jsxs("div", { className: "border-1-neutral-400 mt-2 flex justify-end border-t px-5 py-4", children: [
          d.agreementType === "Storebelt" && /* @__PURE__ */ e.jsxs(
            mt,
            {
              href: n(
                `agreementTypes.${d == null ? void 0 : d.agreementType}.readMoreLink`
              ),
              target: "_blank",
              className: "mr-4 flex flex-row items-center p-2",
              children: [
                n("action.readMore"),
                /* @__PURE__ */ e.jsx(Ol, { className: "ml-2" })
              ]
            }
          ),
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-end", children: [
            /* @__PURE__ */ e.jsx(
              X,
              {
                intent: "solid",
                disabled: !(t != null && t.hasActiveRecognitions),
                onClick: () => s(d),
                children: n("agreement.action.add")
              }
            ),
            !(t != null && t.hasActiveRecognitions) && /* @__PURE__ */ e.jsx(k, { weight: "light", className: "mt-2", children: n("agreement.discount.noActiveRecognitionWarning") })
          ] })
        ] }),
        disabled: !0
      },
      d.agreementType
    )) })
  ] });
}, Zo = {
  showConfirmation: !1,
  success: !1,
  loading: !1,
  contractNo: void 0,
  agreedToPoliciesClicked: !1,
  error: !1,
  errorMessage: void 0
}, hs = Ns(
  () => Zo
), Qm = () => hs.setState(Zo), Xm = () => hs.setState({ loading: !0 }), Jm = (t) => hs.setState({
  success: !0,
  showConfirmation: !0,
  loading: !1,
  contractNo: t
}), eu = (t) => hs.setState({
  error: !0,
  loading: !1,
  errorMessage: t
}), tu = () => {
  const t = hs.getState();
  hs.setState({
    agreedToPoliciesClicked: !t.agreedToPoliciesClicked
  });
}, su = ({ close: t, onReactivate: s, agreedToPolicies: n }) => {
  const { t: r } = O(["account", "common"], {
    nsMode: "fallback"
  }), { loading: a } = hs();
  return /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end", children: [
    /* @__PURE__ */ e.jsx(
      X,
      {
        intent: "text",
        onClick: t,
        className: "max-w-[65ch] truncate text-ellipsis",
        children: r("action.cancel")
      }
    ),
    /* @__PURE__ */ e.jsx(
      De,
      {
        intent: "solid",
        onClick: s,
        isLoading: a,
        disabled: !n,
        loadingLabel: r("actions.loading"),
        className: "max-w-[65ch] truncate text-ellipsis",
        children: r("reactivateContract.modal.action.reactivate")
      }
    )
  ] });
}, nu = ({ close: t }) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ e.jsx(X, { intent: "text", onClick: t, children: s("action.complete") }) });
}, ru = ({ onToggleAgreeToPolicies: t, paymentContract: s }) => {
  const { t: n } = O(["account", "common"], {
    nsMode: "fallback"
  }), { customerType: r } = Ot(), { app: a } = Ye();
  return ot.OresundPay, /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsx(
      Hr,
      {
        translationKey: `agreementProviders.${s == null ? void 0 : s.provider.id}.badge`
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ e.jsx(
        k,
        {
          size: "md",
          className: He("flex", "flex-col", "gap-3", "text-left, pt-2"),
          children: n("reactivateContract.modal.confirm.description")
        }
      ),
      /* @__PURE__ */ e.jsx(
        ns,
        {
          label: n("reactivateContract.agreeToPoliciesLabel"),
          onChange: () => t()
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "flex space-x-1", children: /* @__PURE__ */ e.jsx(
        Wn,
        {
          isOresundPay: !0,
          type: r === "private" ? Z.OresundGo : Z.OresundBusiness
        }
      ) })
    ] })
  ] });
}, au = ({ errorMessage: t }) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    s("reactivateContract.backendError"),
    " ",
    null
  ] });
}, ou = () => {
  const { t } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx("div", { className: "mb-0", children: /* @__PURE__ */ e.jsx(k, { children: t("reactivateContract.modal.success") }) });
}, iu = ({
  onSuccess: t,
  onClose: s,
  paymentContract: n
}) => {
  const r = Le(), { t: a } = O(["account", "common"], {
    nsMode: "fallback"
  }), {
    success: o,
    agreedToPoliciesClicked: i,
    error: d,
    errorMessage: l
  } = hs(), { mutateAsync: c } = fe(
    ["contract", "reactivate"],
    ({ Contract: h }) => h.reactivate,
    {
      onMutate: Xm,
      onError: (h) => {
        eu(h.error);
      },
      onSuccess: (h) => {
        r.invalidateQueries(ee.Agreements()), r.invalidateQueries(ee.CustomerInformation()), r.invalidateQueries({
          queryKey: ee.AllContracts()
        }), Jm(h.success);
      }
    }
  ), m = L(() => {
    Qm(), o && t && t(), s();
  }, [t, o, s]), u = () => o ? /* @__PURE__ */ e.jsx(ou, {}) : d ? /* @__PURE__ */ e.jsx(au, { errorMessage: l }) : /* @__PURE__ */ e.jsx(
    ru,
    {
      onToggleAgreeToPolicies: tu,
      paymentContract: n
    }
  );
  return /* @__PURE__ */ e.jsx(
    ht,
    {
      footer: () => o ? /* @__PURE__ */ e.jsx(nu, { close: m }) : /* @__PURE__ */ e.jsx(
        su,
        {
          close: m,
          onReactivate: async () => {
            n && c({ contractNo: n.contractNo });
          },
          agreedToPolicies: i
        }
      ),
      title: /* @__PURE__ */ e.jsx(k, { as: "span", className: "text-neutral-900", weight: "bold", children: a("reactivateContract.modal.title") }),
      onOpenChange: (h) => {
        h || m();
      },
      open: !0,
      children: u()
    }
  );
}, lu = ({
  contractNumber: t
}) => {
  const [s, n] = M(), [r, a] = M(), [o, i] = M(), [d, l] = M(), [c, m] = M(!1), { data: u, refetch: h } = Ke(!0, t), { customerType: p } = Ot();
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-12", children: [
    /* @__PURE__ */ e.jsx(
      Zm,
      {
        agreements: u,
        onEditAgreement: i,
        onCancelAgreement: (f, x) => {
          n(f), a(x);
        },
        onReactiveateClick: m
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ym,
      {
        agreements: u,
        onAddAgreement: l
      }
    ),
    c === !0 ? /* @__PURE__ */ e.jsx(
      iu,
      {
        paymentContract: u == null ? void 0 : u.paymentAgreement,
        onClose: () => {
          m(!1);
        },
        onSuccess: () => h()
      }
    ) : null,
    s && /* @__PURE__ */ e.jsx(
      _o,
      {
        contract: s,
        paymentContract: u == null ? void 0 : u.paymentAgreement,
        periodCard: r,
        customerType: p,
        onClose: () => n(void 0),
        onSuccess: () => h()
      }
    ),
    o && /* @__PURE__ */ e.jsx(ut, { children: /* @__PURE__ */ e.jsx(
      Td,
      {
        contract: o,
        onClose: () => i(void 0)
      }
    ) }),
    /* @__PURE__ */ e.jsx(ut, { children: d && /* @__PURE__ */ e.jsx(
      fm,
      {
        contract: d,
        onClose: () => l(void 0),
        onSuccess: () => h()
      }
    ) })
  ] });
}, cu = (t) => {
  if (t.length === 0) return !0;
  const { provider: s } = t[0].paymentAgreement;
  return t.every(
    ({ paymentAgreement: n }) => n.provider.id === s.id
  );
}, du = ({
  contracts: t
}) => {
  const { t: s } = O(["account", "common"], { nsMode: "fallback" }), n = !cu(t), { locale: r } = se(), a = [
    {
      key: "contractNo",
      label: s("agreement.agreementTableColumns.labels.contractNo")
    },
    {
      key: "details",
      label: s("agreement.agreementTableColumns.labels.carsOrBizzes")
    },
    {
      key: "paymentType",
      label: s("agreement.agreementTableColumns.labels.paymentMethod")
    },
    {
      key: "activeAgreements",
      label: s("agreement.agreementTableColumns.labels.activeAgreements")
    }
  ];
  n && a.push({
    key: "paymentProvider",
    label: s("agreement.agreementTableColumns.labels.paymentProvider")
  });
  const o = {
    contractNo: "",
    paymentType: "",
    activeAgreements: "",
    filter: "",
    startDate: "",
    endDate: "",
    apply: ""
  }, i = (c) => {
    const u = ((c == null ? void 0 : c.activeDiscountAgreements) || []).map(
      (h) => h.agreementType
    );
    return c.tollingAgreementSigned && u.push("KmToll"), u.map((h, p) => /* @__PURE__ */ e.jsxs(jr, { children: [
      s(`agreementTypes.${h}.label`),
      p < u.length - 1 ? ", " : ""
    ] }, h));
  }, d = (c) => {
    let m = "";
    switch (c) {
      case "invoice":
        m = "form.labels.invoice";
        break;
      case "card":
        m = "";
        break;
    }
    return s(m);
  }, l = (c) => {
    var p;
    if (!c) return "";
    const m = c.validDate || "", u = ((p = c.cardNumber) == null ? void 0 : p.replace(/\*/g, "")) || "", h = d(c.paymentType) || "";
    return c.paymentType === "card" ? /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-1 overflow-hidden truncate text-ellipsis", children: [
      /* @__PURE__ */ e.jsx(El, {}),
      " ",
      "...",
      u,
      " ",
      /* @__PURE__ */ e.jsxs("span", { className: "hidden sm:inline", children: [
        "•",
        " ",
        h,
        m
      ] })
    ] }) : c.paymentType === "invoice" ? /* @__PURE__ */ e.jsx(e.Fragment, { children: h }) : h;
  };
  return /* @__PURE__ */ e.jsx(Sr, { columns: a, labels: o, children: t.map((c) => {
    var m, u;
    return /* @__PURE__ */ e.jsxs(
      "tr",
      {
        className: "border-b-2 text-xs leading-4 text-neutral-800 sm:text-sm",
        children: [
          /* @__PURE__ */ e.jsx("td", { className: "pr-14 sm:py-2 sm:pr-0 ", children: /* @__PURE__ */ e.jsx(
            mt,
            {
              className: "font-bold text-blue-700",
              as: "a",
              href: `/${r}/account/agreement/${c.paymentAgreement.contractNo}`,
              children: c.paymentAgreement.contractNo
            }
          ) }),
          /* @__PURE__ */ e.jsx("td", { className: "py-2 pr-14 sm:py-2", children: /* @__PURE__ */ e.jsxs("div", { className: "flex gap-1 ", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flex  items-center gap-1 rounded bg-neutral-100 px-1 py-1 sm:px-2 sm:py-1", children: [
              /* @__PURE__ */ e.jsx("span", { children: ((m = c.recognitions) == null ? void 0 : m.alpr) ?? "0" }),
              /* @__PURE__ */ e.jsx(Dn, {})
            ] }),
            /* @__PURE__ */ e.jsxs("div", { className: "flex  items-center gap-1 rounded bg-neutral-100 px-1 py-1 sm:px-2 sm:py-1", children: [
              /* @__PURE__ */ e.jsx("span", { children: ((u = c.recognitions) == null ? void 0 : u.bizz) ?? "0" }),
              /* @__PURE__ */ e.jsx(Pr, {})
            ] })
          ] }) }),
          /* @__PURE__ */ e.jsx("td", { className: "gap-1 py-2 pr-14 sm:pr-2", children: l(c.paymentAgreement) || "-" }),
          /* @__PURE__ */ e.jsx("td", { className: "py-2", children: /* @__PURE__ */ e.jsx("span", { children: i(c) || "-" }) }),
          n && /* @__PURE__ */ e.jsx("td", { className: "py-2", children: /* @__PURE__ */ e.jsx("span", { children: s(
            `agreementProviders.${c.paymentAgreement.provider.id}.label`
          ) }) })
        ]
      },
      c.paymentAgreement.contractNo
    );
  }) });
};
class tn extends jl {
  constructor(s) {
    super(s), this.state = { error: void 0 };
  }
  static getDerivedStateFromError(s) {
    return { error: s };
  }
  componentDidCatch(s, n) {
    console.log({ error: s, errorInfo: n });
  }
  render() {
    if (this.state.error) {
      if (this.props.fallback)
        return this.props.fallback;
      if (this.props.fallbackCallback)
        return this.props.fallbackCallback(this.state.error);
    }
    return this.props.children;
  }
}
const mu = ({ error: t, namespace: s, i18nKey: n }) => {
  const { t: r } = O(s);
  if (t.code !== 404)
    throw t;
  return /* @__PURE__ */ e.jsx(zt, { variant: "notice", children: r(n) });
}, uu = ({
  namespace: t,
  i18nKey: s,
  children: n
}) => /* @__PURE__ */ e.jsx(
  tn,
  {
    fallbackCallback: (r) => /* @__PURE__ */ e.jsx(mu, { error: r, namespace: t, i18nKey: s }),
    children: n
  }
), zg = () => {
  var c, m, u;
  const { t } = O(["account", "common"], { nsMode: "fallback" }), { data: s, error: n } = Or(
    !0,
    void 0,
    !0
  ), { customerType: r } = Ot(), { customerInformation: a } = Oe(), o = D(
    () => Nd(a),
    [a]
  );
  if (n)
    return /* @__PURE__ */ e.jsx(zt, { variant: "error", children: t("agreement.error.notFound") });
  const i = ["Oresund_Business_Pendler", "OresundPendler"], d = (c = a == null ? void 0 : a.contracts) == null ? void 0 : c.filter(
    (h) => !i.includes(h.contractType)
  ), l = s == null ? void 0 : s.filter(
    (h) => h.paymentAgreement.agreementType !== Z.OresundBusinessPendler
  );
  return l ? r === "business-commuter" ? (
    //This is to not show agreements to business-commuter if they enter the URL manually as they should not have access (currently backend does not stop them from activating pendler+)
    /* @__PURE__ */ e.jsx(zt, { variant: "notice", children: t("agreement.unauthorized") })
  ) : /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs(
    Vt,
    {
      fallback: /* @__PURE__ */ e.jsx("div", { className: "flex content-center justify-center p-6", children: /* @__PURE__ */ e.jsx("div", { className: "w-11", children: /* @__PURE__ */ e.jsx(At, { "aria-label": t("action.loading") }) }) }),
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "mb-12", children: /* @__PURE__ */ e.jsx($r, { status: o }) }),
        /* @__PURE__ */ e.jsx(
          uu,
          {
            namespace: "account",
            i18nKey: "agreement.error.notFound",
            children: d && d.length > 1 ? /* @__PURE__ */ e.jsx("div", { className: "overflow-x-auto", children: /* @__PURE__ */ e.jsx(du, { contracts: l }) }) : /* @__PURE__ */ e.jsx(
              lu,
              {
                contractNumber: (u = (m = l[0]) == null ? void 0 : m.paymentAgreement) == null ? void 0 : u.contractNo
              }
            )
          }
        )
      ]
    }
  ) }) : /* @__PURE__ */ e.jsx("div", { className: "flex justify-center p-6", children: /* @__PURE__ */ e.jsx("div", { className: "w-11", children: /* @__PURE__ */ e.jsx(At, { "aria-label": t("action.loading") }) }) });
}, hu = [
  Z.OresundBusinessPendler,
  Z.OresundPendler
], pu = [Qs.ORESUNDPAY], fu = (t, s) => t ? s ? t.filter((n) => !hu.includes(n.agreementType)) : t : [], xu = (t, s) => t ? s ? t.filter(
  (n) => pu.includes(n.providerId)
) : t : [], gu = (t, s) => t ? s ? t.filter((n) => n.paymentType === s) : t : [], Ag = ({
  paymentAgreement: {
    agreementType: t,
    contractNo: s,
    paymentType: n,
    provider: r,
    status: a
  }
}) => ({
  agreementType: t,
  contractNo: s,
  paymentType: n,
  providerId: r.id,
  providerName: r.name,
  status: a
}), bu = (t) => (s) => ({
  label: `${t == null ? void 0 : t(`agreementProviders.${s == null ? void 0 : s.providerId}.label`)} - ${s.contractNo}`,
  value: s.contractNo
}), vu = (t, s, n, r, a) => {
  let o = fu(s, n);
  return o = xu(o, r), o = gu(o, a), o.map(bu(t));
}, yu = [
  Z.OresundBusinessPendler,
  Z.OresundPendler
], qn = ps(
  ({
    onAgreementChange: t,
    hideCommuter: s,
    hideProviders: n,
    initialContractNo: r,
    showPaymentType: a,
    selectFirstContractWithInvoicePaymentMethod: o,
    ...i
  }, d) => {
    var x;
    const { t: l } = O(["common"], { nsMode: "fallback" }), { contracts: c } = Rn(!0), m = Ae(null), u = (g) => {
      var N;
      return (N = c == null ? void 0 : c.find((b) => b.contractNo === g)) == null ? void 0 : N.providerId;
    }, h = c == null ? void 0 : c.every(
      ({ agreementType: g }) => yu.includes(g)
    ), p = vu(
      l,
      c,
      h ? !1 : s,
      n,
      a
    );
    let f = r;
    return c && c.length > 0 && !f && (o ? f = (x = c.filter(
      (g) => g.paymentType === "invoice"
    )[0]) == null ? void 0 : x.contractNo : p.length === 1 && (f = p[0].value)), f && m.current !== f && (m.current = f, t(f, u(f))), p.length < 1 ? /* @__PURE__ */ e.jsx(e.Fragment, {}) : p.length !== 1 ? /* @__PURE__ */ e.jsx(
      nt,
      {
        ref: d,
        label: l("form.labels.contract"),
        placeholder: l("form.labels.contract"),
        options: p,
        onChange: (g) => {
          m.current !== g && (m.current = g, t(g, u(g)));
        },
        required: !0,
        initialValue: f,
        ...i
      }
    ) : /* @__PURE__ */ e.jsxs(k, { ref: d, className: "pt-3", children: [
      l("form.labels.contract"),
      ": ",
      p[0].label
    ] });
  }
);
qn.displayName = "AgreementSelector";
const Kr = ({
  hits: t,
  labelKey: s,
  search: n,
  dates: r,
  setAgreements: a,
  otherFilters: o,
  hideCommuter: i
}) => {
  const { t: d } = O(["account", "common"], {
    nsMode: "fallback"
  }), [l, c] = M(!0);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    s && /* @__PURE__ */ e.jsx(
      k,
      {
        as: "h3",
        style: {
          fontWeight: "fontWeights.medium",
          fontSize: "fontSizes.300"
        },
        children: /* @__PURE__ */ e.jsx(G, { ns: "account", i18nKey: s, values: { amount: t }, children: /* @__PURE__ */ e.jsx(
          k,
          {
            as: "span",
            style: { fontWeight: "fontWeights.light" }
          }
        ) })
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "mt-6 flex flex-col gap-4", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3 sm:flex-row sm:items-end", children: [
        n && /* @__PURE__ */ e.jsx(
          al,
          {
            className: "sm:w-1/2",
            label: d(n.labelKey),
            query: n.query,
            setQuery: n.setSearch,
            description: d(n.descriptionKey ?? ""),
            maxLength: 30
          }
        ),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            onClick: () => c((m) => !m),
            className: `${l ? "border-2" : "border-1"} h-12 min-w-40 rounded border border-blue-950 px-4 py-3`,
            children: d(l ? "form.labels.hideFilter" : "form.labels.showFilter")
          }
        )
      ] }),
      l && /* @__PURE__ */ e.jsxs("div", { className: "grid  grid-cols-2 gap-6 sm:grid-cols-3", children: [
        r && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            qe,
            {
              label: d("form.labels.dateFrom"),
              className: "w-full",
              type: "date",
              value: (r == null ? void 0 : r.startDate) || "",
              onChange: (m) => r.setStartDate(m.target.value)
            }
          ),
          /* @__PURE__ */ e.jsx(
            qe,
            {
              label: d("form.labels.dateTo"),
              className: "w-full",
              type: "date",
              value: r.endDate || "",
              onChange: (m) => r.setEndDate(m.target.value)
            }
          )
        ] }),
        o == null ? void 0 : o.map((m) => m.multiSelect ? /* @__PURE__ */ e.jsx(
          Rr,
          {
            className: "w-full",
            label: d(m.labelKey),
            onChange: m.setValue,
            showAll: !0,
            options: m.options
          },
          m.labelKey
        ) : /* @__PURE__ */ e.jsx(
          nt,
          {
            className: "sm:w-1/3",
            label: d(m.labelKey),
            onChange: (u) => m.setValue(u),
            options: m.options
          },
          m.labelKey
        )),
        a && /* @__PURE__ */ e.jsx(
          Cd,
          {
            onAgreementChange: a,
            hideCommuter: i
          }
        )
      ] })
    ] })
  ] });
};
function ju(t = 20, {
  searchText: s,
  agreements: n,
  fromDate: r,
  toDate: a
} = {}) {
  const [o, i] = M(1), d = {
    agreements: n,
    page: o,
    pageSize: t,
    fromDate: r,
    toDate: a,
    searchText: s
  }, l = as(), { data: c, isFetching: m } = ye(
    ee.TripsV2({ ...d, contractNo: l }),
    ({ Trips: u }) => u.listV2(d),
    {
      keepPreviousData: !0,
      suspense: !0
    }
  );
  return !c || m ? {
    isFetching: m,
    trips: [],
    totalTrips: 0,
    page: o,
    pages: 1,
    setPage: i
  } : {
    isFetching: m,
    trips: c.trips,
    page: o,
    pages: c.pages,
    totalTrips: c.totalTrips,
    setPage: i
  };
}
const Cu = () => {
  const t = at(Do);
  if (!t)
    throw new Error("useAuthStore must be used within an AuthStoreProvider");
  const { getDateLocale: s } = t;
  return { locale: s() };
}, Nu = ({ onAddReceipt: t }) => {
  const s = (U) => {
    const re = /* @__PURE__ */ new Date();
    return re.setMonth(re.getMonth() - U), Lt(re, "yyyy-MM-dd");
  }, { locale: n } = se(), { locale: r } = Cu(), { data: a } = Ke(), [o, i] = M(""), [d, l] = M(
    s(12)
  ), [c, m] = M(s(0)), [u, h] = M([]), [p, f] = M(), { isMobile: x } = Po(), { t: g } = O(["account", "common"], {
    nsMode: "fallback"
  }), N = Vr(), b = {
    agreements: u,
    fromDate: d || void 0,
    toDate: c || void 0,
    /* operators, */
    searchText: o || void 0
  }, { trips: v, page: S, pages: y, setPage: w, totalTrips: z, isFetching: C } = ju(20, b), E = D(
    () => ({
      startDate: g("trips.labels.startDate"),
      endDate: g("trips.labels.endDate"),
      apply: g("trips.action.apply"),
      filter: g("trips.action.filter")
    }),
    [g]
  ), A = D(() => x ? [{ key: "tripDatetime", label: g("trips.columns.tripDatetime") }] : [
    { key: "tripDatetime", label: g("trips.columns.tripDatetime") },
    {
      key: "tripPaymentStation",
      label: g("form.labels.station")
    },
    {
      key: "tripRoute",
      label: g("trips.columns.tripRoute")
    },
    { key: "tripCost", label: g("trips.columns.tripCost") }
  ], [g, x]), F = L(
    (U) => f((re) => re === U ? null : U),
    [f]
  ), R = async () => await (await fetch("/api/auth/access-token")).json(), { apiUrl: T, apiSecret: P } = Ye(), V = L(
    async (U) => {
      const re = `${T}/api/customer/v1/trips/${N}/download`, ie = {
        headers: {
          Accept: U,
          Authorization: "",
          "x-azure-api-secret": P
        }
      }, le = new URLSearchParams({}), me = await R();
      ie.headers.Authorization = `Bearer ${me}`, n && le.append("lang", n), d && le.append("fromDate", d), c && le.append("toDate", c);
      const ce = `${re}?${le.toString()}`, de = await (await fetch(ce, ie)).blob(), ae = window.URL.createObjectURL(de), je = document.createElement("a");
      je.href = ae, je.download = "trips-" + hr(), je.click();
    },
    [N, n, d, c]
  ), I = L(
    async (U, re, ie, le, me) => {
      let ce;
      const q = {
        headers: {
          Accept: me,
          Authorization: "",
          "x-azure-api-secret": P
        }
      };
      if (le === "Trip") {
        const [ft] = ie.split("-");
        ce = `${T}/api/customer/v1/trips/${N}/download/${re}/${ft}?lang=${n}`;
      } else
        ce = `${T}/api/customer/v1/trips/${N}/download/annualFee?lang=${n}`;
      const de = await R();
      q.headers.Authorization = `Bearer ${de}`;
      const je = await (await fetch(ce, q)).blob(), pe = window.URL.createObjectURL(je), Ve = document.createElement("a");
      Ve.href = pe, Ve.download = "trip-" + hr(U), Ve.click();
    },
    [n, N]
  ), _ = D(() => a ? a.activeDiscountAgreements.filter(
    ({ agreementType: U }) => !ur(U)
  ).length > 0 : !1, [a]), ne = (U) => U.contract === "Oresund_Business_Pendler" || U.contract === "Oresund_Business" ? U.price.amount : U.price.amountInclVAT;
  B(() => {
    w(1);
  }, [o, d, c, u]);
  const K = () => {
    if (v.length === 0)
      return /* @__PURE__ */ e.jsx(ze, { colorMode: "information", className: "mt-6 text-blue-700", children: g("kmtoll.userFeedBack.information.noResults") });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      Kr,
      {
        hideCommuter: !0,
        hits: z,
        labelKey: "trips.label",
        search: {
          setSearch: i,
          query: o,
          labelKey: "action.search",
          descriptionKey: "form.labels.searchDescription"
        },
        setAgreements: h,
        dates: { startDate: d, endDate: c, setStartDate: l, setEndDate: m },
        otherFilters: [
          // Operators filter is hidden until requirements for it are figured out
          // {
          //   labelKey: 'form.labels.operator',
          //   multiSelect: true,
          //   options: operatorOptions,
          //   setValue: setOperators,
          // },
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "mt-7 flex flex-row justify-end", children: [
      _ && /* @__PURE__ */ e.jsx(
        X,
        {
          intent: "text",
          startIcon: /* @__PURE__ */ e.jsx(cs, {}),
          onClick: t,
          children: g("invoices.action.addReceipt")
        }
      ),
      v.length > 0 && /* @__PURE__ */ e.jsxs(Xe.Root, { children: [
        /* @__PURE__ */ e.jsx(Xe.Trigger, { asChild: !0, children: /* @__PURE__ */ e.jsx(X, { intent: "text", startIcon: /* @__PURE__ */ e.jsx(Rs, {}), children: g("invoices.action.exportAllTrips") }) }),
        /* @__PURE__ */ e.jsx(Xe.Portal, { children: /* @__PURE__ */ e.jsxs(
          Xe.Content,
          {
            className: "w-48 rounded-lg bg-white px-1.5 py-1 shadow-md md:w-56",
            sideOffset: 5,
            children: [
              /* @__PURE__ */ e.jsx(
                Xe.Item,
                {
                  className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-600 outline-none  hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
                  onClick: () => V(ls.CSV),
                  children: g("invoices.action.exportAllTripsAsCsv")
                }
              ),
              /* @__PURE__ */ e.jsx(
                Xe.Item,
                {
                  className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-600 outline-none hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
                  onClick: () => V(ls.XLSX),
                  children: g("invoices.action.exportAllTripsAsExcel")
                }
              ),
              /* @__PURE__ */ e.jsx(
                Xe.Item,
                {
                  className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-900 outline-none hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
                  onClick: () => V(ls.PDF),
                  children: g("invoices.action.exportAllTripsAsPdf")
                }
              ),
              /* @__PURE__ */ e.jsx(Xe.Arrow, { className: "fill-white" })
            ]
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(Sr, { columns: A, labels: E, children: C ? /* @__PURE__ */ e.jsx("tr", { children: /* @__PURE__ */ e.jsx("td", { colSpan: 4, className: "py-4 text-center", children: /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsx(As, {}) }) }) }) : v.map((U) => /* @__PURE__ */ e.jsxs(jr, { children: [
      /* @__PURE__ */ e.jsxs(
        "tr",
        {
          onClick: () => F(U.id),
          className: "cursor-pointer text-sm leading-5 text-neutral-800 md:hover:bg-neutral-50",
          children: [
            /* @__PURE__ */ e.jsx("td", { className: "py-4", children: /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
              /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: `text-sm ${x ? "flex-grow" : ""} transition-colors duration-300`,
                  children: ad(U.dateTime, r)
                }
              ),
              x && /* @__PURE__ */ e.jsx(
                _t,
                {
                  "aria-label": p === U.id ? "expand" : "collapse",
                  variant: "text",
                  icon: yn,
                  className: "mr-3",
                  rotate: p === U.id ? "180deg" : "0deg",
                  sx: {
                    "svg path": { fill: "none" },
                    "svg, i": { height: "10px", width: "10px" }
                  },
                  style: { paddingRight: 0 }
                }
              )
            ] }) }),
            !x && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(
                "td",
                {
                  className: `leading-tight transition-colors duration-300 ${C ? "text-neutral-400" : "inherit"}`,
                  children: U.type === "AnnualFee" ? `${g("form.labels.price")} ${U.contract ? g(`agreementTypes.${U.contract}.label`) : "-"}` : U.station
                }
              ),
              /* @__PURE__ */ e.jsx("td", { children: U.route === "-" ? "-" : /* @__PURE__ */ e.jsx(
                mt,
                {
                  href: U.route,
                  className: "text-primary-600 py-2",
                  as: "a",
                  onClick: (re) => {
                    re.stopPropagation();
                  },
                  children: g("trips.labels.viewTripRoute")
                }
              ) }),
              /* @__PURE__ */ e.jsx(
                "td",
                {
                  className: `leading-tight transition-colors duration-300 ${C ? "text-neutral-400" : ""}`,
                  children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center justify-between", children: [
                    Js(
                      ne(U),
                      U.price.currencyCode
                    ),
                    /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
                      /* @__PURE__ */ e.jsx(
                        "button",
                        {
                          className: "mr-4 p-2",
                          onClick: (re) => {
                            re.stopPropagation(), I(
                              U.dateTime,
                              U.listId,
                              U.id,
                              U.type,
                              ls.PDF
                            );
                          },
                          children: /* @__PURE__ */ e.jsx(Rs, { className: "text-neutral-800" })
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        _t,
                        {
                          "aria-label": p === U.id ? "expand" : "collapse",
                          variant: "text",
                          icon: yn,
                          className: "mr-3",
                          rotate: p === U.id ? "180deg" : "0deg",
                          sx: {
                            "svg path": {
                              fill: "none",
                              stroke: C ? "colors.neutral.400" : "colors.neutral.900",
                              transition: "stroke 0.3s ease-in-out"
                            },
                            "svg, i": { height: "10px", width: "10px" }
                          },
                          style: { paddingRight: 0 }
                        }
                      )
                    ] })
                  ] })
                }
              )
            ] })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx("tr", { className: "border-b border-neutral-400 transition-colors duration-300", children: /* @__PURE__ */ e.jsx("td", { colSpan: 4, "aria-colspan": 4, className: "py-0", children: /* @__PURE__ */ e.jsx(zc, { open: p === U.id, children: /* @__PURE__ */ e.jsx(
        ud,
        {
          trip: U,
          isMobile: x,
          showColumns: ["tripPaymentStation", "tripRoute"],
          downloadTrip: I
        }
      ) }) }) })
    ] }, U.id)) }),
    K(),
    /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: /* @__PURE__ */ e.jsx(
      Ln,
      {
        currentPage: S,
        totalPages: y,
        onPageChange: w,
        labels: {
          next: g("pagination.next"),
          previous: g("pagination.previous")
        }
      }
    ) })
  ] });
}, Yo = ({
  loadingLabel: t,
  size: s = "35px"
}) => /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center p-10", children: /* @__PURE__ */ e.jsx("div", { style: { width: s }, children: /* @__PURE__ */ e.jsx(At, { "aria-label": t }) }) }), wu = ({
  contracts: t,
  labels: s
}) => {
  const { registerField: n, getError: r } = he({
    namespace: "add-receipt"
  });
  return /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: /* @__PURE__ */ e.jsxs(rs, { template: "two-column", children: [
    /* @__PURE__ */ e.jsx(jt, { children: /* @__PURE__ */ e.jsx(
      jn,
      {
        label: s.contractNo,
        variant: "secondary",
        error: r("contractNo"),
        ...n("contractNo"),
        children: t.map(({ label: a, value: o }) => /* @__PURE__ */ e.jsx(Cn, { value: o, children: a }, o))
      }
    ) }),
    /* @__PURE__ */ e.jsx(jt, { odd: !0, children: /* @__PURE__ */ e.jsx(
      es,
      {
        label: s.receiptNo,
        error: r("receiptNo"),
        required: !0,
        ...n("receiptNo")
      }
    ) })
  ] }) });
}, ku = ({
  onShowReceiptExample: t,
  onError: s
}) => {
  const n = Ae(null), { t: r } = O(["trips", "common"], {
    nsMode: "fallback"
  }), a = Le(), { close: o, nextStep: i } = Cs(), { mutateAsync: d, isLoading: l } = fe(
    ["trips", "add-receipt"],
    ({ Trips: f }) => f.addReceipt,
    {
      onError: (f) => {
        s(f.code === 429 ? "429" : "general");
      },
      onSuccess: () => a.invalidateQueries({
        queryKey: ee.AllTrips()
      }),
      onSettled: i
    }
  ), { data: c } = Ke(!0), m = D(() => {
    if (!c)
      return [];
    const f = c.activeDiscountAgreements.filter(
      ({ agreementType: x }) => x !== "Storebelt"
    );
    return f || [c.paymentAgreement];
  }, [c]), {
    handleSubmit: u,
    resetData: h,
    validate: p
  } = he({
    namespace: "add-receipt",
    onValidate: Ts(sc.spa, r),
    onSubmit: ({ receiptNo: f, contractNo: x }) => d({ receipt: f, contractNo: x })
  });
  return /* @__PURE__ */ e.jsxs(
    Fn,
    {
      onSubmit: Nt(p, u),
      onReset: () => h(),
      ref: n,
      children: [
        /* @__PURE__ */ e.jsxs(Ut, { children: [
          /* @__PURE__ */ e.jsxs("div", { className: "w-0 min-w-full", children: [
            /* @__PURE__ */ e.jsx(Y, { variant: "small", children: r("addReceiptModal.description.partOne") }),
            /* @__PURE__ */ e.jsx(Y, { variant: "small", children: /* @__PURE__ */ e.jsxs(G, { ns: "trips", i18nKey: "addReceiptModal.description.partTwo", children: [
              /* @__PURE__ */ e.jsx(
                Y,
                {
                  variant: "small",
                  as: "span",
                  sx: { fontWeight: "fontWeights.medium" }
                }
              ),
              /* @__PURE__ */ e.jsx(
                Y,
                {
                  variant: "small",
                  as: "span",
                  sx: { fontWeight: "fontWeights.medium" }
                }
              )
            ] }) }),
            /* @__PURE__ */ e.jsx(Y, { variant: "small", children: r("addReceiptModal.description.partThree") })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "pt-4", children: /* @__PURE__ */ e.jsx(
            _t,
            {
              variant: "text",
              style: { paddingLeft: 0 },
              onClick: t,
              type: "button",
              icon: Dl,
              sx: {
                span: {
                  textTransform: "initial",
                  display: "flex",
                  alignItems: "center"
                },
                svg: { width: 16, height: 16 },
                "svg path": { fill: "none" }
              },
              children: r("addReceiptModal.receiptExample")
            }
          ) }),
          /* @__PURE__ */ e.jsx(
            wu,
            {
              labels: {
                contractNo: r("form.labels.discountAgreement"),
                receiptNo: r("form.labels.receiptNo")
              },
              contracts: m.map(({ agreementType: f, contractNo: x }) => ({
                label: r(`agreementTypes.${f}.label`),
                value: x
              }))
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx(
          Rt,
          {
            cancelLabel: r("action.cancel"),
            actionLabel: r("action.add"),
            onClose: o,
            cancelButtonType: "reset",
            actionButtonType: "submit",
            isLoading: l,
            loadingLabel: r("action.loading"),
            loadingButton: !0
          }
        )
      ]
    }
  );
}, Pu = ({ error: t }) => {
  const { t: s } = O(["trips", "common"], {
    nsMode: "fallback"
  }), { close: n } = Cs(), r = D(
    () => t ? `errorCodes.${t}` : "success",
    [t]
  );
  return /* @__PURE__ */ e.jsxs(
    Ut,
    {
      sx: { display: "flex", flexDirection: "column", alignItems: "center" },
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "pt-1", children: t ? /* @__PURE__ */ e.jsx(kr, { width: "50px", height: "50px" }) : /* @__PURE__ */ e.jsx(Fl, { width: "50px", height: "50px" }) }),
        /* @__PURE__ */ e.jsx(
          Y,
          {
            pt: "spacing.200",
            pb: "spacing.100",
            variant: "smallParagraph",
            sx: { maxWidth: "65ch", textAlign: "center" },
            children: s(`addReceiptModal.confirmation.${r}.description`)
          }
        ),
        /* @__PURE__ */ e.jsx(_t, { variant: "text", onClick: n, children: s("action.complete") })
      ]
    }
  );
}, Tu = ({ onBack: t }) => {
  const { t: s } = O("common");
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Ut, { children: /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center p-6", children: /* @__PURE__ */ e.jsx($m, { width: 310, height: 485 }) }) }),
    /* @__PURE__ */ e.jsx(
      Rt,
      {
        cancelLabel: s("action.cancel"),
        actionLabel: s("action.back"),
        action: t,
        removeCancelButton: !0
      }
    )
  ] });
}, Su = () => {
  const [t, s] = M(), { t: n } = O(["trips", "common"], {
    nsMode: "fallback"
  }), { close: r, isOnLastStep: a } = Cs(), o = D(
    () => a ? `addReceiptModal.confirmation.${t ? `errorCodes.${t}` : "success"}.title` : "addReceiptModal.label",
    [a, t]
  ), [i, d] = M(!1);
  return /* @__PURE__ */ e.jsxs(on, { open: !0, ariaLabelledBy: "title", children: [
    /* @__PURE__ */ e.jsx(ln, { closeLabel: n("action.close"), onClose: r, children: n(o) }),
    /* @__PURE__ */ e.jsxs(Ac, { children: [
      /* @__PURE__ */ e.jsx(
        Vt,
        {
          fallback: /* @__PURE__ */ e.jsx(Yo, { loadingLabel: n("action.loading") }),
          children: i ? /* @__PURE__ */ e.jsx(Tu, { onBack: () => d(!1) }) : /* @__PURE__ */ e.jsx(
            ku,
            {
              onShowReceiptExample: () => d(!0),
              onError: s
            }
          )
        }
      ),
      /* @__PURE__ */ e.jsx(Pu, { error: t })
    ] })
  ] });
}, Og = () => {
  const { t } = O("common"), [s, n] = M(!1);
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsx(
      tn,
      {
        fallback: /* @__PURE__ */ e.jsx(ze, { colorMode: "error", className: "mt-4", children: /* @__PURE__ */ e.jsx(e.Fragment, { children: t("errors.generic") }) }),
        children: /* @__PURE__ */ e.jsx(
          Vt,
          {
            fallback: /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center p-12", children: /* @__PURE__ */ e.jsx("div", { className: "w-11", children: /* @__PURE__ */ e.jsx(At, { "aria-label": t("action.loading") }) }) }),
            children: /* @__PURE__ */ e.jsx(Nu, { onAddReceipt: () => n(!0) })
          }
        )
      }
    ),
    s ? /* @__PURE__ */ e.jsx(Oc, { onClose: () => n(!1), hideProgress: !0, children: /* @__PURE__ */ e.jsx(ut, { children: /* @__PURE__ */ e.jsx(Su, {}) }) }) : null
  ] });
}, Mu = (t) => {
  if (!t) return;
  const s = t.split("-"), n = Number(s[0]);
  return isNaN(n) ? void 0 : n;
}, zu = (t, s) => t.filter((n) => s.includes(n.registrationNo)).map(({ id: n, label: r }) => ({ value: n, label: r })), Qo = () => {
  const { apiUrl: t, apiSecret: s } = Ye(), { authToken: n } = Ot(), r = async (i, d = {}) => {
    const l = await fetch(i, {
      headers: {
        Authorization: `Bearer ${n}`,
        "x-azure-api-secret": s,
        ...d
      }
    });
    if (!l.ok) throw new Error("Failed to fetch blob");
    return await l.blob();
  }, a = (i, d) => {
    const l = window.URL.createObjectURL(i), c = document.createElement("a");
    c.href = l, c.download = d, c.click();
  };
  return async (i, d, l) => {
    const c = `${t}${i}`, m = await r(c, l);
    a(m, d);
  };
}, Au = () => {
  const { locale: t } = se(), s = Qo();
  return L(
    async ({ contractLineNo: r, contractNo: a }) => {
      const o = `/api/customer/v1/recognition/vehicle-declaration?no=${r}&contractNo=${a}&lang=${t || ""}`;
      await s(o, `vehicle-declaration-${r}`);
    },
    [t, s]
  );
}, Ou = () => {
  const { locale: t } = se(), s = Qo();
  return Pc({
    mutationFn: async ({ fileType: n, contractNos: r }) => {
      const o = `/api/customer/v1/recognition/download?${r.map((i) => `contractNo=${i}`).join("&")}&lang=${t || "en"}`;
      await s(o, `vehicles-${hr()}`, {
        Accept: n
      });
    }
  });
}, Eu = ({
  activeAgreements: t
}) => {
  const { mutate: s } = Ou(), { t: n } = O(["recognitions", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(Xe.Root, { children: [
    /* @__PURE__ */ e.jsx(Xe.Trigger, { asChild: !0, children: /* @__PURE__ */ e.jsx(X, { startIcon: /* @__PURE__ */ e.jsx(Rs, {}), className: "pl-0", intent: "text", children: n("action.exportVehicles") }) }),
    /* @__PURE__ */ e.jsx(Xe.Portal, { children: /* @__PURE__ */ e.jsxs(
      Xe.Content,
      {
        className: "w-48 rounded-lg bg-white px-1.5 py-1 shadow-md md:w-56",
        sideOffset: 5,
        children: [
          /* @__PURE__ */ e.jsx(
            Xe.Item,
            {
              className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-600 outline-none  hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
              onClick: () => s({
                fileType: ls.CSV,
                contractNos: t
              }),
              children: n("action.exportVehiclesAsCsv")
            }
          ),
          /* @__PURE__ */ e.jsx(
            Xe.Item,
            {
              className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-600 outline-none hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
              onClick: () => s({
                fileType: ls.XLSX,
                contractNos: t
              }),
              children: n("action.exportVehiclesAsExcel")
            }
          ),
          /* @__PURE__ */ e.jsx(
            Xe.Item,
            {
              className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-600 outline-none hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
              onClick: () => s({
                fileType: ls.PDF,
                contractNos: t
              }),
              children: n("action.exportVehiclesAsPDF")
            }
          ),
          /* @__PURE__ */ e.jsx(Xe.Arrow, { className: "fill-white" })
        ]
      }
    ) })
  ] });
}, Xo = ({
  isOpen: t,
  onClose: s,
  onContinue: n
}) => {
  const { t: r } = O(["account", "common", "recognitions"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx(
    ht,
    {
      open: t,
      title: r("kmtoll.order.orderBizzOInfoModal.title"),
      onOpenChange: s,
      children: /* @__PURE__ */ e.jsxs("div", { className: "mb-4 gap-8", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ e.jsx("p", { children: r("kmtoll.order.orderBizzOInfoModal.preamble") }),
          /* @__PURE__ */ e.jsxs("ul", { className: "ml-3 h-full list-inside list-disc", children: [
            /* @__PURE__ */ e.jsx("li", { className: "mb-2", children: r("kmtoll.order.orderBizzOInfoModal.ListItemOne") }),
            /* @__PURE__ */ e.jsx("li", { children: r("kmtoll.order.orderBizzOInfoModal.ListItemTwo") })
          ] })
        ] }),
        /* @__PURE__ */ e.jsx("hr", { className: "mb-3 mt-8" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end gap-2", children: [
          /* @__PURE__ */ e.jsx(
            X,
            {
              intent: "text",
              type: "button",
              className: "font-semibold text-blue-700 underline",
              onClick: s,
              children: r("action.cancelOrder")
            }
          ),
          /* @__PURE__ */ e.jsx(
            X,
            {
              type: "button",
              intent: "solid",
              className: "bg-blue-700 font-semibold",
              onClick: n,
              children: r("action.continue")
            }
          )
        ] })
      ] })
    }
  );
}, qe = ps(
  ({
    label: t,
    description: s,
    error: n,
    required: r = !1,
    className: a,
    classNames: o,
    disabled: i = !1,
    type: d = "text",
    icon: l,
    ...c
  }, m) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `${a} ${(o == null ? void 0 : o.wrapper) || ""} ${i ? "opacity-30" : ""} `,
      children: [
        t && /* @__PURE__ */ e.jsxs(
          "label",
          {
            className: `block text-sm font-medium ${(o == null ? void 0 : o.label) || ""} ${n ? "text-red-500" : "text-neutral-950"} ${i ? "text-neutral-400" : ""}`,
            children: [
              t,
              r && /* @__PURE__ */ e.jsx("span", { children: " *" }),
              s && /* @__PURE__ */ e.jsx("p", { className: "mt-2 text-sm font-normal text-neutral-800", children: s })
            ]
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
            /* @__PURE__ */ e.jsx(
              "input",
              {
                ...c,
                ref: m,
                type: d,
                className: `border-1 relative mt-2 flex h-[48px] w-full appearance-none items-center justify-end rounded-[4px] border bg-white px-3 py-4 text-base font-normal focus:border-0 focus:outline-neutral-900 focus:ring-offset-1 focus-visible:ring  
                ${(o == null ? void 0 : o.input) || ""}
                ${l ? "pr-10" : ""}
                ${n ? "border-red-500" : "border-neutral-500"} 
                ${i ? "cursor-not-allowed border-neutral-300 bg-neutral-200" : ""}
                `,
                tabIndex: 0,
                disabled: i
              }
            ),
            l && /* @__PURE__ */ e.jsx(
              "span",
              {
                className: "absolute right-0 top-0  flex h-full items-center justify-center p-3",
                children: l
              }
            )
          ] }),
          n && /* @__PURE__ */ e.jsx("p", { className: "mt-2 rounded-[4px] bg-red-50 p-2 text-base font-normal text-red-600", children: n })
        ] })
      ]
    }
  )
);
qe.displayName = "InputField";
const Du = ({
  isOpen: t,
  onClose: s,
  contractNo: n,
  contractLineNo: r
}) => {
  const { t: a } = O(["account", "common", "recognitions"], {
    nsMode: "fallback"
  }), [o, i] = M(""), [d, l] = M(
    void 0
  ), c = Le(), { mutateAsync: m } = fe(
    ["recognitions", "update"],
    ({ Recognition: h }) => h.updateRecognition,
    {
      onSuccess: () => (c.invalidateQueries({
        queryKey: ["account", "recognitions"]
      }), l(void 0), s())
    }
  ), u = async () => {
    try {
      await m({
        contractNo: n,
        contractLineNo: r,
        changes: {
          reference: o
        }
      }), l(void 0);
    } catch {
      l(a("kmtoll.landing.bizzList.referenceFieldError"));
    }
  };
  return /* @__PURE__ */ e.jsx(
    ht,
    {
      className: "max-w-prose",
      open: t,
      title: a("action.editReference"),
      onOpenChange: s,
      children: /* @__PURE__ */ e.jsxs("div", { className: "mb-4 gap-8", children: [
        /* @__PURE__ */ e.jsx("div", { className: "mt-8", children: /* @__PURE__ */ e.jsx(
          qe,
          {
            onChange: (h) => i(h.target.value),
            value: o,
            label: a("kmtoll.landing.bizzList.referenceFieldLabel"),
            error: d
          }
        ) }),
        /* @__PURE__ */ e.jsx("hr", { className: "mb-3 mt-8" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end gap-2", children: [
          /* @__PURE__ */ e.jsx(
            X,
            {
              intent: "text",
              type: "button",
              className: "font-semibold text-blue-700 underline",
              onClick: s,
              children: a("action.cancel")
            }
          ),
          /* @__PURE__ */ e.jsx(
            X,
            {
              type: "button",
              intent: "solid",
              className: "bg-blue-700 font-semibold",
              onClick: u,
              children: a("action.save")
            }
          )
        ] })
      ] })
    }
  );
};
var Jo = /* @__PURE__ */ ((t) => (t.oresundPeriodCard = "oresundPeriodCard", t))(Jo || {});
const Fu = ({
  isOpen: t,
  isBizz: s,
  isExternalCustomer: n,
  isReplacable: r,
  onEditRecognition: a,
  onRemoveRecognition: o,
  onReplaceRecognition: i,
  paymentAgreementType: d,
  contract: l,
  isGNSS: c,
  contractNo: m,
  contractLineNo: u,
  serialNo: h
}) => {
  const { t: p } = O(["recognitions", "common"], {
    nsMode: "fallback"
  }), [f, x] = M(!1), [g, N] = M(!1), { locale: b, push: v } = se(), { app: S } = Ye(), y = S === ot.OresundPay, w = () => {
    x(!1);
  }, z = () => {
    N(!1);
  }, C = () => {
    v(`./vehicles/change-vehicle?bizz=${h}&contractNo=${m}`), N(!1);
  }, E = D(() => !n && r ? /* @__PURE__ */ e.jsx(
    _t,
    {
      variant: "text",
      px: 0,
      sx: {
        span: { fontSize: "fontSizes.300" }
      },
      className: "mr-5",
      onClick: () => {
        i(), lr("replace", b);
      },
      small: !0,
      children: p("action.replace")
    }
  ) : null, [i, p, r, d]);
  return c && s && t ? /* @__PURE__ */ e.jsxs("div", { className: `flex ${y ? "gap-4" : ""}`, children: [
    /* @__PURE__ */ e.jsx(
      X,
      {
        padding: !1,
        intent: "text",
        type: "button",
        onClick: () => x(!0),
        className: " h-0 bg-white font-normal",
        children: p("action.updateReference")
      }
    ),
    /* @__PURE__ */ e.jsx(
      Du,
      {
        onSubmit: a,
        isOpen: f,
        onClose: w,
        contractLineNo: u,
        contractNo: m
      }
    ),
    y && /* @__PURE__ */ e.jsx(
      X,
      {
        padding: !1,
        intent: "text",
        type: "button",
        onClick: () => N(!0),
        className: " h-0 bg-white font-normal",
        children: p("action.changeVehicle")
      }
    ),
    /* @__PURE__ */ e.jsx(
      Xo,
      {
        isOpen: g,
        onClose: z,
        onContinue: C
      }
    )
  ] }) : !t || n && !s ? null : n ? /* @__PURE__ */ e.jsxs(
    Je,
    {
      display: "flex",
      sx: {
        justifyContent: "flex-end",
        pt: "spacing.200",
        pb: "spacing.100"
      },
      children: [
        E,
        /* @__PURE__ */ e.jsx(
          _t,
          {
            variant: "text",
            px: 0,
            sx: {
              span: { fontSize: "fontSizes.300" }
            },
            onClick: () => {
              a(), lr("edit", b);
            },
            small: !0,
            children: p("action.edit")
          }
        )
      ]
    }
  ) : /* @__PURE__ */ e.jsxs(
    Je,
    {
      display: "flex",
      sx: {
        justifyContent: "space-between",
        pt: "spacing.200",
        pb: "spacing.100"
      },
      children: [
        Object.values(Jo).includes(l) ? /* @__PURE__ */ e.jsx("span", { className: "mb-4 w-full text-center text-red-300 md:mt-4 md:text-lg", children: p("removeRecognitionModal.removeCarWithActiveAgreement") }) : !c && /* @__PURE__ */ e.jsx(
          _t,
          {
            variant: "text",
            style: { paddingLeft: 0 },
            sx: {
              color: "colors.negative.300",
              "&:hover": { color: "colors.negative.200" },
              span: { fontSize: "fontSizes.300" }
            },
            onClick: o,
            small: !0,
            children: p(s ? "action.block" : "action.remove")
          }
        ),
        /* @__PURE__ */ e.jsxs(Je, { display: "flex", children: [
          E,
          !c && /* @__PURE__ */ e.jsx(
            _t,
            {
              variant: "text",
              px: 0,
              sx: {
                span: { fontSize: "fontSizes.300" }
              },
              onClick: () => {
                a(), lr("edit", b);
              },
              small: !0,
              children: p("action.edit")
            }
          )
        ] })
      ]
    }
  );
}, Lu = (t) => {
  const { data: s } = Ke(!0, t), { data: n } = Ar(t), r = D(
    () => s == null ? void 0 : s.activeDiscountAgreements.find(
      ({ agreementType: o }) => [
        Z.OresundBusinessPendler,
        Z.OresundPendler,
        Z.OresundGo
      ].includes(o)
    ),
    [s == null ? void 0 : s.activeDiscountAgreements]
  ), a = ei(
    r,
    n
  );
  return { discountAgreement: r, contractTypeTranslationKey: a };
}, ei = (t, s) => t ? s ? Wt.OresundPeriodCard : Wt[t == null ? void 0 : t.agreementType] : Wt.OresundPAY, Vu = () => {
  const { data: t, isLoading: s, error: n } = ye(
    ["useGetRegistrationCertificates"],
    ({ Recognitions: r }) => r.registrationCertificates()
  );
  return { data: t, isLoading: s, error: n };
}, Ru = ({
  contractNo: t,
  registrationNo: s
}) => {
  const [n, r] = M(!1), { t: a } = O(["account", "common"], {
    nsMode: "fallback"
  }), o = L(async () => {
    r(!1);
    try {
      const i = `${process.env.NEXT_PUBLIC_API_URL}/api/customer/v1/recognition/registration-certificate?contractNo=${t}&registrationNo=${s}`, d = {
        headers: {
          "x-azure-api-secret": process.env.API_SECRET || "",
          Accept: "application/pdf",
          Authorization: ""
        }
      }, c = await (await fetch("/api/auth/access-token")).json();
      d.headers.Authorization = `Bearer ${c}`;
      const m = await fetch(i, d);
      if (!m.ok) {
        r(!0);
        return;
      }
      const u = await m.blob(), h = window.URL.createObjectURL(u);
      let p = "vehicle-declaration.pdf";
      const f = m.headers.get("content-disposition");
      if (f) {
        const g = f.match(/filename="?(.+)"?/);
        g != null && g[1] && (p = g[1]);
      }
      const x = document.createElement("a");
      x.href = h, x.download = p, document.body.appendChild(x), x.click(), document.body.removeChild(x), window.URL.revokeObjectURL(h);
    } catch {
      r(!0);
    }
  }, [t, s]);
  return /* @__PURE__ */ e.jsxs("div", { className: "flex max-w-fit flex-col", children: [
    /* @__PURE__ */ e.jsx(
      X,
      {
        padding: !1,
        intent: "text",
        type: "button",
        style: {
          fontWeight: 400,
          fontSize: "fontSizes.200"
        },
        onClick: o,
        children: a("kmtoll.landing.bizzList.downloadVehicleRegistration")
      }
    ),
    n && /* @__PURE__ */ e.jsx(ze, { colorMode: "error", size: "small", children: a("errors.generic") })
  ] });
}, $u = ({ recognition: t }) => {
  var F;
  const {
    contract: s,
    contractNo: n,
    contractLineNo: r,
    recognitionType: a,
    serialNo: o,
    registrationNo: i,
    fuelType: d,
    emissionClass: l,
    isHybrid: c,
    vehicleDeclarationAvailable: m,
    isGNSS: u,
    lineStatus: h,
    isReplaceable: p,
    isPeriodCardActive: f,
    reference: x,
    grossWeight: g,
    firstRegistation: N,
    endDate: b
  } = t, { t: v } = O(["account", "common"], {
    nsMode: "fallback"
  }), { data: S } = Ar(n), { data: y } = Vu(), { onEditRecognition: w, onReplaceRecognition: z, onRemoveRecognition: C } = Dx(), E = us(s.provider), A = Au();
  return /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("div", { className: "mt-4 flex flex-col gap-8 sm:gap-6 sm:px-2 ", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col ", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "pb-2 text-base font-semibold sm:text-lg", children: v("kmtoll.landing.bizzList.agreementDetails") }),
      /* @__PURE__ */ e.jsxs("div", { className: "grid grid-cols-1 gap-4  sm:flex sm:gap-6 ", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            v("kmtoll.landing.bizzList.operatorAgreement"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { className: "text-sm sm:text-base", children: s.agreementType })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            v("kmtoll.landing.bizzList.activeDiscountAgreement"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { className: "text-sm sm:text-base", children: s.isDiscount ? v("hybrid.true") : v("hybrid.false") })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            v("kmtoll.landing.bizzList.startDate"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { children: s.startDate })
        ] })
      ] })
    ] }),
    a === "bizz" && /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col ", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "pb-2 text-base font-semibold sm:text-lg", children: v("kmtoll.landing.bizzList.bizzDetails") }),
      /* @__PURE__ */ e.jsxs("div", { className: "grid grid-cols-1 gap-4 sm:flex sm:gap-6", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            v("kmtoll.landing.bizzList.bizzType"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { className: "", children: a })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            v("kmtoll.landing.bizzList.bizzNumber"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { children: o || "-" })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            v("kmtoll.landing.bizzList.reference"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { children: x || "-" })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "pb-2 text-base font-semibold sm:text-lg", children: v("kmtoll.landing.bizzList.vehicleInformation") }),
      /* @__PURE__ */ e.jsxs("div", { className: "grid grid-cols-1 flex-wrap gap-4 sm:flex sm:gap-6", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: v("kmtoll.landing.bizzList.registrationNumber") }),
          /* @__PURE__ */ e.jsx("span", { className: "", children: i })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: v("kmtoll.landing.bizzList.fuel") }),
          /* @__PURE__ */ e.jsx("span", { children: d == null ? void 0 : d.label })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: v("kmtoll.landing.bizzList.emissionClass") }),
          /* @__PURE__ */ e.jsx("span", { children: l == null ? void 0 : l.label })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: v("kmtoll.landing.bizzList.hybrid") }),
          /* @__PURE__ */ e.jsx("span", { children: v(c === !1 ? "hybrid.false" : "hybrid.true") })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: v("kmtoll.landing.bizzList.exactWeight") }),
          /* @__PURE__ */ e.jsx("span", { children: g || "-" })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: v("kmtoll.landing.bizzList.registrationDate") }),
          /* @__PURE__ */ e.jsx("span", { children: N || "-" })
        ] }),
        b ? /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: v("kmtoll.landing.bizzList.endDate") }),
          /* @__PURE__ */ e.jsx("span", { children: b })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-start justify-between gap-4 md:flex-row md:items-center", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-4", children: [
        m && /* @__PURE__ */ e.jsx(
          X,
          {
            padding: !1,
            intent: "text",
            type: "button",
            style: {
              fontWeight: 400,
              fontSize: "fontSizes.200"
            },
            onClick: () => A(t),
            children: v("kmtoll.landing.bizzList.downLoadVehicleDeclaration")
          }
        ),
        ((F = y == null ? void 0 : y[n]) == null ? void 0 : F.map((R) => R.toLocaleLowerCase()).includes(i.toLocaleLowerCase())) && /* @__PURE__ */ e.jsx(
          Ru,
          {
            contractNo: n,
            registrationNo: i
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
        Fu,
        {
          isGNSS: u,
          serialNo: o,
          isBizz: a === "bizz",
          isExternalCustomer: E,
          isOpen: h === "open",
          isReplacable: p,
          paymentAgreementType: s.provider.id,
          onEditRecognition: () => w == null ? void 0 : w(t),
          onReplaceRecognition: () => z == null ? void 0 : z(t),
          contract: ei(
            s,
            f ? S : void 0
          ),
          contractNo: n,
          contractLineNo: r,
          onRemoveRecognition: () => C == null ? void 0 : C({
            contractLineNos: [r],
            contractNo: String(s.contractNo),
            recognitionType: a
          })
        }
      ) })
    ] })
  ] }) });
}, Bu = (t) => {
  const { t: s } = O(["account"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    s("singleOrderBizzFlow.order.summary.Obus.info.autopass"),
    t.isGNSS && `, ${s("singleOrderBizzFlow.order.summary.Obus.info.gnss")}`,
    // asFinag is only applicable and should only be displayed for vehicles that are not GNSS
    t.isAsfinag && !t.isGNSS && `, ${s("singleOrderBizzFlow.order.summary.Obus.info.asFinag")}`
  ] });
}, Iu = ({
  recognitions: t,
  currentPage: s,
  totalPages: n,
  setPage: r
}) => {
  const { t: a } = O(["account", "common", "recognitions"], {
    nsMode: "fallback"
  }), [o, i] = M(null), d = (c) => {
    i((m) => m === c ? null : c);
  }, l = [
    {
      key: "bizzNumber",
      label: a("kmtoll.landing.bizzList.bizzNumber"),
      classNames: "text-start pb-2 "
    },
    {
      key: "",
      label: "",
      classNames: "w-18 pb-2"
    },
    {
      key: "country",
      label: a("form.labels.country"),
      classNames: "text-start pb-2"
    },
    {
      key: "licencePlateShort",
      label: a("form.labels.licencePlateShort"),
      classNames: "text-start pb-2"
    },
    {
      key: "weightClass",
      label: a("form.labels.weightClass"),
      classNames: "text-start pb-2"
    },
    {
      key: "validFor",
      label: a("form.labels.validFor"),
      classNames: "text-start pb-2 lg:w-34"
    },
    {
      key: "",
      label: "",
      classNames: "text-start pb-2"
    }
  ];
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("table", { className: "mt-0 w-full table-auto md:mt-8 ", children: [
      /* @__PURE__ */ e.jsx("thead", { className: "border-b-2 text-sm ", children: /* @__PURE__ */ e.jsx("tr", { className: "w-full", children: l.map((c, m) => /* @__PURE__ */ e.jsx(
        "th",
        {
          className: `${c.classNames} ${c.key === "contractNo" || c.key === "" ? "" : "hidden sm:table-cell"}`,
          children: c.label
        },
        m
      )) }) }),
      /* @__PURE__ */ e.jsx("tbody", { children: t.map((c, m) => /* @__PURE__ */ e.jsxs(jr, { children: [
        /* @__PURE__ */ e.jsxs(
          "tr",
          {
            className: `cursor-pointer text-sm leading-5 text-neutral-950 ${o === m ? "border-b-0" : "border-b border-b-neutral-400"}`,
            onClick: () => d(m),
            children: [
              /* @__PURE__ */ e.jsxs("td", { className: "flex flex-row justify-start  gap-3 py-4", children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col", children: [
                  /* @__PURE__ */ e.jsxs("div", { className: "flex flex-row items-center gap-1", children: [
                    c.recognitionType === "bizz" ? /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(Ll, { width: 15, height: 15 }) }) : /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(Dn, { width: 15, height: 15 }) }),
                    /* @__PURE__ */ e.jsx("div", { className: "font-semibold", children: c.serialNo ? c.serialNo : a("kmtoll.landing.bizzList.ordered") })
                  ] }),
                  /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("span", { className: "text-xs", children: [
                    a("kmtoll.landing.bizzList.reference"),
                    ":",
                    " ",
                    c.reference ? c.reference : "-"
                  ] }) })
                ] }),
                c.recognitionType === "bizz" && /* @__PURE__ */ e.jsx("div", { className: " sm:hidden", children: /* @__PURE__ */ e.jsx(wn, { status: c.lineStatus }) })
              ] }),
              /* @__PURE__ */ e.jsx("td", { className: "hidden sm:table-cell", children: c.recognitionType === "bizz" && /* @__PURE__ */ e.jsx("div", { className: "m-auto h-fit w-fit", children: /* @__PURE__ */ e.jsx(wn, { status: c.lineStatus }) }) }),
              /* @__PURE__ */ e.jsx("td", { className: "m-auto hidden py-4 sm:table-cell", children: c.countryCode }),
              /* @__PURE__ */ e.jsx("td", { className: "hidden sm:table-cell", children: c.registrationNo }),
              /* @__PURE__ */ e.jsxs("td", { className: "hidden sm:table-cell", children: [
                c.grossWeight === 0 ? "-" : c.grossWeight !== void 0 ? a(Qc(c.grossWeight)) : a("kmtoll.landing.bizzList.vehicle.weight.unknown"),
                " "
              ] }),
              /* @__PURE__ */ e.jsx("td", { className: "hidden sm:table-cell", children: /* @__PURE__ */ e.jsx(
                Bu,
                {
                  isGNSS: c.isGNSS,
                  isAsfinag: c.isAsfinag
                }
              ) }),
              /* @__PURE__ */ e.jsx("td", { className: "", children: /* @__PURE__ */ e.jsx(
                yn,
                {
                  className: `transition-transform ${o === m ? "rotate-180" : ""} ml-auto text-black `,
                  onClick: (u) => {
                    u.stopPropagation(), d(m);
                  }
                }
              ) })
            ]
          }
        ),
        o === m && /* @__PURE__ */ e.jsx("tr", { className: "border-b border-neutral-400 pr-0 transition-colors duration-300 ease-in-out", children: /* @__PURE__ */ e.jsx("td", { colSpan: l.length, children: /* @__PURE__ */ e.jsx($u, { recognition: c }) }) })
      ] }, m)) })
    ] }),
    n > 1 && /* @__PURE__ */ e.jsx("div", { className: "mt-10 flex justify-between text-sm font-medium uppercase text-neutral-500", children: /* @__PURE__ */ e.jsx(
      Ln,
      {
        currentPage: s,
        totalPages: n,
        onPageChange: r,
        labels: {
          next: a("pagination.next"),
          previous: a("pagination.previous")
        }
      }
    ) })
  ] });
};
function _u({
  searchText: t,
  contractNo: s,
  fromDate: n,
  toDate: r,
  status: a
} = {}) {
  const [o, i] = M(1), d = {
    searchText: t,
    fromDate: n,
    toDate: r,
    contractNo: s,
    status: a,
    page: o
  }, l = as(), { data: c } = ye(
    ee.ListCustomerInvoices({ params: d, currentContractNo: l }),
    ({ Customer: m }) => m.invoices(d),
    { suspense: !0, keepPreviousData: !0 }
  );
  return c ? {
    invoices: c.invoices,
    page: o,
    pages: c.pages,
    total: c.total,
    setPage: i
  } : {
    invoices: [],
    total: 0,
    page: o,
    pages: 1,
    setPage: i
  };
}
const Eg = () => {
  const [t, s] = M(""), [n, r] = M([]), [a, o] = M(null), [i, d] = M(null), [l, c] = M([]), { locale: m } = se(), { t: u } = O(["account", "common"], { nsMode: "fallback" }), h = D(
    () => ({
      startDate: u("invoices.labels.startDate"),
      endDate: u("invoices.labels.endDate"),
      apply: u("invoices.action.apply"),
      filter: u("invoices.action.filter")
    }),
    [u]
  ), { isMobile: p } = Po(), f = D(
    () => p ? { display: "flex", justifyContent: "space-between" } : {},
    [p]
  ), { data: x } = Gc(), g = D(
    () => (x == null ? void 0 : x.map(({ label: T, value: P }) => ({
      value: P,
      label: u(`invoices.status.${T}`)
    }))) || [],
    [x, u]
  ), N = D(() => p ? [{ key: "invoiceNumber", label: u("invoices.columns.invoiceNumber") }] : [
    { key: "invoiceNumber", label: u("invoices.columns.invoiceNumber") },
    { key: "invoiceDate", label: u("invoices.columns.invoiceDate") },
    { key: "dueDate", label: u("invoices.columns.invoiceDueDate") },
    { key: "status", label: u("invoices.columns.invoiceStatus") },
    { key: "invoiceAmount", label: u("invoices.columns.invoiceAmount") }
  ], [u, p]), b = {
    searchText: t,
    fromDate: a || void 0,
    toDate: i || void 0,
    contractNo: l,
    status: n
  }, { invoices: v, page: S, pages: y, total: w, setPage: z } = _u(b), { apiUrl: C, apiSecret: E } = Ye(), A = L(
    async (T) => {
      const P = `${C}/api/customer/v1/account/invoices/${T}?lang=${m}`, V = {
        headers: { Authorization: "", "x-azure-api-secret": E }
      }, _ = await (await fetch("/api/auth/access-token")).json();
      V.headers.Authorization = `Bearer ${_}`;
      const K = await (await fetch(P, V)).blob(), U = window.URL.createObjectURL(K);
      setTimeout(() => {
        window.open(U, "_top");
      });
    },
    [m]
  ), F = () => {
    if (v.length === 0)
      return /* @__PURE__ */ e.jsx(ze, { className: "mt-6", colorMode: "information", children: u("invoices.userFeedBack.information.emptyInvoicesList") });
  }, R = (T) => T.status === "-" ? "-" : u(`invoices.status.${T.status}`);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      Kr,
      {
        hideCommuter: !0,
        hits: w,
        labelKey: "invoices.label",
        search: {
          query: t,
          setSearch: s,
          labelKey: "action.search"
        },
        setAgreements: c,
        dates: { startDate: a, endDate: i, setStartDate: o, setEndDate: d },
        otherFilters: [
          {
            labelKey: "form.labels.filterInvoiceStatus",
            multiSelect: !0,
            options: g,
            setValue: r
          }
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(Sr, { columns: N, labels: h, children: v.map((T) => /* @__PURE__ */ e.jsxs(
      "tr",
      {
        style: {
          borderBottomWidth: "1px",
          borderBottomColor: "colors.neutral.200",
          borderBottomStyle: "solid"
        },
        children: [
          /* @__PURE__ */ e.jsxs(
            "td",
            {
              className: "py-3 text-sm",
              style: {
                fontWeight: "fontWeights.medium",
                ...f
              },
              children: [
                /* @__PURE__ */ e.jsx(
                  Y,
                  {
                    variant: "body2",
                    as: "span",
                    className: "cursor-pointer font-semibold text-blue-700 underline md:pt-0",
                    onClick: () => A(T.no),
                    children: T.no
                  }
                ),
                p && /* @__PURE__ */ e.jsx(
                  _t,
                  {
                    variant: "text",
                    onClick: () => A(T.no),
                    children: /* @__PURE__ */ e.jsx(Rs, {})
                  }
                )
              ]
            }
          ),
          !p && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsx(Y, { variant: "body2", children: T.postingDate }) }),
            /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsx(Y, { variant: "body2", children: T.dueDate || "-" }) }),
            /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsx(Y, { variant: "body2", children: R(T) }) }),
            /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ e.jsxs(Y, { variant: "body2", children: [
                T.amount,
                " ",
                T.currency
              ] }),
              /* @__PURE__ */ e.jsx("button", { onClick: () => A(T.no), children: /* @__PURE__ */ e.jsx(Rs, { className: "text-neutral-800" }) })
            ] }) })
          ] })
        ]
      },
      T.no
    )) }),
    F(),
    /* @__PURE__ */ e.jsx("div", { className: "mt-8", children: /* @__PURE__ */ e.jsx(
      Ln,
      {
        currentPage: S,
        totalPages: y,
        onPageChange: z,
        labels: {
          next: u("pagination.next"),
          previous: u("pagination.previous")
        }
      }
    ) })
  ] });
}, Wu = ({
  className: t,
  hideCustomerNo: s
}) => {
  const { customerInformation: n } = Oe();
  return n ? /* @__PURE__ */ e.jsxs("div", { className: t, children: [
    /* @__PURE__ */ e.jsxs("span", { children: [
      n == null ? void 0 : n.firstName,
      " ",
      n == null ? void 0 : n.lastName
    ] }),
    (n == null ? void 0 : n.customerType) === "business" && !s && ` ${n == null ? void 0 : n.customerNo}`
  ] }) : /* @__PURE__ */ e.jsx(e.Fragment, {});
}, ti = () => {
  const { t } = O(["common", "account"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsx("div", { className: "bg-primary-600 mr-2 rounded-md px-2 py-1 text-white", children: t("corporateGroup.selectedCompany") });
}, qu = ({
  corporate: t,
  index: s,
  handleUpdateSessionCustomer: n,
  errorIndex: r,
  isLoading: a,
  activeCustomerNo: o
}) => {
  const { t: i } = O(["common", "account"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flex max-h-min items-center border-[0.5px] border-neutral-300 p-4 text-sm font-semibold hover:cursor-pointer hover:bg-neutral-50",
      onClick: () => n(t.customerNo, s),
      children: [
        a ? /* @__PURE__ */ e.jsx("div", { className: "flex flex-grow font-thin", children: i("action.loading") }) : /* @__PURE__ */ e.jsxs("div", { className: "flex flex-grow flex-col", children: [
          /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-between ", children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center", children: [
            o === t.customerNo && /* @__PURE__ */ e.jsx(ti, {}),
            t.name,
            ", ",
            t.customerNo
          ] }) }),
          r === s && /* @__PURE__ */ e.jsx("div", { className: "mt-2 w-full rounded bg-red-50 p-2 text-red-700", children: i("corporateGroup.missingContract") })
        ] }),
        /* @__PURE__ */ e.jsx(Tr, { className: "text-primary-700 ml-2 rotate-90" })
      ]
    },
    t.customerNo
  );
};
function Hu() {
  const { customerInformation: t } = Oe(), s = (t == null ? void 0 : t.customerType) === "business", n = s ? t == null ? void 0 : t.customerNo : "", { data: r, isLoading: a } = ye(
    ee.CorporateGroupMembers(),
    (o) => o.CorporateGroup.getMembers(),
    {
      suspense: !0,
      enabled: s
    }
  );
  return D(() => {
    if (!r) return { isLoading: a, corporateGroup: [] };
    const { corporateGroup: o, corporateHead: i } = r;
    return { corporateGroup: o.filter(({ customerNo: l }) => l !== i.customerNo).sort((l, c) => l.customerNo === n ? -1 : c.customerNo === n ? 1 : `${l.name}${l.companyNo}`.localeCompare(
      `${c.name}${c.companyNo}`
    )), corporateHead: i, isLoading: a };
  }, [r, a]);
}
function Uu() {
  const { updateCustomer: t } = Oe(), { mutateAsync: s } = fe(
    ["useUpdateSessionCustomer"],
    ({ Customer: r }) => r.updateSessionCustomer
  );
  return L(
    async (r) => {
      try {
        const a = await s({ customerNo: r });
        await t(a);
      } catch (a) {
        return { error: a.message };
      }
    },
    [s, t]
  );
}
const cr = 10, Gu = ["name", "customerNo"], Sa = 1234566789, Ku = ({ onSuccess: t }) => {
  const [s, n] = M(1), [r, a] = M(""), [o, i] = M([]), [d, l] = M(), [c, m] = M(), [u, h] = M(""), { t: p } = O(["common", "account"], { nsMode: "fallback" }), { corporateGroup: f, corporateHead: x, isLoading: g } = Hu(), { customerInformation: N } = Oe(), b = Uu(), v = Ae(null), S = (N == null ? void 0 : N.customerType) === "business" ? N.customerNo : "", y = D(
    () => Lc((R) => a(R), 300),
    []
  );
  B(() => (y(u), () => y.cancel()), [u]);
  const w = D(() => f.filter(
    (R) => (r.length < 3 || Gu.some(
      (T) => {
        var P;
        return (P = R[T]) == null ? void 0 : P.toString().toLowerCase().includes(r.toLowerCase());
      }
    )) && (o.length === 0 || o.includes(R.languageCode))
  ), [f, r, o]), z = D(
    () => Math.ceil(w.length / cr),
    [w]
  ), C = D(() => {
    const R = (s - 1) * cr;
    return w.slice(R, R + cr);
  }, [w, s]), E = D(() => Array.from(
    new Set(f.map((T) => T.languageCode))
  ).map((T) => ({ value: T, label: T })), [f]);
  B(() => n(1), [r, o]);
  const A = L(
    async (R, T) => {
      m(T), l(void 0);
      const P = await b(R);
      P && "error" in P ? (m(void 0), l(T), setTimeout(() => l(void 0), 4e3)) : t == null || t();
    },
    [b, t]
  ), F = L(() => {
    var R;
    (R = v.current) == null || R.resetSelection(), a("");
  }, []);
  return g ? /* @__PURE__ */ e.jsx(As, {}) : /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
    f.length > 0 && /* @__PURE__ */ e.jsxs("div", { className: "mx-auto max-w-2xl", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ e.jsx("h1", { className: "text-2xl font-semibold", children: `${p("corporateGroup.header")} (${w.length})` }) }),
      /* @__PURE__ */ e.jsxs("div", { className: "my-8 flex flex-col items-end gap-5 rounded-lg bg-neutral-50 p-4 md:flex-row", children: [
        /* @__PURE__ */ e.jsx(
          al,
          {
            label: p("corporateGroup.filter.search"),
            query: u,
            setQuery: h,
            className: "flex-grow"
          }
        ),
        /* @__PURE__ */ e.jsx(
          Rr,
          {
            className: "flex-grow",
            options: E,
            label: p("corporateGroup.filter.country"),
            onChange: i,
            ref: v
          }
        ),
        /* @__PURE__ */ e.jsx(X, { onClick: F, children: p("corporateGroup.filter.clear") })
      ] }),
      x && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("div", { className: "font-bold", children: p("corporateGroup.mainCompany") }),
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "mt-2 flex cursor-pointer items-center border border-neutral-300 p-4 text-sm font-semibold hover:bg-neutral-50",
            onClick: async () => {
              m(Sa), await b(x.customerNo), t == null || t();
            },
            children: c === Sa ? /* @__PURE__ */ e.jsx("div", { children: p("action.loading") }) : /* @__PURE__ */ e.jsxs("div", { className: "flex w-full items-center justify-between", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flex items-center", children: [
                S === x.customerNo && /* @__PURE__ */ e.jsx(ti, {}),
                " ",
                x.name,
                ", ",
                x.customerNo
              ] }),
              /* @__PURE__ */ e.jsx(Tr, { className: "text-primary-700 rotate-90" })
            ] })
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "mt-8 flex flex-col gap-2", children: [
        /* @__PURE__ */ e.jsx("div", { className: "font-bold", children: p("corporateGroup.corporateGroupCompanies") }),
        C.length === 0 ? /* @__PURE__ */ e.jsx(ze, { colorMode: "information", children: p("corporateGroup.emptySearch") }) : C.map((R, T) => /* @__PURE__ */ e.jsx(
          qu,
          {
            corporate: R,
            activeCustomerNo: S,
            handleUpdateSessionCustomer: A,
            index: T,
            errorIndex: d,
            isLoading: T === c
          },
          R.customerNo
        ))
      ] }),
      z > 1 && /* @__PURE__ */ e.jsx(
        Ln,
        {
          className: "mt-8",
          currentPage: s,
          totalPages: z,
          labels: {
            next: p("action.next"),
            previous: p("action.previous")
          },
          onPageChange: n
        }
      )
    ] }),
    c !== void 0 && /* @__PURE__ */ e.jsx(sa, {})
  ] });
}, Dg = () => {
  const { t } = O(["account"]), [s, n] = M(!1);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: " flex flex-col pt-8 text-white md:mb-8 md:pt-0 md:text-neutral-950", children: [
      /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "mb-1 flex cursor-pointer items-center font-semibold ",
          onClick: () => n(!0),
          children: [
            /* @__PURE__ */ e.jsx(Vl, { className: "mr-2" }),
            t("corporateGroup.changeActiveCorporate")
          ]
        }
      ),
      /* @__PURE__ */ e.jsx(Wu, { className: "flex flex-col", hideCustomerNo: !0 })
    ] }),
    /* @__PURE__ */ e.jsx(ht, { open: s, title: "", onOpenChange: () => n(!1), children: /* @__PURE__ */ e.jsx(Ku, { onSuccess: () => n(!1) }) })
  ] });
}, si = ({ onSuccess: t, token: s }) => {
  const n = Ae(), r = Ae(), a = L(() => {
    if (!window.Reepay || !s || r.current)
      return;
    clearInterval(n.current);
    const { EmbeddedCheckout: o } = window.Reepay;
    r.current = new o(s, {
      html_element: "rp-container",
      showReceipt: !1
    }), r.current.addEventHandler(Reepay.Event.Accept, (i) => {
      var d;
      t(i), (d = r.current) == null || d.destroy();
    });
  }, [s, t]);
  return B(() => () => {
    if (r.current) {
      r.current.removeEventHandler(Reepay.Event.Accept);
      try {
        r.current.destroy();
      } catch {
      }
    }
  }, []), B(() => (n.current = setInterval(a), () => {
    n.current && clearInterval(n.current);
  })), /* @__PURE__ */ e.jsx("div", { className: "col-span-full flex items-center justify-center md:col-span-6 md:col-start-4", children: /* @__PURE__ */ e.jsx(ke.Root, { id: "rp-container", className: "h-[600px] w-full sm:w-[500px]" }) });
}, Zu = () => {
  const { t } = O("common", {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsx(
    nn,
    {
      label: t("action.loading"),
      className: "mx-auto block",
      width: "2em",
      height: "2em"
    }
  ) });
}, Yu = ({ onClose: t }) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center py-6", children: [
    /* @__PURE__ */ e.jsx(wr, { className: "mb-8 h-12 w-12 text-green-500" }),
    /* @__PURE__ */ e.jsx(k, { intent: "body", className: "mb-8", children: /* @__PURE__ */ e.jsx(G, { ns: "account", i18nKey: "debitCard.modal.success.description" }) }),
    /* @__PURE__ */ e.jsx(X, { intent: "solid", onClick: t, children: s("action.complete") })
  ] });
}, Qu = ({
  token: t,
  onSuccess: s,
  errorMessage: n
}) => t ? /* @__PURE__ */ e.jsx(si, { token: t, onSuccess: s }) : /* @__PURE__ */ e.jsx(k, { children: n }), Xu = ({
  onClose: t,
  currency: s
}) => {
  const n = Le(), r = Ae(""), { t: a } = O(["account", "common"], {
    nsMode: "fallback"
  }), o = Vr(), [i, d] = M(!1), { mutateAsync: l, isLoading: c, isIdle: m } = fe(
    ["reepay", "update", "token"],
    ({ Reepay: f }) => f.createUpdateToken,
    {
      onSuccess: (f) => r.current = f.token
    }
  ), { mutateAsync: u } = fe(
    ["reepay", "update", "card"],
    ({ Reepay: f }) => f.updateCard,
    {
      onSuccess: () => {
        n.invalidateQueries(ee.Agreements()), d(!0);
      }
    }
  );
  B(() => {
    o && !r.current && l({
      contractNo: o,
      currency: s || "DKK"
    });
  }, [o, s, l]);
  const h = L(
    (f) => {
      if (!(!o || !r.current))
        return u({
          contractNo: o,
          card: { data: { ...f, invoice: "" }, session: r.current },
          method: "card",
          currency: s || "DKK"
        });
    },
    [o, s, u]
  ), p = L(
    (f) => {
      f || t(i);
    },
    [i, t]
  );
  return /* @__PURE__ */ e.jsx(ht, { open: !0, title: a("debitCard.modal.title"), onOpenChange: p, children: /* @__PURE__ */ e.jsx("div", { children: i ? /* @__PURE__ */ e.jsx(Yu, { onClose: () => p(!1) }) : m || c ? /* @__PURE__ */ e.jsx(Zu, {}) : /* @__PURE__ */ e.jsx(
    Qu,
    {
      token: r.current,
      onSuccess: h,
      errorMessage: a("errors.reepay")
    }
  ) }) });
}, Ju = () => {
  var v;
  const {
    query: { contract: t, updateCreditCard: s }
  } = se(), [n, r] = M(s !== void 0), { customerInformation: a } = Oe(), o = t || ((a == null ? void 0 : a.contracts.length) === 1 ? a.contracts[0].contractNo : void 0), { t: i } = O(["account", "common"], {
    nsMode: "fallback"
  }), { data: d, refetch: l } = Ke(!0, o, !0), c = D(
    () => ({
      inactive: i("debitCard.labels.inactive"),
      active: i("debitCard.labels.active"),
      type: i("debitCard.labels.debitCard")
    }),
    [i]
  ), { query: m, push: u } = se(), h = Le(), p = (S) => {
    u({ query: { ...m, contract: S } });
  }, [f, x] = M(
    (v = d == null ? void 0 : d.paymentAgreement.price) == null ? void 0 : v.currency
  ), g = L(
    (S) => {
      S && (h.invalidateQueries(ee.PaymentAgreementList), l()), r(!1);
    },
    [h, l]
  ), N = d && !us(d.paymentAgreement.provider) && d.paymentAgreement.paymentType === "card", b = a && a.contracts.length > 1;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    b && /* @__PURE__ */ e.jsx("div", { className: "mb-4", children: /* @__PURE__ */ e.jsx(
      Vt,
      {
        fallback: /* @__PURE__ */ e.jsx("div", { className: "w-9", children: /* @__PURE__ */ e.jsx(As, { "aria-label": i("action.loading") }) }),
        children: /* @__PURE__ */ e.jsx(
          qn,
          {
            hideCommuter: !0,
            onAgreementChange: p,
            initialContractNo: m.contract
          }
        )
      }
    ) }),
    o ? N ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        Y,
        {
          variant: "h3",
          sx: {
            fontWeight: "fontWeights.medium",
            fontSize: "fontSizes.300"
          },
          children: i("debitCard.label", {
            amount: 1,
            maxAmount: 1
          })
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ec,
        {
          labels: c,
          variant: "primary",
          cardTitle: /* @__PURE__ */ e.jsx(
            Y,
            {
              variant: "h4",
              pt: "spacing.0",
              pb: "spacing.0",
              sx: { color: "inherit", fontWeight: "fontWeights.regular" },
              children: d == null ? void 0 : d.paymentAgreement.cardType
            }
          ),
          icon: Rl,
          active: !0,
          children: /* @__PURE__ */ e.jsxs("div", { className: "bg-neutral-100 px-8 pb-8 pt-6 md:px-10", children: [
            /* @__PURE__ */ e.jsxs(rs, { template: "two-column", children: [
              /* @__PURE__ */ e.jsx(Fs, { column: "1", children: /* @__PURE__ */ e.jsx(bs, { label: i("form.labels.cardNo"), children: d == null ? void 0 : d.paymentAgreement.cardNumber }) }),
              /* @__PURE__ */ e.jsx(Fs, { column: { xs: "1", md: "3" }, children: /* @__PURE__ */ e.jsx(bs, { label: i("form.labels.expiryDate"), children: d == null ? void 0 : d.paymentAgreement.validDate }) }),
              /* @__PURE__ */ e.jsx(Fs, { column: "1", children: /* @__PURE__ */ e.jsx(bs, { label: i("form.labels.connectedAgreement"), children: i(
                `agreementProviders.${d == null ? void 0 : d.paymentAgreement.provider.id}.label`
              ) }) }),
              /* @__PURE__ */ e.jsx(Fs, { column: { xs: "1", md: "3" }, children: /* @__PURE__ */ e.jsx(
                nt,
                {
                  onChange: x,
                  className: "mt-5",
                  label: i("form.labels.currency"),
                  placeholder: i("form.placeholders.currency"),
                  options: [
                    { label: "SEK", value: "SEK" },
                    { label: "DKK", value: "DKK" }
                  ]
                }
              ) })
            ] }),
            /* @__PURE__ */ e.jsx("div", { className: "mb-2 mt-4 flex justify-end", children: /* @__PURE__ */ e.jsx(
              X,
              {
                as: "button",
                intent: "outlined",
                onClick: () => r(!0),
                children: i("agreement.action.updateCard")
              }
            ) })
          ] })
        }
      )
    ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(ze, { colorMode: "warning", children: i("debitCard.unauthorized") }),
      /* @__PURE__ */ e.jsx(X, { className: "!my-5", onClick: () => r(!0), children: i("agreement.action.changePaymentMethod") })
    ] }) : /* @__PURE__ */ e.jsx(ze, { className: "my-4", colorMode: "warning", children: i("debitCard.pickContract") }),
    n ? /* @__PURE__ */ e.jsx(
      Xu,
      {
        currency: f,
        onClose: g
      }
    ) : null,
    /* @__PURE__ */ e.jsx(
      Mr,
      {
        strategy: "lazyOnload",
        src: "https://checkout.reepay.com/checkout.js"
      }
    )
  ] });
}, Fg = () => {
  const { t } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx(
    tn,
    {
      fallback: /* @__PURE__ */ e.jsx(ze, { colorMode: "error", children: t("errors.generic") }),
      children: /* @__PURE__ */ e.jsx(Ju, {})
    }
  );
}, Ma = {
  INVOICE: "invoice",
  CARD: "card"
}, ni = (t, s) => {
  const { locale: n } = se(), { data: r } = ye(
    ee.ContractTypeList({ type: t, locale: n }),
    (o) => o.Contract.contractTypeList({ type: t, locale: n || "" })
  );
  return D(
    () => (r == null ? void 0 : r.filter((o) => o.value === s).map(({ currency: o, price: i, priceInclVat: d }) => ({
      currency: o,
      price: i,
      priceInclVat: d
    }))) ?? [],
    [s, r]
  );
}, e1 = Vc.object({
  agreement: nc
}), t1 = rc.and(
  e1
), qt = Ns(() => ({
  action: () => Promise.resolve(),
  disableNext: !1,
  body: {}
})), s1 = (t) => qt.setState(() => ({ contractNo: t })), Hn = (t) => {
  const { action: s } = qt.getState();
  s !== t && qt.setState(() => ({ action: t }));
}, sn = (t) => qt.setState(() => ({ disableNext: t })), Zr = (t) => qt.setState((s) => ({
  body: { ...s.body, ...t }
})), n1 = () => qt.setState(() => ({ body: {} })), r1 = async () => {
  const { action: t } = qt.getState();
  t && await t();
}, a1 = [
  "black",
  "blue",
  "brown",
  "green",
  "grey",
  "orange",
  "purple",
  "red",
  "white",
  "yellow",
  "other"
];
function o1(t) {
  const { country: s, licensePlate: n } = t || {};
  return ye(
    ee.VehicleInfo(t),
    ({ VehicleInfo: r }) => r.getBilvVehicleInfo(s, n),
    {
      enabled: !!t && !!s && !!n,
      retry: 0
    }
  );
}
const za = (t) => !t || t.trim() === "", Yr = (t) => t.reduce((s, { value: n }) => (s[n] = n, s), {}), ri = (t, s, n, r) => {
  if (!t) {
    n();
    return;
  }
  const a = r.reduce((o, { value: i }) => (o[i] = i, o), {});
  s({
    ...t,
    weightClass: t.isHGV ? "true" : "false",
    hybrid: t.isHybrid.toString(),
    fuelType: t.fuelTypeId.toString(),
    emissionClass: t.euroEmissionNorm ? a[t.euroEmissionNorm] : void 0
  });
}, xn = "CREDIT_EVAL_YELLOW", ai = "CREDIT_EVAL_RED", Qr = (t) => (!!t && typeof t.error == "string" || Array.isArray(t.validationError)) && typeof t.code == "number", i1 = (t) => t === ai || t === xn, l1 = (t) => (s) => s ? t ? { ...s, ...t } : s : t, c1 = (t) => async (s) => {
  let n = s;
  for (const r of t) {
    const a = await r(n), o = a ? d1(a) : void 0;
    o && (n = l1(n)(o));
  }
  return n;
}, Un = (...t) => async (s) => {
  try {
    return await c1(t)(s) ?? s;
  } catch {
    return s;
  }
}, dt = (t) => (s) => {
  if (!s || !(t in s))
    return !0;
  const n = s[t];
  return n != null;
}, d1 = (t) => {
  if (!t)
    return;
  const s = Object.entries(t).filter(([n, r]) => r !== void 0).reduce((n, [r, a]) => ({ ...n, [r]: a }), {});
  return Object.keys(s).length > 0 ? s : void 0;
};
function hn(t) {
  return t.toUpperCase().slice(0, 10).replace(/[^0-9a-zäöæøåü]/gi, "").replace(/[\s-]+/g, "");
}
function pn(t, s) {
  if (t.length === 0 || s.length === 0)
    return !1;
  switch (s.toUpperCase()) {
    case "DA":
    case "DK":
    case "NO":
      return /^[A-ZÆØÅ]{2}[0-9]{4,5}$/i.test(t);
    case "SV":
    case "SE":
      return /^[A-ZÄÜÖ]{3}[0-9]{2}[A-ZÄÜÖ0-9]{1}$/i.test(t);
    default:
      return !1;
  }
}
const m1 = () => {
  const { locale: t } = se(), { t: s } = O(["account", "common"], { nsMode: "fallback" }), [n, r] = M(), a = kt(), { nextStep: o } = Is(), i = ks(), d = wt(), [l, c] = M(), [m, u] = M(), h = L(
    async (le, me) => {
      if (me && dt("licensePlate")(me))
        return { licensePlate: me.licensePlate };
      const ce = await i({
        licensePlate: s("form.validations.licensePlate.exist")
      })({ licensePlate: le.licensePlate, country: le.country });
      return ce ? {
        ...me,
        ...ce
      } : me;
    },
    [s, i]
  ), p = L(
    async (le) => {
      const me = await $t(ac.spa, s)(le);
      return me ? await h(le, me) : void 0;
    },
    [h, s]
  ), f = L(() => {
    o();
  }, [o]), {
    registerField: x,
    getError: g,
    handleSubmit: N,
    resetFieldErrors: b,
    validate: v,
    isValid: S,
    getData: y,
    setFieldErrors: w,
    resetSelectedData: z,
    setPartialData: C
  } = he({
    onValidate: p,
    onSubmit: f,
    namespace: "alpr",
    defaultValues: {
      country: ms(t || ""),
      paymentOptions: "licensePlate"
    }
  }), [E, A, F, R] = Ee(
    "alpr",
    "country",
    "licensePlate",
    "fuelType",
    "emissionClass"
  ), {
    data: T,
    error: P,
    isFetching: V
  } = o1(l);
  B(() => r(P), [P]), B(() => r(null), [A]), B(() => u(T), [T]), B(() => u(void 0), [A, E]), B(() => c(void 0), [E]), B(() => {
    F === "5" && R && C({
      emissionClass: void 0
    });
  }, [F, C, R]), B(() => (sn(!S), () => sn(!1)), [S]);
  const I = y(), _ = L(N, []), ne = L(v, [I.licensePlate]);
  B(() => {
    Hn(Nt(ne, _));
  }, [_, ne]), B(() => () => {
    b();
  }, []);
  const K = L(() => {
    z([
      "make",
      "model",
      "color",
      "weightClass",
      "hybrid",
      "fuelType",
      "emissionClass"
    ]);
  }, [z]);
  B(() => {
    if (m || K(), !E && !A)
      return;
    const me = Yr(
      d.emissionClasses
    )[m == null ? void 0 : m.euroEmissionNorm] ?? void 0, ce = {
      ...m,
      paymentOptions: "licensePlate",
      country: E || "",
      licensePlate: A || "",
      weightClass: (!!(m != null && m.isHGV)).toString(),
      hybrid: (!!(m != null && m.isHybrid)).toString(),
      fuelType: m == null ? void 0 : m.fuelTypeId.toString(),
      emissionClass: me
    };
    (m || E && A) && Zr({ alpr: { ...ce } }), C(ce);
  }, [
    m,
    C,
    K,
    E,
    A
  ]);
  const U = L(() => {
    c({
      licensePlate: A,
      country: E
    });
  }, [E, A]), re = a1.map((le) => ({
    label: s(`vehicleColors.${le}`),
    value: le
  })), ie = L(async () => {
    if (!((q) => !!q.trim())(E)) return;
    const ce = h ? await h({
      licensePlate: A,
      country: E
    }) : void 0;
    if (!ce) {
      U();
      return;
    }
    w(ce), K(), c(void 0);
  }, [
    h,
    w,
    K,
    U,
    A,
    E
  ]);
  return B(() => {
    pn(
      hn(A),
      E
    ) && ie();
  }, [A, E]), /* @__PURE__ */ e.jsxs(
    Bt,
    {
      title: s("businessCommuters.modals.add.alpr.title"),
      id: "commuter-contact-information",
      full: !1,
      titleIntent: "title",
      titleSize: "md",
      className: "pb-0",
      editButton: !1,
      children: [
        /* @__PURE__ */ e.jsx(k, { className: "col-span-full", weight: "light", children: s("businessCommuters.modals.add.alpr.description") }),
        /* @__PURE__ */ e.jsx(
          xe,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...x("country"),
            label: s("form.labels.country"),
            options: a.map((le) => ({ ...le, label: le.key })),
            placeholder: s("form.placeholders.country"),
            error: g("country"),
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          Q,
          {
            className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
            ...x("licensePlate"),
            label: s("form.labels.licensePlate"),
            error: g("licensePlate"),
            required: !0
          }
        ),
        n ? /* @__PURE__ */ e.jsx(ge, { className: "col-span-full sm:col-span-12 md:col-span-12", children: s("form.validations.licensePlate.notfound") }) : null,
        /* @__PURE__ */ e.jsx(
          k,
          {
            as: "h6",
            size: "lg",
            className: "col-span-full sm:col-span-12 md:col-span-12",
            children: s("form.labels.vlinfo")
          }
        ),
        /* @__PURE__ */ e.jsx(
          Q,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...x("make"),
            label: s("form.labels.make"),
            error: g("make"),
            disabled: !!(m != null && m.make)
          }
        ),
        /* @__PURE__ */ e.jsx(
          Q,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...x("model"),
            label: s("form.labels.model"),
            error: g("model"),
            disabled: !!(m != null && m.model)
          }
        ),
        /* @__PURE__ */ e.jsx(
          xe,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...x("color"),
            placeholder: s("form.placeholders.color"),
            label: s("form.labels.color"),
            options: re,
            placeholderDisabled: !1,
            error: g("color"),
            disabled: !!(m != null && m.color)
          }
        ),
        /* @__PURE__ */ e.jsx(
          xe,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...x("weightClass"),
            label: s("form.labels.weightClass"),
            options: [
              { label: s("weightClasses.heavy"), value: "true" },
              { label: s("weightClasses.light"), value: "false" }
            ],
            placeholder: s("form.placeholders.weightClass"),
            error: g("weightClass"),
            required: !0,
            disabled: (m == null ? void 0 : m.isHGV) !== void 0
          }
        ),
        /* @__PURE__ */ e.jsx(
          xe,
          {
            className: "col-span-full sm:col-start-5 md:col-span-6",
            ...x("fuelType"),
            label: s("form.labels.fuelType"),
            options: d.fuelTypes,
            placeholder: s("form.placeholders.fuelType"),
            error: g("fuelType"),
            disabled: !!(m != null && m.fuelType)
          }
        ),
        /* @__PURE__ */ e.jsx(
          xe,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6 md:col-start-7",
            ...x("emissionClass"),
            label: s("form.labels.emissionClass"),
            options: d.emissionClasses,
            placeholder: s("form.placeholders.emissionClass"),
            error: g("emissionClass"),
            disabled: F === "5" || !!(m != null && m.euroEmissionNorm)
          }
        ),
        /* @__PURE__ */ e.jsx(
          Q,
          {
            ...x("hybrid", {
              type: "checkbox",
              value: "true"
            }),
            label: s("form.labels.hybrid"),
            className: "col-span-full sm:col-start-5 md:col-span-6",
            error: g("hybrid"),
            disabled: (m == null ? void 0 : m.isHybrid) !== void 0
          }
        )
      ]
    }
  );
};
var u1 = function(t, s) {
  for (var n = {}; t.length; ) {
    var r = t[0], a = r.code, o = r.message, i = r.path.join(".");
    if (!n[i]) if ("unionErrors" in r) {
      var d = r.unionErrors[0].errors[0];
      n[i] = { message: d.message, type: d.code };
    } else n[i] = { message: o, type: a };
    if ("unionErrors" in r && r.unionErrors.forEach(function(m) {
      return m.errors.forEach(function(u) {
        return t.push(u);
      });
    }), s) {
      var l = n[i].types, c = l && l[r.code];
      n[i] = Rc(i, s, n, a, c ? [].concat(c, r.message) : r.message);
    }
    t.shift();
  }
  return n;
}, _s = function(t, s, n) {
  return n === void 0 && (n = {}), function(r, a, o) {
    try {
      return Promise.resolve(function(i, d) {
        try {
          var l = Promise.resolve(t[n.mode === "sync" ? "parse" : "parseAsync"](r, s)).then(function(c) {
            return o.shouldUseNativeValidation && $c({}, o), { errors: {}, values: n.raw ? r : c };
          });
        } catch (c) {
          return d(c);
        }
        return l && l.then ? l.then(void 0, d) : l;
      }(0, function(i) {
        if (function(d) {
          return d.errors != null;
        }(i)) return { values: {}, errors: Bc(u1(i.errors, !o.shouldUseNativeValidation && o.criteriaMode === "all"), o) };
        throw i;
      }));
    } catch (i) {
      return Promise.reject(i);
    }
  };
};
function pt() {
  const t = at(Fo);
  if (!t)
    throw new Error("useFlags must be used within an FlagsProvider");
  return new Map(Object.entries(t));
}
const h1 = () => {
  var h, p, f, x;
  const t = qt(
    (g) => g.body
  ), { t: s } = O(["account", "common"], { nsMode: "fallback" }), { nextStep: n } = Is(), r = pt(), a = !!(r != null && r.get("showPendlareStartDate")), {
    register: o,
    handleSubmit: i,
    formState: { errors: d, isValid: l },
    reset: c
  } = ws({
    resolver: _s(oc),
    mode: "onChange",
    defaultValues: {
      ...t,
      startDate: t.startDate ? t.startDate : (/* @__PURE__ */ new Date()).toISOString().slice(0, 10)
    }
  }), m = L(
    (g) => {
      Zr({
        ...g,
        startDate: g.startDate.toISOString().slice(0, 10)
      }), n();
    },
    [n]
  );
  B(() => {
    sn(!l);
  }, [l]);
  const u = L(async () => {
    await i(m)();
  }, [i, m]);
  return B(() => {
    Hn(u);
  }, [u]), B(() => () => {
    c();
  }, [c]), /* @__PURE__ */ e.jsxs(
    Bt,
    {
      title: s("businessCommuters.modals.add.contactInformation.title"),
      id: "commuter-contact-information",
      full: !1,
      titleIntent: "title",
      titleSize: "md",
      className: "pb-0",
      editButton: !1,
      children: [
        /* @__PURE__ */ e.jsx(k, { className: "col-span-full", weight: "light", children: s("businessCommuters.modals.add.contactInformation.description") }),
        /* @__PURE__ */ e.jsx(
          qe,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...o("firstName"),
            label: s("form.labels.firstName"),
            error: s(((h = d.firstName) == null ? void 0 : h.message) || ""),
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          qe,
          {
            className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
            ...o("lastName"),
            label: s("form.labels.lastName"),
            error: s(((p = d.lastName) == null ? void 0 : p.message) || ""),
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          qe,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...o("email"),
            label: s("form.labels.email"),
            error: s(((f = d.email) == null ? void 0 : f.message) || ""),
            required: !0
          }
        ),
        a ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            qe,
            {
              className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
              ...o("startDate"),
              label: s("form.labels.startDate"),
              type: "date",
              error: s(((x = d.startDate) == null ? void 0 : x.message) || ""),
              required: !0
            }
          ),
          /* @__PURE__ */ e.jsx("p", { className: "col-span-full mt-[-8px] text-sm sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7", children: s("form.descriptions.startDate") })
        ] }) : null
      ]
    }
  );
}, p1 = () => {
  const { locale: t } = se(), { t: s } = O(["account", "common"], { nsMode: "fallback" }), n = ni(
    "business",
    Z.OresundBusinessPendler
  ), { nextStep: r } = Is();
  B(() => {
    r && Hn(async () => r());
  }, [r]);
  const a = D(
    () => ss(t || ""),
    [t]
  ), o = n.find((d) => d.currency === a), i = o ? Bn(o.price || 0, t, a) : "";
  return /* @__PURE__ */ e.jsxs(Ue, { children: [
    /* @__PURE__ */ e.jsx(k, { className: "col-span-full", as: "h3", intent: "title", children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "businessCommuters.modals.add.disclaimer.title",
        children: /* @__PURE__ */ e.jsx(Ze, { contract: "oresundBusinessCommuter" })
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "businessCommuters.modals.add.disclaimer.description",
        children: /* @__PURE__ */ e.jsx(k, { className: "col-span-full", gutter: !0, children: /* @__PURE__ */ e.jsx(Ze, { contract: "oresundBusinessCommuter" }) })
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "col-span-full mb-4 sm:w-2/3", children: /* @__PURE__ */ e.jsx(
      qn,
      {
        hideCommuter: !0,
        showPaymentType: "invoice",
        onAgreementChange: s1,
        selectFirstContractWithInvoicePaymentMethod: !0
      }
    ) }),
    /* @__PURE__ */ e.jsxs(k, { className: "col-span-full mb-4", children: [
      /* @__PURE__ */ e.jsx(k, { as: "span", className: "block", intent: "label", children: s("form.labels.priceExclVAT") }),
      /* @__PURE__ */ e.jsx(
        k,
        {
          as: "span",
          intent: "title",
          className: "text-primary-400 block pt-2",
          children: i
        }
      )
    ] })
  ] });
}, f1 = () => {
  const [t, s] = M(!1), { t: n } = O(["account", "common"], { nsMode: "fallback" }), { prevStep: r, currentStep: a, isOnLastStep: o } = Is(), { disableNext: i } = qt(), d = async () => {
    s(!0), await r1(), s(!1);
  };
  return /* @__PURE__ */ e.jsxs($, { className: "flex justify-end gap-4", children: [
    a > 0 && /* @__PURE__ */ e.jsx(X, { as: "button", onClick: r, intent: "text", children: n("action.back") }),
    /* @__PURE__ */ e.jsx(
      De,
      {
        loadingLabel: n("action.loading"),
        onClick: d,
        isLoading: t,
        disabled: i,
        children: n(o ? "action.add" : "action.continue")
      }
    )
  ] });
}, oi = ({ state: t, close: s }) => {
  const { t: n } = O(["account", "common"], { nsMode: "fallback" });
  return t === "loading" ? /* @__PURE__ */ e.jsx($, {}) : t === "success" ? /* @__PURE__ */ e.jsx($, { className: "flex justify-end gap-4", children: /* @__PURE__ */ e.jsx(X, { as: "button", onClick: s, children: n("action.complete") }) }) : t === "error" ? /* @__PURE__ */ e.jsx($, { className: "flex justify-end gap-4", children: /* @__PURE__ */ e.jsx(X, { as: "button", onClick: s, children: n("action.close") }) }) : /* @__PURE__ */ e.jsx(f1, {});
};
oi.displayName = "ModalFooter";
const x1 = () => {
  const { t } = O(["account", "common"], { nsMode: "fallback" }), s = L((d) => {
    Zr(d);
  }, []), {
    registerField: n,
    handleSubmit: r,
    validate: a
  } = he({
    onSubmit: s,
    namespace: "termsOfAgreement"
  }), [o] = Ee(
    "termsOfAgreement",
    "agreement"
  ), i = D(() => o === "true", [o]);
  return B(() => (sn(!i), () => sn(!1)), [i]), B(() => {
    Hn(Nt(a, r));
  }, [r, a]), /* @__PURE__ */ e.jsxs(
    Bt,
    {
      title: t("businessCommuters.modals.add.termsOfAgreement.title"),
      id: "commuter-contact-information",
      full: !1,
      titleIntent: "title",
      titleSize: "md",
      className: "pb-0",
      editButton: !1,
      children: [
        /* @__PURE__ */ e.jsx(k, { className: "col-span-full", weight: "light", children: /* @__PURE__ */ e.jsxs(
          G,
          {
            ns: "account",
            i18nKey: "businessCommuters.modals.add.termsOfAgreement.description",
            children: [
              /* @__PURE__ */ e.jsx(Ze, { contract: "oresundBusinessCommuter" }),
              /* @__PURE__ */ e.jsx(Ze, { contract: "oresundPayBusiness" })
            ]
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          Q,
          {
            ...n("agreement", { type: "checkbox", value: "true" }),
            className: "col-span-full",
            label: t("form.labels.termsOfAgreement"),
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(k, { size: "sm", className: "col-span-full", children: /* @__PURE__ */ e.jsx(Wn, { type: Z.OresundBusiness }) })
      ]
    }
  );
}, g1 = async (t) => (await t1.spa(t)).success, b1 = ({
  className: t = "",
  isCommuterAdditionRestricted: s = !1
}) => {
  const [n, r] = M(), { t: a } = O(["account", "common"], { nsMode: "fallback" }), { body: o, contractNo: i } = qt(), d = Le(), { mutateAsync: l } = fe(
    ["add", "business", "commuter"],
    (p) => p.Contract.addBusinessCommuter,
    {
      onError: () => {
        r("error");
      },
      onSuccess: () => {
        r("success"), d.invalidateQueries(ee.BusinessCommutersList);
      }
    }
  );
  B(() => {
    if (!o || !i || n === "loading" || n === "success")
      return;
    let p = !1;
    return (async () => {
      if (!(!await g1(
        o
      ) || p)) {
        r("loading");
        try {
          await l({
            ...o,
            startDate: o.startDate ?? (/* @__PURE__ */ new Date()).toISOString().slice(0, 10),
            contractNo: i
          }), p || r("success");
        } catch {
          p || r("error");
        }
      }
    })(), () => {
      p = !0;
    };
  }, [o, i, l, n]);
  const c = D(() => n === "loading" ? /* @__PURE__ */ e.jsxs($, { className: "flex h-64 flex-col items-center justify-center", children: [
    /* @__PURE__ */ e.jsx(
      nn,
      {
        label: a("action.loading"),
        className: "text-primary-400 text-4xl"
      }
    ),
    /* @__PURE__ */ e.jsx(k, { className: "mt-8", children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "businessCommuters.modals.add.loading.description",
        children: /* @__PURE__ */ e.jsx(Ze, { contract: "oresundBusinessCommuter" })
      }
    ) })
  ] }) : n === "success" ? /* @__PURE__ */ e.jsxs($, { className: "flex h-64 flex-col items-center justify-center", children: [
    /* @__PURE__ */ e.jsx($l, { className: "text-[3.25rem]", "aria-hidden": "true" }),
    /* @__PURE__ */ e.jsx(k, { intent: "title", className: "mt-8", gutter: !0, children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "businessCommuters.modals.add.success.title",
        children: /* @__PURE__ */ e.jsx(Ze, { contract: "oresundBusinessCommuter" })
      }
    ) }),
    /* @__PURE__ */ e.jsx(k, { children: a("businessCommuters.modals.add.success.description") })
  ] }) : n === "error" ? /* @__PURE__ */ e.jsxs($, { className: "flex h-64 flex-col items-center justify-center", children: [
    /* @__PURE__ */ e.jsx(ro, { className: "text-[3.25rem]", "aria-hidden": "true" }),
    /* @__PURE__ */ e.jsx(k, { intent: "title", className: "mt-8", gutter: !0, children: a("businessCommuters.modals.add.error.title") }),
    /* @__PURE__ */ e.jsx(k, { children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "account",
        i18nKey: "businessCommuters.modals.add.error.description",
        children: /* @__PURE__ */ e.jsx(Ze, { contract: "oresundBusinessCommuter" })
      }
    ) })
  ] }) : [
    /* @__PURE__ */ e.jsx(p1, {}, 0),
    /* @__PURE__ */ e.jsx(h1, {}, 1),
    /* @__PURE__ */ e.jsx(m1, {}, 2),
    /* @__PURE__ */ e.jsx(x1, {}, 3)
  ], [n, a]), m = D(() => {
    const p = (f) => /* @__PURE__ */ e.jsx(oi, { state: n, close: f });
    return p.displayName = "MultiStepModalFooter", p;
  }, [n]), u = D(
    () => n === void 0 ? {
      title: a("businessCommuters.modals.add.preventClose.title"),
      content: a("businessCommuters.modals.add.preventClose.description"),
      cancelText: a("businessCommuters.modals.add.preventClose.cancel"),
      confirmText: a("businessCommuters.modals.add.preventClose.confirm")
    } : void 0,
    [n, a]
  ), h = L(() => {
    r(void 0), n1();
  }, []);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    s && /* @__PURE__ */ e.jsx(ze, { colorMode: "warning", className: "mb-4", children: a("businessCommuters.creditCardCustomer") }),
    /* @__PURE__ */ e.jsx(
      um,
      {
        contentWrapper: "form",
        title: /* @__PURE__ */ e.jsx(G, { ns: "account", i18nKey: "businessCommuters.modals.add.title", children: /* @__PURE__ */ e.jsx(Ze, { contract: "oresundBusinessCommuter" }) }),
        trigger: /* @__PURE__ */ e.jsx(
          X,
          {
            disabled: s,
            startIcon: /* @__PURE__ */ e.jsx(cs, {}),
            iconSize: "lg",
            className: t,
            children: a("businessCommuters.action.addCommuter")
          }
        ),
        footer: m,
        hideProgress: n !== void 0 ? !0 : void 0,
        onClose: h,
        preventClose: u,
        children: c
      }
    )
  ] });
}, v1 = (t, s) => [t, s].join(" "), y1 = (t) => `/account/vehicles?contract=${t}`, j1 = () => {
  const { data: t } = ye(
    ee.BusinessCommutersList,
    ({ Contract: a }) => a.businessCommuters,
    { suspense: !0 }
  ), { push: s } = se();
  if (!t)
    return null;
  const n = t.filter(
    (a) => a.paymentAgreement.agreementType === "Oresund_Business_Pendler"
  );
  if (n.length < 1) return /* @__PURE__ */ e.jsx(e.Fragment, {});
  const r = (a) => {
    s(y1(a));
  };
  return /* @__PURE__ */ e.jsx($, { as: "ul", className: "flex flex-col gap-4", children: n.map(({ paymentAgreement: a }) => /* @__PURE__ */ e.jsx("li", { children: /* @__PURE__ */ e.jsxs(
    "button",
    {
      onClick: () => r(a.contractNo),
      className: "hover:ring-primary-700 focus-visible:ring-primary-700 group flex w-full items-center justify-between rounded px-4 py-4 text-left shadow-md hover:ring-2 focus-visible:ring-2",
      children: [
        /* @__PURE__ */ e.jsxs($, { as: "span", className: "mr-4 flex items-center gap-2", children: [
          /* @__PURE__ */ e.jsx(Bl, { fontSize: "15px", "aria-hidden": "true" }),
          /* @__PURE__ */ e.jsx(k, { intent: "label", size: "lg", as: "p", children: v1(
            a.firstName,
            a.lastName
          ) })
        ] }),
        /* @__PURE__ */ e.jsx(
          Tr,
          {
            fontSize: "12px",
            className: "group-hover:text-primary-700 rotate-90",
            "aria-hidden": "true"
          }
        )
      ]
    }
  ) }, a.contractNo)) });
}, Lg = () => {
  const { t } = O(["account"]);
  ni("business", Z.OresundBusinessPendler);
  const { contracts: s } = Rn(), n = s == null ? void 0 : s.some(
    (a) => a.paymentType === Ma.CARD
  ), r = s == null ? void 0 : s.some(
    (a) => a.paymentType === Ma.INVOICE
  );
  return /* @__PURE__ */ e.jsxs($, { children: [
    /* @__PURE__ */ e.jsx($, { className: "mb-12 mt-4 sm:mb-16 sm:mt-2", children: r ? /* @__PURE__ */ e.jsx(
      b1,
      {
        isCommuterAdditionRestricted: n
      }
    ) : /* @__PURE__ */ e.jsx(ze, { colorMode: "warning", children: t("businessCommuters.creditCardCustomer") }) }),
    /* @__PURE__ */ e.jsx(j1, {})
  ] });
}, C1 = (t = "information") => {
  switch (t) {
    case "information":
      return " border-blue-600";
    case "success":
      return " border-green-600";
    case "error":
      return " border-red-600";
    case "warning":
      return "border-yellow-600";
  }
}, N1 = (t = "information") => {
  switch (t) {
    case "information":
      return /* @__PURE__ */ e.jsx(Il, { width: 24, height: 24, className: "text-blue-600" });
    case "success":
      return /* @__PURE__ */ e.jsx(wr, { width: 24, height: 24, className: "text-green-600" });
    case "error":
      return /* @__PURE__ */ e.jsx(ro, { width: 24, height: 24, className: "text-red-600" });
    case "warning":
      return /* @__PURE__ */ e.jsx(ao, { width: 24, height: 24, className: "text-yellow-600" });
  }
}, ii = ({
  registrationNumber: t,
  duration: s = 5e3,
  colorMode: n = "success",
  onClose: r
}) => {
  const [a, o] = M(!0), { t: i } = O(["account"], {
    nsMode: "fallback"
  }), d = Ae(null);
  B(() => ((() => {
    d.current = setTimeout(() => {
      o(!1), r == null || r();
    }, s);
  })(), () => {
    d.current && clearTimeout(d.current);
  }), [s, r]);
  const l = () => {
    o(!1), r == null || r();
  }, c = () => {
    o(!0), d.current && clearTimeout(d.current);
  }, m = () => {
    d.current && clearTimeout(d.current), d.current = setTimeout(() => {
      o(!1), r == null || r();
    }, s);
  };
  if (!a)
    return null;
  const u = C1(n), h = N1(n);
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      "aria-live": "assertive",
      onMouseEnter: c,
      onMouseLeave: m,
      className: `shadow-toast absolute right-6 top-7 z-50 flex max-w-[417px] cursor-pointer justify-between rounded-lg border-l-[3px] bg-white p-4 ${u}`,
      children: [
        /* @__PURE__ */ e.jsx("div", { className: " flex justify-between  ", children: /* @__PURE__ */ e.jsxs("div", { className: "flex gap-6 ", children: [
          /* @__PURE__ */ e.jsx("div", { children: h }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ e.jsx("div", { className: "font-semibold text-neutral-950", children: i("kmtoll.order.toast.title") }),
            /* @__PURE__ */ e.jsx(
              G,
              {
                as: "span",
                ns: "account",
                i18nKey: "kmtoll.order.toast.orderSuccess",
                children: t
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
          rn,
          {
            width: 16,
            height: 16,
            onClick: l,
            className: "cursor-pointer  text-neutral-700 "
          }
        ) })
      ]
    }
  );
}, li = Ns(
  () => ({})
), ci = (t) => li.setState(t), di = () => li.getState(), w1 = () => {
  const { customerInformation: t } = Oe();
  return t ? /* @__PURE__ */ e.jsxs(Je, { pt: "spacing.200", pb: "spacing.100", display: "block", children: [
    /* @__PURE__ */ e.jsxs(Y, { variant: "smallParagraph", my: "spacing.100", mt: 0, children: [
      t.firstName,
      " ",
      t.lastName
    ] }),
    /* @__PURE__ */ e.jsx(Y, { variant: "smallParagraph", my: "spacing.100", mt: 0, children: t.address }),
    /* @__PURE__ */ e.jsxs(Y, { variant: "smallParagraph", my: "spacing.100", mt: 0, children: [
      t.zipCode,
      " ",
      t.city
    ] })
  ] }) : null;
}, k1 = () => {
  const t = Le(), [s, n] = M(), { t: r } = O(["recognitions", "common"], {
    nsMode: "fallback"
  }), { locale: a } = se(), { nextStep: o, close: i } = Cs(), { mutateAsync: d, isLoading: l } = fe(
    ["recognitions", "add", "bizz"],
    ({ Recognition: m }) => m.addRecognition,
    {
      onSuccess: () => {
        t.invalidateQueries({
          queryKey: ["account", "recognitions"]
        });
      },
      onError: (m) => m && m.code === 400 && m.error === un.blockCommercialVehicle ? n(r("form.validations.commercial.notAllowed")) : n(r("errors.generic"))
    }
  ), c = L(async () => {
    try {
      const m = di();
      await d(m), o();
    } catch {
    }
  }, [d, o]);
  return B(() => () => n(void 0), [n]), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    s ? /* @__PURE__ */ e.jsx(zt, { variant: "error", children: s }) : null,
    /* @__PURE__ */ e.jsxs(Je, { mt: "spacing.300", children: [
      /* @__PURE__ */ e.jsxs(Je, { sx: { maxWidth: "65ch" }, children: [
        /* @__PURE__ */ e.jsx(
          Y,
          {
            variant: "smallParagraph",
            mt: 0,
            mb: 0,
            pt: "spacing.200",
            pb: "spacing.100",
            children: r("replaceRecognitionModal.descriptions.verifyAddress")
          }
        ),
        /* @__PURE__ */ e.jsx(
          Y,
          {
            variant: "smallParagraph",
            mt: 0,
            mb: 0,
            pt: "spacing.200",
            pb: "spacing.100",
            children: r("replaceRecognitionModal.descriptions.order")
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs(
        Vt,
        {
          fallback: /* @__PURE__ */ e.jsx(
            Je,
            {
              display: "flex",
              p: "spacing.500",
              sx: { justifyContent: "center", alignItems: "center" },
              children: /* @__PURE__ */ e.jsx(Je, { sx: { width: "35px" }, children: /* @__PURE__ */ e.jsx(At, { "aria-label": r("action.loading") }) })
            }
          ),
          children: [
            /* @__PURE__ */ e.jsx(w1, {}),
            /* @__PURE__ */ e.jsx(
              mt,
              {
                as: "a",
                href: `/${a}/account/customerInformation`,
                className: "mb-2 mt-3 font-normal",
                children: r("action.updateAddress")
              }
            )
          ]
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      Rt,
      {
        px: 0,
        actionLabel: r("action.order"),
        cancelLabel: r("action.cancel"),
        loadingLabel: r("action.loading"),
        disabled: l || !!s,
        action: c,
        onClose: i,
        isLoading: l,
        loadingButton: !0
      }
    )
  ] });
}, P1 = () => {
  const { t } = O(["recognitions", "common"], {
    nsMode: "fallback"
  }), { close: s } = Cs(), { type: n = "alpr" } = D(
    () => di(),
    []
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(Je, { py: "spacing.300", sx: { textAlign: "center" }, children: [
      /* @__PURE__ */ e.jsx(Y, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: /* @__PURE__ */ e.jsx(
        G,
        {
          ns: "recognitions",
          i18nKey: `addRecognitionModal.confirmation.${n}.title`,
          children: /* @__PURE__ */ e.jsx(
            Y,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.bold" }
            }
          )
        }
      ) }),
      /* @__PURE__ */ e.jsx(Y, { variant: "small", children: /* @__PURE__ */ e.jsxs(
        G,
        {
          ns: "recognitions",
          i18nKey: `addRecognitionModal.confirmation.${n}.description`,
          children: [
            /* @__PURE__ */ e.jsx(
              Y,
              {
                as: "span",
                variant: "small",
                sx: { fontWeight: "fontWeights.medium" }
              }
            ),
            /* @__PURE__ */ e.jsx(
              Y,
              {
                as: "span",
                variant: "small",
                sx: { fontWeight: "fontWeights.medium" }
              }
            ),
            /* @__PURE__ */ e.jsx(
              Y,
              {
                as: "span",
                variant: "small",
                sx: { fontWeight: "fontWeights.medium" }
              }
            )
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(
      fs,
      {
        actionLabel: t("action.close"),
        cancelLabel: t("action.cancel"),
        action: () => () => Promise.resolve(s()).then(() => !0),
        removeCancelButton: !0
      }
    )
  ] });
}, T1 = (t) => (s) => s && t[s] ? t[s] : "", Aa = ({
  weightClass: t,
  hybrid: s,
  asfinag: n,
  country: r,
  licensePlate: a,
  fuelType: o,
  emissionClass: i,
  reference: d,
  recognitionType: l,
  contractNo: c,
  isCommercialVehicle: m,
  endDate: u
}) => ({
  type: l,
  isHGV: t === "heavy",
  isHybrid: s === "true",
  isAsfinag: n === "true",
  countryCode: r,
  regNo: a,
  fuelType: o ? Number(o) : void 0,
  reference: d || "",
  emissionClass: i ? Number(i) : void 0,
  contractNo: c,
  isCommercialVehicle: m === "true",
  endDate: u || ""
}), S1 = {
  isHybrid: "hybrid",
  isAsfinag: "asfinag",
  isHGV: "weightClass",
  regNo: "licensePlate",
  countryCode: "country"
}, M1 = (t) => t && Object.entries(t).reduce((s, [n, r]) => {
  if (!r)
    return s;
  const a = S1[n] || n;
  return a ? { ...s, [a]: r } : s;
}, {}), Vg = () => typeof window > "u", z1 = (t) => !!t && t.trim() !== "", A1 = ({
  namespace: t,
  countries: s,
  fuelTypes: n,
  emissionClasses: r,
  weightClasses: a,
  contracts: o,
  recognitionTypes: i,
  labels: d,
  placeholders: l,
  descriptions: c,
  validateLicensePlate: m,
  defaultValues: u,
  vehicleColors: h
}) => {
  const {
    registerField: p,
    getError: f,
    setFieldErrors: x,
    setPartialData: g,
    resetSelectedData: N,
    resetFieldError: b
  } = he({
    namespace: t,
    defaultValues: u
  }), [
    v,
    S,
    y,
    w,
    z,
    C,
    E
  ] = Ee(
    t,
    "country",
    "licensePlate",
    "recognitionType",
    "contractNo",
    "weightClass",
    "fuelType",
    "emissionClass"
  );
  B(() => {
    C === "5" && E && g({
      emissionClass: void 0
    });
  }, [C, g, E]);
  const [A, F] = M(), [R, T] = M(), [P, V] = M(), I = D(() => y === "alpr", [y]), _ = D(() => z === "heavy", [z]), ne = D(() => y === "bizz", [y]);
  B(() => {
    ne && g({
      endDate: void 0
    });
  }, [ne, g]);
  const {
    data: K,
    error: U,
    isFetching: re
  } = $n(A);
  B(() => T(U), [U]), B(() => T(null), [S]), B(() => V(K), [K]), B(() => V(void 0), [S, v]), B(() => F(void 0), [v]), B(() => {
    C === "5" && E && g({
      emissionClass: void 0
    });
  }, [C, g, E]);
  const ie = L(() => {
    F({
      licensePlate: S,
      country: v
    });
  }, [v, S]), le = L(() => {
    N([
      "make",
      "model",
      "color",
      "weightClass",
      "hybrid",
      "asfinag",
      "fuelType",
      "emissionClass"
    ]);
  }, [N]);
  B(() => {
    if (P) {
      const ae = P;
      g({
        ...ae,
        weightClass: ae.isHGV ? "heavy" : "light",
        hybrid: ae.isHybrid ? "true" : "false",
        fuelType: ae.fuelTypeId.toString(),
        isCommercialVehicle: ae.isCommercialVehicle ? "true" : "false",
        emissionClass: ae.euroEmissionNorm !== void 0 ? Yr(r)[ae.euroEmissionNorm] : void 0
      });
    } else
      le();
  }, [
    P,
    g,
    le,
    r
  ]), B(() => {
    le(), b("licensePlate");
  }, [v, le, b]);
  const me = L(async () => {
    if (!z1(v)) return;
    let je = !0;
    if (I) {
      const Ve = await m({
        country: v,
        licensePlate: S
      })(void 0);
      Ve && (je = !1, x(Ve), le(), F(void 0));
    }
    (!I || je) && ie();
  }, [
    v,
    I,
    m,
    S,
    x,
    le,
    ie
  ]);
  B(() => {
    pn(hn(S), v) && me();
  }, [v, me, S]);
  const ce = D(() => y != "", [y]), q = D(() => w != "", [w]), de = T1(c)(y);
  return /* @__PURE__ */ e.jsxs(Ue, { className: He("mb-4 gap-4"), children: [
    /* @__PURE__ */ e.jsxs($, { className: "col-span-full sm:col-span-12 md:col-span-12 md:col-start-1", children: [
      /* @__PURE__ */ e.jsx(k, { children: c.recognitionType }),
      /* @__PURE__ */ e.jsx(
        xe,
        {
          label: d.recognitionType,
          error: f("recognitionType"),
          ...p("recognitionType"),
          options: i,
          required: !0
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs($, { className: "col-span-full mb-8 sm:col-span-12 md:col-span-12 md:col-start-1", children: [
      /* @__PURE__ */ e.jsx(k, { children: c.contract }),
      /* @__PURE__ */ e.jsx(
        xe,
        {
          placeholder: l.contractNo,
          label: d.contractNo,
          disabled: !ce,
          error: f("contractNo"),
          ...p("contractNo"),
          options: o,
          required: !0
        }
      )
    ] }),
    de && de.trim() !== "" ? /* @__PURE__ */ e.jsx($, { className: "col-span-full w-0 min-w-full sm:col-span-12 md:col-span-12", children: /* @__PURE__ */ e.jsx(ge, { children: de }) }) : null,
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-12 md:col-span-12", children: /* @__PURE__ */ e.jsx(
      Q,
      {
        ...p("reference"),
        label: ne ? d.reference : d.alprName,
        error: f("reference"),
        disabled: !ce || !q
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      xe,
      {
        label: d.country,
        placeholder: l.country,
        error: f("country"),
        disabled: !ce || !q,
        ...p("country"),
        options: s,
        required: !0
      }
    ) }),
    /* @__PURE__ */ e.jsxs($, { className: "col-span-full w-0 min-w-full sm:col-span-12 md:col-span-6", children: [
      /* @__PURE__ */ e.jsx(
        Q,
        {
          ...p("licensePlate"),
          label: d.licensePlate,
          error: f("licensePlate"),
          disabled: !ce || !q,
          required: !ne
        }
      ),
      R ? /* @__PURE__ */ e.jsx(ge, { children: d.noVehicleInfo }) : null
    ] }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full mb-0 sm:col-span-12 md:col-span-12", children: /* @__PURE__ */ e.jsx(k, { as: "h6", size: "lg", className: "mb-0", children: d.volVehicleInfo }) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Q,
      {
        ...p("make"),
        label: d.make,
        error: f("make"),
        disabled: !ce || !q || !!(P != null && P.make)
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Q,
      {
        ...p("model"),
        label: d.model,
        error: f("model"),
        disabled: !ce || !q || !!(P != null && P.model)
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      xe,
      {
        ...p("color"),
        placeholder: l.color,
        label: d.color,
        options: h,
        placeholderDisabled: !1,
        error: f("color"),
        disabled: !ce || !q || !!(P != null && P.color)
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      xe,
      {
        label: d.weightClass,
        placeholder: l.weightClass,
        error: f("weightClass"),
        placeholderDisabled: !1,
        disabled: !ce || !q || (P == null ? void 0 : P.isHGV) !== void 0,
        ...p("weightClass"),
        options: a
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      xe,
      {
        label: d.fuelType,
        placeholder: l.fuelType,
        placeholderDisabled: !1,
        error: f("fuelType"),
        disabled: !ce || !q || !!(P != null && P.fuelType),
        ...p("fuelType"),
        options: n
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      xe,
      {
        label: d.emissionClass,
        placeholder: l.emissionClass,
        placeholderDisabled: !1,
        error: f("emissionClass"),
        disabled: !ce || !q || C === "5" || !!(P != null && P.euroEmissionNorm),
        ...p("emissionClass"),
        options: r
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Q,
      {
        error: f("hybrid"),
        label: d.hybrid,
        disabled: !ce || !q || (P == null ? void 0 : P.isHybrid) !== void 0,
        ...p("hybrid", {
          type: "checkbox",
          value: "true"
        })
      }
    ) }),
    ne && _ && /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Q,
      {
        error: f("asfinag"),
        label: d.asfinag,
        disabled: !ce || !q,
        ...p("asfinag", {
          type: "checkbox",
          value: "true"
        })
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full hidden sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Q,
      {
        error: f("isCommercialVehicle"),
        label: d.isCommercialVehicle,
        ...p("isCommercialVehicle", {
          type: "checkbox",
          value: "true"
        }),
        disabled: (P == null ? void 0 : P.isCommercialVehicle) !== void 0
      }
    ) }),
    ne ? null : /* @__PURE__ */ e.jsxs($, { className: "col-span-full text-neutral-500 sm:col-span-12 md:col-span-12", children: [
      /* @__PURE__ */ e.jsx(
        Q,
        {
          error: f("endDate"),
          label: /* @__PURE__ */ e.jsx("span", { className: "text-neutral-900", children: d.endDate }),
          ...p("endDate", {
            type: "date"
          }),
          onClick: (ae) => ae.currentTarget.showPicker()
        }
      ),
      /* @__PURE__ */ e.jsx(k, { className: "max-w-[672px] text-wrap pt-4 text-neutral-500", children: c.endDate })
    ] })
  ] });
}, Rg = (t) => {
  switch (t) {
    case "oresundsPay":
      return "Som kund hos ÖresundsPay måste du registrera ditt Bropass-avtal via Mitt konto.";
    case "brobizz":
      return "Som kund hos Brobizz måste du registrera ditt Bropass-avtal via Brobizz hemsida.";
    default:
      return `Om du har en aktiv bizz med ${t} kan du lägga till den här. Ditt Bropass-avtal knyts då till din bizz och konto hos ${t}.`;
  }
}, Gn = [
  "black",
  "blue",
  "brown",
  "green",
  "grey",
  "orange",
  "purple",
  "red",
  "white",
  "yellow",
  "other"
], $g = (t, s) => {
  const n = s == null ? void 0 : s.supportedCountries;
  return Array.isArray(n) && n.includes(t);
}, O1 = {
  sv: "/sv/account",
  da: "/da/account",
  en: "/account"
  // en is the default locale so we do not need the locale prefix here
}, E1 = (t) => t != null && t.includes("sv") ? "sv" : t != null && t.includes("da") ? "da" : "en", Bg = (t) => {
  const s = E1(t);
  return O1[s];
}, mi = (t, s) => {
  const { query: n, replace: r, pathname: a } = s;
  delete n[t], r({ pathname: a, query: n }, void 0, { shallow: !0 });
}, D1 = Gt()("licensePlate", "country"), F1 = ({
  contractNo: t,
  preSelectedRecognitionType: s
}) => {
  const n = Ae(null), r = Le(), [a, o] = M(), { t: i } = O(["recognitions", "common"], {
    nsMode: "fallback"
  }), { mutateAsync: d, isLoading: l } = fe(
    ["recognitions", "add", "alpr"],
    ({ Recognition: T }) => T.addRecognition,
    {
      onSuccess: () => {
        r.invalidateQueries({
          queryKey: ["account", "recognitions"]
        });
      },
      onError: (T) => T && T.code === 400 && T.error === un.blockCommercialVehicle ? o(i("form.validations.commercial.notAllowed")) : o(i("errors.generic"))
    }
  ), [c] = Ee(
    "add-recognition",
    "recognitionType"
  ), m = D(() => c === "alpr", [c]), { nextStep: u, close: h } = Cs(), p = ks(), f = L(
    (T) => async (P) => {
      const V = P || {};
      if (V && !dt("licensePlate")(V) || V && !dt("country")(V))
        return;
      const I = D1(T);
      try {
        return await p({
          licensePlate: i("form.validations.licensePlate.exist")
        })(I);
      } catch {
        return;
      }
    },
    [i, p]
  ), x = L(
    async (T) => {
      try {
        const P = Aa(T), V = await $t(
          ic.spa,
          i
        )(P), I = M1(V);
        let _ = I;
        return _ || (m && (_ = await f(T)(I), !_) ? void 0 : _);
      } catch {
        return;
      }
    },
    [i, f, m]
  ), g = L(
    async (T) => {
      const P = Aa(T);
      if (ci(P), m)
        try {
          await d(P), u();
        } catch {
        }
      else
        u();
    },
    [m, d, u]
  ), N = "add-recognition", { handleSubmit: b, resetData: v, validate: S, isValid: y } = he({
    namespace: N,
    onValidate: x,
    onSubmit: g
  }), { emissionClasses: w, fuelTypes: z } = wt(), C = kt(), { contracts: E } = Rn(!1), { data: A } = qr(t);
  B(
    () => () => {
      v(), o(void 0);
    },
    [v, o]
  );
  const F = D(
    () => Gn.map((T) => ({
      label: i(`vehicleColors.${T}`),
      value: T
    })),
    [i]
  ), R = D(
    () => ({
      namespace: N,
      fuelTypes: z,
      emissionClasses: w,
      countries: C.map(({ key: T, value: P }) => ({
        label: T,
        value: P
      })),
      vehicleColors: F,
      weightClasses: [
        { label: i("weightClasses.heavy"), value: "heavy" },
        { label: i("weightClasses.light"), value: "light" }
      ],
      contracts: A ? [
        Mo(i)(
          vd(A)
        )
      ] : zo(i, E, !1, !0),
      recognitionTypes: [
        { label: i("form.labels.bizz.order"), value: "bizz" },
        {
          label: i("form.labels.regNo.add"),
          value: "alpr"
        }
      ],
      labels: {
        contractNo: i("form.labels.contract"),
        country: i("form.labels.country"),
        emissionClass: i("form.labels.emissionClass"),
        fuelType: i("form.labels.fuelType"),
        licensePlate: i("form.labels.licensePlate"),
        weightClass: i("form.labels.weightClass"),
        hybrid: i("form.labels.hybrid"),
        asfinag: i("form.labels.asfinag"),
        reference: i("form.labels.reference"),
        recognitionType: i("form.labels.recognitionType"),
        lookup: i("form.labels.lookupLicensePlate"),
        vehicleSearch: i("action.search"),
        make: i("form.labels.make"),
        model: i("form.labels.model"),
        color: i("form.labels.color"),
        alprName: i("form.labels.alprName"),
        volVehicleInfo: i("form.labels.vlinfo"),
        noVehicleInfo: i("form.validations.licensePlate.notfound"),
        loadingSearch: i("action.loading"),
        isCommercialVehicle: i("form.labels.commercialVehicle"),
        endDate: i("form.labels.lastUseDate")
      },
      placeholders: {
        weightClass: i("form.placeholders.weightClass"),
        country: i("form.placeholders.country"),
        emissionClass: i("form.placeholders.emissionClass"),
        fuelType: i("form.placeholders.fuelType"),
        color: i("form.placeholders.color"),
        contractNo: i("form.placeholders.contractNo")
      },
      descriptions: {
        bizz: i("form.descriptions.bizz"),
        licensePlate: i("form.descriptions.licensePlate"),
        contract: i("form.descriptions.contract"),
        recognitionType: i("form.descriptions.recognitionType"),
        contractBizzSelected: i("form.descriptions.contractBizzSelected"),
        contractAlprSelected: i("form.descriptions.contractAlprSelected"),
        endDate: i("form.descriptions.endDate")
      },
      validateLicensePlate: f,
      defaultValues: {
        recognitionType: s === "bizz" || s === "alpr" ? s : "alpr",
        contractNo: t
      }
    }),
    [
      A,
      t,
      E,
      C,
      w,
      z,
      s,
      i,
      f,
      F
    ]
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    a ? /* @__PURE__ */ e.jsx(zt, { variant: "error", children: a }) : null,
    /* @__PURE__ */ e.jsxs(
      Fn,
      {
        onSubmit: Nt(S, b),
        onReset: h,
        ref: n,
        children: [
          /* @__PURE__ */ e.jsx(
            A1,
            {
              preSelectedRecognitionType: s,
              ...R
            }
          ),
          /* @__PURE__ */ e.jsx(
            Rt,
            {
              px: 0,
              actionLabel: i(m ? "action.add" : "action.next"),
              cancelLabel: i("action.cancel"),
              loadingLabel: i("action.loading"),
              disabled: !y,
              actionButtonType: "submit",
              cancelButtonType: "reset",
              isLoading: l,
              loadingButton: !0
            }
          )
        ]
      }
    )
  ] });
}, ui = () => {
  const t = se(), { query: s } = t, { contracts: n } = Rn();
  return (n ?? []).length === 1 ? n == null ? void 0 : n[0].contractNo : s.contract;
}, L1 = ({
  preSelectedRecognitionType: t,
  onClose: s
}) => {
  const { t: n } = O(["recognitions", "common"], {
    nsMode: "fallback"
  }), r = ui(), [a] = Ee(
    "add-recognition",
    "recognitionType"
  ), o = D(() => a === "bizz", [a]), i = t === "bizz" ? "action.bizz" : "action.alpr";
  return /* @__PURE__ */ e.jsxs(
    xo,
    {
      open: !0,
      ariaLabelledBy: "title",
      title: /* @__PURE__ */ e.jsx(
        Y,
        {
          id: "title",
          variant: "paragraph",
          mt: 0,
          mb: 0,
          sx: { color: "colors.neutral.100" },
          children: n(i)
        }
      ),
      labels: {
        close: n("action.close"),
        cancel: n("action.cancel"),
        complete: n("action.complete"),
        continue: n("action.continue")
      },
      onClose: () => {
        s(), ci({});
      },
      hideProgress: !0,
      children: [
        /* @__PURE__ */ e.jsx(
          F1,
          {
            preSelectedRecognitionType: t,
            contractNo: r
          }
        ),
        o ? /* @__PURE__ */ e.jsx(k1, {}) : null,
        /* @__PURE__ */ e.jsx(P1, {})
      ]
    }
  );
}, V1 = (t) => t == null ? "" : String(t), R1 = ({
  namespace: t,
  defaultValues: s,
  labels: n,
  placeholders: r,
  countries: a,
  fuelTypes: o,
  emissionClasses: i,
  weightClasses: d,
  isExternalCustomer: l,
  isLicensePlate: c,
  vehicleColors: m
}) => {
  const {
    registerField: u,
    getError: h,
    setPartialData: p,
    resetSelectedData: f,
    resetFieldError: x
  } = he({
    namespace: t,
    defaultValues: s
  }), [
    g,
    N,
    b,
    v,
    S,
    y
  ] = Ee(
    t,
    "countryCode",
    "licensePlate",
    "fuelType",
    "emissionClass",
    "reference",
    "recognitionType"
  ), [w, z] = M(), [C, E] = M(), A = D(() => y === "bizz", [y]);
  B(() => {
    b === "5" && v && p({
      emissionClass: void 0
    });
  }, [b, p, v]);
  const { data: F, error: R } = $n(
    w
  ), T = L(() => {
    f([
      "make",
      "model",
      "color",
      "weightClass",
      "hybrid",
      "fuelType",
      "emissionClass"
    ]);
  }, [f]);
  B(() => E(F), [F]), B(
    () => E(void 0),
    [N, g]
  ), B(() => z(void 0), [g]), B(() => {
    if (!C)
      T();
    else {
      const I = C, _ = Yr(i)[I.euroEmissionNorm] || void 0;
      p({
        ...I,
        weightClass: (!!I.isHGV).toString(),
        hybrid: (!!I.isHybrid).toString(),
        fuelType: I.fuelTypeId.toString(),
        emissionClass: _
      });
    }
  }, [
    C,
    p,
    T,
    i
  ]), B(() => {
    T(), x("licensePlate");
  }, [g, T, x]);
  const P = L(
    (I) => z({
      licensePlate: I,
      country: g
    }),
    [z, g]
  );
  B(() => {
    pn(
      hn(N),
      g
    ) && P(N);
  }, [N, g, P]);
  const { t: V } = O(["recognitions", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(Ue, { className: He("mb-4 gap-4"), children: [
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      xe,
      {
        label: n.countryCode,
        ...u("countryCode"),
        error: h("countryCode"),
        options: a,
        disabled: c,
        placeholder: r.countryCode,
        required: !0
      }
    ) }),
    /* @__PURE__ */ e.jsxs($, { className: "col-span-full w-0 min-w-full sm:col-span-4 md:col-span-6", children: [
      /* @__PURE__ */ e.jsx(
        Q,
        {
          label: n.licensePlate,
          ...u("licensePlate"),
          error: h("licensePlate"),
          required: !A,
          disabled: c,
          helpText: h("licensePlate") == null ? V("modal.form.licensePlateHelp") : void 0
        }
      ),
      R ? /* @__PURE__ */ e.jsx(ge, { children: n.noVehicleInfo }) : null
    ] }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Q,
      {
        ...u("make"),
        label: n.make,
        className: "col-span-full sm:col-span-12 md:col-span-6",
        error: h("make"),
        disabled: l || !!(C != null && C.make)
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Q,
      {
        ...u("model"),
        label: n.model,
        className: "col-span-full sm:col-span-12 md:col-span-6",
        error: h("model"),
        disabled: l || !!(C != null && C.model)
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-12 md:col-span-6",
        ...u("color"),
        placeholder: r.color,
        label: n.color,
        options: m,
        error: h("color"),
        disabled: l || !!(C != null && C.color),
        placeholderDisabled: !1
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      xe,
      {
        label: n.weightClass,
        ...u("weightClass"),
        error: h("weightClass"),
        disabled: l || (C == null ? void 0 : C.isHGV) !== void 0,
        options: d,
        placeholder: r.weightClass,
        placeholderDisabled: !1
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      xe,
      {
        label: n.fuelType,
        ...u("fuelType"),
        error: h("fuelType"),
        disabled: l || !!(C != null && C.fuelType),
        options: o,
        placeholder: r.fuelType,
        placeholderDisabled: !1
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      xe,
      {
        label: n.emissionClass,
        ...u("emissionClass"),
        error: h("emissionClass"),
        disabled: l || b === "5" || !!(C != null && C.euroEmissionNorm),
        options: i,
        placeholder: r.emissionClass,
        placeholderDisabled: !1
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Q,
      {
        label: n.hybrid,
        ...u("hybrid", { type: "checkbox", value: "true" }),
        disabled: l || (C == null ? void 0 : C.isHybrid) !== void 0
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "border-black-400 col-span-full border-t pt-4", children: /* @__PURE__ */ e.jsx(
      Q,
      {
        label: n.reference,
        ...u("reference"),
        error: h("reference"),
        disabled: l
      }
    ) })
  ] });
}, $1 = ({ white: t, contract: s }) => /* @__PURE__ */ e.jsx($, { className: "text-primary-400", children: /* @__PURE__ */ e.jsxs(
  k,
  {
    size: "sm",
    color: t ? "white" : "default",
    className: "flex items-center",
    children: [
      /* @__PURE__ */ e.jsx(_l, { width: "15px", height: "10px", className: "mr-2" }),
      /* @__PURE__ */ e.jsx(Ze, { contract: s })
    ]
  }
) }), B1 = ({
  bizzName: t,
  bizzNumber: s,
  licensePlate: n,
  type: r,
  contract: a,
  isOSB: o
}) => {
  const { t: i } = O("common"), d = D(
    () => t ? "modal.title.withReference" : "modal.title.withoutReference",
    [t]
  ), l = D(
    () => r === "licensePlate" ? "form.labels.licensePlate" : "form.labels.bizz",
    [r]
  );
  return /* @__PURE__ */ e.jsxs(Je, { display: "flex", sx: { flexDirection: "column" }, children: [
    /* @__PURE__ */ e.jsxs(
      Y,
      {
        as: "span",
        mt: 0,
        mb: 0,
        sx: {
          color: "colors.neutral.100",
          display: "flex",
          alignItems: "center"
        },
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "mr-4", children: i(l) }),
          o ? /* @__PURE__ */ e.jsx($1, { contract: a, white: !0 }) : null
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(
      Y,
      {
        id: "description",
        variant: "paragraph",
        mt: 0,
        mb: 0,
        sx: { color: "colors.neutral.100" },
        children: /* @__PURE__ */ e.jsx(
          G,
          {
            ns: "recognitions",
            i18nKey: d,
            values: { bizzName: t, bizzNumber: s, licensePlate: n },
            children: /* @__PURE__ */ e.jsx(
              Y,
              {
                id: "title",
                as: "span",
                mt: 0,
                mb: 0,
                sx: {
                  color: "inherit",
                  fontWeight: "fontWeights.medium"
                }
              }
            )
          }
        )
      }
    )
  ] });
}, Oa = ({
  activeRecognition: t,
  onClose: s,
  isExternalCustomer: n,
  contract: r,
  replaceSerialNumber: a,
  onSuccessReplaceBizz: o
}) => {
  var C, E;
  const i = Ae(null), d = Le(), { t: l } = O(["recognitions", "common"], {
    nsMode: "fallback"
  }), [c, m] = M(!1), { mutateAsync: u, isLoading: h } = fe(
    ["recognitions", "update"],
    ({ Recognition: A }) => A.updateRecognition,
    {
      onSuccess: () => (d.invalidateQueries({
        queryKey: ["account", "recognitions"]
      }), o ? o() : s()),
      onError: () => {
        m(!0);
      }
    }
  ), p = L(
    (A) => (async () => {
      if (!t) {
        console.error("Invalid recognition, recognition is null");
        return;
      }
      const F = {
        contractLineNo: t.contractLineNo,
        contractNo: t.contract.contractNo,
        changes: {
          countryCode: A.countryCode,
          registrationNo: A.licensePlate,
          isHybrid: A.hybrid === "true",
          isHGV: A.weightClass === "heavy",
          reference: A.reference || void 0,
          emissionClass: Number(A.emissionClass) || void 0,
          fuelType: Number(A.fuelType) || void 0
        }
      };
      try {
        await u(F);
      } catch {
      }
    })(),
    [t, u]
  ), f = "edit-recognition-modal", {
    resetData: x,
    handleSubmit: g,
    validate: N,
    isDirty: b,
    isValid: v
  } = he({
    namespace: f,
    onSubmit: p,
    onValidate: Ts(lc.spa, l),
    defaultValues: { recognitionType: t.recognitionType }
  });
  B(() => () => {
    x(), m(!1);
  }, [x, m]);
  const { fuelTypes: S, emissionClasses: y } = wt(), w = Dr(), z = kt();
  return /* @__PURE__ */ e.jsxs(on, { open: !0, ariaLabelledBy: "title", ariaDescribedBy: "description", children: [
    /* @__PURE__ */ e.jsx(ln, { closeLabel: l("action.close"), onClose: s, children: a ? /* @__PURE__ */ e.jsx(k, { as: "h2", children: l("replaceBizz.title") }) : /* @__PURE__ */ e.jsx(
      B1,
      {
        bizzName: t.reference,
        bizzNumber: t.serialNo,
        licensePlate: t.registrationNo,
        type: t.recognitionType,
        contract: r,
        isOSB: t.isOSB
      }
    ) }),
    /* @__PURE__ */ e.jsxs(
      $,
      {
        ref: i,
        as: "form",
        noValidate: !0,
        onSubmit: Nt(N, g),
        onReset: s,
        className: "flex flex-col gap-12",
        children: [
          /* @__PURE__ */ e.jsx(Ut, { children: /* @__PURE__ */ e.jsxs($, { className: "flex flex-col gap-12", children: [
            /* @__PURE__ */ e.jsx(k, { intent: "label", size: "lg", children: l("form.requiredFields") }),
            /* @__PURE__ */ e.jsx($, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(k, { intent: "title", children: l("modal.form.title") }) }),
            /* @__PURE__ */ e.jsx(ge, { color: "inform", children: /* @__PURE__ */ e.jsxs($, { as: "div", className: "flex flex-1 flex-row items-center	", children: [
              /* @__PURE__ */ e.jsx(no, { height: "20", width: "20", className: "mr-2" }),
              /* @__PURE__ */ e.jsx(k, { intent: "body", size: "md", children: l("modal.form.infoBanner") })
            ] }) }),
            c && /* @__PURE__ */ e.jsx(zt, { variant: "error", children: l("errors.generic") }),
            t && /* @__PURE__ */ e.jsx(
              R1,
              {
                namespace: f,
                countries: z.map(({ key: A, value: F }) => ({
                  label: A,
                  value: F
                })),
                bvSupportCountries: w,
                fuelTypes: S,
                emissionClasses: y,
                weightClasses: [
                  { label: l("weightClasses.heavy"), value: "heavy" },
                  { label: l("weightClasses.light"), value: "light" }
                ],
                vehicleColors: Gn.map((A) => ({
                  label: l(`vehicleColors.${A}`),
                  value: A
                })),
                labels: {
                  reference: l("form.labels.reference"),
                  emissionClass: l("form.labels.emissionClass"),
                  fuelType: l("form.labels.fuelType"),
                  weightClass: l("form.labels.weightClass"),
                  hybrid: l("form.labels.hybrid"),
                  licensePlate: l("form.labels.licensePlate"),
                  countryCode: l("form.labels.country"),
                  vehicleSearch: l("action.search"),
                  make: l("form.labels.make"),
                  model: l("form.labels.model"),
                  color: l("form.labels.color"),
                  alprName: l("form.labels.alprName"),
                  volVehicleInfo: l("form.labels.vlinfo"),
                  noVehicleInfo: l("form.validations.licensePlate.notfound"),
                  loadingSearch: l("action.loading"),
                  licensePlateExist: l("form.validations.licensePlate.exist")
                },
                placeholders: {
                  weightClass: l("form.placeholders.weightClass"),
                  countryCode: l("form.placeholders.country"),
                  emissionClass: l("form.placeholders.emissionClass"),
                  fuelType: l("form.placeholders.fuelType"),
                  color: l("form.placeholders.color")
                },
                defaultValues: {
                  reference: t.reference,
                  licensePlate: t.registrationNo,
                  fuelType: (C = t.fuelType) == null ? void 0 : C.value,
                  emissionClass: (E = t.emissionClass) == null ? void 0 : E.value,
                  hybrid: V1(t.isHybrid),
                  weightClass: t.isHGV ? "heavy" : "light",
                  countryCode: t.countryCode
                },
                isExternalCustomer: n,
                isLicensePlate: t.recognitionType === "licensePlate"
              }
            )
          ] }) }),
          /* @__PURE__ */ e.jsx(
            Rt,
            {
              actionLabel: l(
                a ? "action.continue" : "action.save"
              ),
              cancelLabel: l("action.cancel"),
              loadingLabel: l("action.loading"),
              cancelButtonType: "reset",
              actionButtonType: "submit",
              onClose: s,
              isLoading: h,
              disabled: h || c || !b || !v,
              loadingButton: !0
            }
          )
        ]
      }
    )
  ] });
}, I1 = ({
  recognition: t,
  onClose: s
}) => {
  const { t: n } = O(["recognitions", "common"], {
    nsMode: "fallback"
  }), [r, a] = M(), o = D(
    () => t.recognitionType == "bizz",
    [t.recognitionType]
  ), i = Le(), { mutateAsync: d } = fe(
    ["recognitions", "remove"],
    ({ Recognition: c }) => c.closeRecognition,
    {
      onSuccess: () => (i.invalidateQueries({
        queryKey: ["account", "recognitions"]
      }), s()),
      onError: () => {
        a(n("errors.generic"));
      }
    }
  ), l = L(async () => {
    const { ...c } = t;
    try {
      await d(c);
    } catch {
    }
  }, [t, d]);
  return B(() => () => {
    a(void 0);
  }, [a]), /* @__PURE__ */ e.jsxs(on, { open: !0, ariaLabelledBy: "title", children: [
    /* @__PURE__ */ e.jsx(ln, { closeLabel: n("action.close"), onClose: s, children: /* @__PURE__ */ e.jsx(
      Y,
      {
        id: "title",
        variant: "paragraph",
        mt: 0,
        mb: 0,
        sx: { color: "colors.neutral.100" },
        children: n(o ? "removeRecognitionModal.title.bizz" : "removeRecognitionModal.title.licensePlate")
      }
    ) }),
    /* @__PURE__ */ e.jsxs(Ut, { children: [
      r && /* @__PURE__ */ e.jsx(zt, { variant: "error", children: r }),
      /* @__PURE__ */ e.jsxs("div", { className: "max-w-[65ch]", children: [
        /* @__PURE__ */ e.jsx(
          Y,
          {
            variant: "smallParagraph",
            mt: 0,
            mb: 0,
            pt: "spacing.200",
            pb: "spacing.100",
            sx: { textAlign: "center" },
            children: n(o ? "removeRecognitionModal.confirmation.bizz" : "removeRecognitionModal.confirmation.licensePlate")
          }
        ),
        /* @__PURE__ */ e.jsx(
          Y,
          {
            variant: "smallParagraph",
            mt: 0,
            mb: 0,
            pt: "spacing.200",
            pb: "spacing.100",
            sx: { textAlign: "center" },
            children: n(o ? "removeRecognitionModal.description.bizz" : "removeRecognitionModal.description.licensePlate")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      Rt,
      {
        onClose: s,
        cancelLabel: n("action.cancel"),
        actionLabel: n(o ? "action.block" : "action.remove"),
        action: l
      }
    )
  ] });
}, _1 = ({
  preambleKey: t
}) => {
  const { t: s } = O(["recognitions"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx(k, { as: "span", className: "max-w-3xl", children: s(t) });
}, Ea = ({ isOSB: t, isPeriodCardActive: s }) => t || s, W1 = ({ lineStatus: t }) => t == "open", q1 = (t) => t === "bizz", H1 = (t) => q1(t.recognitionType) ? t.registrationNo : [
  t.reference,
  t.registrationNo,
  t.serialNo
].filter(Boolean).join(" - "), U1 = (t) => ({
  status: t.lineStatus,
  id: `${t.contractLineNo}-${t.contractNo}`,
  label: H1(t),
  isEditable: t.isEditable,
  isOSB: t.isOSB,
  isInvalid: t.country === "-" || !t.country || !t.registrationNo,
  isPeriodCardActive: t.isPeriodCardActive,
  serialNo: t.serialNo,
  contractLineNo: t.contractLineNo,
  recognitionType: t.recognitionType,
  registrationNo: t.registrationNo
}), G1 = (t) => W1(t) ? [U1(t)] : [];
function Xr() {
  const { query: t } = se(), s = t.contract, n = s ? [s] : void 0, { recognitions: r, loading: a } = Lr(20, {
    agreements: n
  }), { data: o } = dn();
  return D(() => {
    if (!r || r.length === 0 || a)
      return {
        activeRecognitions: [],
        recognitionChoices: [],
        loading: a
      };
    const i = r.flatMap(G1), d = i.filter(Ea), l = i.filter(
      (u) => !Ea(u)
    ), c = d.concat(l), m = r.length > 0 ? r[0].contract : void 0;
    return {
      activeRecognitions: d,
      recognitionChoices: o ? c.filter((u) => u.recognitionType === "licensePlate") : c,
      loading: !1,
      contract: m
    };
  }, [a, r, o]);
}
const K1 = ({ rowNumber: t, alpr: s }) => {
  const { t: n } = O("recognitions");
  return /* @__PURE__ */ e.jsxs("div", { className: "flex gap-4 py-2", children: [
    /* @__PURE__ */ e.jsx("div", { className: "w-[30px]", children: /* @__PURE__ */ e.jsx(k, { intent: "headline", size: "sm", className: "text-center", children: t }) }),
    s ? /* @__PURE__ */ e.jsx(ct, { label: n("form.labels.regNo.short"), children: s }) : /* @__PURE__ */ e.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ e.jsx(
      k,
      {
        intent: "body",
        size: "lg",
        weight: "light",
        className: "text-neutral-700",
        children: n("form.labels.notInUse")
      }
    ) })
  ] });
}, Z1 = ({
  usedLicensePlates: t,
  maxCount: s,
  description: n
}) => {
  const { t: r } = O("recognitions"), [a, o] = M(!1), i = D(
    () => new Array(s).fill(void 0).map((d, l) => t[l]),
    [t, s]
  );
  return /* @__PURE__ */ e.jsxs(vt.Root, { open: a, onOpenChange: o, children: [
    /* @__PURE__ */ e.jsx(vt.Trigger, { asChild: !0, children: /* @__PURE__ */ e.jsx(X, { intent: "text", className: "mt-4 sm:mt-2 md:mt-0", children: r("usageHistory.labels.readMore") }) }),
    /* @__PURE__ */ e.jsx(vt.Portal, { children: /* @__PURE__ */ e.jsx(vt.Overlay, { className: "fixed inset-0 flex bg-black/75 sm:items-center sm:justify-center", children: /* @__PURE__ */ e.jsx(
      vt.Content,
      {
        className: He(
          "relative",
          "z-30",
          "sm:rounded-xl",
          "overflow-hidden"
        ),
        children: /* @__PURE__ */ e.jsxs("div", { className: "flex h-full flex-col bg-white sm:max-h-fit", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "bg-primary-800 flex justify-between px-4 py-4", children: [
            /* @__PURE__ */ e.jsx(k, { intent: "headline", color: "white", size: "sm", children: r("usageHistory.title") }),
            /* @__PURE__ */ e.jsx(vt.Close, { asChild: !0, children: /* @__PURE__ */ e.jsx(
              X,
              {
                intent: "text",
                "aria-label": r("action.close"),
                startIcon: /* @__PURE__ */ e.jsx(rn, { fontSize: "25px" }),
                color: "white",
                iconSize: "lg"
              }
            ) })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "px-4 py-4", children: i.map((d, l) => /* @__PURE__ */ e.jsx(K1, { alpr: d, rowNumber: l + 1 }, l)) }),
          /* @__PURE__ */ e.jsx("div", { className: "px-5 pb-4", children: n })
        ] })
      }
    ) }) })
  ] });
}, Y1 = ({
  usedLicensePlates: t,
  usedCount: s,
  maxCount: n,
  nextPeriod: r,
  description: a,
  longDescription: o,
  isPeriodCard: i
}) => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col justify-between sm:flex-row", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ e.jsx(k, { children: /* @__PURE__ */ e.jsx(
      G,
      {
        i18nKey: i ? "periodCard.form.labels.usage" : "form.labels.usage",
        ns: "recognitions",
        values: { count: s, maxCount: n },
        children: /* @__PURE__ */ e.jsx(k, { intent: "title", size: "md", as: "span" })
      }
    ) }),
    a ? /* @__PURE__ */ e.jsx(k, { weight: "light", size: "sm", children: a }) : null
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ e.jsx(
    Z1,
    {
      usedLicensePlates: t,
      nextPeriod: r,
      maxCount: n,
      description: o
    }
  ) })
] }), Q1 = Ht("flex gap-5 p-5", {
  variants: {
    intent: {
      primary: ["bg-primary-400", "text-white"],
      secondary: ["bg-white"]
    }
  },
  defaultVariants: {
    intent: "primary"
  }
}), X1 = Ht("rounded-full p-2", {
  variants: {
    intent: {
      primary: ["bg-white", "text-primary-400"],
      secondary: ["bg-primary-400", "text-white"]
    }
  },
  defaultVariants: {
    intent: "primary"
  }
});
function J1({
  onError: t,
  queryParam: s
}) {
  const n = Le(), { t: r } = O(["recognitions", "common"], {
    nsMode: "fallback"
  });
  let a = Vr();
  const { query: o } = se();
  if (s) {
    const b = o[s];
    b && (a = b);
  }
  const { data: i } = dn(), { recognitionChoices: d, contract: l } = Xr(), { mutateAsync: c, isLoading: m } = fe(
    ["recognitions", "swap"],
    ({ Recognition: b }) => b.swapRecognitions,
    {
      onMutate: () => {
        t(void 0);
      },
      onSuccess: () => n.invalidateQueries({
        queryKey: ["account", "recognitions"]
      }),
      onError: (b) => (b.error || "") === Z.SWAP_LIMIT_EXCEEDED ? t(r("errors.swapLimitExceeded")) : t(r("errors.generic"))
    }
  ), [u, h] = M(!1), { mutateAsync: p, isLoading: f } = fe(
    ["periodCard", "swap"],
    ({ PeriodCard: b }) => b.swap,
    {
      onMutate: () => {
        t(void 0);
      },
      onSuccess: (b) => {
        n.invalidateQueries({
          queryKey: ["account", "recognitions"]
        }), n.setQueryData(
          ee.PeriodCard({
            contractNo: a
          }),
          b
        );
      },
      onError: (b) => {
        const v = (b == null ? void 0 : b.code) === 400 && b.error === un.blockCommercialVehicle;
        return h(v), v ? t(
          r("form.validations.periodCard.isCommercialVehicle")
        ) : (b.error || "") === Z.SWAP_LIMIT_EXCEEDED ? t(r("errors.swapLimitExceeded")) : t(r("errors.generic"));
      }
    }
  ), x = L(() => l && l.contractNo.split("-")[0] || null, [l]), g = L(
    async (b) => {
      if (!i)
        return c(b);
      const v = b.attach[0], S = d.find(
        (y) => y.contractLineNo === v
      );
      return S ? p({
        serialNo: S.serialNo,
        periodCardId: i.id,
        contractNo: i.contractNo
      }) : c(b);
    },
    [i, d, c, p]
  );
  return {
    swap: L(
      async ({
        recognition1: b = "",
        recognition2: v = ""
      }) => {
        if (d.some(
          ({ id: z, isInvalid: C }) => (z === b || z === v) && C
        ))
          return t(r("errors.invalidRecognition")), Promise.resolve();
        const y = x();
        if (!y) return Promise.resolve();
        const w = [b, v].map(Mu).filter(Boolean);
        await g({ contractNo: y, attach: w });
      },
      [d, g, t, r]
    ),
    isMutating: m || f,
    periodCard: i,
    attemptSwapToCommercialVehicle: u
  };
}
function lt(t, s) {
  if (s.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + s.length + " present");
}
function gn(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? gn = function(n) {
    return typeof n;
  } : gn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, gn(t);
}
function eh(t) {
  return lt(1, arguments), t instanceof Date || gn(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function bn(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? bn = function(n) {
    return typeof n;
  } : bn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, bn(t);
}
function Kt(t) {
  lt(1, arguments);
  var s = Object.prototype.toString.call(t);
  return t instanceof Date || bn(t) === "object" && s === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || s === "[object Number]" ? new Date(t) : ((typeof t == "string" || s === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function th(t) {
  if (lt(1, arguments), !eh(t) && typeof t != "number")
    return !1;
  var s = Kt(t);
  return !isNaN(Number(s));
}
function js(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var s = Number(t);
  return isNaN(s) ? s : s < 0 ? Math.ceil(s) : Math.floor(s);
}
function sh(t, s) {
  lt(2, arguments);
  var n = Kt(t).getTime(), r = js(s);
  return new Date(n + r);
}
function nh(t, s) {
  lt(2, arguments);
  var n = js(s);
  return sh(t, -n);
}
var rh = 864e5;
function ah(t) {
  lt(1, arguments);
  var s = Kt(t), n = s.getTime();
  s.setUTCMonth(0, 1), s.setUTCHours(0, 0, 0, 0);
  var r = s.getTime(), a = n - r;
  return Math.floor(a / rh) + 1;
}
function Pn(t) {
  lt(1, arguments);
  var s = 1, n = Kt(t), r = n.getUTCDay(), a = (r < s ? 7 : 0) + r - s;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function hi(t) {
  lt(1, arguments);
  var s = Kt(t), n = s.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = Pn(r), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var i = Pn(o);
  return s.getTime() >= a.getTime() ? n + 1 : s.getTime() >= i.getTime() ? n : n - 1;
}
function oh(t) {
  lt(1, arguments);
  var s = hi(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(s, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Pn(n);
  return r;
}
var ih = 6048e5;
function lh(t) {
  lt(1, arguments);
  var s = Kt(t), n = Pn(s).getTime() - oh(s).getTime();
  return Math.round(n / ih) + 1;
}
var ch = {};
function Kn() {
  return ch;
}
function Tn(t, s) {
  var n, r, a, o, i, d, l, c;
  lt(1, arguments);
  var m = Kn(), u = js((n = (r = (a = (o = s == null ? void 0 : s.weekStartsOn) !== null && o !== void 0 ? o : s == null || (i = s.locale) === null || i === void 0 || (d = i.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && a !== void 0 ? a : m.weekStartsOn) !== null && r !== void 0 ? r : (l = m.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(u >= 0 && u <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = Kt(t), p = h.getUTCDay(), f = (p < u ? 7 : 0) + p - u;
  return h.setUTCDate(h.getUTCDate() - f), h.setUTCHours(0, 0, 0, 0), h;
}
function pi(t, s) {
  var n, r, a, o, i, d, l, c;
  lt(1, arguments);
  var m = Kt(t), u = m.getUTCFullYear(), h = Kn(), p = js((n = (r = (a = (o = s == null ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : s == null || (i = s.locale) === null || i === void 0 || (d = i.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && a !== void 0 ? a : h.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = h.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(p >= 1 && p <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var f = /* @__PURE__ */ new Date(0);
  f.setUTCFullYear(u + 1, 0, p), f.setUTCHours(0, 0, 0, 0);
  var x = Tn(f, s), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(u, 0, p), g.setUTCHours(0, 0, 0, 0);
  var N = Tn(g, s);
  return m.getTime() >= x.getTime() ? u + 1 : m.getTime() >= N.getTime() ? u : u - 1;
}
function dh(t, s) {
  var n, r, a, o, i, d, l, c;
  lt(1, arguments);
  var m = Kn(), u = js((n = (r = (a = (o = s == null ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : s == null || (i = s.locale) === null || i === void 0 || (d = i.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && a !== void 0 ? a : m.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = m.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), h = pi(t, s), p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(h, 0, u), p.setUTCHours(0, 0, 0, 0);
  var f = Tn(p, s);
  return f;
}
var mh = 6048e5;
function uh(t, s) {
  lt(1, arguments);
  var n = Kt(t), r = Tn(n, s).getTime() - dh(n, s).getTime();
  return Math.round(r / mh) + 1;
}
function Te(t, s) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < s; )
    r = "0" + r;
  return n + r;
}
var is = {
  // Year
  y: function(s, n) {
    var r = s.getUTCFullYear(), a = r > 0 ? r : 1 - r;
    return Te(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M: function(s, n) {
    var r = s.getUTCMonth();
    return n === "M" ? String(r + 1) : Te(r + 1, 2);
  },
  // Day of the month
  d: function(s, n) {
    return Te(s.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(s, n) {
    var r = s.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(s, n) {
    return Te(s.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(s, n) {
    return Te(s.getUTCHours(), n.length);
  },
  // Minute
  m: function(s, n) {
    return Te(s.getUTCMinutes(), n.length);
  },
  // Second
  s: function(s, n) {
    return Te(s.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(s, n) {
    var r = n.length, a = s.getUTCMilliseconds(), o = Math.floor(a * Math.pow(10, r - 3));
    return Te(o, n.length);
  }
}, Ds = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, hh = {
  // Era
  G: function(s, n, r) {
    var a = s.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(s, n, r) {
    if (n === "yo") {
      var a = s.getUTCFullYear(), o = a > 0 ? a : 1 - a;
      return r.ordinalNumber(o, {
        unit: "year"
      });
    }
    return is.y(s, n);
  },
  // Local week-numbering year
  Y: function(s, n, r, a) {
    var o = pi(s, a), i = o > 0 ? o : 1 - o;
    if (n === "YY") {
      var d = i % 100;
      return Te(d, 2);
    }
    return n === "Yo" ? r.ordinalNumber(i, {
      unit: "year"
    }) : Te(i, n.length);
  },
  // ISO week-numbering year
  R: function(s, n) {
    var r = hi(s);
    return Te(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(s, n) {
    var r = s.getUTCFullYear();
    return Te(r, n.length);
  },
  // Quarter
  Q: function(s, n, r) {
    var a = Math.ceil((s.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(a);
      case "QQ":
        return Te(a, 2);
      case "Qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(s, n, r) {
    var a = Math.ceil((s.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(a);
      case "qq":
        return Te(a, 2);
      case "qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(s, n, r) {
    var a = s.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return is.M(s, n);
      case "Mo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(s, n, r) {
    var a = s.getUTCMonth();
    switch (n) {
      case "L":
        return String(a + 1);
      case "LL":
        return Te(a + 1, 2);
      case "Lo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(s, n, r, a) {
    var o = uh(s, a);
    return n === "wo" ? r.ordinalNumber(o, {
      unit: "week"
    }) : Te(o, n.length);
  },
  // ISO week of year
  I: function(s, n, r) {
    var a = lh(s);
    return n === "Io" ? r.ordinalNumber(a, {
      unit: "week"
    }) : Te(a, n.length);
  },
  // Day of the month
  d: function(s, n, r) {
    return n === "do" ? r.ordinalNumber(s.getUTCDate(), {
      unit: "date"
    }) : is.d(s, n);
  },
  // Day of year
  D: function(s, n, r) {
    var a = ah(s);
    return n === "Do" ? r.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : Te(a, n.length);
  },
  // Day of week
  E: function(s, n, r) {
    var a = s.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(s, n, r, a) {
    var o = s.getUTCDay(), i = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(i);
      case "ee":
        return Te(i, 2);
      case "eo":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(s, n, r, a) {
    var o = s.getUTCDay(), i = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(i);
      case "cc":
        return Te(i, n.length);
      case "co":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return r.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(s, n, r) {
    var a = s.getUTCDay(), o = a === 0 ? 7 : a;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return Te(o, n.length);
      case "io":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(s, n, r) {
    var a = s.getUTCHours(), o = a / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(s, n, r) {
    var a = s.getUTCHours(), o;
    switch (a === 12 ? o = Ds.noon : a === 0 ? o = Ds.midnight : o = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(s, n, r) {
    var a = s.getUTCHours(), o;
    switch (a >= 17 ? o = Ds.evening : a >= 12 ? o = Ds.afternoon : a >= 4 ? o = Ds.morning : o = Ds.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(s, n, r) {
    if (n === "ho") {
      var a = s.getUTCHours() % 12;
      return a === 0 && (a = 12), r.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return is.h(s, n);
  },
  // Hour [0-23]
  H: function(s, n, r) {
    return n === "Ho" ? r.ordinalNumber(s.getUTCHours(), {
      unit: "hour"
    }) : is.H(s, n);
  },
  // Hour [0-11]
  K: function(s, n, r) {
    var a = s.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : Te(a, n.length);
  },
  // Hour [1-24]
  k: function(s, n, r) {
    var a = s.getUTCHours();
    return a === 0 && (a = 24), n === "ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : Te(a, n.length);
  },
  // Minute
  m: function(s, n, r) {
    return n === "mo" ? r.ordinalNumber(s.getUTCMinutes(), {
      unit: "minute"
    }) : is.m(s, n);
  },
  // Second
  s: function(s, n, r) {
    return n === "so" ? r.ordinalNumber(s.getUTCSeconds(), {
      unit: "second"
    }) : is.s(s, n);
  },
  // Fraction of second
  S: function(s, n) {
    return is.S(s, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(s, n, r, a) {
    var o = a._originalDate || s, i = o.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (n) {
      case "X":
        return Fa(i);
      case "XXXX":
      case "XX":
        return gs(i);
      case "XXXXX":
      case "XXX":
      default:
        return gs(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(s, n, r, a) {
    var o = a._originalDate || s, i = o.getTimezoneOffset();
    switch (n) {
      case "x":
        return Fa(i);
      case "xxxx":
      case "xx":
        return gs(i);
      case "xxxxx":
      case "xxx":
      default:
        return gs(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(s, n, r, a) {
    var o = a._originalDate || s, i = o.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Da(i, ":");
      case "OOOO":
      default:
        return "GMT" + gs(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(s, n, r, a) {
    var o = a._originalDate || s, i = o.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Da(i, ":");
      case "zzzz":
      default:
        return "GMT" + gs(i, ":");
    }
  },
  // Seconds timestamp
  t: function(s, n, r, a) {
    var o = a._originalDate || s, i = Math.floor(o.getTime() / 1e3);
    return Te(i, n.length);
  },
  // Milliseconds timestamp
  T: function(s, n, r, a) {
    var o = a._originalDate || s, i = o.getTime();
    return Te(i, n.length);
  }
};
function Da(t, s) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return n + String(a);
  var i = s;
  return n + String(a) + i + Te(o, 2);
}
function Fa(t, s) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + Te(Math.abs(t) / 60, 2);
  }
  return gs(t, s);
}
function gs(t, s) {
  var n = s || "", r = t > 0 ? "-" : "+", a = Math.abs(t), o = Te(Math.floor(a / 60), 2), i = Te(a % 60, 2);
  return r + o + n + i;
}
var La = function(s, n) {
  switch (s) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, fi = function(s, n) {
  switch (s) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, ph = function(s, n) {
  var r = s.match(/(P+)(p+)?/) || [], a = r[1], o = r[2];
  if (!o)
    return La(s, n);
  var i;
  switch (a) {
    case "P":
      i = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = n.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", La(a, n)).replace("{{time}}", fi(o, n));
}, fh = {
  p: fi,
  P: ph
};
function xh(t) {
  var s = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return s.setUTCFullYear(t.getFullYear()), t.getTime() - s.getTime();
}
var gh = ["D", "DD"], bh = ["YY", "YYYY"];
function vh(t) {
  return gh.indexOf(t) !== -1;
}
function yh(t) {
  return bh.indexOf(t) !== -1;
}
function Va(t, s, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(s, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(s, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(s, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(s, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var jh = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, xi = function(s, n, r) {
  var a, o = jh[s];
  return typeof o == "string" ? a = o : n === 1 ? a = o.one : a = o.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : a + " ago" : a;
};
function rt(t) {
  return function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = s.width ? String(s.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var Ch = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Nh = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, wh = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, kh = {
  date: rt({
    formats: Ch,
    defaultWidth: "full"
  }),
  time: rt({
    formats: Nh,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: wh,
    defaultWidth: "full"
  })
}, Ph = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, gi = function(s, n, r, a) {
  return Ph[s];
};
function _e(t) {
  return function(s, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", a;
    if (r === "formatting" && t.formattingValues) {
      var o = t.defaultFormattingWidth || t.defaultWidth, i = n != null && n.width ? String(n.width) : o;
      a = t.formattingValues[i] || t.formattingValues[o];
    } else {
      var d = t.defaultWidth, l = n != null && n.width ? String(n.width) : t.defaultWidth;
      a = t.values[l] || t.values[d];
    }
    var c = t.argumentCallback ? t.argumentCallback(s) : s;
    return a[c];
  };
}
var Th = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Sh = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Mh = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, zh = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Ah = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Oh = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Eh = function(s, n) {
  var r = Number(s), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, bi = {
  ordinalNumber: Eh,
  era: _e({
    values: Th,
    defaultWidth: "wide"
  }),
  quarter: _e({
    values: Sh,
    defaultWidth: "wide",
    argumentCallback: function(s) {
      return s - 1;
    }
  }),
  month: _e({
    values: Mh,
    defaultWidth: "wide"
  }),
  day: _e({
    values: zh,
    defaultWidth: "wide"
  }),
  dayPeriod: _e({
    values: Ah,
    defaultWidth: "wide",
    formattingValues: Oh,
    defaultFormattingWidth: "wide"
  })
};
function We(t) {
  return function(s) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, a = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], o = s.match(a);
    if (!o)
      return null;
    var i = o[0], d = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(d) ? Fh(d, function(u) {
      return u.test(i);
    }) : Dh(d, function(u) {
      return u.test(i);
    }), c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var m = s.slice(i.length);
    return {
      value: c,
      rest: m
    };
  };
}
function Dh(t, s) {
  for (var n in t)
    if (t.hasOwnProperty(n) && s(t[n]))
      return n;
}
function Fh(t, s) {
  for (var n = 0; n < t.length; n++)
    if (s(t[n]))
      return n;
}
function Zn(t) {
  return function(s) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = s.match(t.matchPattern);
    if (!r) return null;
    var a = r[0], o = s.match(t.parsePattern);
    if (!o) return null;
    var i = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    var d = s.slice(a.length);
    return {
      value: i,
      rest: d
    };
  };
}
var Lh = /^(\d+)(th|st|nd|rd)?/i, Vh = /\d+/i, Rh = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, $h = {
  any: [/^b/i, /^(a|c)/i]
}, Bh = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ih = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, _h = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Wh = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, qh = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Hh = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Uh = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Gh = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, vi = {
  ordinalNumber: Zn({
    matchPattern: Lh,
    parsePattern: Vh,
    valueCallback: function(s) {
      return parseInt(s, 10);
    }
  }),
  era: We({
    matchPatterns: Rh,
    defaultMatchWidth: "wide",
    parsePatterns: $h,
    defaultParseWidth: "any"
  }),
  quarter: We({
    matchPatterns: Bh,
    defaultMatchWidth: "wide",
    parsePatterns: Ih,
    defaultParseWidth: "any",
    valueCallback: function(s) {
      return s + 1;
    }
  }),
  month: We({
    matchPatterns: _h,
    defaultMatchWidth: "wide",
    parsePatterns: Wh,
    defaultParseWidth: "any"
  }),
  day: We({
    matchPatterns: qh,
    defaultMatchWidth: "wide",
    parsePatterns: Hh,
    defaultParseWidth: "any"
  }),
  dayPeriod: We({
    matchPatterns: Uh,
    defaultMatchWidth: "any",
    parsePatterns: Gh,
    defaultParseWidth: "any"
  })
}, Kh = {
  code: "en-US",
  formatDistance: xi,
  formatLong: kh,
  formatRelative: gi,
  localize: bi,
  match: vi,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Zh = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Yh = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Qh = /^'([^]*?)'?$/, Xh = /''/g, Jh = /[a-zA-Z]/;
function ep(t, s, n) {
  var r, a, o, i, d, l, c, m, u, h, p, f, x, g;
  lt(2, arguments);
  var N = String(s), b = Kn(), v = (r = (a = void 0) !== null && a !== void 0 ? a : b.locale) !== null && r !== void 0 ? r : Kh, S = js((o = (i = (d = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && d !== void 0 ? d : b.firstWeekContainsDate) !== null && i !== void 0 ? i : (c = b.locale) === null || c === void 0 || (m = c.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(S >= 1 && S <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var y = js((u = (h = (p = (f = void 0) !== null && f !== void 0 ? f : void 0) !== null && p !== void 0 ? p : b.weekStartsOn) !== null && h !== void 0 ? h : (x = b.locale) === null || x === void 0 || (g = x.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && u !== void 0 ? u : 0);
  if (!(y >= 0 && y <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!v.localize)
    throw new RangeError("locale must contain localize property");
  if (!v.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var w = Kt(t);
  if (!th(w))
    throw new RangeError("Invalid time value");
  var z = xh(w), C = nh(w, z), E = {
    firstWeekContainsDate: S,
    weekStartsOn: y,
    locale: v,
    _originalDate: w
  }, A = N.match(Yh).map(function(F) {
    var R = F[0];
    if (R === "p" || R === "P") {
      var T = fh[R];
      return T(F, v.formatLong);
    }
    return F;
  }).join("").match(Zh).map(function(F) {
    if (F === "''")
      return "'";
    var R = F[0];
    if (R === "'")
      return tp(F);
    var T = hh[R];
    if (T)
      return yh(F) && Va(F, s, String(t)), vh(F) && Va(F, s, String(t)), T(C, F, v.localize, E);
    if (R.match(Jh))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + R + "`");
    return F;
  }).join("");
  return A;
}
function tp(t) {
  var s = t.match(Qh);
  return s ? s[1].replace(Xh, "'") : t;
}
const sp = ({
  namespace: t,
  defaultValues: s,
  recognitions: n,
  isPendler: r,
  onValidate: a,
  onSubmit: o,
  className: i,
  isLoading: d,
  maxNoOfConnections: l,
  hasPeriodCard: c,
  usedRecognitions: m,
  onInfo: u
}) => {
  const { t: h } = O(["recognitions", "common"], {
    nsMode: "fallback"
  }), {
    registerField: p,
    getError: f,
    setFieldData: x,
    validate: g,
    handleSubmit: N,
    isValid: b,
    setPartialData: v,
    isDirty: S
  } = he({
    namespace: t,
    defaultValues: s,
    onValidate: a,
    onSubmit: o
  }), [y, w] = M(s), [z, C] = Ee(
    t,
    "recognition1",
    "recognition2"
  ), E = () => w({
    recognition1: z,
    recognition2: C
  }), A = D(
    () => !z || z === (y == null ? void 0 : y.recognition1),
    [z, y == null ? void 0 : y.recognition1]
  ), F = D(
    () => !C || C === (y == null ? void 0 : y.recognition2),
    [C, y == null ? void 0 : y.recognition2]
  );
  B(() => {
    (s == null ? void 0 : s.recognition1) !== z && (x(
      "recognition1",
      (s == null ? void 0 : s.recognition1) || "",
      "select",
      !1
    ), w((K) => ({
      ...K,
      recognition1: (s == null ? void 0 : s.recognition1) || ""
    }))), (s == null ? void 0 : s.recognition2) !== C && (x(
      "recognition2",
      (s == null ? void 0 : s.recognition2) || "",
      "select",
      !1
    ), w((K) => ({
      ...K,
      recognition2: (s == null ? void 0 : s.recognition2) || ""
    })));
  }, [s == null ? void 0 : s.recognition1, s == null ? void 0 : s.recognition2]);
  const R = D(
    () => (K) => String(K).trim() !== "" && !m.some((U) => U.value === K),
    [m]
  ), T = D(
    () => !r && l && (R(C) || R(z)),
    [
      z,
      C,
      r,
      R,
      l
    ]
  ), P = D(
    () => r ? !b || A || d : !b || T || A && F || d,
    [
      A,
      F,
      r,
      T,
      b,
      d
    ]
  ), V = D(
    () => r && l,
    [l, r]
  );
  B(() => {
    u(
      T || V ? h(
        c ? "periodCard.errors.swapLimitExceeded" : "errors.swapLimitExceeded"
      ) : void 0
    );
  }, [T, V, u, h, c]);
  const I = L(
    (K) => {
      (y == null ? void 0 : y.recognition1) === C && (y == null ? void 0 : y.recognition2) === z ? x(K, (y == null ? void 0 : y[K]) ?? "", "select") : v(
        y
      );
    },
    [y, C, z, x, v]
  ), { label: _, placeholder: ne } = D(() => c ? {
    label: h("periodCard.paymentOption.label"),
    placeholder: h("periodCard.paymentOption.placeholder")
  } : r ? {
    label: h("commuter.paymentOption.label"),
    placeholder: h("commuter.paymentOption.placeholder")
  } : {
    label: h("paymentOption.label", { amount: 1 }),
    placeholder: h("paymentOption.placeholder", { amount: 1 })
  }, [c, r, h]);
  return /* @__PURE__ */ e.jsxs(
    Ue,
    {
      as: "form",
      onSubmit: (K) => {
        Nt(g, N)(K), E();
      },
      className: i,
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "col-span-full md:col-span-6", children: c ? /* @__PURE__ */ e.jsx(
          xe,
          {
            label: _,
            error: f("recognition1"),
            placeholder: ne,
            disabled: l,
            options: n.filter(({ value: K }) => K !== C),
            ...p("recognition1")
          }
        ) : /* @__PURE__ */ e.jsx(
          xe,
          {
            label: _,
            error: f("recognition1"),
            placeholder: ne,
            options: n,
            ...p("recognition1")
          }
        ) }),
        /* @__PURE__ */ e.jsx("div", { className: "col-span-full md:col-span-6 md:flex md:items-end", children: /* @__PURE__ */ e.jsx(
          X,
          {
            intent: "text",
            onClick: () => I("recognition1"),
            startIcon: /* @__PURE__ */ e.jsx(ha, {}),
            iconSize: "lg",
            disabled: A,
            children: h("action.reset")
          }
        ) }),
        r ? null : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { className: "col-span-full md:col-span-6", children: /* @__PURE__ */ e.jsx(
            xe,
            {
              label: h("paymentOption.label", { amount: 2 }),
              placeholder: h("paymentOption.placeholder", { amount: 2 }),
              error: f("recognition2"),
              options: n,
              ...p("recognition2")
            }
          ) }),
          /* @__PURE__ */ e.jsx("div", { className: "col-span-full md:col-span-6 md:flex md:items-end", children: /* @__PURE__ */ e.jsx(
            X,
            {
              intent: "text",
              onClick: () => I("recognition2"),
              startIcon: /* @__PURE__ */ e.jsx(ha, {}),
              iconSize: "lg",
              disabled: F,
              children: h("action.reset")
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "col-span-full flex justify-end", children: /* @__PURE__ */ e.jsx(
          De,
          {
            type: "submit",
            disabled: P || !S,
            loadingLabel: h("action.loading"),
            isLoading: d,
            children: h("action.save")
          }
        ) })
      ]
    }
  );
}, np = ({
  contract: t,
  isPendler: s,
  className: n,
  intent: r = "primary",
  onError: a,
  onInfo: o
}) => {
  var y, w;
  const { t: i } = O(["recognitions", "common"], {
    nsMode: "fallback"
  }), { swap: d, isMutating: l, periodCard: c } = J1({
    onError: a,
    queryParam: "contract"
  }), {
    activeRecognitions: m,
    recognitionChoices: u,
    loading: h,
    contract: p
  } = Xr(), f = D(() => {
    if (p)
      return p.contractNo.split("-")[0];
  }, [p]), { data: x, isLoading: g } = ye(
    ee.RecognitionsUsageHistory(f),
    ({ Recognitions: z }) => z.usageHistory(f),
    { enabled: !!f }
  ), N = f ? g : !1, b = D(
    () => ((x == null ? void 0 : x.usedLicensePlates.length) ?? 0) >= ((x == null ? void 0 : x.maxNoOfChanges) ?? 5),
    [x == null ? void 0 : x.usedLicensePlates, x == null ? void 0 : x.maxNoOfChanges]
  ), v = D(
    () => zu(u, (x == null ? void 0 : x.usedLicensePlates) ?? []),
    [u, x == null ? void 0 : x.usedLicensePlates]
  );
  return D(
    () => h || N,
    [h, N]
  ) ? /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center p-5", children: /* @__PURE__ */ e.jsx(nn, { label: i("action.loading") }) }) : /* @__PURE__ */ e.jsxs("div", { className: n, children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: Q1({
          intent: r
        }),
        children: [
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: X1({
                intent: r
              }),
              children: /* @__PURE__ */ e.jsx(oo, { fontSize: "35px" })
            }
          ),
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col justify-center", children: [
            r === "primary" ? /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
              Ze,
              {
                contract: c ? Wt.OresundPeriodCard : t
              }
            ) }) : null,
            /* @__PURE__ */ e.jsx(k, { intent: "title", size: "md", children: i("form.labels.activeRecognitions", {
              count: s ? 1 : 2
            }) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "border-b-[1px] border-b-neutral-300 bg-white px-6 pb-4 pt-6", children: [
      !c && t === Wt.OresundPendler ? /* @__PURE__ */ e.jsxs(
        ge,
        {
          color: "inform",
          className: "mb-4 flex items-center justify-between",
          children: [
            /* @__PURE__ */ e.jsx(k, { size: "md", children: /* @__PURE__ */ e.jsx(G, { ns: "account", i18nKey: "agreement.periodCard.upgrade", children: /* @__PURE__ */ e.jsx(k, { as: "span", size: "md", weight: "bold" }) }) }),
            /* @__PURE__ */ e.jsx(
              qo,
              {
                buttonProps: { intent: "text", color: "primary" }
              }
            )
          ]
        }
      ) : null,
      /* @__PURE__ */ e.jsx(
        sp,
        {
          namespace: "activeRecognitions",
          defaultValues: {
            recognition1: ((y = m[0]) == null ? void 0 : y.id) ?? "",
            recognition2: c || t === Wt.OresundPendler ? "" : ((w = m[1]) == null ? void 0 : w.id) ?? ""
          },
          recognitions: u.map(({ id: z, label: C }) => ({
            value: z,
            label: C
          })),
          usedRecognitions: v,
          onValidate: ({ recognition1: z }) => {
            if (!z)
              return {
                recognition1: i("form.validations.recognition.required")
              };
          },
          onSubmit: d,
          isPendler: s,
          isLoading: l,
          maxNoOfConnections: b,
          onInfo: o,
          hasPeriodCard: !!c
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "border-b-[1px] border-b-black bg-white px-6 py-4", children: /* @__PURE__ */ e.jsx(
      Y1,
      {
        isPeriodCard: !!c,
        usedCount: (x == null ? void 0 : x.usedLicensePlates.length) ?? 0,
        maxCount: (x == null ? void 0 : x.maxNoOfChanges) ?? 5,
        usedLicensePlates: (x == null ? void 0 : x.usedLicensePlates) ?? [],
        nextPeriod: (x == null ? void 0 : x.nextPeriod) ?? "",
        description: c && c.endDateTime ? i("periodCard.usageHistory.description.short", {
          nextPeriod: ep(
            new Date(c.endDateTime),
            "yyyy-MM-dd"
          )
        }) : i("usageHistory.description.short"),
        longDescription: c ? /* @__PURE__ */ e.jsxs(
          G,
          {
            ns: "recognitions",
            i18nKey: "usageHistory.description.long",
            values: { resetDate: (x == null ? void 0 : x.nextPeriod) ?? "" },
            children: [
              /* @__PURE__ */ e.jsx(k, { intent: "label", weight: "light", gutter: !0 }),
              /* @__PURE__ */ e.jsx(k, { intent: "label", weight: "light", gutter: !0 })
            ]
          }
        ) : /* @__PURE__ */ e.jsxs(
          G,
          {
            ns: "recognitions",
            i18nKey: "periodCard.usageHistory.description.long",
            children: [
              /* @__PURE__ */ e.jsx(k, { intent: "label", weight: "light", gutter: !0 }),
              /* @__PURE__ */ e.jsx(k, { intent: "label", weight: "light", gutter: !0 })
            ]
          }
        )
      }
    ) })
  ] });
}, rp = ({ data: t, labels: s }) => /* @__PURE__ */ e.jsxs(rs, { template: "two-column", children: [
  /* @__PURE__ */ e.jsx(jt, { children: /* @__PURE__ */ e.jsx(bs, { label: s.email, children: t.email }) }),
  /* @__PURE__ */ e.jsx(jt, { odd: !0, children: /* @__PURE__ */ e.jsx(bs, { label: s.contractNo, children: t.contractNo }) }),
  /* @__PURE__ */ e.jsx(jt, { children: /* @__PURE__ */ e.jsx(bs, { label: s.startDate, children: t.startDate }) }),
  /* @__PURE__ */ e.jsx(jt, { odd: !0, children: /* @__PURE__ */ e.jsx(bs, { label: s.nextPeriod, children: t.nextPeriod ?? "-" }) })
] }), yi = ({
  onClose: t
}) => {
  const [s, n] = M(!1), { t: r } = O(["account", "common"], { nsMode: "fallback" }), a = (h) => {
    if (!((h == null ? void 0 : h.code) === 400))
      return n(!0);
  }, { mutateAsync: o, isLoading: i } = fe(
    ["changePasswordV2"],
    ({ Customer: h }) => h.changePasswordV2,
    {
      onError: (h) => a(h),
      onSuccess: t
    }
  ), {
    registerField: d,
    getError: l,
    handleSubmit: c,
    validate: m,
    resetData: u
  } = he({
    namespace: "changePassword",
    onSubmit: (h) => o(h),
    onValidate: Ts(io.spa, r)
  });
  return B(
    () => () => {
      n(!1), u();
    },
    []
  ), /* @__PURE__ */ e.jsx(
    ht,
    {
      title: r("customerInformation.contactInformation.modal.title"),
      open: !0,
      onOpenChange: t,
      children: /* @__PURE__ */ e.jsx(
        "form",
        {
          onSubmit: Nt(m, c),
          onReset: t,
          children: /* @__PURE__ */ e.jsxs(Ue, { className: "mb-4 gap-4", children: [
            s && /* @__PURE__ */ e.jsx(ge, { color: "negative", className: "col-span-full", children: r("errors.changePassword") }),
            /* @__PURE__ */ e.jsx(
              Q,
              {
                ...d("oldPassword", {
                  type: "password",
                  required: !0
                }),
                label: r("form.labels.currentPassword"),
                error: l("oldPassword"),
                className: "col-span-full sm:col-span-4 md:col-span-6"
              }
            ),
            /* @__PURE__ */ e.jsx(
              Q,
              {
                ...d("password", {
                  type: "password",
                  required: !0
                }),
                label: r("form.labels.newPassword"),
                error: l("password"),
                className: "col-span-full row-start-2 sm:col-span-4 md:col-span-6"
              }
            ),
            /* @__PURE__ */ e.jsx(
              Q,
              {
                ...d("confirmPassword", {
                  type: "password",
                  required: !0
                }),
                label: r("form.labels.repeatPassword"),
                error: l("confirmPassword"),
                className: "col-span-full row-start-2 sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
              }
            ),
            /* @__PURE__ */ e.jsx("div", { className: "col-span-full my-2", children: /* @__PURE__ */ e.jsxs(ge, { color: "inform", children: [
              /* @__PURE__ */ e.jsx(k, { size: "sm", children: r(
                "customerInformation.accountInformation.changePassword.modal.passwordRequirements.title"
              ) }),
              /* @__PURE__ */ e.jsx("ul", { className: "pl-5", children: /* @__PURE__ */ e.jsxs(
                G,
                {
                  i18nKey: "customerInformation.accountInformation.changePassword.modal.passwordRequirements.content",
                  ns: "account",
                  children: [
                    /* @__PURE__ */ e.jsx(k, { size: "sm", as: "li" }),
                    /* @__PURE__ */ e.jsx(k, { size: "sm", as: "li" }),
                    /* @__PURE__ */ e.jsx(k, { size: "sm", as: "li" }),
                    /* @__PURE__ */ e.jsx(k, { size: "sm", as: "li" })
                  ]
                }
              ) })
            ] }) }),
            /* @__PURE__ */ e.jsxs("div", { className: "col-span-full flex justify-self-end", children: [
              /* @__PURE__ */ e.jsx(X, { intent: "text", type: "reset", children: r("action.cancel") }),
              /* @__PURE__ */ e.jsx(
                De,
                {
                  intent: "solid",
                  type: "submit",
                  isLoading: i,
                  loadingLabel: r("action.loading"),
                  children: r("action.save")
                }
              )
            ] })
          ] })
        }
      )
    }
  );
}, ap = () => {
  const {
    query: { contract: t },
    replace: s
  } = se(), n = Le(), { t: r } = O(["recognitions", "common"], {
    nsMode: "fallback"
  }), [a, o] = M(!1), [i, d] = M(!1), { customerInformation: l } = Oe(), { data: c } = dn(), { data: m } = qr(t), u = D(
    () => (m == null ? void 0 : m.paymentAgreement.firstName) || (l == null ? void 0 : l.firstName),
    [m == null ? void 0 : m.paymentAgreement.firstName, l == null ? void 0 : l.firstName]
  ), h = D(
    () => (m == null ? void 0 : m.paymentAgreement.lastName) || (l == null ? void 0 : l.lastName),
    [m == null ? void 0 : m.paymentAgreement.lastName, l == null ? void 0 : l.lastName]
  ), p = L(() => (n.resetQueries({
    queryKey: ee.BusinessCommutersList
  }), s("/account/business/commuters")), [n, s]);
  return !m || !l ? null : /* @__PURE__ */ e.jsxs("div", { className: "py-5", children: [
    /* @__PURE__ */ e.jsx(Y, { variant: "h1", children: `${u} ${h}` }),
    /* @__PURE__ */ e.jsx(
      rp,
      {
        data: {
          contractNo: m.paymentAgreement.contractNo,
          email: m.paymentAgreement.commuterEmail,
          nextPeriod: m.paymentAgreement.nextPeriod,
          startDate: m.paymentAgreement.startDate
        },
        labels: {
          contractNo: r("form.labels.contractNo"),
          email: r("form.labels.email"),
          nextPeriod: r("form.labels.nextPeriodDate"),
          startDate: r("form.labels.startDate")
        }
      }
    ),
    (l == null ? void 0 : l.customerType) === "business" ? /* @__PURE__ */ e.jsx(
      X,
      {
        as: "button",
        intent: "outlined",
        color: "negative",
        className: "mt-4 hover:bg-red-600 hover:text-white",
        onClick: () => d(!0),
        children: r("action.cancelContract")
      }
    ) : /* @__PURE__ */ e.jsx(
      X,
      {
        as: "button",
        className: "mt-4",
        onClick: () => o(!0),
        children: r("action.changePassword")
      }
    ),
    /* @__PURE__ */ e.jsx(ut, { children: a ? /* @__PURE__ */ e.jsx(
      yi,
      {
        onClose: () => o(!1)
      }
    ) : null }),
    i ? /* @__PURE__ */ e.jsx(
      _o,
      {
        contract: {
          ...m.paymentAgreement,
          agreementType: Z.OresundBusinessPendler
        },
        periodCard: c,
        onSuccess: p,
        customerType: ds.businessCommuter,
        onClose: () => d(!1)
      }
    ) : null
  ] });
}, op = ({
  contractNo: t
}) => {
  const { t: s } = O(["recognitions", "account", "common"], {
    nsMode: "fallback"
  }), [n, r] = M(), [a, o] = M(), { data: i } = Ke(!0, t), { data: d } = Ar(t), { discountAgreement: l, contractTypeTranslationKey: c } = Lu(t), { customerInformation: m } = Oe(), u = D(
    () => (m == null ? void 0 : m.customerType) === ds.businessCustomer,
    []
  );
  if (!i || !l) return null;
  const h = [
    Z.OresundBusinessPendler,
    Z.OresundPendler
  ].includes(l == null ? void 0 : l.agreementType);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(ut, { children: [
    /* @__PURE__ */ e.jsx(ap, {}),
    /* @__PURE__ */ e.jsxs("div", { className: "rounded-[15px] bg-neutral-100 px-4 py-6 sm:rounded-[23px] sm:px-8 md:rounded-[30px]", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "mb-4", children: [
        /* @__PURE__ */ e.jsx(k, { as: "h3", intent: "title", weight: "medium", className: "mb-2", children: `${s("discountAgreement.title")} - ${i.paymentAgreement.contractNo}` }),
        /* @__PURE__ */ e.jsx(k, { weight: "light", className: "mb-2", children: s("discountAgreement.description") })
      ] }),
      /* @__PURE__ */ e.jsx(
        en,
        {
          preTitle: s("agreement.label.discountAgreement"),
          description: s(
            `agreementTypes.${l.agreementType}.description`
          ),
          title: /* @__PURE__ */ e.jsx(Ze, { contract: c }),
          actionBanner: u ? Ko(d) : void 0,
          children: /* @__PURE__ */ e.jsx(
            fr,
            {
              contract: {
                ...i.paymentAgreement,
                contractType: "discount"
              },
              periodCard: d,
              actionsDisabled: !0,
              hideBillingInfo: !0
            }
          )
        }
      ),
      a ? /* @__PURE__ */ e.jsx(ge, { color: "inform", className: "mt-4", children: a }) : null,
      n ? /* @__PURE__ */ e.jsx(ge, { color: "negative", className: "mb-4", children: n }) : null,
      /* @__PURE__ */ e.jsx(
        np,
        {
          contract: c,
          className: "mt-4",
          intent: "secondary",
          onError: r,
          onInfo: o,
          isPendler: h
        }
      )
    ] })
  ] }) });
}, ip = ({
  recognition: t,
  onMoreLocations: s,
  labels: n
}) => {
  const r = (o) => s({ replaceRecognition: t, isMoreLocations: o });
  s(void 0);
  const { locale: a } = se();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Ut, { children: /* @__PURE__ */ e.jsx(
      Vt,
      {
        fallback: /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx("div", { className: "w-9", children: /* @__PURE__ */ e.jsx(At, { "aria-label": n.loading }) }) }),
        children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(k, { as: "h4", children: n.title }) })
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      Rt,
      {
        activeCancel: !0,
        onClose: () => {
          r(!1), Pa("no", a);
        },
        cancelLabel: n.noButton,
        actionLabel: n.yesButton,
        action: () => {
          r(!0), Pa("yes", a);
        }
      }
    )
  ] });
}, lp = ({ onIsSelectReading: t, isLoadingData: s, labels: n }) => {
  const { locale: r } = se();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Ut, { children: /* @__PURE__ */ e.jsx(
      Vt,
      {
        fallback: /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx("div", { className: "w-9", children: /* @__PURE__ */ e.jsx(At, { "aria-label": n.loading }) }) }),
        children: /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx(k, { as: "h3", intent: "title", children: n.title }),
          /* @__PURE__ */ e.jsx(k, { className: "mt-5", children: n.descriptionMain }),
          /* @__PURE__ */ e.jsxs(ge, { className: "mt-4", children: [
            /* @__PURE__ */ e.jsx(
              k,
              {
                as: "h4",
                weight: "semibold",
                className: "text-primary-900",
                children: n.description
              }
            ),
            /* @__PURE__ */ e.jsx("ul", { className: "marker:text-primary-400 mt-2 list-disc pl-6", children: n.benefitsList })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "pt-2", children: n.descriptionBottom })
        ] })
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      Rt,
      {
        onClose: () => {
          t(!1), Ta("bizz", r);
        },
        cancelLabel: n.btnKeepBusiness,
        actionLabel: n.btnSelRegNumReading,
        action: () => {
          t(!0), Ta("numberplate", r);
        },
        loadingButton: !0,
        loadingLabel: n.loading,
        isLoading: s
      }
    )
  ] });
}, cp = ({
  customerInformation: t,
  onOrderBiz: s,
  isLoadingData: n,
  labels: r,
  onError: a,
  asfinagInput: o
}) => {
  const [i, d] = M(), l = "addressdata", { address: c, zipCode: m, city: u } = t, { mutateAsync: h, isLoading: p } = fe(
    ["account", "address"],
    (z) => z.Customer.updateCustomerAddress,
    {
      onSuccess: () => d(!1),
      onError: () => a(!0)
    }
  ), f = (z) => {
    h(z);
  }, { registerField: x, getError: g, validate: N, handleSubmit: b } = he({
    namespace: l,
    defaultValues: { address: c, zipCode: m, city: u },
    onSubmit: f
  }), [v, S, y] = Ee(
    l,
    "address",
    "zipCode",
    "city"
  );
  B(() => a(!1), [i, a]);
  const { locale: w } = se();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Ut, { children: /* @__PURE__ */ e.jsx(
      Vt,
      {
        fallback: /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx("div", { className: "w-9", children: /* @__PURE__ */ e.jsx(At, { "aria-label": r.loading }) }) }),
        children: /* @__PURE__ */ e.jsxs(Ue, { children: [
          /* @__PURE__ */ e.jsx(
            k,
            {
              as: "h3",
              intent: "title",
              className: "col-span-full sm:col-span-12 md:col-span-12",
              children: r.title
            }
          ),
          i ? /* @__PURE__ */ e.jsxs(
            Fn,
            {
              onSubmit: Nt(N, b),
              className: "col-span-full grid",
              children: [
                /* @__PURE__ */ e.jsx(
                  Q,
                  {
                    className: "col-span-full mb-10 sm:col-span-12 md:col-span-12",
                    ...x("address"),
                    label: r.address,
                    error: g("address"),
                    required: !0
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Q,
                  {
                    className: "col-span-full mb-10 sm:col-span-6 md:col-span-6",
                    ...x("zipCode"),
                    label: r.zipCode,
                    error: g("zipCode"),
                    required: !0
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Q,
                  {
                    className: "col-span-full mb-10 sm:col-span-5 md:col-span-5 md:col-start-8",
                    ...x("city"),
                    label: r.city,
                    error: g("city"),
                    required: !0
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  De,
                  {
                    intent: "text",
                    type: "submit",
                    loadingLabel: r.loading,
                    isLoading: p,
                    children: r.btnRegSave
                  }
                )
              ]
            }
          ) : /* @__PURE__ */ e.jsxs("div", { className: "col-span-full grid", children: [
            /* @__PURE__ */ e.jsx(rr, { className: "col-span-full sm:col-span-12 md:col-span-12", children: v }),
            /* @__PURE__ */ e.jsx(rr, { className: "col-span-full sm:col-span-12 md:col-span-12", children: S }),
            /* @__PURE__ */ e.jsx(rr, { className: "col-span-full sm:col-span-12 md:col-span-12", children: y })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "col-span-full sm:col-span-12 md:col-span-12", children: !i && /* @__PURE__ */ e.jsx(
            X,
            {
              onClick: () => d(!i),
              intent: "text",
              children: r.btnReg
            }
          ) }),
          o && /* @__PURE__ */ e.jsx("div", { className: "col-span-full sm:col-span-12 md:col-span-12", children: o })
        ] })
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      Rt,
      {
        actionLabel: r.btnNewBizz,
        action: () => {
          s(), Sm(w);
        },
        loadingButton: !0,
        loadingLabel: r.loading,
        isLoading: n,
        disabled: i
      }
    )
  ] });
}, Ra = ({
  onClear: t,
  labels: s
}) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  /* @__PURE__ */ e.jsx(Ut, { children: /* @__PURE__ */ e.jsx(
    Vt,
    {
      fallback: /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx("div", { className: "w-9", children: /* @__PURE__ */ e.jsx(At, { "aria-label": s.loading }) }) }),
      children: /* @__PURE__ */ e.jsxs("div", { className: "col-span-full flex w-0 min-w-full items-start", children: [
        /* @__PURE__ */ e.jsx("div", { className: "inline-block rounded-full bg-green-500 p-8 text-4xl text-neutral-100", children: /* @__PURE__ */ e.jsx(an, {}) }),
        /* @__PURE__ */ e.jsxs("div", { className: "pl-5", children: [
          /* @__PURE__ */ e.jsx(k, { as: "h3", intent: "title", children: s.title }),
          /* @__PURE__ */ e.jsx(k, { className: "pt-5", as: "p", children: s.description }),
          /* @__PURE__ */ e.jsx(k, { as: "p", className: "pt-2", children: s.oldDescription })
        ] })
      ] })
    }
  ) }),
  /* @__PURE__ */ e.jsx(Rt, { action: t, actionLabel: s.btnClear })
] }), dp = ({
  onClose: t,
  recognition: s,
  isStoreBeltContract: n,
  customerInformation: r,
  contractNo: a,
  serialNumber: o
}) => {
  const [i, d] = M(!1), { t: l } = O(["recognitions", "common"], {
    nsMode: "fallback"
  }), { app: c, baseURL: m } = Ye(), h = se().locale || "en", p = c === ot.OresundPay ? Jt({ locale: h, key: "faq", url: m }) : kn(h, "faq", m), [f, x] = M(), [g, N] = M(), [b, v] = M(), S = L(() => {
    v(!0), x(g);
  }, [g]), { mutateAsync: y, isLoading: w } = fe(
    ["recognition", "replace"],
    ({ Recognition: ae }) => ae.replace,
    { onSuccess: S, onError: () => d(!0) }
  ), z = "replacebizz", { registerField: C, getError: E } = he({
    namespace: z,
    defaultValues: { isAsfinag: !1 }
  }), [
    A,
    F,
    R,
    T,
    P,
    V,
    I,
    _,
    ne,
    K
  ] = Ee(
    "edit-recognition-modal",
    "countryCode",
    "licensePlate",
    "make",
    "model",
    "color",
    "weightClass",
    "fuelType",
    "emissionClass",
    "hybrid",
    "reference"
  ), [U] = Ee(z, "isAsfinag"), re = D(
    () => ({
      countryCode: A || "",
      registrationNo: F || "",
      make: R || "",
      model: T || "",
      color: P || "",
      isHGV: s != null && s.isHGV ? s.isHGV : !!V,
      fuelType: parseInt(I) || void 0,
      co2EmissionClass: parseInt(_) || void 0,
      isHybrid: !!ne,
      reference: K || ""
    }),
    [
      A,
      F,
      R,
      T,
      P,
      s.isHGV,
      V,
      I,
      _,
      ne,
      K
    ]
  ), [ie, le] = M(void 0), me = (ae) => le(ae), ce = L(
    async (ae) => {
      N(ae), y({
        serialNumber: o,
        contractNo: a,
        convertToRegNo: ae,
        isAsfinag: !!U,
        vehicleData: re
      });
    },
    [y, o, a, U, re]
  ), q = () => ce(!1), de = (ae) => {
    ae ? ce(!0) : x(!1);
  };
  return B(() => d(!1), [f]), /* @__PURE__ */ e.jsxs(on, { open: !0, ariaLabelledBy: "title", children: [
    /* @__PURE__ */ e.jsx(ln, { closeLabel: l("action.close"), onClose: t, children: /* @__PURE__ */ e.jsx(k, { as: "h3", children: l("replaceBizz.title") }) }),
    i && /* @__PURE__ */ e.jsx(ge, { color: "negative", children: l("errors.generic") }),
    ie ? b ? /* @__PURE__ */ e.jsx(
      Ra,
      {
        onClear: t,
        labels: {
          loading: l("action.loading"),
          title: l(
            `replaceBizz.resultModal.${g ? "changedToRedTitle" : "newbizzOrderTitle"}`
          ),
          description: l(
            `replaceBizz.resultModal.${g ? "changedToRedDesc" : "newbizzOrderDesc"}`
          ),
          oldDescription: l("replaceBizz.resultModal.oldBusinessDesc"),
          btnClear: l("replaceBizz.resultModal.clear")
        }
      }
    ) : ie != null && ie.isMoreLocations || f === !1 ? /* @__PURE__ */ e.jsx(
      cp,
      {
        customerInformation: r,
        recognition: s,
        asfinagInput: s != null && s.isHGV ? /* @__PURE__ */ e.jsx(
          Q,
          {
            error: E("isAsfinag"),
            label: l("form.labels.asfinag"),
            ...C("isAsfinag", {
              type: "checkbox",
              value: "true"
            })
          }
        ) : void 0,
        onOrderBiz: q,
        isLoadingData: w,
        labels: {
          loading: l("action.loading"),
          title: l("replaceBizz.addressModal.title"),
          address: l("form.labels.address"),
          city: l("form.labels.city"),
          zipCode: l("form.labels.zipCode"),
          btnRegSave: l("replaceBizz.addressModal.btnRegSave"),
          btnReg: l("replaceBizz.addressModal.btnReg"),
          btnNewBizz: l("replaceBizz.addressModal.btnNewBizz")
        },
        onError: (ae) => d(ae)
      }
    ) : f ? /* @__PURE__ */ e.jsx(
      Ra,
      {
        onClear: t,
        labels: {
          loading: l("action.loading"),
          title: l("replaceBizz.resultModal.changedToRedTitle"),
          description: l("replaceBizz.resultModal.changedToRedDesc"),
          oldDescription: l("replaceBizz.resultModal.oldBusinessDesc"),
          btnClear: l("replaceBizz.resultModal.clear")
        }
      }
    ) : /* @__PURE__ */ e.jsx(
      lp,
      {
        onIsSelectReading: de,
        isLoadingData: w,
        labels: {
          loading: l("action.loading"),
          title: l("replaceBizz.regNumberModal.title"),
          descriptionMain: l(
            "replaceBizz.regNumberModal.descriptionMain"
          ),
          description: l("replaceBizz.regNumberModal.description"),
          benefitsList: /* @__PURE__ */ e.jsxs(G, { i18nKey: "replaceBizz.benefitsList", ns: "recognitions", children: [
            /* @__PURE__ */ e.jsx(
              k,
              {
                className: "text-primary-900 pb-2 pt-3",
                as: "li"
              }
            ),
            /* @__PURE__ */ e.jsx(k, { className: "text-primary-900 pb-2", as: "li" }),
            /* @__PURE__ */ e.jsx(k, { className: "text-primary-900 pb-2", as: "li" }),
            /* @__PURE__ */ e.jsx(k, { className: "text-primary-900 pb-2", as: "li" })
          ] }),
          descriptionBottom: /* @__PURE__ */ e.jsxs(
            G,
            {
              i18nKey: "replaceBizz.regNumberModal.descriptionBottom",
              ns: "recognitions",
              children: [
                /* @__PURE__ */ e.jsx(k, { className: "pt-5", as: "span", size: "sm" }),
                /* @__PURE__ */ e.jsx(
                  ys,
                  {
                    className: "text-primary-400 pl-1 text-[0.75rem]",
                    href: p,
                    target: "_blank"
                  }
                )
              ]
            }
          ),
          btnKeepBusiness: l(
            "replaceBizz.regNumberModal.btnKeepBusiness"
          ),
          btnSelRegNumReading: l(
            "replaceBizz.regNumberModal.btnSelRegNumReading"
          )
        }
      }
    ) : /* @__PURE__ */ e.jsx(
      ip,
      {
        onMoreLocations: me,
        recognition: s,
        labels: {
          title: l(
            `replaceBizz.promptInfoModal.${n ? "storebelt" : "nonStorebelt"}`
          ),
          noButton: l("replaceBizz.promptInfoModal.btnNo"),
          yesButton: l("replaceBizz.promptInfoModal.btnYes"),
          loading: l("action.loading")
        }
      }
    )
  ] });
}, Ig = () => {
  var K, U;
  const t = se(), { query: s } = t, [n, r] = M(!1), [a, o] = M(
    "bizz"
  ), { t: i } = O(["account", "common"], {
    nsMode: "fallback"
  }), { app: d } = Ye(), l = pt(), c = !!(l != null && l.get("price-and-product")), m = (re) => {
    o(re), r(!0);
  }, [u, h] = M(), [p, f] = M(), [x, g] = M(), [N, b] = M(), v = L((re) => {
    const ie = re && re.registrationNo && re.countryCode;
    g(re), b(ie ? 2 : 1);
  }, []), { customerInformation: S } = Oe(), y = (S == null ? void 0 : S.customerType) === ds.affiliatePartner, w = (S == null ? void 0 : S.customerType) === ds.businessCommuter, z = ["business", "business-commuter"].includes(
    (S == null ? void 0 : S.customerType) ?? ""
  ), C = [
    "private",
    "business-commuter"
  ].includes((S == null ? void 0 : S.customerType) ?? ""), E = ui(), { data: A } = Ke(), F = ((K = A == null ? void 0 : A.paymentAgreement) == null ? void 0 : K.agreementType) === "OresundGO", R = (U = A == null ? void 0 : A.paymentAgreement) == null ? void 0 : U.paymentIssuer, T = R ? cc[R] : void 0, P = [
    {
      labelKey: y ? "kmtoll.order.layout.title" : "action.orderBizz",
      icon: /* @__PURE__ */ e.jsx(cs, {}),
      action: () => {
        y ? t.push("./bizz/order") : z && d === ot.OresundPay ? t.push("/account/vehicles/order-bizz") : m("bizz");
      }
    }
  ];
  y || P.push({
    labelKey: "action.addRegNoPayment",
    icon: /* @__PURE__ */ e.jsx(cs, {}),
    action: () => m("alpr")
  });
  const V = Array.isArray(s.contract) ? s.contract[0] : s.contract, I = C && E || V, _ = F && c;
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(
    tn,
    {
      fallback: /* @__PURE__ */ e.jsx(ze, { colorMode: "error", children: i("errors.generic") }),
      children: /* @__PURE__ */ e.jsxs(Vt, { fallback: /* @__PURE__ */ e.jsx(Yo, { loadingLabel: "loading" }), children: [
        s.toast && /* @__PURE__ */ e.jsx(
          ii,
          {
            registrationNumber: s.toast,
            onClose: () => mi("toast", t)
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
          T && _ && !y && /* @__PURE__ */ e.jsxs("div", { className: "mb-8 flex items-start gap-2", children: [
            /* @__PURE__ */ e.jsx("div", { className: "pt-1", children: /* @__PURE__ */ e.jsx(Wl, {}) }),
            /* @__PURE__ */ e.jsx("p", { className: "text-type-secondary text-base font-normal", children: /* @__PURE__ */ e.jsx(
              G,
              {
                i18nKey: "priceAndProduct.recognitionLanding.paymentIssuerText",
                values: { issuerName: T.name },
                components: [
                  /* @__PURE__ */ e.jsx(
                    "a",
                    {
                      className: "text-primary-600 inline-flex items-center gap-1 underline",
                      href: T.url,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }
                  )
                ],
                ns: "account"
              }
            ) })
          ] }),
          !_ && /* @__PURE__ */ e.jsx(_1, { preambleKey: "myPaymentOptions.businessDescription" }),
          I && !_ && /* @__PURE__ */ e.jsx(op, { contractNo: E }),
          _ && /* @__PURE__ */ e.jsx(Ux, {}),
          /* @__PURE__ */ e.jsxs(
            rl,
            {
              value: {
                onEditRecognition: f,
                onRemoveRecognition: h,
                onReplaceRecognition: v
              },
              children: [
                _ && /* @__PURE__ */ e.jsx("h2", { className: "mt-8 text-2xl font-medium sm:mt-8 md:mt-16", children: i(
                  "priceAndProduct.recognitionLanding.paymentIssuerHeading",
                  {
                    issuerName: (T == null ? void 0 : T.name) || "ØresundPAY"
                  }
                ) }),
                /* @__PURE__ */ e.jsx(
                  sl,
                  {
                    pageType: "vehicle",
                    shouldTriggerModal: !1,
                    actions: P
                  }
                )
              ]
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx(
          tn,
          {
            fallback: /* @__PURE__ */ e.jsx(ze, { colorMode: "error", children: i("errors.generic") }),
            children: /* @__PURE__ */ e.jsxs(ut, { children: [
              n && /* @__PURE__ */ e.jsx(
                L1,
                {
                  preSelectedRecognitionType: a,
                  onClose: () => r(!1)
                }
              ),
              p && /* @__PURE__ */ e.jsx(
                Oa,
                {
                  onClose: () => f(void 0),
                  activeRecognition: p,
                  isExternalCustomer: us(
                    p.contract.provider
                  ),
                  contract: Wt[p.contract.agreementType]
                }
              ),
              u && /* @__PURE__ */ e.jsx(
                I1,
                {
                  recognition: u,
                  onClose: () => h(void 0)
                }
              ),
              x && (N === 1 ? /* @__PURE__ */ e.jsx(
                Oa,
                {
                  onClose: () => g(void 0),
                  onSuccessReplaceBizz: () => {
                    b(2);
                  },
                  activeRecognition: x,
                  isExternalCustomer: us(
                    x.contract.provider
                  ),
                  contract: Wt[x.contract.agreementType],
                  replaceSerialNumber: x.serialNo
                }
              ) : N === 2 ? S && !w && /* @__PURE__ */ e.jsx(
                dp,
                {
                  onClose: () => {
                    g(void 0), b(void 0);
                  },
                  recognition: x,
                  isStoreBeltContract: x.isSBF,
                  customerInformation: S,
                  contractNo: x.contractNo,
                  serialNumber: x.serialNo
                }
              ) : null)
            ] })
          }
        )
      ] })
    }
  ) });
}, ji = Ct({}), Pt = () => {
  const t = at(ji);
  if (!t)
    throw new Error("useFormContext must be used within the FormProvider");
  return t;
}, mp = ({ children: t }) => {
  const [s, n] = M({}), [r, a] = M(1), o = (l) => {
    a((c) => typeof l == "function" ? l(c) : l);
  }, i = (l) => {
    n({ ...l });
  }, d = (l) => {
    n((c) => ({ ...c, ...l }));
  };
  return /* @__PURE__ */ e.jsx(
    ji.Provider,
    {
      value: {
        formData: s,
        setFormData: i,
        step: r,
        updateStep: o,
        updateFormData: d
      },
      children: t
    }
  );
}, Ci = ({ children: t }) => /* @__PURE__ */ e.jsx("div", { className: "pb-1", children: /* @__PURE__ */ e.jsx("span", { className: "block font-semibold uppercase text-neutral-600", children: t }) });
function Jr() {
  const { locale: t } = se(), { t: s } = O(["common"]), { data: n } = ye(
    ee.VehicleTypeList({ locale: t }),
    (o) => o.VehicleType.list(t || ""),
    { staleTime: 1 / 0 }
  ), r = ((n == null ? void 0 : n.vehicleTypes) || []).map((o) => ({
    id: s(`vehicleTypes.${o.id}`),
    label: s(`vehicleTypes.${o.label}`),
    value: o.value,
    uneceClass: o == null ? void 0 : o.uneceClass,
    vehicleGroup: o == null ? void 0 : o.vehicleGroup,
    weightCategory: o == null ? void 0 : o.weightCategory
  })), a = n == null ? void 0 : n.co2VehicleSubgroups;
  return { vehicleTypes: r, co2VehicleSubgroups: a };
}
const up = {
  p: /* @__PURE__ */ e.jsx("p", { className: "pb-4 leading-relaxed last-of-type:pb-0" }),
  strong: /* @__PURE__ */ e.jsx("strong", { className: "font-semibold" })
}, hp = Ht("", {
  variants: {
    intent: {
      default: "mt-8 max-w-3xl overflow-hidden rounded-lg bg-neutral-50 p-6"
    }
  },
  defaultVariants: {
    intent: "default"
  }
}), Sn = ({
  title: t = "",
  image: s,
  descriptionPhraseKey: n,
  className: r = "",
  intent: a
}) => /* @__PURE__ */ e.jsxs("div", { className: hp({ intent: a, className: r }), children: [
  t && /* @__PURE__ */ e.jsx("h3", { className: "pb-4 text-3xl font-semibold", children: t }),
  /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-10 sm:flex-row", children: [
    /* @__PURE__ */ e.jsx("div", { className: "w-full flex-auto sm:w-2/3", children: n ? /* @__PURE__ */ e.jsx(
      G,
      {
        i18nKey: n,
        ns: "account",
        components: up
      }
    ) : null }),
    s && /* @__PURE__ */ e.jsx("div", { className: "relative aspect-square h-full min-h-[100px] w-auto max-w-[300px] flex-auto overflow-hidden rounded-xl", children: /* @__PURE__ */ e.jsx(Ic, { src: s == null ? void 0 : s.src, alt: (s == null ? void 0 : s.alt) || "", fill: !0 }) })
  ] })
] }), Ni = (t) => t.replace(/[- ]+/gi, "").toUpperCase(), Yn = ({
  children: t,
  allowFull: s
}) => /* @__PURE__ */ e.jsx("div", { className: `flex flex-col gap-10 ${!s && "sm:max-w-xs"}`, children: t }), wi = () => L(
  (s, n) => {
    const r = {
      scrollIntoView: {
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      },
      focus: { preventScroll: !0 },
      ...n
    };
    s != null && s.current && (s.current.scrollIntoView(r == null ? void 0 : r.scrollIntoView), s.current.focus(r == null ? void 0 : r.focus));
  },
  []
), ea = ps(
  (t, s) => /* @__PURE__ */ e.jsx(
    "input",
    {
      type: "radio",
      ...t,
      ref: s,
      className: `peer mr-4  grid h-6 w-6 appearance-none place-content-center items-center justify-center rounded-full border border-neutral-700 pr-4 text-base font-medium text-inherit outline-0 before:ml-4 before:block before:h-4 before:w-4 before:scale-0 before:rounded-full before:shadow-[inset_16px_16px_var(--osb-primary-800)] before:duration-100 before:ease-in-out before:content-[''] checked:before:scale-100 focus:ring-0 disabled:before:shadow-[inset_16px_16px_var(--osb-neutral-400)] ${t.className ?? ""}`
    }
  )
);
ea.displayName = "RadioOption";
const dr = (t) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: " ring-primary-600 flex flex-row items-center rounded-lg p-2 focus-within:ring",
    style: {
      opacity: t.disabled ? 0.32 : 1
    },
    children: [
      /* @__PURE__ */ e.jsx(
        ea,
        {
          id: t.id,
          name: t.name,
          value: t.value,
          checked: t.checked,
          onChange: t.onChange,
          disabled: t.disabled
        }
      ),
      /* @__PURE__ */ e.jsx("label", { className: "text-sm text-neutral-900", htmlFor: t.id, children: t.label })
    ]
  }
), ki = () => {
  const t = at(Lo);
  if (!t)
    throw new Error(
      "useContentRequest must be used within an ContentRequestProvider"
    );
  const { contentRequest: s } = t;
  return s;
}, Pi = {
  [$e.Under3500kg]: { min: 0, max: 3500 },
  [$e.Over3500kgUnder12000kg]: { min: 3501, max: 11999 },
  [$e.Over12000kgToInfinity]: { min: 12e3, max: 1 / 0 },
  [$e.Over35000kgToInfinity]: { min: 3501, max: 1 / 0 }
}, $a = [
  "isAUTOPASS",
  "isASFINAG",
  "isGNSS"
], Ti = (t, s, n) => {
  const r = parseInt(t), { min: a, max: o } = n[s] || {};
  return r >= a && r <= o;
}, pp = ({ isRoadTollDenmark: t = !1 }) => {
  var de, ae, je, pe, Ve, ft, os, It, xt, gt, Dt;
  const { updateStep: s, setFormData: n, updateFormData: r, formData: a } = Pt(), o = ki(), { asPath: i } = se(), [d, l] = M(!1), [c, m] = M(
    a.weightInterval ? a.weightInterval : $e.Under3500kg
  ), { app: u } = Ye(), h = kt(!0), { vehicleTypes: p } = Jr(), [f, x] = M(
    a != null && a.country ? a.country : void 0
  ), [g, N] = M(!1), b = wi(), v = pt(), S = !!(v != null && v.get("toll-collect")), y = Ae({
    contractNo: null,
    licensePlate: null,
    vehicleType: null
  }), {
    setValue: w,
    register: z,
    handleSubmit: C,
    formState: { errors: E },
    watch: A,
    clearErrors: F,
    setError: R
  } = ws({
    defaultValues: {
      isAUTOPASS: !1,
      isASFINAG: !1,
      isGNSS: !1,
      isTollCollect: !1,
      isHGV: !1,
      customerNumber: "",
      ...a
    },
    resolver: _s(dc)
  });
  B(() => {
    var oe;
    if (h && h.length > 0 && !(a != null && a.country)) {
      const be = (oe = h == null ? void 0 : h[0]) == null ? void 0 : oe.value;
      x(be), w("country", be);
    }
  }, [h, w, a == null ? void 0 : a.country]);
  const T = Ae(!1);
  B(() => {
    t && !T.current && (T.current = !0, w("vehicleType", ir.HeavyTruckOver12Ton.toString()), w("isGNSS", !0), w("isASFINAG", !1), w("isAUTOPASS", !1), w("isHGV", !0), r({ showExtendedForm: !0 }), m($e.Over12000kgToInfinity));
  }, [t, w, r]);
  const { t: P } = O(["account", "common"], {
    nsMode: "fallback"
  }), V = A("licensePlate"), I = A("isAUTOPASS"), _ = A("isASFINAG"), ne = A("isGNSS"), K = A("isTollCollect");
  B(() => {
    const oe = Object.keys(E)[0];
    oe && y.current[oe] && b({
      current: y.current[oe]
    });
  }, [E, b]);
  const U = async (oe) => {
    var Tt;
    const { country: be, licensePlate: we } = oe;
    if (l(!0), !oe.isASFINAG && !oe.isTollCollect && !oe.isAUTOPASS && !oe.isGNSS) {
      R("root.enableCountries", {
        type: "manual",
        message: P("form.validations.enableCountries.required")
      }), l(!1);
      return;
    }
    const et = (Qe = {}) => {
      n({
        ...oe,
        ...Qe,
        //This is to let the next form step know which fields come from bilvision
        bilvisionFields: Object.keys(Qe),
        //This is to let the next form step know which weights to accept in validation
        weightInterval: c,
        showExtendedForm: a == null ? void 0 : a.showExtendedForm,
        isASFINAG: oe.isGNSS ? !0 : oe.isASFINAG
      }), s(2);
    }, Ge = ["NO", "DK", "SE"];
    try {
      if (Ge.includes(be)) {
        const Qe = Ni(we), tt = await o(
          "vehicle-info",
          `countryCode=${be}&regNo=${Qe}`
        );
        if (!Ti(
          (tt == null ? void 0 : tt.grossWeight) || "0",
          c,
          Pi
        ))
          throw new Error("Invalid weight", { cause: "invalid_weight" });
        et(tt);
      } else
        et();
    } catch (Qe) {
      Qe.cause === "invalid_weight" ? (R("vehicleType", {
        type: "manual",
        message: P("form.validations.weight.invalid")
      }), b({ current: (Tt = y.current) == null ? void 0 : Tt.vehicleType })) : et();
    } finally {
      l(!1);
    }
  };
  B(() => {
    F("licensePlate");
  }, [V, F]);
  const re = (oe) => {
    F("vehicleType");
    const be = p.find(({ value: tt }) => tt === oe), we = (be == null ? void 0 : be.weightCategory) ?? $e.Under3500kg, et = [
      ir.HeavyTruckOver12Ton,
      ir.HeavyTruck3_5To12Ton
    ].includes(parseInt(oe)), Ge = we === $e.Over3500kgUnder12000kg || we === $e.Over12000kgToInfinity || we === $e.Over35000kgToInfinity, Tt = we === $e.Over12000kgToInfinity, Qe = K && we === $e.Over12000kgToInfinity;
    w("vehicleType", oe), w("isHGV", Ge), w("isASFINAG", _ && Ge), w("isGNSS", ne && Tt), w("isTollCollect", Qe), m(we), r({ isHGV: Ge, showExtendedForm: et });
  }, ie = (oe, be) => {
    F(oe), w(oe, be);
  }, le = (oe, be) => {
    F("contractNo"), w("contractNo", oe);
    const we = be ? us({ id: be, name: "_provider" }) : !1;
    w("isASFINAG", _ && !we), w("isGNSS", ne && !we), w("isTollCollect", K && !we), N(we);
  }, me = (oe) => {
    const be = oe.target.value, we = oe.target.name, et = oe.target.checked;
    we === "isTollCollect" && S ? w(we, et) : $a.includes(be) && (w(be, !0), $a.forEach((Ge) => {
      Ge !== be && w(Ge, !1);
    }));
  }, ce = i.lastIndexOf("/"), q = i.substring(0, ce);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("h2", { className: "mb-7 text-2xl font-semibold", children: P("singleOrderBizzFlow.order.basicVehicleInfo.title") }),
    /* @__PURE__ */ e.jsx("p", { children: P("singleOrderBizzFlow.order.basicVehicleInfo.description") }),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: C(U), className: "mt-8 w-full ", children: [
      /* @__PURE__ */ e.jsxs(Yn, { children: [
        /* @__PURE__ */ e.jsx(
          qn,
          {
            ref: (oe) => y.current.contractNo = oe,
            hideProviders: !0,
            hideCommuter: !0,
            initialContractNo: A("contractNo"),
            onAgreementChange: (oe, be) => le(oe, be),
            error: (de = E.contractNo) != null && de.message ? P(`${(ae = E.contractNo) == null ? void 0 : ae.message}`) : void 0
          }
        ),
        /* @__PURE__ */ e.jsxs("fieldset", { className: "flex flex-row", children: [
          /* @__PURE__ */ e.jsx("legend", { className: "block text-sm font-medium text-neutral-950", children: P("form.labels.licensePlate") }),
          /* @__PURE__ */ e.jsx(
            nt,
            {
              ...z("country", {
                required: P("form.validations.vehicleCountry.required")
              }),
              initialValue: f,
              options: h == null ? void 0 : h.map(({ value: oe }) => ({
                label: oe,
                value: oe
              })),
              classNames: {
                button: "border-r-0 rounded-r-none w-20",
                dropdown: "overflow-x-hidden"
              },
              error: (je = E.country) != null && je.message ? P(`${(pe = E.country) == null ? void 0 : pe.message}`) : void 0,
              onChange: (oe) => ie("country", oe)
            }
          ),
          /* @__PURE__ */ e.jsx(
            qe,
            {
              ...z("licensePlate"),
              ref: (oe) => y.current.licensePlate = oe,
              classNames: { wrapper: "w-full", input: "rounded-l-none" },
              icon: /* @__PURE__ */ e.jsx(Dn, { className: "h-4 w-4" }),
              error: t && E.vehicleType ? P("form.validations.weight.invalidRoadtaxDenmark") : (Ve = E.licensePlate) != null && Ve.message ? P(`${(ft = E.licensePlate) == null ? void 0 : ft.message}`) : void 0,
              defaultValue: a.licensePlate ? a.licensePlate : "",
              onChange: (oe) => {
                var be, we;
                ie(
                  "licensePlate",
                  (we = (be = oe == null ? void 0 : oe.target) == null ? void 0 : be.value) == null ? void 0 : we.toUpperCase()
                );
              }
            }
          )
        ] }),
        !t && /* @__PURE__ */ e.jsx(
          nt,
          {
            ...z("vehicleType", {
              required: P("form.validations.vehicleType.required")
            }),
            label: `${P("form.labels.vehicleType")}`,
            ref: (oe) => y.current.vehicleType = oe,
            required: !0,
            placeholder: P("form.placeholders.vehicleType"),
            options: p == null ? void 0 : p.map(({ label: oe, value: be, uneceClass: we }) => ({
              label: `${(we == null ? void 0 : we.join(", ")) || ""} - ${oe}`,
              value: be
            })),
            initialValue: a.vehicleType ? a.vehicleType : "",
            error: (os = E.vehicleType) != null && os.message ? P(`${(It = E.vehicleType) == null ? void 0 : It.message}`) : void 0,
            onChange: (oe) => re(oe)
          }
        ),
        (!t || u === ot.Oresundsbron) && /* @__PURE__ */ e.jsxs("fieldset", { className: "", children: [
          /* @__PURE__ */ e.jsxs("legend", { className: "block text-sm text-neutral-950", children: [
            /* @__PURE__ */ e.jsx("p", { className: "mb-1 font-medium", children: P("form.labels.enableCountries") }),
            /* @__PURE__ */ e.jsx("p", { children: P("form.descriptions.enableCountries") })
          ] }),
          ((xt = E.root) == null ? void 0 : xt.enableCountries) && /* @__PURE__ */ e.jsx("span", { className: "text-red-500", children: (Dt = (gt = E.root) == null ? void 0 : gt.enableCountries) == null ? void 0 : Dt.message }),
          /* @__PURE__ */ e.jsxs("div", { className: "mt-4 flex flex-col gap-0.5", children: [
            /* @__PURE__ */ e.jsx(
              dr,
              {
                id: "isAUTOPASS",
                name: "enabledCountries",
                value: "isAUTOPASS",
                checked: I,
                onChange: me,
                label: P("form.labels.isAutopass")
              }
            ),
            /* @__PURE__ */ e.jsx(
              dr,
              {
                id: "isASFINAG",
                name: "enabledCountries",
                value: "isASFINAG",
                checked: _,
                disabled: g || ![
                  $e.Over3500kgUnder12000kg,
                  $e.Over12000kgToInfinity,
                  $e.Over35000kgToInfinity
                ].includes(c),
                onChange: me,
                label: P("form.labels.isAsfinag")
              }
            ),
            /* @__PURE__ */ e.jsx(
              dr,
              {
                id: "isGNSS",
                name: "enabledCountries",
                value: "isGNSS",
                checked: ne,
                disabled: ![$e.Over12000kgToInfinity].includes(
                  c
                ) || g,
                onChange: me,
                label: P("form.labels.isGnss")
              }
            ),
            S && /* @__PURE__ */ e.jsx(
              ns,
              {
                ...z("isTollCollect"),
                onChange: me,
                disabled: c !== $e.Over12000kgToInfinity || g,
                className: "mt-2",
                label: P("form.labels.isTollCollect")
              }
            )
          ] })
        ] })
      ] }),
      ne && /* @__PURE__ */ e.jsx(
        Sn,
        {
          title: P(
            "singleOrderBizzFlow.order.basicVehicleInfo.details.roadTollDenmark.title"
          ),
          descriptionPhraseKey: "singleOrderBizzFlow.order.confirmation.details.roadTollDenmark.description"
        }
      ),
      K && /* @__PURE__ */ e.jsx(
        Sn,
        {
          title: P(
            "singleOrderBizzFlow.order.basicVehicleInfo.details.roadTollGermany.title"
          ),
          descriptionPhraseKey: "singleOrderBizzFlow.order.confirmation.details.roadTollGermany.description"
        }
      ),
      /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
      /* @__PURE__ */ e.jsxs("div", { className: "my-4 flex items-center gap-4", children: [
        /* @__PURE__ */ e.jsx(
          ys,
          {
            href: q,
            className: "ml-auto pr-4 font-medium text-blue-700 underline",
            children: P("action.cancel")
          }
        ),
        /* @__PURE__ */ e.jsx(
          De,
          {
            as: "button",
            type: "submit",
            loadingLabel: P("action.loading"),
            isLoading: d,
            children: P("action.next")
          }
        )
      ] })
    ] })
  ] });
}, fp = ({
  bizzInfo: t
}) => {
  var F, R, T, P;
  const { updateStep: s, setFormData: n, formData: r } = Pt(), a = ki(), { asPath: o } = se(), [i, d] = M(!1), l = D(() => t.isGNSS ? $e.Over12000kgToInfinity : t.isHGV ? $e.Over35000kgToInfinity : $e.Under3500kg, [t]), c = kt(!0), [m, u] = M(
    r != null && r.country ? r.country : void 0
  ), h = wi(), p = Ae({
    contractNo: null,
    licensePlate: null,
    vehicleType: null
  }), {
    setValue: f,
    register: x,
    handleSubmit: g,
    formState: { errors: N },
    watch: b,
    clearErrors: v,
    setError: S
  } = ws({
    defaultValues: {
      ...r,
      contractNo: t.contractNo,
      isHGV: t.isHGV,
      customerNumber: t.customerNo,
      isASFINAG: t.isAsfinag,
      isGNSS: t.isGNSS,
      prevRegNo: t.registrationNo,
      contractLineNo: t.contractLineNo
    }
  });
  B(() => {
    var V;
    if (c && c.length > 0 && !(r != null && r.country)) {
      const I = (V = c == null ? void 0 : c[0]) == null ? void 0 : V.value;
      u(I), f("country", I);
    }
  }, [c, f, r == null ? void 0 : r.country]);
  const { t: y } = O(["account", "common"], {
    nsMode: "fallback"
  }), w = b("licensePlate");
  B(() => {
    const V = Object.keys(N)[0];
    V && p.current[V] && h({
      current: p.current[V]
    });
  }, [N, h]);
  const z = async (V) => {
    var U;
    const { country: I, licensePlate: _ } = V;
    if (d(!0), !V.isASFINAG && !V.isTollCollect && !V.isAUTOPASS && !V.isGNSS) {
      S("root.enableCountries", {
        type: "manual",
        message: y("form.validations.enableCountries.required")
      }), d(!1);
      return;
    }
    const ne = (re = {}) => {
      n({
        ...V,
        ...re,
        //This is to let the next form step know which fields come from bilvision
        bilvisionFields: Object.keys(re),
        //This is to let the next form step know which weights to accept in validation
        weightInterval: l,
        showExtendedForm: l !== $e.Under3500kg,
        isASFINAG: V.isGNSS ? !0 : V.isASFINAG
      }), s(2);
    }, K = ["NO", "DK", "SE"];
    try {
      if (K.includes(I)) {
        const re = Ni(_), ie = await a(
          "vehicle-info",
          `countryCode=${I}&regNo=${re}`
        );
        if (!Ti(
          (ie == null ? void 0 : ie.grossWeight) || "0",
          l,
          Pi
        ))
          throw new Error("Invalid weight", { cause: "invalid_weight" });
        ne(ie);
      } else
        ne();
    } catch (re) {
      re.cause === "invalid_weight" ? (S("licensePlate", {
        type: "manual",
        message: y("form.validations.weight.invalid")
      }), h({ current: (U = p.current) == null ? void 0 : U.vehicleType })) : ne();
    } finally {
      d(!1);
    }
  };
  B(() => {
    v("licensePlate");
  }, [w, v]);
  const C = (V, I) => {
    v(V), f(V, I);
  }, E = o.lastIndexOf("/"), A = o.substring(0, E);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("h2", { className: "mb-7 text-2xl font-semibold", children: y("singleOrderBizzFlow.order.basicVehicleInfo.title") }),
    /* @__PURE__ */ e.jsx("p", { className: "mb-10", children: y("singleOrderBizzFlow.order.basicVehicleInfo.description") }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-4", children: [
      /* @__PURE__ */ e.jsx(Pr, { className: "h-8 w-8" }),
      /* @__PURE__ */ e.jsx("span", { className: "block font-semibold uppercase text-neutral-600", children: y("singleOrderBizzFlow.order.basicVehicleInfo.bizz") })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "mb-7 flex gap-2", children: [
      /* @__PURE__ */ e.jsx("p", { className: "text-2xl font-semibold", children: t.serialNo }),
      /* @__PURE__ */ e.jsx(wn, { status: "open" })
    ] }),
    /* @__PURE__ */ e.jsx("legend", { className: "block text-sm font-medium text-neutral-950", children: y("singleOrderBizzFlow.order.basicVehicleInfo.currentLPN") }),
    /* @__PURE__ */ e.jsx("p", { children: t.registrationNo }),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: g(z), className: "mt-8 w-full ", children: [
      /* @__PURE__ */ e.jsx(Yn, { children: /* @__PURE__ */ e.jsxs("fieldset", { className: "flex flex-row", children: [
        /* @__PURE__ */ e.jsx("legend", { className: "block text-sm font-medium text-neutral-950", children: y("form.labels.licensePlate") }),
        /* @__PURE__ */ e.jsx(
          nt,
          {
            ...x("country", {
              required: y("form.validations.vehicleCountry.required")
            }),
            initialValue: m,
            options: c == null ? void 0 : c.map(({ value: V }) => ({
              label: V,
              value: V
            })),
            classNames: {
              button: "border-r-0 rounded-r-none w-20",
              dropdown: "overflow-x-hidden"
            },
            error: (F = N.country) != null && F.message ? y(`${(R = N.country) == null ? void 0 : R.message}`) : void 0,
            onChange: (V) => C("country", V)
          }
        ),
        /* @__PURE__ */ e.jsx(
          qe,
          {
            ...x("licensePlate"),
            ref: (V) => p.current.licensePlate = V,
            classNames: { wrapper: "w-full", input: "rounded-l-none" },
            icon: /* @__PURE__ */ e.jsx(Dn, { className: "h-4 w-4" }),
            error: (T = N.licensePlate) != null && T.message ? y(`${(P = N.licensePlate) == null ? void 0 : P.message}`) : void 0,
            defaultValue: r.licensePlate ? r.licensePlate : "",
            onChange: (V) => {
              var I, _;
              C(
                "licensePlate",
                (_ = (I = V == null ? void 0 : V.target) == null ? void 0 : I.value) == null ? void 0 : _.toUpperCase()
              );
            }
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
      /* @__PURE__ */ e.jsxs("div", { className: "my-4 flex items-center gap-4", children: [
        /* @__PURE__ */ e.jsx(
          ys,
          {
            href: A,
            className: "ml-auto pr-4 font-medium text-blue-700 underline",
            children: y("action.cancel")
          }
        ),
        /* @__PURE__ */ e.jsx(
          De,
          {
            as: "button",
            type: "submit",
            loadingLabel: y("action.loading"),
            isLoading: i,
            children: y("action.next")
          }
        )
      ] })
    ] })
  ] });
}, xp = ({ title: t, value: s }) => /* @__PURE__ */ e.jsxs("div", { children: [
  /* @__PURE__ */ e.jsx("h2", { className: "text-sm ", children: t }),
  /* @__PURE__ */ e.jsx("p", { className: "break-words pt-1 font-medium capitalize text-neutral-950", children: s })
] }), $s = ({ heading: t, subHeading: s, vehicleInfo: n, className: r }) => {
  const a = Math.ceil(n.length / 3);
  return /* @__PURE__ */ e.jsxs("div", { className: r, children: [
    /* @__PURE__ */ e.jsx("h1", { className: "mb-2 text-2xl font-medium", children: t }),
    /* @__PURE__ */ e.jsx("p", { className: "mb-4 text-base font-normal text-neutral-800 ", children: s }),
    /* @__PURE__ */ e.jsx(
      "div",
      {
        className: "grid grid-cols-1 gap-6 rounded-lg bg-neutral-50 p-6 sm:grid-cols-2 md:grid-cols-3",
        style: { gridTemplateRows: `repeat(${a}, minmax(0, 1fr))` },
        children: n.map((o, i) => /* @__PURE__ */ e.jsx(
          xp,
          {
            title: o.title,
            value: o.value,
            className: o.className
          },
          i
        ))
      }
    )
  ] });
}, Fe = ({
  children: t,
  field: s,
  hideUnlessHGV: n
}) => {
  const { formData: r } = Pt(), a = !r.showExtendedForm && n, o = r.bilvisionFields.includes(s ?? "") || a;
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: !o && t });
}, Si = (t) => /* @__PURE__ */ e.jsxs("div", { children: [
  t.label && /* @__PURE__ */ e.jsx("legend", { children: t.label }),
  /* @__PURE__ */ e.jsx("div", { className: "flex flex-col gap-4", children: t.children })
] }), Mn = (t) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: `ring-primary-600 rounded-lg border-2 p-4 focus-within:ring hover:ring ${t.disabled && "opacity-32 pointer-events-none"}`,
    "aria-disabled": t.disabled,
    children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
        /* @__PURE__ */ e.jsx(
          ea,
          {
            className: "mt-3",
            onChange: t.onChange,
            checked: t.checked,
            id: t.keyValue,
            disabled: t.disabled,
            name: t.name,
            value: t.value
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3 pt-2", children: [
          /* @__PURE__ */ e.jsx("label", { htmlFor: t.keyValue, className: "text-3xl font-bold", children: t.label }),
          /* @__PURE__ */ e.jsx("p", { children: t.description ?? "" })
        ] })
      ] }),
      t.checked && t.children
    ]
  }
);
var gp = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, bp = function(s, n, r) {
  var a, o = gp[s];
  return typeof o == "string" ? a = o : n === 1 ? a = o.one : a = o.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + a : a + " siden" : a;
}, vp = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, yp = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, jp = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Cp = {
  date: rt({
    formats: vp,
    defaultWidth: "full"
  }),
  time: rt({
    formats: yp,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: jp,
    defaultWidth: "full"
  })
}, Np = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, wp = function(s, n, r, a) {
  return Np[s];
}, kp = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, Pp = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Tp = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
}, Sp = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, Mp = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, zp = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, Ap = function(s, n) {
  var r = Number(s);
  return r + ".";
}, Op = {
  ordinalNumber: Ap,
  era: _e({
    values: kp,
    defaultWidth: "wide"
  }),
  quarter: _e({
    values: Pp,
    defaultWidth: "wide",
    argumentCallback: function(s) {
      return s - 1;
    }
  }),
  month: _e({
    values: Tp,
    defaultWidth: "wide"
  }),
  day: _e({
    values: Sp,
    defaultWidth: "wide"
  }),
  dayPeriod: _e({
    values: Mp,
    defaultWidth: "wide",
    formattingValues: zp,
    defaultFormattingWidth: "wide"
  })
}, Ep = /^(\d+)(\.)?/i, Dp = /\d+/i, Fp = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, Lp = {
  any: [/^f/i, /^(v|e)/i]
}, Vp = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, Rp = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $p = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, Bp = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Ip = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, _p = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, Wp = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, qp = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, Hp = {
  ordinalNumber: Zn({
    matchPattern: Ep,
    parsePattern: Dp,
    valueCallback: function(s) {
      return parseInt(s, 10);
    }
  }),
  era: We({
    matchPatterns: Fp,
    defaultMatchWidth: "wide",
    parsePatterns: Lp,
    defaultParseWidth: "any"
  }),
  quarter: We({
    matchPatterns: Vp,
    defaultMatchWidth: "wide",
    parsePatterns: Rp,
    defaultParseWidth: "any",
    valueCallback: function(s) {
      return s + 1;
    }
  }),
  month: We({
    matchPatterns: $p,
    defaultMatchWidth: "wide",
    parsePatterns: Bp,
    defaultParseWidth: "any"
  }),
  day: We({
    matchPatterns: Ip,
    defaultMatchWidth: "wide",
    parsePatterns: _p,
    defaultParseWidth: "any"
  }),
  dayPeriod: We({
    matchPatterns: Wp,
    defaultMatchWidth: "any",
    parsePatterns: qp,
    defaultParseWidth: "any"
  })
}, Up = {
  code: "da",
  formatDistance: bp,
  formatLong: Cp,
  formatRelative: wp,
  localize: Op,
  match: Hp,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ba = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, Gp = function(s, n, r) {
  var a, o = r != null && r.addSuffix ? Ba[s].withPreposition : Ba[s].standalone;
  return typeof o == "string" ? a = o : n === 1 ? a = o.one : a = o.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : "vor " + a : a;
}, Kp = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, Zp = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Yp = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Qp = {
  date: rt({
    formats: Kp,
    defaultWidth: "full"
  }),
  time: rt({
    formats: Zp,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: Yp,
    defaultWidth: "full"
  })
}, Xp = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, Jp = function(s, n, r, a) {
  return Xp[s];
}, ef = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, tf = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, xr = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, sf = {
  narrow: xr.narrow,
  abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: xr.wide
}, nf = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, rf = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, af = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, of = function(s) {
  var n = Number(s);
  return n + ".";
}, lf = {
  ordinalNumber: of,
  era: _e({
    values: ef,
    defaultWidth: "wide"
  }),
  quarter: _e({
    values: tf,
    defaultWidth: "wide",
    argumentCallback: function(s) {
      return s - 1;
    }
  }),
  month: _e({
    values: xr,
    formattingValues: sf,
    defaultWidth: "wide"
  }),
  day: _e({
    values: nf,
    defaultWidth: "wide"
  }),
  dayPeriod: _e({
    values: rf,
    defaultWidth: "wide",
    formattingValues: af,
    defaultFormattingWidth: "wide"
  })
}, cf = /^(\d+)(\.)?/i, df = /\d+/i, mf = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, uf = {
  any: [/^v/i, /^n/i]
}, hf = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, pf = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ff = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, xf = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, gf = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, bf = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, vf = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, yf = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, jf = {
  ordinalNumber: Zn({
    matchPattern: cf,
    parsePattern: df,
    valueCallback: function(s) {
      return parseInt(s);
    }
  }),
  era: We({
    matchPatterns: mf,
    defaultMatchWidth: "wide",
    parsePatterns: uf,
    defaultParseWidth: "any"
  }),
  quarter: We({
    matchPatterns: hf,
    defaultMatchWidth: "wide",
    parsePatterns: pf,
    defaultParseWidth: "any",
    valueCallback: function(s) {
      return s + 1;
    }
  }),
  month: We({
    matchPatterns: ff,
    defaultMatchWidth: "wide",
    parsePatterns: xf,
    defaultParseWidth: "any"
  }),
  day: We({
    matchPatterns: gf,
    defaultMatchWidth: "wide",
    parsePatterns: bf,
    defaultParseWidth: "any"
  }),
  dayPeriod: We({
    matchPatterns: vf,
    defaultMatchWidth: "wide",
    parsePatterns: yf,
    defaultParseWidth: "any"
  })
}, Cf = {
  code: "de",
  formatDistance: Gp,
  formatLong: Qp,
  formatRelative: Jp,
  localize: lf,
  match: jf,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Nf = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, wf = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, kf = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Pf = {
  date: rt({
    formats: Nf,
    defaultWidth: "full"
  }),
  time: rt({
    formats: wf,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: kf,
    defaultWidth: "full"
  })
}, Ia = {
  code: "en-GB",
  formatDistance: xi,
  formatLong: Pf,
  formatRelative: gi,
  localize: bi,
  match: vi,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Tf = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, Sf = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], Mf = function(s, n, r) {
  var a, o = Tf[s];
  return typeof o == "string" ? a = o : n === 1 ? a = o.one : r && r.onlyNumeric ? a = o.other.replace("{{count}}", String(n)) : a = o.other.replace("{{count}}", n < 13 ? Sf[n] : String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + a : a + " sedan" : a;
}, zf = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, Af = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Of = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Ef = {
  date: rt({
    formats: zf,
    defaultWidth: "full"
  }),
  time: rt({
    formats: Af,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: Of,
    defaultWidth: "full"
  })
}, Df = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, Ff = function(s, n, r, a) {
  return Df[s];
}, Lf = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, Vf = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, Rf = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
}, $f = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, Bf = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, If = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, _f = function(s, n) {
  var r = Number(s), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
      case 2:
        return r + ":a";
    }
  return r + ":e";
}, Wf = {
  ordinalNumber: _f,
  era: _e({
    values: Lf,
    defaultWidth: "wide"
  }),
  quarter: _e({
    values: Vf,
    defaultWidth: "wide",
    argumentCallback: function(s) {
      return s - 1;
    }
  }),
  month: _e({
    values: Rf,
    defaultWidth: "wide"
  }),
  day: _e({
    values: $f,
    defaultWidth: "wide"
  }),
  dayPeriod: _e({
    values: Bf,
    defaultWidth: "wide",
    formattingValues: If,
    defaultFormattingWidth: "wide"
  })
}, qf = /^(\d+)(:a|:e)?/i, Hf = /\d+/i, Uf = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, Gf = {
  any: [/^f/i, /^[ev]/i]
}, Kf = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, Zf = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Yf = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, Qf = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Xf = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, Jf = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, e2 = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, t2 = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, s2 = {
  ordinalNumber: Zn({
    matchPattern: qf,
    parsePattern: Hf,
    valueCallback: function(s) {
      return parseInt(s, 10);
    }
  }),
  era: We({
    matchPatterns: Uf,
    defaultMatchWidth: "wide",
    parsePatterns: Gf,
    defaultParseWidth: "any"
  }),
  quarter: We({
    matchPatterns: Kf,
    defaultMatchWidth: "wide",
    parsePatterns: Zf,
    defaultParseWidth: "any",
    valueCallback: function(s) {
      return s + 1;
    }
  }),
  month: We({
    matchPatterns: Yf,
    defaultMatchWidth: "wide",
    parsePatterns: Qf,
    defaultParseWidth: "any"
  }),
  day: We({
    matchPatterns: Xf,
    defaultMatchWidth: "wide",
    parsePatterns: Jf,
    defaultParseWidth: "any"
  }),
  dayPeriod: We({
    matchPatterns: e2,
    defaultMatchWidth: "any",
    parsePatterns: t2,
    defaultParseWidth: "any"
  })
}, n2 = {
  code: "sv",
  formatDistance: Mf,
  formatLong: Ef,
  formatRelative: Ff,
  localize: Wf,
  match: s2,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Mi = ({
  label: t,
  required: s,
  value: n,
  setStartDate: r,
  error: a
}) => {
  const [o, i] = M(n), [d, l] = M(Ia), [c, m] = M(!1), u = Ae(null), { locale: h } = se(), p = (g) => {
    g && (i(g), r(g), m(!1));
  }, f = () => {
    m(!c);
  };
  return B(() => {
    l({
      sv: n2,
      da: Up,
      en: Ia,
      de: Cf
    }[h || "en"]);
  }, [h]), B(() => {
    const g = (N) => {
      u.current && !u.current.contains(N.target) && m(!1);
    };
    return c ? document.addEventListener("mouseup", g) : document.removeEventListener("mouseup", g), () => {
      document.removeEventListener("mouseup", g);
    };
  }, [c]), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("style", { children: `
    .rdp {
      --rdp-background-color: var(--colors-blue-200);
      --rdp-accent-color: var(--colors-blue-600);
      --rdp-cell-size: 45px;
    }
  ` }),
    /* @__PURE__ */ e.jsxs("div", { className: "relative w-80", children: [
      /* @__PURE__ */ e.jsx(
        qe,
        {
          label: t,
          defaultValue: o ? Lt(o, "yyyy-MM-dd") : "",
          readOnly: !0,
          onClick: f,
          required: s,
          error: a
        }
      ),
      /* @__PURE__ */ e.jsx(
        "button",
        {
          onClick: (g) => {
            g.preventDefault(), f();
          },
          className: "absolute right-3 top-11",
          children: /* @__PURE__ */ e.jsx(ql, { width: 16, height: 16 })
        }
      )
    ] }),
    c && /* @__PURE__ */ e.jsx(
      "div",
      {
        ref: u,
        style: {
          position: "absolute",
          zIndex: 1,
          background: "white",
          border: "1px solid #ddd",
          marginTop: "85px"
        },
        children: /* @__PURE__ */ e.jsx(
          _c,
          {
            id: "datepicker",
            numberOfMonths: 1,
            mode: "single",
            selected: o,
            onSelect: p,
            captionLayout: "dropdown",
            showOutsideDays: !0,
            fromDate: wc(/* @__PURE__ */ new Date(), 50),
            toDate: /* @__PURE__ */ new Date(),
            locale: d,
            required: !0,
            modifiersClassNames: {
              day: "!text-red-600",
              range_middle: "!bg-primary-600 !rounded-none !text-white !rounded-r-none",
              range_start: "!bg-primary-600 !rounded-l-sm !text-white !rounded-r-none",
              range_end: "!bg-primary-600 !rounded-r-sm !text-white !rounded-l-none"
            }
          }
        )
      }
    )
  ] });
}, zn = ({
  buffer: t,
  setBuffer: s,
  dataType: n,
  showError: r,
  clearErrors: a
}) => {
  const { t: o } = O(["account", "common"], {
    nsMode: "fallback"
  }), [i, d] = M(
    t ? {
      name: t == null ? void 0 : t.name,
      selectedFile: t
    } : null
  ), l = Ae(null), c = (u) => {
    var p;
    const h = (p = u.target.files) == null ? void 0 : p[0];
    h && (s(h), a(), d({ name: h.name, selectedFile: h }));
  }, m = () => {
    d(null), s(void 0), a(), l.current && (l.current.value = "");
  };
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsx("div", { children: o(`kmtoll.order.${n}.documentUpload`) }),
    /* @__PURE__ */ e.jsx("div", { className: "max-w-fit", children: /* @__PURE__ */ e.jsxs(
      De,
      {
        as: "button",
        loadingLabel: o("action.loading"),
        className: "mt-4 rounded",
        intent: "outlined",
        onClick: () => {
          var u;
          return (u = l.current) == null ? void 0 : u.click();
        },
        children: [
          /* @__PURE__ */ e.jsx(
            "input",
            {
              type: "file",
              accept: "application/pdf",
              id: "fileInput",
              ref: l,
              className: "hidden",
              onChange: c
            }
          ),
          /* @__PURE__ */ e.jsxs("span", { className: "flex items-center", children: [
            /* @__PURE__ */ e.jsx(Hl, { className: "mr-2" }),
            o(`kmtoll.order.${n}.documentUploadButton`)
          ] })
        ]
      }
    ) }),
    i && /* @__PURE__ */ e.jsxs("div", { className: "mt-6 flex items-center", children: [
      /* @__PURE__ */ e.jsx(Ul, { className: "mr-2 cursor-pointer", onClick: m }),
      i.name
    ] }),
    r && /* @__PURE__ */ e.jsx(Ys, { as: "div", id: "fileError", error: r })
  ] });
}, zi = ({
  licensePlate: t,
  country: s,
  className: n
}) => /* @__PURE__ */ e.jsx("div", { className: n, children: /* @__PURE__ */ e.jsxs("div", { className: "border-licensePlateBlue flex w-fit items-center rounded-md border-4 ", children: [
  /* @__PURE__ */ e.jsx("div", { className: "bg-licensePlateBlue px-1 py-2 text-2xl font-medium text-white", children: s }),
  /* @__PURE__ */ e.jsx("div", { className: "font-licensePlate px-2 text-3xl", children: /* @__PURE__ */ e.jsx("h1", { children: t }) })
] }) }), r2 = 1048576, a2 = r2 * 10, o2 = [
  "firstRegistrationDate",
  "grossWeight",
  "vinNo",
  "numberOfAxels",
  "fuelType",
  "euroEmissionNorm",
  "co2EmissionClass"
], i2 = ["fuelType", "euroEmissionNorm"], l2 = () => {
  var It, xt, gt, Dt, oe, be, we, et, Ge, Tt, Qe, tt;
  const { t } = O(["account", "common"], {
    nsMode: "fallback"
  }), s = pt(), n = !!(s != null && s.get("toll-collect")), { formData: r, updateFormData: a, updateStep: o } = Pt(), [i, d] = M(!1), { fuelTypes: l, fuelTypeHybridIDs: c, emissionClasses: m, co2EmissionClasses: u } = wt(), { co2VehicleSubgroups: h } = Jr(), {
    register: p,
    handleSubmit: f,
    setValue: x,
    formState: { errors: g },
    watch: N,
    clearErrors: b
  } = ws({
    defaultValues: {
      ...r,
      fuelTypeId: (It = r.fuelTypeId) == null ? void 0 : It.toString(),
      grossWeight: ((xt = r == null ? void 0 : r.grossWeight) == null ? void 0 : xt.toString()) || "",
      co2EmissionClass: (r == null ? void 0 : r.co2EmissionClass) ?? Vs,
      co2VehicleGroup: (r == null ? void 0 : r.co2VehicleGroup) ?? Ie.Empty
    },
    resolver: _s(
      r.showExtendedForm ? (
        // Use extended parser (tollCollectVehicleInfoHGVParserWithOptionalVinNo) if flagAllowTollCollect false
        n ? lo : co
      ) : mo
    )
  }), [v, S] = M(
    ((gt = r == null ? void 0 : r.co2EmissionClass) == null ? void 0 : gt.toString()) ?? "1"
  ), y = N("co2EmissionClass"), w = N("fuelTypeId"), z = N("numberOfAxels"), C = N("co2VehicleGroup"), [E, A] = M(
    r != null && r.firstRegistrationDate ? new Date(r.firstRegistrationDate) : void 0
  ), [F, R] = M(!1), [T, P] = M(
    r.vehicleInfoFile
  ), V = !(r.bilvisionFields.length > 0) && !!r.showExtendedForm, [I, _] = M(
    void 0
  ), [ne, K] = M(
    r.co2File
  ), [U, re] = M(void 0), ie = y !== Vs && !!r.showExtendedForm, le = D(() => {
    const J = w || r.fuelTypeId;
    if (J && (l == null ? void 0 : l.length) > 0) {
      const H = l.find(
        (Se) => Se.value === J
      );
      return H == null ? void 0 : H.tariffClassification;
    }
    return "";
  }, [w, r.fuelTypeId, l]), me = D(() => z === "2" ? [
    { label: Ie.Four, value: Ie.Four },
    { label: Ie.Five, value: Ie.Five }
  ] : z !== "" ? [
    { label: Ie.Nine, value: Ie.Nine },
    { label: Ie.Ten, value: Ie.Ten }
  ] : [], [z]);
  B(() => {
    x("co2VehicleGroup", Ie.Empty);
  }, [z, x]), B(() => {
    x("co2VehicleSubgroup", uo.Empty);
  }, [C, x]);
  const ce = D(() => l.find((J) => J.value === w), [w, l]), q = ie && V && ne && T && (ne == null ? void 0 : ne.size) === (T == null ? void 0 : T.size), de = E && E < Nn, ae = async (J) => {
    _(void 0), re(void 0), d(!0);
    const H = ["application/pdf"], Se = (bt, St, Zt, xs) => {
      if (Zt && !St)
        throw bt(
          t(
            "singleOrderBizzFlow.order.additionalVehicleData.vehicleInfo.documentError"
          )
        ), "Document is missing: " + xs;
      if (T != null && T.size && T.size > a2)
        throw bt(
          t("form.validations.fileUpload.invalidSize", {
            maxSize: "10 MB"
          })
        ), "Invalid size: " + xs;
      if (St && !H.includes(St.type))
        throw bt(t("form.validations.invalidFileType")), "Wrong file type: " + xs;
    };
    try {
      if (r.showExtendedForm && (Se(re, ne, ie, "Co2"), Se(
        _,
        T,
        V,
        "VehicleInfo"
      )), q) {
        d(!1);
        return;
      }
      const bt = r.isHybrid !== void 0 ? !!r.isHybrid : c.includes(J.fuelTypeId);
      a({
        ...J,
        tariffClassification: le,
        isHybrid: bt,
        type: "bizz",
        co2File: ne,
        vehicleInfoFile: T,
        fuelType: (r == null ? void 0 : r.bilvisionFields).length > 0 && (r == null ? void 0 : r.bilvisionFields).includes("fuelType") ? J == null ? void 0 : J.fuelType : ce ?? ""
      }), o(3), d(!1);
    } catch {
      d(!1);
    }
  }, je = (J) => {
    J && J < Nn ? (S(Ne.Class_1), pe("co2EmissionClass", Vs), R(!0)) : R(!1), Ve(), pe("firstRegistrationDate", J.toString()), A(J);
  }, pe = (J, H) => {
    Ve(), x(J, H), a({
      [J]: H
    });
  }, Ve = () => {
    b(), re(void 0), _(void 0);
  }, ft = (J) => {
    J === Ne.Class_1 ? (pe("co2EmissionClass", J), S(Ne.Class_1)) : J === Ne.Class_2 && (pe("co2EmissionClass", J), S(Ne.Class_2));
  }, os = (J) => {
    try {
      return Lt(new Date(J), "yyyy-MM-dd");
    } catch {
      return J;
    }
  };
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-8", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t("singleOrderBizzFlow.order.additionalVehicleData.title") }),
    /* @__PURE__ */ e.jsx(
      zi,
      {
        licensePlate: r.licensePlate,
        country: r.country
      }
    ),
    r.bilvisionFields.length > 0 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(ze, { colorMode: "success", className: "mt-10", children: t(
        "singleOrderBizzFlow.order.userFeedback.success.vehicleInfoFromBilVision"
      ) }),
      /* @__PURE__ */ e.jsx(
        $s,
        {
          heading: t("singleOrderBizzFlow.order.summary.vehicleInfo.title"),
          vehicleInfo: r.bilvisionFields.filter(
            (J) => r.showExtendedForm ? o2.includes(J) : i2.includes(J)
          ).map((J) => {
            const H = r[J];
            return {
              title: t(`form.labels.${J}`),
              value: J === "firstRegistrationDate" ? os(H) : H
            };
          })
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: f(ae), className: "w-full", children: [
      /* @__PURE__ */ e.jsxs(Yn, { allowFull: !0, children: [
        /* @__PURE__ */ e.jsx(
          Fe,
          {
            field: "firstRegistrationDate",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsx(
              Mi,
              {
                label: t("form.labels.stateDateForRegistry"),
                required: !0,
                value: E,
                setStartDate: je,
                error: g.firstRegistrationDate ? t("form.datePicker.reqiured") : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(Fe, { field: "vinNo", hideUnlessHGV: !0, children: n && /* @__PURE__ */ e.jsx(
          qe,
          {
            ...p("vinNo"),
            label: `${t("form.labels.vinNo")}`,
            name: "vinNo",
            type: "string",
            className: "w-80",
            required: !0,
            error: g.vinNo ? t("form.validations.vinNo.length") : void 0,
            onChange: (J) => pe("vinNo", J.target.value)
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          Fe,
          {
            field: "grossWeight",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsx(
              qe,
              {
                ...p("grossWeight"),
                label: `${t("form.labels.vehicleGrossWeight")}`,
                name: "grossWeight",
                required: !0,
                type: "number",
                className: "w-80",
                error: (Dt = g.grossWeight) != null && Dt.message ? t((oe = g.grossWeight) == null ? void 0 : oe.message) : void 0,
                onChange: (J) => pe("grossWeight", J.target.value)
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(Fe, { field: "fuelTypeId", children: /* @__PURE__ */ e.jsx(
          nt,
          {
            ...p("fuelTypeId"),
            label: `${t("form.labels.fuelType")}`,
            required: !0,
            placeholder: t("form.placeholders.fuelType"),
            options: l.sort(
              (J, H) => J.label.localeCompare(H.label)
            ),
            className: "w-80",
            initialValue: w,
            error: (be = g.fuelTypeId) != null && be.message ? t("form.validations.fuelType.required") : void 0,
            onChange: (J) => pe("fuelTypeId", J)
          }
        ) }),
        F && /* @__PURE__ */ e.jsx(ze, { colorMode: "information", className: "mt-8", children: t(
          "singleOrderBizzFlow.order.additionalVehicleData.vehicleInfo.co2EmissionClass"
        ) }),
        /* @__PURE__ */ e.jsx(Fe, { field: "euroEmissionNorm", children: /* @__PURE__ */ e.jsx(
          nt,
          {
            ...p("euroEmissionNorm"),
            label: `${t("form.labels.euroEmissionNorm")}`,
            required: !0,
            placeholder: t("form.placeholders.euroEmissionNorm"),
            options: m,
            className: "w-80",
            initialValue: r.euroEmissionNorm ?? void 0,
            error: (we = g.euroEmissionNorm) != null && we.message ? t("form.validations.euroEmissionNorm.required") : void 0,
            onChange: (J) => pe("euroEmissionNorm", J)
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          Fe,
          {
            field: "numberOfAxels",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsxs("div", { className: "w-80", children: [
              /* @__PURE__ */ e.jsx(
                Ft.Root,
                {
                  className: "block gap-0 text-sm font-medium text-neutral-950",
                  name: "numberOfAxels",
                  onChange: (J) => pe("numberOfAxels", J.target.value),
                  label: `${t("form.labels.numberOfAxels")}`,
                  required: !0,
                  value: z,
                  children: go.map(({ label: J, value: H }) => /* @__PURE__ */ e.jsx(
                    Ft.Item,
                    {
                      label: J,
                      value: H,
                      className: "mx-[-0.5rem]"
                    },
                    J + H
                  ))
                }
              ),
              /* @__PURE__ */ e.jsx(
                Ys,
                {
                  id: "numberOfAxels",
                  as: "div",
                  error: (et = g.numberOfAxels) != null && et.message ? t("form.validations.numberOfAxels.required") : void 0,
                  className: "w-80"
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ e.jsx(Fe, { hideUnlessHGV: !0, children: /* @__PURE__ */ e.jsx(Si, { children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            Mn,
            {
              label: t("form.labels.co2Class1"),
              value: Ne.Class_1,
              keyValue: `CO2 class ${Ne.Class_1} ${Ne.Class_1}`,
              name: "co2Overview",
              checked: v === Ne.Class_1,
              onChange: (J) => {
                ft(J.target.value);
              }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Mn,
            {
              label: t("form.labels.co2Class2_5"),
              description: t("form.descriptions.co2Class2_5"),
              value: Ne.Class_2,
              keyValue: `CO2 class ${Ne.Class_2}, ${Ne.Class_3}, ${Ne.Class_4}, or ${Ne.Class_5} ${Ne.Class_2}+`,
              name: "co2Overview",
              disabled: de,
              checked: !!v && +v > +Ne.Class_1,
              onChange: (J) => {
                ft(J.target.value);
              },
              children: /* @__PURE__ */ e.jsxs("div", { className: "mt-14 flex flex-col gap-10 px-10", children: [
                /* @__PURE__ */ e.jsx(
                  Fe,
                  {
                    field: "co2EmissionClass",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsxs("div", { className: "w-80", children: [
                      /* @__PURE__ */ e.jsx(
                        Ft.Root,
                        {
                          className: "block gap-0 text-sm font-medium text-neutral-950",
                          name: "co2EmissionClass",
                          onChange: (J) => pe(
                            "co2EmissionClass",
                            J.target.value
                          ),
                          label: `${t("form.placeholders.co2EmissionClass")}`,
                          value: y,
                          required: !0,
                          children: u.slice(1).map(({ label: J, value: H }) => /* @__PURE__ */ e.jsx(
                            Ft.Item,
                            {
                              label: J,
                              value: H,
                              disabled: de,
                              className: "mx-[-0.5rem]"
                            },
                            J + H
                          ))
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        Ys,
                        {
                          id: "co2EmissionClass",
                          as: "div",
                          error: y ? void 0 : t(
                            "form.validations.co2EmissionClass.required"
                          ),
                          className: "w-80"
                        }
                      )
                    ] })
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Fe,
                  {
                    field: "specificCo2Emissions",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      qe,
                      {
                        ...p("specificCo2Emissions"),
                        label: `${t("form.labels.specificCo2Emissions")}`,
                        description: `${t(
                          "form.descriptions.specificCo2Emissions"
                        )}`,
                        name: "specificCo2Emissions",
                        type: "string",
                        className: "w-80",
                        required: ie,
                        disabled: !ie,
                        error: g.specificCo2Emissions ? t(
                          "form.validations.specificCo2Emissions.required"
                        ) : void 0,
                        onChange: (J) => pe(
                          "specificCo2Emissions",
                          J.target.value
                        )
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Fe,
                  {
                    field: "co2VehicleGroup",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      nt,
                      {
                        ...p("co2VehicleGroup"),
                        label: `${t("form.labels.co2VehicleGroup")}`,
                        required: ie,
                        disabled: !ie,
                        placeholder: t("form.placeholders.co2VehicleGroup"),
                        options: me,
                        className: "w-80",
                        resetValueOnOptionsChange: !0,
                        initialValue: r.co2VehicleGroup ?? void 0,
                        error: (Ge = g.co2VehicleGroup) != null && Ge.message ? t((Tt = g.co2VehicleGroup) == null ? void 0 : Tt.message) : void 0,
                        onChange: (J) => pe("co2VehicleGroup", J)
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Fe,
                  {
                    field: "co2VehicleSubgroup",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      nt,
                      {
                        ...p("co2VehicleSubgroup"),
                        label: `${t("form.labels.co2VehicleSubgroup")}`,
                        required: ie,
                        disabled: !ie || !C,
                        placeholder: t(
                          "form.placeholders.co2VehicleSubgroup"
                        ),
                        options: (h == null ? void 0 : h[C]) ?? [],
                        className: "w-80",
                        resetValueOnOptionsChange: !0,
                        initialValue: r.co2VehicleSubgroup ?? void 0,
                        error: (Qe = g.co2VehicleSubgroup) != null && Qe.message ? t((tt = g.co2VehicleSubgroup) == null ? void 0 : tt.message) : void 0,
                        onChange: (J) => pe("co2VehicleSubgroup", J)
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsxs("div", { children: [
                  /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t(
                    "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.title"
                  ) }),
                  /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: t(
                    "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.accpetedFormats"
                  ) })
                ] }),
                /* @__PURE__ */ e.jsx(
                  zn,
                  {
                    buffer: r.co2File,
                    setBuffer: K,
                    showError: U,
                    dataType: "co2",
                    clearErrors: Ve
                  }
                )
              ] })
            }
          )
        ] }) }) }),
        V && /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t(
            "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.title"
          ) }),
          /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: t(
            "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.accpetedFormats"
          ) })
        ] }),
        V && /* @__PURE__ */ e.jsx(
          zn,
          {
            buffer: r.vehicleInfoFile,
            setBuffer: P,
            showError: I,
            dataType: "vehicleInfo",
            clearErrors: Ve
          }
        ),
        q && /* @__PURE__ */ e.jsx(ze, { colorMode: "error", children: t("kmtoll.order.vehicleInfo.sameDocumentError") })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
        /* @__PURE__ */ e.jsxs("div", { className: "mb-4 mt-8 flex items-center gap-4", children: [
          /* @__PURE__ */ e.jsx(
            X,
            {
              as: "button",
              intent: "outlined",
              onClick: () => o((J) => J - 1),
              children: t("action.back")
            }
          ),
          /* @__PURE__ */ e.jsx(
            En,
            {
              href: "/account/vehicles",
              className: "ml-auto pr-4 font-medium text-blue-700 underline",
              children: t("action.cancel")
            }
          ),
          /* @__PURE__ */ e.jsx(
            De,
            {
              as: "button",
              type: "submit",
              loadingLabel: t("action.loading"),
              isLoading: i,
              children: t("action.next")
            }
          )
        ] })
      ] })
    ] })
  ] }) });
}, c2 = 1048576, d2 = c2 * 10, m2 = [
  "firstRegistrationDate",
  "grossWeight",
  "vinNo",
  "numberOfAxels",
  "fuelType",
  "euroEmissionNorm",
  "co2EmissionClass"
], u2 = ["fuelType", "euroEmissionNorm"], h2 = () => {
  var It, xt, gt, Dt, oe, be, we, et, Ge, Tt, Qe, tt, J;
  const { t } = O(["account", "common"], {
    nsMode: "fallback"
  }), s = pt(), n = !!(s != null && s.get("toll-collect")), { formData: r, updateFormData: a, updateStep: o } = Pt(), [i, d] = M(!1), { fuelTypes: l, fuelTypeHybridIDs: c, emissionClasses: m, co2EmissionClasses: u } = wt(), { co2VehicleSubgroups: h } = Jr(), {
    register: p,
    handleSubmit: f,
    setValue: x,
    formState: { errors: g },
    watch: N,
    clearErrors: b
  } = ws({
    defaultValues: {
      ...r,
      fuelTypeId: (It = r.fuelTypeId) == null ? void 0 : It.toString(),
      grossWeight: ((xt = r == null ? void 0 : r.grossWeight) == null ? void 0 : xt.toString()) || "",
      co2EmissionClass: ((gt = r == null ? void 0 : r.co2EmissionClass) == null ? void 0 : gt.toString()) ?? Vs,
      co2VehicleGroup: (r == null ? void 0 : r.co2VehicleGroup) ?? Ie.Empty
    },
    resolver: _s(
      r.showExtendedForm ? (
        // Use extended parser (tollCollectVehicleInfoHGVParserWithOptionalVinNo) if flagAllowTollCollect false
        n ? lo : co
      ) : mo
    )
  }), [v, S] = M(
    ((Dt = r == null ? void 0 : r.co2EmissionClass) == null ? void 0 : Dt.toString()) ?? "1"
  ), y = N("co2EmissionClass"), w = N("fuelTypeId"), z = N("numberOfAxels"), C = N("co2VehicleGroup"), [E, A] = M(
    r != null && r.firstRegistrationDate ? new Date(r.firstRegistrationDate) : void 0
  ), [F, R] = M(!1), [T, P] = M(
    r.vehicleInfoFile
  ), V = !(r.bilvisionFields.length > 0) && !!r.showExtendedForm, [I, _] = M(
    void 0
  ), [ne, K] = M(
    r.co2File
  ), [U, re] = M(void 0), ie = y !== Vs && !!r.showExtendedForm, le = D(() => {
    const H = w || r.fuelTypeId;
    if (H && (l == null ? void 0 : l.length) > 0) {
      const Se = l.find(
        (bt) => bt.value === H
      );
      return Se == null ? void 0 : Se.tariffClassification;
    }
    return "";
  }, [w, r.fuelTypeId, l]), me = D(() => z === "2" ? [
    { label: Ie.Four, value: Ie.Four },
    { label: Ie.Five, value: Ie.Five }
  ] : z !== "" ? [
    { label: Ie.Nine, value: Ie.Nine },
    { label: Ie.Ten, value: Ie.Ten }
  ] : [], [z]);
  B(() => {
    x("co2VehicleGroup", Ie.Empty);
  }, [z, x]), B(() => {
    x("co2VehicleSubgroup", uo.Empty);
  }, [C, x]);
  const ce = D(() => l.find((H) => H.value === w), [w, l]), q = ie && V && ne && T && (ne == null ? void 0 : ne.size) === (T == null ? void 0 : T.size), de = E && E < Nn, ae = async (H) => {
    _(void 0), re(void 0), d(!0);
    const Se = ["application/pdf"], bt = (St, Zt, xs, qs) => {
      if (xs && !Zt)
        throw St(
          t(
            "singleOrderBizzFlow.order.additionalVehicleData.vehicleInfo.documentError"
          )
        ), "Document is missing: " + qs;
      if (T != null && T.size && T.size > d2)
        throw St(
          t("form.validations.fileUpload.invalidSize", {
            maxSize: "10 MB"
          })
        ), "Invalid size: " + qs;
      if (Zt && !Se.includes(Zt.type))
        throw St(t("form.validations.invalidFileType")), "Wrong file type: " + qs;
    };
    try {
      if (r.showExtendedForm && (bt(re, ne, ie, "Co2"), bt(
        _,
        T,
        V,
        "VehicleInfo"
      )), q) {
        d(!1);
        return;
      }
      const St = r.isHybrid !== void 0 ? !!r.isHybrid : c.includes(H.fuelTypeId);
      a({
        ...H,
        tariffClassification: le,
        isHybrid: St,
        type: "bizz",
        co2File: ne,
        vehicleInfoFile: T,
        fuelType: (r == null ? void 0 : r.bilvisionFields).length > 0 && (r == null ? void 0 : r.bilvisionFields).includes("fuelType") ? H == null ? void 0 : H.fuelType : ce ?? ""
      }), o(3), d(!1);
    } catch {
      d(!1);
    }
  }, je = (H) => {
    H && H < Nn ? (S(Ne.Class_1), pe("co2EmissionClass", Vs), R(!0)) : R(!1), Ve(), pe("firstRegistrationDate", H.toString()), A(H);
  }, pe = (H, Se) => {
    Ve(), x(H, Se), a({
      [H]: Se
    });
  }, Ve = () => {
    b(), re(void 0), _(void 0);
  }, ft = (H) => {
    H === Ne.Class_1 ? (pe("co2EmissionClass", H), S(Ne.Class_1)) : H === Ne.Class_2 && (pe("co2EmissionClass", H), S(Ne.Class_2));
  }, os = (H) => {
    try {
      return Lt(new Date(H), "yyyy-MM-dd");
    } catch {
      return H;
    }
  };
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-8", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t("singleOrderBizzFlow.order.additionalVehicleData.title") }),
    /* @__PURE__ */ e.jsx(
      zi,
      {
        licensePlate: r.licensePlate,
        country: r.country
      }
    ),
    r.bilvisionFields.length > 0 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(ze, { colorMode: "success", className: "mt-10", children: t(
        "singleOrderBizzFlow.order.userFeedback.success.vehicleInfoFromBilVision"
      ) }),
      /* @__PURE__ */ e.jsx(
        $s,
        {
          heading: t("singleOrderBizzFlow.order.summary.vehicleInfo.title"),
          vehicleInfo: r.bilvisionFields.filter(
            (H) => r.showExtendedForm ? m2.includes(H) : u2.includes(H)
          ).map((H) => {
            const Se = r[H];
            return {
              title: t(`form.labels.${H}`),
              value: H === "firstRegistrationDate" ? os(Se) : Se
            };
          })
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: f(ae), className: "w-full", children: [
      /* @__PURE__ */ e.jsxs(Yn, { allowFull: !0, children: [
        /* @__PURE__ */ e.jsx(
          Fe,
          {
            field: "firstRegistrationDate",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsx(
              Mi,
              {
                label: t("form.labels.stateDateForRegistry"),
                required: !0,
                value: E,
                setStartDate: je,
                error: g.firstRegistrationDate ? t("form.datePicker.reqiured") : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(Fe, { field: "vinNo", hideUnlessHGV: !0, children: n && /* @__PURE__ */ e.jsx(
          qe,
          {
            ...p("vinNo"),
            label: `${t("form.labels.vinNo")}`,
            name: "vinNo",
            type: "string",
            className: "w-80",
            required: !0,
            error: g.vinNo ? t("form.validations.vinNo.length") : void 0,
            onChange: (H) => pe("vinNo", H.target.value)
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          Fe,
          {
            field: "grossWeight",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsx(
              qe,
              {
                ...p("grossWeight"),
                label: `${t("form.labels.vehicleGrossWeight")}`,
                name: "grossWeight",
                required: !0,
                type: "number",
                className: "w-80",
                error: (oe = g.grossWeight) != null && oe.message ? t((be = g.grossWeight) == null ? void 0 : be.message) : void 0,
                onChange: (H) => pe("grossWeight", H.target.value)
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(Fe, { field: "fuelTypeId", children: /* @__PURE__ */ e.jsx(
          nt,
          {
            ...p("fuelTypeId"),
            label: `${t("form.labels.fuelType")}`,
            required: !0,
            placeholder: t("form.placeholders.fuelType"),
            options: l.sort(
              (H, Se) => H.label.localeCompare(Se.label)
            ),
            className: "w-80",
            initialValue: w,
            error: (we = g.fuelTypeId) != null && we.message ? t("form.validations.fuelType.required") : void 0,
            onChange: (H) => pe("fuelTypeId", H)
          }
        ) }),
        F && /* @__PURE__ */ e.jsx(ze, { colorMode: "information", className: "mt-8", children: t(
          "singleOrderBizzFlow.order.additionalVehicleData.vehicleInfo.co2EmissionClass"
        ) }),
        /* @__PURE__ */ e.jsx(Fe, { field: "euroEmissionNorm", children: /* @__PURE__ */ e.jsx(
          nt,
          {
            ...p("euroEmissionNorm"),
            label: `${t("form.labels.euroEmissionNorm")}`,
            required: !0,
            placeholder: t("form.placeholders.euroEmissionNorm"),
            options: m,
            className: "w-80",
            initialValue: r.euroEmissionNorm ?? void 0,
            error: (et = g.euroEmissionNorm) != null && et.message ? t("form.validations.euroEmissionNorm.required") : void 0,
            onChange: (H) => pe("euroEmissionNorm", H)
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          Fe,
          {
            field: "numberOfAxels",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsxs("div", { className: "w-80", children: [
              /* @__PURE__ */ e.jsx(
                Ft.Root,
                {
                  className: "block gap-0 text-sm font-medium text-neutral-950",
                  name: "numberOfAxels",
                  onChange: (H) => pe("numberOfAxels", H.target.value),
                  label: `${t("form.labels.numberOfAxels")}`,
                  required: !0,
                  value: z,
                  children: go.map(({ label: H, value: Se }) => /* @__PURE__ */ e.jsx(
                    Ft.Item,
                    {
                      label: H,
                      value: Se,
                      className: "mx-[-0.5rem]"
                    },
                    H + Se
                  ))
                }
              ),
              /* @__PURE__ */ e.jsx(
                Ys,
                {
                  id: "numberOfAxels",
                  as: "div",
                  error: (Ge = g.numberOfAxels) != null && Ge.message ? t("form.validations.numberOfAxels.required") : void 0,
                  className: "w-80"
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ e.jsx(Fe, { hideUnlessHGV: !0, children: /* @__PURE__ */ e.jsx(Si, { children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            Mn,
            {
              label: t("form.labels.co2Class1"),
              value: Ne.Class_1,
              keyValue: `CO2 class ${Ne.Class_1} ${Ne.Class_1}`,
              name: "co2Overview",
              checked: v === Ne.Class_1,
              onChange: (H) => {
                ft(H.target.value);
              }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Mn,
            {
              label: t("form.labels.co2Class2_5"),
              description: t("form.descriptions.co2Class2_5"),
              value: Ne.Class_2,
              keyValue: `CO2 class ${Ne.Class_2}, ${Ne.Class_3}, ${Ne.Class_4}, or ${Ne.Class_5} ${Ne.Class_2}+`,
              name: "co2Overview",
              disabled: de,
              checked: !!v && +v > +Ne.Class_1,
              onChange: (H) => {
                ft(H.target.value);
              },
              children: /* @__PURE__ */ e.jsxs("div", { className: "mt-14 flex flex-col gap-10 px-10", children: [
                /* @__PURE__ */ e.jsx(
                  Fe,
                  {
                    field: "co2EmissionClass",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsxs("div", { className: "w-80", children: [
                      /* @__PURE__ */ e.jsx(
                        Ft.Root,
                        {
                          className: "block gap-0 text-sm font-medium text-neutral-950",
                          name: "co2EmissionClass",
                          onChange: (H) => pe(
                            "co2EmissionClass",
                            H.target.value
                          ),
                          label: `${t("form.placeholders.co2EmissionClass")}`,
                          value: y,
                          required: !0,
                          children: u.slice(1).map(({ label: H, value: Se }) => /* @__PURE__ */ e.jsx(
                            Ft.Item,
                            {
                              label: H,
                              value: Se,
                              disabled: de,
                              className: "mx-[-0.5rem]"
                            },
                            H + Se
                          ))
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        Ys,
                        {
                          id: "co2EmissionClass",
                          as: "div",
                          error: y ? void 0 : t(
                            "form.validations.co2EmissionClass.required"
                          ),
                          className: "w-80"
                        }
                      )
                    ] })
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Fe,
                  {
                    field: "specificCo2Emissions",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      qe,
                      {
                        ...p("specificCo2Emissions"),
                        label: `${t("form.labels.specificCo2Emissions")}`,
                        description: `${t(
                          "form.descriptions.specificCo2Emissions"
                        )}`,
                        name: "specificCo2Emissions",
                        type: "string",
                        className: "w-80",
                        required: ie,
                        disabled: !ie,
                        error: g.specificCo2Emissions ? t(
                          "form.validations.specificCo2Emissions.required"
                        ) : void 0,
                        onChange: (H) => pe(
                          "specificCo2Emissions",
                          H.target.value
                        )
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Fe,
                  {
                    field: "co2VehicleGroup",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      nt,
                      {
                        ...p("co2VehicleGroup"),
                        label: `${t("form.labels.co2VehicleGroup")}`,
                        required: ie,
                        disabled: !ie,
                        placeholder: t("form.placeholders.co2VehicleGroup"),
                        options: me,
                        className: "w-80",
                        resetValueOnOptionsChange: !0,
                        initialValue: r.co2VehicleGroup ?? void 0,
                        error: (Tt = g.co2VehicleGroup) != null && Tt.message ? t((Qe = g.co2VehicleGroup) == null ? void 0 : Qe.message) : void 0,
                        onChange: (H) => pe("co2VehicleGroup", H)
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Fe,
                  {
                    field: "co2VehicleSubgroup",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      nt,
                      {
                        ...p("co2VehicleSubgroup"),
                        label: `${t("form.labels.co2VehicleSubgroup")}`,
                        required: ie,
                        disabled: !ie || !C,
                        placeholder: t(
                          "form.placeholders.co2VehicleSubgroup"
                        ),
                        options: (h == null ? void 0 : h[C]) ?? [],
                        className: "w-80",
                        resetValueOnOptionsChange: !0,
                        initialValue: r.co2VehicleSubgroup ?? void 0,
                        error: (tt = g.co2VehicleSubgroup) != null && tt.message ? t((J = g.co2VehicleSubgroup) == null ? void 0 : J.message) : void 0,
                        onChange: (H) => pe("co2VehicleSubgroup", H)
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsxs("div", { children: [
                  /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t(
                    "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.title"
                  ) }),
                  /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: t(
                    "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.accpetedFormats"
                  ) })
                ] }),
                /* @__PURE__ */ e.jsx(
                  zn,
                  {
                    buffer: r.co2File,
                    setBuffer: K,
                    showError: U,
                    dataType: "co2",
                    clearErrors: Ve
                  }
                )
              ] })
            }
          )
        ] }) }) }),
        V && /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t(
            "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.title"
          ) }),
          /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: t(
            "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.accpetedFormats"
          ) })
        ] }),
        V && /* @__PURE__ */ e.jsx(
          zn,
          {
            buffer: r.vehicleInfoFile,
            setBuffer: P,
            showError: I,
            dataType: "vehicleInfo",
            clearErrors: Ve
          }
        ),
        q && /* @__PURE__ */ e.jsx(ze, { colorMode: "error", children: t("kmtoll.order.vehicleInfo.sameDocumentError") })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
        /* @__PURE__ */ e.jsxs("div", { className: "mb-4 mt-8 flex items-center gap-4", children: [
          /* @__PURE__ */ e.jsx(
            X,
            {
              as: "button",
              intent: "outlined",
              onClick: () => o((H) => H - 1),
              children: t("action.back")
            }
          ),
          /* @__PURE__ */ e.jsx(
            En,
            {
              href: "/account/vehicles",
              className: "ml-auto pr-4 font-medium text-blue-700 underline",
              children: t("action.cancel")
            }
          ),
          /* @__PURE__ */ e.jsx(
            De,
            {
              as: "button",
              type: "submit",
              loadingLabel: t("action.loading"),
              isLoading: i,
              children: t("action.next")
            }
          )
        ] })
      ] })
    ] })
  ] }) });
};
var Zs = /* @__PURE__ */ ((t) => (t.reference = "reference", t.referenceTollCollect = "referenceTollCollect", t))(Zs || {});
const Ai = ({
  heading: t,
  obus: s,
  className: n,
  subHeading: r,
  register: a,
  errors: o,
  onChange: i
}) => {
  const { t: d } = O(["account", "common"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsxs("div", { className: n, children: [
    /* @__PURE__ */ e.jsx("h1", { className: "mb-2 text-2xl font-medium", children: t }),
    /* @__PURE__ */ e.jsx("h2", { className: "mb-4 text-base font-normal text-neutral-800 ", children: r }),
    /* @__PURE__ */ e.jsx("div", { className: "flex flex-col gap-4", children: s.map((l) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "w-full rounded-lg border-2 border-blue-200",
        children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-grow-0 items-center gap-4 bg-blue-50 px-3 py-3 sm:px-6 sm:py-3", children: [
            /* @__PURE__ */ e.jsx(Pr, { className: "h-8 w-8 text-blue-800 sm:h-12 sm:w-12" }),
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx("h2", { className: "text-base font-medium text-blue-800", children: l.title }),
              /* @__PURE__ */ e.jsx("p", { className: "pt-1 text-sm leading-3 text-blue-800", children: l.weightClass }),
              /* @__PURE__ */ e.jsx("p", { className: "pt-1 text-sm text-blue-800", children: l.info })
            ] })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "sm-py-6 w-full px-3 sm:w-96 sm:px-6 sm:pb-6 sm:pt-2", children: /* @__PURE__ */ e.jsx(
            qe,
            {
              ...a(l.reference),
              label: d("tollcollect.order.summary.vehicleInfo.reference"),
              name: l.reference,
              placeholder: d(
                "tollcollect.order.summary.vehicleInfo.referenceMax"
              ),
              error: o[l.reference] ? d("form.validations.reference.long") : void 0,
              onChange: (c) => i(l.reference, c.target.value)
            }
          ) })
        ]
      },
      l.reference
    )) })
  ] });
}, p2 = (t) => {
  const s = Le();
  O(["common"], {
    nsMode: "fallback"
  });
  const { mutateAsync: n, isLoading: r } = fe(
    ["useAddRecognitionWithDocument"],
    ({ Recognition: i }) => i.addRecognitionV2,
    {
      onSuccess: () => {
        s.invalidateQueries({
          queryKey: ["account", "recognitions"]
        });
      },
      onError: void 0
    }
  ), { mutateAsync: a, isLoading: o } = fe(
    ["recognitions", "add", "alpr"],
    ({ Recognition: i }) => i.addRecognition,
    {
      onSuccess: () => {
        s.invalidateQueries({
          queryKey: ["account", "recognitions"]
        });
      },
      onError: void 0
    }
  );
  return {
    addRecognitionWithFile: n,
    addRecognition: a,
    isLoadingBasic: o,
    isLoadingWithFile: r
  };
}, f2 = () => {
  const { addRecognition: t, addRecognitionWithFile: s } = p2(), { fuelTypeHybridIDs: n } = wt(), { t: r } = O("account"), a = Le(), [o, i] = M(null), [d, l] = M(!1), c = async (u, h) => {
    l(!0);
    const p = u.isHybrid !== void 0 ? !!u.isHybrid : n.includes(u.fuelTypeId), {
      contractNo: f,
      grossWeight: x,
      licensePlate: g,
      country: N,
      isASFINAG: b,
      isCommercialVehicle: v,
      isGNSS: S,
      isTollCollect: y,
      firstRegistrationDate: w,
      vehicleType: z,
      vehicleInfoFile: C,
      co2File: E,
      co2VehicleGroup: A,
      specificCo2Emissions: F,
      co2VehicleSubgroup: R,
      numberOfAxels: T
    } = u, P = {
      co2EmissionClass: parseInt(u.co2EmissionClass) || void 0,
      type: "bizz",
      contractNo: f,
      regNo: g,
      reference: h.reference || "",
      countryCode: N,
      isHGV: parseInt(u.grossWeight) > 3500,
      emissionClass: parseInt(u.euroEmissionNorm) || void 0,
      isAsfinag: b,
      isCommercialVehicle: v,
      isGNSS: S,
      isHybrid: p,
      fuelType: parseInt(u.fuelTypeId) || void 0,
      grossWeight: parseInt(x) || void 0,
      firstRegistration: w ? Lt(new Date(w), "yyyy-MM-dd") : void 0,
      numberOfAxels: parseInt(T) || void 0,
      specificCo2Emissions: F ? parseFloat(F.replace(",", ".")) : void 0,
      co2VehicleGroup: A,
      co2VehicleSubgroup: R,
      vehicleType: z
    };
    try {
      if (await m(P, E, C), y) {
        const V = {
          ...P,
          isTollCollect: y,
          reference: h.referenceTollCollect || ""
        };
        await m(V, E, C);
      }
      return a.invalidateQueries({
        queryKey: ee.Recognitions()
      }), a.invalidateQueries({
        queryKey: ee.Agreements({
          contractNo: u.contractNo
        })
      }), !0;
    } catch {
      return i(r("tollcollect.order.summary.submissionError")), !1;
    } finally {
      l(!1);
    }
  }, m = async (u, h, p) => {
    if (h || p) {
      const f = new FormData();
      f.append("data", JSON.stringify(u)), h && f.append("co2File", h), p && f.append("vehicleInfoFile", p), await s(f);
    } else
      await t(u);
  };
  return {
    submissionError: o,
    submissionIsLoading: d,
    handleRecognitionSubmission: c
  };
}, Oi = (t, s) => {
  const n = [];
  if (t.isASFINAG || t.isGNSS || t.isAUTOPASS) {
    const r = [
      t.isASFINAG ? s("singleOrderBizzFlow.order.summary.Obus.info.asFinag") : "",
      t.isGNSS ? s("singleOrderBizzFlow.order.summary.Obus.info.gnss") : "",
      t.isAUTOPASS ? s("singleOrderBizzFlow.order.summary.Obus.info.autopass") : ""
    ].filter(Boolean).map(
      (a, o, i) => o === i.length - 1 && i.length > 1 ? `${s("singleOrderBizzFlow.order.summary.Obus.info.and")} ${a}` : a
    ).join(", ");
    n.push({
      title: s("singleOrderBizzFlow.order.summary.Obus.title.ordinaryBizz"),
      weightClass: s(
        `singleOrderBizzFlow.order.summary.Obus.weight.${t.weightInterval}`
      ) || "",
      info: `${s(
        "singleOrderBizzFlow.order.summary.Obus.info.for"
      )} ${r}`,
      reference: Zs.reference,
      errors: Zs.reference
    });
  }
  return t.isTollCollect && n.push({
    title: s("singleOrderBizzFlow.order.summary.Obus.title.tollCollectBizz"),
    weightClass: s(
      `singleOrderBizzFlow.order.summary.Obus.weight.${t.weightInterval}`
    ) || "",
    info: `${s("singleOrderBizzFlow.order.summary.Obus.info.for")} ${s(
      "singleOrderBizzFlow.order.summary.Obus.info.tollCollect"
    )}`,
    reference: Zs.referenceTollCollect,
    errors: Zs.referenceTollCollect
  }), n;
}, Ei = ({
  heading: t,
  files: s = [],
  className: n
}) => /* @__PURE__ */ e.jsxs("div", { className: n, children: [
  /* @__PURE__ */ e.jsx("h1", { className: "mb-2 text-2xl font-medium", children: t }),
  /* @__PURE__ */ e.jsx("div", { className: "grid grid-cols-1 gap-4 rounded-lg bg-neutral-50 p-4 sm:grid-cols-2", children: s.map((r, a) => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-start p-4 ", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "text-sm", children: r.title }),
    /* @__PURE__ */ e.jsx("p", { className: "pt-1 font-medium text-neutral-950", children: r.fileName })
  ] }, a)) })
] }), x2 = ({
  hasTollingAgreement: t,
  hasTollCollectAgreement: s
}) => {
  var le, me, ce;
  const { locale: n } = se(), { updateStep: r, formData: a } = Pt(), {
    register: o,
    handleSubmit: i,
    formState: { errors: d },
    clearErrors: l
  } = ws({
    resolver: _s(ho)
  }), { t: c } = O(["account", "common"], {
    nsMode: "fallback"
  }), m = pt(), u = !!(m != null && m.get("toll-collect")), p = (le = kt().find(
    (q) => q.value === a.country
  )) == null ? void 0 : le.key, [f, x] = M(!1), [g, N] = M(!1), [b, v] = M(!1), [S, y] = M(!1), [w, z] = M(!1), { customerInformation: C } = Oe(), { handleRecognitionSubmission: E, submissionIsLoading: A, submissionError: F } = f2(), { fuelTypes: R } = wt(), T = !!a.isTollCollect && !s, P = !!a.isGNSS && !t, V = async (q) => {
    z(!0), v(!1), y(!1);
    let de = !1;
    if (T && !q.acceptTollCollectTerms && (v(!0), de = !0), P && !q.acceptRoadTaxDenmarkTerms && (y(!0), de = !0), de) {
      z(!1);
      return;
    }
    await E(
      a,
      q
    ) && r(4), z(!1);
  }, I = (q) => {
    if (typeof q == "string" || typeof q == "number") return q;
  }, _ = (q) => {
    const de = R.find(
      (ae) => ae.value === (q == null ? void 0 : q.toString())
    );
    return de ? de.label : "";
  }, ne = [
    {
      title: c("form.labels.firstName"),
      value: I(C == null ? void 0 : C.firstName)
    },
    {
      title: c("form.labels.lastName"),
      value: I(C == null ? void 0 : C.lastName)
    },
    {
      title: c("form.labels.email"),
      value: I(C == null ? void 0 : C.email)
    },
    ...C && "address" in C ? [
      {
        title: c("form.labels.address"),
        value: I(C.address)
      }
    ] : [],
    ...C && "phone" in C ? [
      {
        title: c("form.labels.phone"),
        value: I(
          C.phone ? `${C.phoneCode ?? ""} ${C.phone}` : void 0
        )
      }
    ] : []
  ].filter((q) => q.value), K = [
    {
      title: c("form.labels.reference"),
      value: I(a.reference)
    },
    {
      title: c("form.labels.licensePlate"),
      value: I(a.licensePlate)
    },
    {
      title: c("form.labels.registrationCountry"),
      value: p
    },
    {
      title: c("form.labels.firstRegistrationDate"),
      value: typeof a.firstRegistrationDate == "string" || a.firstRegistrationDate instanceof Date ? Lt(new Date(a.firstRegistrationDate), "yyyy-MM-dd") : ""
    },
    {
      title: c("form.labels.vinNo"),
      value: I(a.vinNo)
    },
    {
      title: c("form.labels.grossWeight"),
      value: I(a.grossWeight)
    },
    {
      title: c("form.labels.fuelType"),
      value: _(a.fuelTypeId)
    },
    {
      title: c("form.labels.euroEmissionNorm"),
      value: I(a.euroEmissionNorm)
    },
    {
      title: c("form.labels.co2EmissionClass"),
      value: I(a.co2EmissionClass)
    },
    {
      title: c("form.labels.specificCo2Emissions"),
      value: I(a.specificCo2Emissions)
    },
    {
      title: c("form.labels.vehicleGroup"),
      value: I(a.vehicleGroup)
    },
    {
      title: c("form.labels.vehicleSubGroup"),
      value: I(a.vehicleSubGroup)
    },
    {
      title: c("form.labels.numberOfAxels"),
      value: I(a.numberOfAxels)
    }
  ].filter((q) => q.value), U = [
    {
      title: c(
        "singleOrderBizzFlow.order.summary.uploadedDocuments.proofOfRegistration"
      ),
      fileName: (me = a.vehicleInfoFile) == null ? void 0 : me.name
    },
    {
      title: c("singleOrderBizzFlow.order.summary.uploadedDocuments.cifOrCoc"),
      fileName: (ce = a.co2File) == null ? void 0 : ce.name
    }
  ].filter((q) => q.fileName), re = (q) => {
    l(q);
  }, ie = Oi(a, c);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    w && /* @__PURE__ */ e.jsx(sa, {}),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: i(V), children: [
      /* @__PURE__ */ e.jsx("h2", { className: "text-4xl font-semibold leading-10 text-neutral-950", children: c("singleOrderBizzFlow.order.summary.title") }),
      /* @__PURE__ */ e.jsx("div", { className: "pt-6 text-base font-normal leading-[27px] text-neutral-500", children: c("singleOrderBizzFlow.order.summary.preamble") }),
      /* @__PURE__ */ e.jsx(
        $s,
        {
          className: "mt-16",
          heading: c("singleOrderBizzFlow.order.summary.vehicleInfo.title"),
          vehicleInfo: K
        }
      ),
      U.length > 0 && /* @__PURE__ */ e.jsx(
        Ei,
        {
          className: "mt-16",
          heading: c(
            "singleOrderBizzFlow.order.summary.uploadedDocuments.title"
          ),
          files: U
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ai,
        {
          className: "mt-16",
          heading: c("singleOrderBizzFlow.order.summary.Obus.heading"),
          obus: ie,
          register: o,
          errors: d,
          clearErrors: l,
          onChange: re
        }
      ),
      /* @__PURE__ */ e.jsx(
        $s,
        {
          className: "mt-16",
          heading: c("singleOrderBizzFlow.order.summary.customerInfo.title"),
          vehicleInfo: ne
        }
      ),
      !!a.isTollCollect && u && /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("h3", { className: "mb-2 pt-16 text-2xl font-medium", children: c("singleOrderBizzFlow.order.summary.tollCollect.title") }),
        /* @__PURE__ */ e.jsx("div", { className: "text-base font-normal leading-[27px] text-neutral-500", children: c("singleOrderBizzFlow.order.summary.tollCollect.preamble") }),
        /* @__PURE__ */ e.jsx(
          qe,
          {
            ...o("tollCollectCustomerNumber"),
            className: "mt-6 w-full sm:w-96",
            label: c("singleOrderBizzFlow.order.summary.tollCollect.label")
          }
        )
      ] }),
      T || P && /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("h3", { className: "mb-2 pt-16 text-2xl font-medium", children: c("singleOrderBizzFlow.order.summary.acceptTerms.title") }),
        /* @__PURE__ */ e.jsx("div", { className: "text-base font-normal leading-[27px] text-neutral-500", children: c("singleOrderBizzFlow.order.summary.acceptTerms.preamble") })
      ] }),
      /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3", children: [
        T && /* @__PURE__ */ e.jsx(
          ns,
          {
            ...o("acceptTollCollectTerms"),
            error: b ? c("form.validations.termsOfAgreement.required") : void 0,
            className: "mt-8",
            onChange: () => {
              N(!g), b && v(!1);
            },
            label: /* @__PURE__ */ e.jsx(
              G,
              {
                i18nKey: "singleOrderBizzFlow.order.summary.acceptTerms.terms.tollCollect",
                ns: "account",
                children: /* @__PURE__ */ e.jsx(
                  "a",
                  {
                    onClick: (q) => {
                      q.stopPropagation(), window.open(
                        `/pdfs/${n}/terms/terms.pdf`,
                        "_blank"
                      );
                    },
                    className: "cursor-pointer underline"
                  }
                )
              }
            )
          }
        ),
        P && /* @__PURE__ */ e.jsx(
          ns,
          {
            ...o("acceptRoadTaxDenmarkTerms"),
            error: S ? c("form.validations.termsOfAgreement.required") : void 0,
            onChange: () => {
              x(!f), S && y(!1);
            },
            label: /* @__PURE__ */ e.jsx(
              G,
              {
                i18nKey: "singleOrderBizzFlow.order.summary.acceptTerms.terms.roadTaxDenmark",
                ns: "account",
                children: /* @__PURE__ */ e.jsx(
                  "a",
                  {
                    onClick: (q) => {
                      q.stopPropagation(), window.open(
                        `/pdfs/${n}/terms/terms.pdf`,
                        "_blank"
                      );
                    },
                    className: "cursor-pointer underline"
                  }
                )
              }
            )
          }
        ),
        F && /* @__PURE__ */ e.jsx(ze, { className: "mt-8", colorMode: "error", children: F })
      ] }) }),
      /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
      /* @__PURE__ */ e.jsxs("div", { className: "mb-4 mt-8 flex items-center gap-4", children: [
        /* @__PURE__ */ e.jsx(
          X,
          {
            as: "button",
            intent: "outlined",
            onClick: () => r((q) => q - 1),
            children: c("action.back")
          }
        ),
        /* @__PURE__ */ e.jsx(
          En,
          {
            href: "/account/vehicles",
            className: "ml-auto pr-4 font-medium text-blue-700 underline",
            children: c("action.cancel")
          }
        ),
        /* @__PURE__ */ e.jsx(
          De,
          {
            as: "button",
            type: "submit",
            loadingLabel: c("action.loading"),
            isLoading: A,
            children: c("action.order")
          }
        )
      ] })
    ] })
  ] });
}, g2 = (t) => {
  const s = Le();
  O(["common"], {
    nsMode: "fallback"
  });
  const { mutateAsync: n, isLoading: r } = fe(
    ["useUpdateRecognitionWithDocument"],
    ({ Recognition: a }) => a.updateRecognitionV2,
    {
      onSuccess: () => {
        s.invalidateQueries({
          queryKey: ["account", "recognitions"]
        });
      },
      onError: void 0
    }
  );
  return {
    updateRecognitionWithFile: n,
    isLoading: r
  };
}, b2 = () => {
  const { updateRecognitionWithFile: t } = g2(), { fuelTypeHybridIDs: s } = wt(), { t: n } = O("account"), r = Le(), [a, o] = M(null), [i, d] = M(!1), l = async (m, u) => {
    d(!0);
    const h = m.isHybrid !== void 0 ? !!m.isHybrid : s.includes(m.fuelTypeId), {
      contractNo: p,
      grossWeight: f,
      licensePlate: x,
      country: g,
      isASFINAG: N,
      isCommercialVehicle: b,
      isGNSS: v,
      isTollCollect: S,
      firstRegistrationDate: y,
      vehicleType: w,
      vehicleInfoFile: z,
      co2File: C,
      co2VehicleGroup: E,
      specificCo2Emissions: A,
      co2VehicleSubgroup: F,
      numberOfAxels: R,
      vehicleIdentificationNumber: T,
      licensePlateCertificate: P
    } = m, V = {
      contractNo: p,
      contractLineNo: parseInt(m.contractLineNo),
      changes: {
        co2EmissionClass: parseInt(m.co2EmissionClass) || void 0,
        type: "bizz",
        registrationNo: x,
        reference: u.reference || "",
        countryCode: g,
        isHGV: parseInt(m.grossWeight) > 3500,
        emissionClass: parseInt(m.euroEmissionNorm) || void 0,
        isAsfinag: N,
        isCommercialVehicle: b,
        isGNSS: v,
        isHybrid: h,
        fuelType: parseInt(m.fuelTypeId) || void 0,
        vehicleMaxLadenWeight: parseInt(f) || void 0,
        firstRegistration: y ? Lt(new Date(y), "yyyy-MM-dd") : void 0,
        numberOfAxels: parseInt(R) || void 0,
        specificCo2Emissions: A ? parseFloat(A.replace(",", ".")) : void 0,
        vehicleGroup: E,
        vehicleSubgroup: F,
        vehicleType: w,
        vehicleIdentificationNumber: T,
        licensePlateCertificate: P
      }
    };
    try {
      if (await c(V, C, z), S) {
        const I = {
          ...V,
          isTollCollect: S,
          reference: u.referenceTollCollect || ""
        };
        await c(I, C, z);
      }
      return r.invalidateQueries({
        queryKey: ee.Recognitions()
      }), r.invalidateQueries({
        queryKey: ee.Agreements({
          contractNo: m.contractNo
        })
      }), !0;
    } catch {
      return o(n("tollcollect.order.summary.submissionError")), !1;
    } finally {
      d(!1);
    }
  }, c = async (m, u, h) => {
    if (u || h) {
      const p = new FormData();
      p.append("data", JSON.stringify(m)), u && p.append("co2File", u), h && p.append("vehicleInfoFile", h), await t(p);
    } else
      await t(m);
  };
  return {
    submissionError: a,
    submissionIsLoading: i,
    handleRecognitionUpdate: l
  };
}, v2 = ({
  hasTollingAgreement: t,
  hasTollCollectAgreement: s
}) => {
  var le, me, ce;
  const { locale: n } = se(), { updateStep: r, formData: a } = Pt(), {
    register: o,
    handleSubmit: i,
    formState: { errors: d },
    clearErrors: l
  } = ws({
    resolver: _s(ho)
  }), { t: c } = O(["account", "common"], {
    nsMode: "fallback"
  }), m = pt(), u = !!(m != null && m.get("toll-collect")), p = (le = kt().find(
    (q) => q.value === a.country
  )) == null ? void 0 : le.key, [f, x] = M(!1), [g, N] = M(!1), [b, v] = M(!1), [S, y] = M(!1), [w, z] = M(!1), { customerInformation: C } = Oe(), { handleRecognitionUpdate: E, submissionIsLoading: A, submissionError: F } = b2(), { fuelTypes: R } = wt(), T = !!a.isTollCollect && !s, P = !!a.isGNSS && !t, V = async (q) => {
    z(!0), v(!1), y(!1);
    let de = !1;
    if (T && !q.acceptTollCollectTerms && (v(!0), de = !0), P && !q.acceptRoadTaxDenmarkTerms && (y(!0), de = !0), de) {
      z(!1);
      return;
    }
    await E(
      a,
      q
    ) && r(4), z(!1);
  }, I = (q) => {
    if (typeof q == "string" || typeof q == "number") return q;
  }, _ = (q) => {
    const de = R.find(
      (ae) => ae.value === (q == null ? void 0 : q.toString())
    );
    return de ? de.label : "";
  }, ne = [
    {
      title: c("form.labels.firstName"),
      value: I(C == null ? void 0 : C.firstName)
    },
    {
      title: c("form.labels.lastName"),
      value: I(C == null ? void 0 : C.lastName)
    },
    {
      title: c("form.labels.email"),
      value: I(C == null ? void 0 : C.email)
    },
    ...C && "address" in C ? [
      {
        title: c("form.labels.address"),
        value: I(C.address)
      }
    ] : [],
    ...C && "phone" in C ? [
      {
        title: c("form.labels.phone"),
        value: I(
          C.phone ? `${C.phoneCode ?? ""} ${C.phone}` : void 0
        )
      }
    ] : []
  ].filter((q) => q.value), K = [
    {
      title: c("form.labels.reference"),
      value: I(a.reference)
    },
    {
      title: c("form.labels.licensePlate"),
      value: I(a.licensePlate)
    },
    {
      title: c("form.labels.registrationCountry"),
      value: p
    },
    {
      title: c("form.labels.firstRegistrationDate"),
      value: typeof a.firstRegistrationDate == "string" || a.firstRegistrationDate instanceof Date ? Lt(new Date(a.firstRegistrationDate), "yyyy-MM-dd") : ""
    },
    {
      title: c("form.labels.vinNo"),
      value: I(a.vinNo)
    },
    {
      title: c("form.labels.grossWeight"),
      value: I(a.grossWeight)
    },
    {
      title: c("form.labels.fuelType"),
      value: _(a.fuelTypeId)
    },
    {
      title: c("form.labels.euroEmissionNorm"),
      value: I(a.euroEmissionNorm)
    },
    {
      title: c("form.labels.co2EmissionClass"),
      value: I(a.co2EmissionClass)
    },
    {
      title: c("form.labels.specificCo2Emissions"),
      value: I(a.specificCo2Emissions)
    },
    {
      title: c("form.labels.vehicleGroup"),
      value: I(a.vehicleGroup)
    },
    {
      title: c("form.labels.vehicleSubGroup"),
      value: I(a.vehicleSubGroup)
    },
    {
      title: c("form.labels.numberOfAxels"),
      value: I(a.numberOfAxels)
    }
  ].filter((q) => q.value), U = [
    {
      title: c(
        "singleOrderBizzFlow.order.summary.uploadedDocuments.proofOfRegistration"
      ),
      fileName: (me = a.vehicleInfoFile) == null ? void 0 : me.name
    },
    {
      title: c("singleOrderBizzFlow.order.summary.uploadedDocuments.cifOrCoc"),
      fileName: (ce = a.co2File) == null ? void 0 : ce.name
    }
  ].filter((q) => q.fileName), re = (q) => {
    l(q);
  }, ie = Oi(a, c);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    w && /* @__PURE__ */ e.jsx(sa, {}),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: i(V), children: [
      /* @__PURE__ */ e.jsx("h2", { className: "text-4xl font-semibold leading-10 text-neutral-950", children: c("singleOrderBizzFlow.order.summary.title") }),
      /* @__PURE__ */ e.jsx("div", { className: "pt-6 text-base font-normal leading-[27px] text-neutral-500", children: c("singleOrderBizzFlow.order.summary.preamble") }),
      /* @__PURE__ */ e.jsx(
        $x,
        {
          oldPlate: a.prevRegNo,
          newPlate: a.licensePlate
        }
      ),
      /* @__PURE__ */ e.jsx(
        $s,
        {
          className: "mt-16",
          heading: c("singleOrderBizzFlow.order.summary.vehicleInfo.title"),
          vehicleInfo: K
        }
      ),
      U.length > 0 && /* @__PURE__ */ e.jsx(
        Ei,
        {
          className: "mt-16",
          heading: c(
            "singleOrderBizzFlow.order.summary.uploadedDocuments.title"
          ),
          files: U
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ai,
        {
          className: "mt-16",
          heading: c("singleOrderBizzFlow.order.summary.Obus.heading"),
          obus: ie,
          register: o,
          errors: d,
          clearErrors: l,
          onChange: re
        }
      ),
      /* @__PURE__ */ e.jsx(
        $s,
        {
          className: "mt-16",
          heading: c("singleOrderBizzFlow.order.summary.customerInfo.title"),
          vehicleInfo: ne
        }
      ),
      !!a.isTollCollect && u && /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("h3", { className: "mb-2 pt-16 text-2xl font-medium", children: c("singleOrderBizzFlow.order.summary.tollCollect.title") }),
        /* @__PURE__ */ e.jsx("div", { className: "text-base font-normal leading-[27px] text-neutral-500", children: c("singleOrderBizzFlow.order.summary.tollCollect.preamble") }),
        /* @__PURE__ */ e.jsx(
          qe,
          {
            ...o("tollCollectCustomerNumber"),
            className: "mt-6 w-full sm:w-96",
            label: c("singleOrderBizzFlow.order.summary.tollCollect.label")
          }
        )
      ] }),
      T || P && /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("h3", { className: "mb-2 pt-16 text-2xl font-medium", children: c("singleOrderBizzFlow.order.summary.acceptTerms.title") }),
        /* @__PURE__ */ e.jsx("div", { className: "text-base font-normal leading-[27px] text-neutral-500", children: c("singleOrderBizzFlow.order.summary.acceptTerms.preamble") })
      ] }),
      /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3", children: [
        T && /* @__PURE__ */ e.jsx(
          ns,
          {
            ...o("acceptTollCollectTerms"),
            error: b ? c("form.validations.termsOfAgreement.required") : void 0,
            className: "mt-8",
            onChange: () => {
              N(!g), b && v(!1);
            },
            label: /* @__PURE__ */ e.jsx(
              G,
              {
                i18nKey: "singleOrderBizzFlow.order.summary.acceptTerms.terms.tollCollect",
                ns: "account",
                children: /* @__PURE__ */ e.jsx(
                  "a",
                  {
                    onClick: (q) => {
                      q.stopPropagation(), window.open(
                        `/pdfs/${n}/terms/terms.pdf`,
                        "_blank"
                      );
                    },
                    className: "cursor-pointer underline"
                  }
                )
              }
            )
          }
        ),
        P && /* @__PURE__ */ e.jsx(
          ns,
          {
            ...o("acceptRoadTaxDenmarkTerms"),
            error: S ? c("form.validations.termsOfAgreement.required") : void 0,
            onChange: () => {
              x(!f), S && y(!1);
            },
            label: /* @__PURE__ */ e.jsx(
              G,
              {
                i18nKey: "singleOrderBizzFlow.order.summary.acceptTerms.terms.roadTaxDenmark",
                ns: "account",
                children: /* @__PURE__ */ e.jsx(
                  "a",
                  {
                    onClick: (q) => {
                      q.stopPropagation(), window.open(
                        `/pdfs/${n}/terms/terms.pdf`,
                        "_blank"
                      );
                    },
                    className: "cursor-pointer underline"
                  }
                )
              }
            )
          }
        ),
        F && /* @__PURE__ */ e.jsx(ze, { className: "mt-8", colorMode: "error", children: F })
      ] }) }),
      /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
      /* @__PURE__ */ e.jsxs("div", { className: "mb-4 mt-8 flex items-center gap-4", children: [
        /* @__PURE__ */ e.jsx(
          X,
          {
            as: "button",
            intent: "outlined",
            onClick: () => r((q) => q - 1),
            children: c("action.back")
          }
        ),
        /* @__PURE__ */ e.jsx(
          En,
          {
            href: "/account/vehicles",
            className: "ml-auto pr-4 font-medium text-blue-700 underline",
            children: c("action.cancel")
          }
        ),
        /* @__PURE__ */ e.jsx(
          De,
          {
            as: "button",
            type: "submit",
            loadingLabel: c("action.loading"),
            isLoading: A,
            children: c("action.order")
          }
        )
      ] })
    ] })
  ] });
}, y2 = () => {
  const { push: t } = se(), { formData: s } = Pt(), { isTollCollect: n, isGNSS: r } = s || {}, { t: a } = O(["account", "common"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsxs("div", { className: "flex max-w-2xl flex-col gap-10", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "text-4xl font-semibold leading-10 text-neutral-950", children: a("singleOrderBizzFlow.order.confirmation.title") }),
    /* @__PURE__ */ e.jsx("div", { className: "text-base font-normal leading-[27px] text-neutral-500", children: a("singleOrderBizzFlow.order.confirmation.preamble") }),
    /* @__PURE__ */ e.jsx(
      ze,
      {
        colorMode: "success",
        hideIcon: !0,
        title: a("singleOrderBizzFlow.order.confirmation.feedback.title"),
        children: a("singleOrderBizzFlow.order.confirmation.feedback.description")
      }
    ),
    r && /* @__PURE__ */ e.jsx(
      Sn,
      {
        title: a(
          "singleOrderBizzFlow.order.confirmation.details.roadTollDenmark.title"
        ),
        descriptionPhraseKey: "singleOrderBizzFlow.order.confirmation.details.roadTollDenmark.description"
      }
    ),
    n && /* @__PURE__ */ e.jsx(
      Sn,
      {
        title: a(
          "singleOrderBizzFlow.order.confirmation.details.roadTollGermany.title"
        ),
        descriptionPhraseKey: "singleOrderBizzFlow.order.details.confirmation.roadTollGermany.description"
      }
    ),
    /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
      X,
      {
        onClick: () => t("/account/vehicles/"),
        className: "max-w-fit",
        children: a("action.close")
      }
    ) })
  ] });
}, j2 = () => {
  const { push: t } = se(), { t: s } = O(["account", "common"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsxs("div", { className: "flex max-w-2xl flex-col gap-10", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "text-4xl font-semibold leading-10 text-neutral-950", children: s("singleOrderBizzFlow.order.confirmation.title") }),
    /* @__PURE__ */ e.jsx(ze, { colorMode: "success", hideIcon: !0, children: s("singleOrderBizzFlow.order.confirmation.vehicleChange.description") }),
    /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
      X,
      {
        onClick: () => t("/account/vehicles/"),
        className: "max-w-fit",
        children: s("action.close")
      }
    ) })
  ] });
}, C2 = () => {
  const { step: t, formData: s } = Pt(), { t: n } = O("account"), { data: r } = Ke(
    !1,
    s.contractNo
  ), { pathname: a } = se();
  B(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [t]);
  const o = () => {
    switch (t) {
      case 2:
        return /* @__PURE__ */ e.jsx(l2, {});
      case 3:
        return /* @__PURE__ */ e.jsx(
          x2,
          {
            hasTollingAgreement: (r == null ? void 0 : r.tollingAgreementSigned) || !1,
            hasTollCollectAgreement: (r == null ? void 0 : r.tollCollectAgreementSigned) || !1
          }
        );
      case 4:
        return /* @__PURE__ */ e.jsx(y2, {});
      default:
        return /* @__PURE__ */ e.jsx(
          pp,
          {
            isRoadTollDenmark: a === "/account/bizz/order"
          }
        );
    }
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "mt-4 pt-8", children: [
    /* @__PURE__ */ e.jsx(Ci, { children: n("singleOrderBizzFlow.pretitle") }),
    o()
  ] });
}, N2 = ({ index: t, stepText: s, isPrevStep: n }) => {
  const { step: r, updateStep: a } = Pt(), o = r === t + 1;
  return /* @__PURE__ */ e.jsx(
    "button",
    {
      className: `flex h-full flex-1 flex-col after:h-1 after:w-full after:shadow after:content-['']
        ${n ? "cursor-pointer after:bg-green-600" : "after:bg-neutral-300"} 
        ${o ? "after:bg-neutral-500" : ""}
        `,
      onClick: () => {
        n && a(t + 1);
      },
      disabled: !n,
      children: /* @__PURE__ */ e.jsxs("div", { className: "flex h-full items-center md:px-2", children: [
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: `mr-2 flex w-6 flex-[0_0_1.2rem] items-center justify-center rounded-full text-xs md:h-8 md:flex-[0_0_2rem] md:text-base 
            ${n ? "border-2 border-green-700 bg-green-100 text-green-700" : o ? "border-2 border-neutral-500 text-neutral-500" : "border border-neutral-400 text-neutral-500"} 
          `,
            children: n ? /* @__PURE__ */ e.jsx(an, { width: 11 }) : t + 1
          }
        ),
        /* @__PURE__ */ e.jsx("span", { className: "text-xs text-black md:text-sm", children: s })
      ] })
    }
  );
}, w2 = ({
  index: t,
  stepText: s,
  isPrevStep: n,
  lastStep: r,
  cutoffStep: a
}) => {
  const { step: o, updateStep: i } = Pt(), d = o === t + 1;
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: `flex h-full flex-col
        ${n && a !== o ? "after:bg-green-600" : "after:bg-neutral-300"} 
        ${d ? "after:bg-neutral-500" : ""}
        ${r ? "" : "flex-1"}
        `,
      children: /* @__PURE__ */ e.jsxs("div", { className: "flex h-full w-full items-center gap-2 px-1", children: [
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            className: " h-18 flex w-12 flex-[0_0_3rem] flex-col items-center gap-1 md:w-14 md:flex-[0_0_3.5rem]",
            onClick: () => {
              n && a !== o && i(t + 1);
            },
            disabled: !n || a === o,
            children: [
              /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: `flex w-10 flex-[0_0_2.5rem] items-center justify-center rounded-full text-xs font-semibold md:w-12 md:flex-[0_0_3rem] md:text-base 
                ${n || a === o ? "border-4 border-green-600 bg-green-600 text-white" : d ? "border-4 border-green-600" : "border-4 border-neutral-300"} 
              `,
                  children: n || a === o ? /* @__PURE__ */ e.jsx(an, { width: 18 }) : t + 1
                }
              ),
              /* @__PURE__ */ e.jsx("span", { className: "h-5 w-24 text-center text-xs font-semibold text-black md:text-sm", children: s })
            ]
          }
        ),
        !r && /* @__PURE__ */ e.jsxs("div", { className: " flex w-full flex-col items-center gap-1", children: [
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: "flex h-8 w-full items-center justify-center md:h-10",
              children: /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: `h-1 w-full rounded-md ${n ? "bg-green-600" : "bg-neutral-300"}`
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx("span", { className: "invisible h-5 w-0 text-center text-xs text-black md:text-sm", children: s })
        ] })
      ] })
    }
  );
};
var Di = /* @__PURE__ */ ((t) => (t[t.Rectangle = 0] = "Rectangle", t[t.Circle = 1] = "Circle", t))(Di || {});
const k2 = ({
  stepTexts: t,
  className: s,
  stepVariant: n = 0,
  cutoffStep: r
}) => {
  const { step: a } = Pt();
  return /* @__PURE__ */ e.jsxs("div", { className: `flex flex-wrap items-center ${s ?? ""}`, children: [
    n === 0 && t.map((o, i) => /* @__PURE__ */ e.jsx(
      N2,
      {
        stepText: o,
        index: i,
        isPrevStep: a > i + 1
      },
      i
    )),
    n === 1 && t.map((o, i) => /* @__PURE__ */ e.jsx(
      w2,
      {
        stepText: o,
        index: i,
        isPrevStep: a > i + 1,
        lastStep: t.length - 1 === i,
        cutoffStep: r
      },
      i
    ))
  ] });
};
function P2(t, s) {
  const n = {
    serialNumber: s,
    contractNo: t
  }, { data: r, isLoading: a } = ye(
    ee.GetRecognition(s),
    ({ Recognitions: c }) => c.getRecognition(n),
    { keepPreviousData: !0 }
  ), o = bo(), { emissionClasses: i, fuelTypes: d } = wt();
  return {
    recognition: D(() => {
      if (!(!r || a))
        return {
          ...r.recognition,
          fuelType: d.find(
            ({ value: c }) => Number(c) === r.recognition.fuelType
          ),
          emissionClass: i.find(
            ({ value: c }) => Number(c) === r.recognition.emissionClass
          ),
          country: o(r.recognition.countryCode) ?? "-"
        };
    }, [r, i, d, o, a])
  };
}
const T2 = ({
  bizzno: t,
  contractNo: s
}) => {
  const { step: n } = Pt(), { t: r } = O("account"), { data: a } = Ke(!1, s), { recognition: o } = P2(s, t);
  B(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [n]);
  const i = () => {
    switch (n) {
      case 2:
        return /* @__PURE__ */ e.jsx(h2, {});
      case 3:
        return /* @__PURE__ */ e.jsx(
          v2,
          {
            hasTollingAgreement: (a == null ? void 0 : a.tollingAgreementSigned) || !1,
            hasTollCollectAgreement: (a == null ? void 0 : a.tollCollectAgreementSigned) || !1
          }
        );
      case 4:
        return /* @__PURE__ */ e.jsx(j2, {});
      default:
        return o ? /* @__PURE__ */ e.jsx(fp, { bizzInfo: o }) : null;
    }
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "mt-4 pt-8", children: [
    /* @__PURE__ */ e.jsx(Ci, { children: r("singleOrderBizzFlow.editPretitle") }),
    i()
  ] });
}, Fi = () => {
  const { t } = O(["account", "common"], {
    nsMode: "fallback"
  }), { query: s } = se();
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(mp, { children: [
    /* @__PURE__ */ e.jsx(
      k2,
      {
        stepTexts: [
          t("singleOrderBizzFlow.progressBar.steps.basicVehicleInfo"),
          t("singleOrderBizzFlow.progressBar.steps.additionalVehicleData"),
          t("singleOrderBizzFlow.progressBar.steps.summary"),
          t("singleOrderBizzFlow.progressBar.steps.confirmation")
        ],
        stepVariant: Di.Circle,
        cutoffStep: 4
      }
    ),
    /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
    s.bizz && s.contractNo ? /* @__PURE__ */ e.jsx(
      T2,
      {
        bizzno: s.bizz,
        contractNo: s.contractNo
      }
    ) : /* @__PURE__ */ e.jsx(C2, {})
  ] }) });
}, _g = () => /* @__PURE__ */ e.jsx(Fi, {}), Wg = () => {
  const t = se(), { query: s, push: n } = t, r = t.locale || "sv", { t: a } = O(["account", "common", "recognitions"], {
    nsMode: "fallback"
  }), { data: o, error: i } = Or(!1), { app: d, oresundPayBase: l } = Ye(), c = d === ot.OresundPay && Jt({
    locale: r,
    key: "installationGuide",
    url: l
  }), m = d === ot.OresundPay && Jt({
    locale: r,
    key: "prePaid",
    url: l
  }), u = o == null ? void 0 : o.filter(
    (h) => h.paymentAgreement.agreementType !== "Oresund_Business_Pendler"
  );
  return i ? /* @__PURE__ */ e.jsx(zt, { variant: "error", children: a("agreement.error.notFound") }) : u ? u.length === 0 ? /* @__PURE__ */ e.jsx(Je, { children: /* @__PURE__ */ e.jsx(
    $r,
    {
      status: {
        backgroundColor: "bg-red-300",
        translationKey: "dashboard.inactive"
      }
    }
  ) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    s.toast && /* @__PURE__ */ e.jsx(
      ii,
      {
        registrationNumber: s.toast,
        onClose: () => mi("toast", t)
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-6", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-6", children: [
        /* @__PURE__ */ e.jsx(k, { as: "span", className: "max-w-3xl", children: a("kmtoll.landing.layout.preamble") }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 text-sm sm:gap-6 sm:text-base lg:flex-row lg:gap-12", children: [
          /* @__PURE__ */ e.jsx(
            ys,
            {
              href: m || "#",
              className: "font-semibold text-blue-700 underline",
              children: a("kmtoll.landing.layout.prePaidTicketLinkText")
            }
          ),
          /* @__PURE__ */ e.jsx(
            ys,
            {
              className: "font-semibold text-blue-700 underline",
              href: c || "#",
              children: a("kmtoll.landing.layout.bizzInstallationGuideLinkText")
            }
          )
        ] })
      ] }),
      u.length > 0 && /* @__PURE__ */ e.jsx(rl, { value: {}, children: /* @__PURE__ */ e.jsx(
        sl,
        {
          pageType: "kmtoll",
          productType: "GNSS",
          actions: [
            {
              labelKey: "kmtoll.order.layout.title",
              action: () => n("./bizz/order"),
              icon: /* @__PURE__ */ e.jsx(cs, {})
            }
          ],
          hideCommuter: !0
        }
      ) })
    ] })
  ] }) : /* @__PURE__ */ e.jsx(
    Je,
    {
      p: "spacing.600",
      display: "flex",
      sx: { justifyContent: "center", alignContent: "center" },
      children: /* @__PURE__ */ e.jsx(Je, { sx: { width: "45px" }, children: /* @__PURE__ */ e.jsx(At, { "aria-label": a("action.loading") }) })
    }
  );
}, qg = () => {
  const { t } = O(["account", "common"], {
    nsMode: "fallback"
  }), { data: s, error: n } = Or(!0), r = s == null ? void 0 : s.filter(
    (a) => a.paymentAgreement.agreementType !== "Oresund_Business_Pendler"
  );
  return n ? /* @__PURE__ */ e.jsx(zt, { variant: "error", children: t("agreement.error.notFound") }) : r ? r.length === 0 ? /* @__PURE__ */ e.jsx(Je, { children: /* @__PURE__ */ e.jsx(
    $r,
    {
      status: {
        backgroundColor: "bg-red-300",
        translationKey: "dashboard.inactive"
      }
    }
  ) }) : /* @__PURE__ */ e.jsx(Fi, {}) : /* @__PURE__ */ e.jsx(
    Je,
    {
      p: "spacing.600",
      display: "flex",
      sx: { justifyContent: "center", alignContent: "center" },
      children: /* @__PURE__ */ e.jsx(Je, { sx: { width: "45px" }, children: /* @__PURE__ */ e.jsx(At, { "aria-label": t("action.loading") }) })
    }
  );
}, { AuthenticationConnectionSources: _a } = Z, Wa = ({
  authConnection: t
}) => {
  const { t: s } = O(["account", "common"], { nsMode: "fallback" }), n = se(), { mutateAsync: r } = fe(
    ["nonce", "set", "V2"],
    (c) => c.Customer.setNonceV2
  ), a = D(() => ({
    BankID: {
      authenticationMethodText: s(
        "customerInformation.accountInformation.connectBankID.title"
      ),
      source: _a.BankID
    },
    MitID: {
      authenticationMethodText: s(
        "customerInformation.accountInformation.connectMitID.title"
      ),
      source: _a.MitID
    }
  }), [s]), { authenticationMethodText: o, source: i } = a[t], { customerInformation: d } = Oe();
  if (!d)
    return null;
  const l = async () => {
    const c = await r(), m = n.locale;
    await n.replace(
      `/api/auth/login?locale=${m}&source=${i}$&nonce=${c.nonce}`
    );
  };
  return /* @__PURE__ */ e.jsx("section", { className: "mb-2", children: /* @__PURE__ */ e.jsx(ke.Root, { rounded: !1, children: /* @__PURE__ */ e.jsxs(ke.Content, { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ e.jsx(k, { as: "h3", weight: "medium", children: o }),
    /* @__PURE__ */ e.jsx(X, { intent: "text", onClick: l, children: s("action.connect") })
  ] }) }) });
}, S2 = () => {
  const [t, s] = M(!1), { t: n } = O(["account", "common"], { nsMode: "fallback" }), { customerInformation: r } = Oe();
  return r ? /* @__PURE__ */ e.jsx(ut, { children: /* @__PURE__ */ e.jsxs($, { as: "section", className: "mb-2", children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        as: "h3",
        intent: "title",
        weight: "medium",
        size: "md",
        className: "mb-3 mt-2",
        children: n("customerInformation.titleSecurity")
      }
    ),
    /* @__PURE__ */ e.jsx(ke.Root, { rounded: !1, children: /* @__PURE__ */ e.jsxs(ke.Content, { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ e.jsx(k, { as: "h3", weight: "medium", children: n("customerInformation.accountInformation.changePassword.title") }),
      /* @__PURE__ */ e.jsx(X, { intent: "text", onClick: () => s(!0), children: n("action.edit") })
    ] }) }),
    t ? /* @__PURE__ */ e.jsx(yi, { onClose: () => s(!1) }) : null
  ] }) }) : null;
}, Li = {
  success: !1,
  loading: !1,
  agreedToPoliciesClicked: !1,
  error: !1,
  errorMessage: void 0
}, fn = Ns(
  () => Li
), M2 = () => fn.setState(Li), z2 = () => fn.setState({ loading: !0 }), A2 = (t) => fn.setState({
  success: !0,
  loading: !1
}), O2 = (t) => fn.setState({
  error: !0,
  loading: !1,
  errorMessage: t
}), E2 = () => {
  const { t } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx($, { className: "flex justify-center", children: /* @__PURE__ */ e.jsx(k, { children: t("deleteAccount.modal.content.success") }) });
}, D2 = ({
  errorMessage: t
}) => /* @__PURE__ */ e.jsx($, { className: "flex justify-center", children: /* @__PURE__ */ e.jsx(k, { children: t }) }), F2 = ({
  onConfirmDelete: t,
  confirmDelete: s
}) => {
  const { t: n } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs($, { children: [
    /* @__PURE__ */ e.jsx(k, { children: n("deleteAccount.modal.content.confirm.description") }),
    /* @__PURE__ */ e.jsx(
      ns,
      {
        label: n("deleteAccount.modal.content.confirm.label"),
        onChange: () => {
          t(!s);
        }
      }
    )
  ] });
}, L2 = ({
  close: t
}) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx($, { className: "flex justify-end", children: /* @__PURE__ */ e.jsx(X, { onClick: t, children: s("deleteAccount.modal.footer.success") }) });
}, V2 = ({
  onDelete: t,
  deleteConfirmed: s,
  loading: n
}) => {
  const { t: r } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx($, { className: "flex justify-end", children: /* @__PURE__ */ e.jsx(
    De,
    {
      loadingLabel: r("deleteAccount.modal.footer.button.loading"),
      isLoading: n,
      disabled: !s,
      onClick: t,
      children: r("deleteAccount.modal.footer.button.confirm")
    }
  ) });
}, R2 = ({
  onSuccess: t,
  close: s
}) => {
  const { t: n } = O(["account", "common"], {
    nsMode: "fallback"
  }), [r, a] = M(!1), { success: o, error: i, loading: d } = fn(), { mutateAsync: l } = fe(
    ["customer", "deleteCustomer"],
    ({ Customer: u }) => u.deleteCustomer,
    {
      onMutate: z2,
      onError: (u) => {
        O2(u.error);
      },
      onSuccess: (u) => {
        A2(u.success);
      }
    }
  ), c = L(() => {
    M2(), o && t && t(), s();
  }, [t, o, s]), m = () => o ? /* @__PURE__ */ e.jsx(E2, {}) : i ? /* @__PURE__ */ e.jsx(D2, { errorMessage: "errorMessage" }) : /* @__PURE__ */ e.jsx(
    F2,
    {
      onConfirmDelete: a,
      confirmDelete: r
    }
  );
  return /* @__PURE__ */ e.jsx(
    ht,
    {
      footer: () => o ? /* @__PURE__ */ e.jsx(L2, { close: c }) : /* @__PURE__ */ e.jsx(
        V2,
        {
          onDelete: async () => {
            await l();
          },
          deleteConfirmed: r,
          loading: d
        }
      ),
      title: /* @__PURE__ */ e.jsx(k, { as: "span", className: "text-black", weight: "bold", children: n("deleteAccount.modal.title") }),
      onOpenChange: (u) => {
        u || c();
      },
      open: !0,
      children: m()
    }
  );
};
function $2({
  ref: t,
  type: s = "page"
}) {
  var i;
  const { locale: n, isPreview: r } = se(), { data: a } = bc(
    vc.PageSlug({
      type: s,
      locale: n || "en",
      preview: r,
      ref: t
    }),
    ({ Page: d }) => d.getSlugByPageRef({ locale: n || "en", preview: r, ref: t })
  );
  return {
    slugByRef: `${n}/${(i = a == null ? void 0 : a.items[0]) == null ? void 0 : i.slug}`
  };
}
const B2 = [
  "gdpr.paragraphOne",
  "gdpr.paragraphTwo",
  "gdpr.paragraphThree",
  "gdpr.paragraphFour",
  "gdpr.paragraphFive"
], I2 = () => {
  const { t } = O(["account", "common"], { nsMode: "fallback" }), s = se(), { oresundPayBase: n, app: r } = Ye(), a = s.locale || "sv", { slugByRef: o } = $2({ ref: "customer_support" }), [i, d] = M(!1), [l, c] = M(!1), m = Oe(), u = Zc(), h = (() => {
    let p;
    switch (r) {
      case ot.OresundPay:
        p = Jt({
          locale: a,
          key: "customerService",
          url: n
        });
        break;
      case ot.Oresundsbron:
        p = `/${o}`;
        break;
      default:
        p = "";
    }
    return p;
  })();
  return B(() => {
    var p, f;
    ((p = m.customerInformation) == null ? void 0 : p.contracts.filter(
      (x) => x.status === "closed"
    ).length) === ((f = m.customerInformation) == null ? void 0 : f.contracts.length) && c(!0);
  }, [m]), /* @__PURE__ */ e.jsxs($, { as: "section", className: "mb-2", children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        as: "h3",
        intent: "title",
        weight: "medium",
        size: "md",
        className: "mb-3 pt-6",
        children: t("gdpr.title")
      }
    ),
    /* @__PURE__ */ e.jsx(ke.Root, { rounded: !1, children: /* @__PURE__ */ e.jsxs(ke.Content, { className: "flex flex-col", children: [
      /* @__PURE__ */ e.jsx(k, { size: "sm", className: "mb-3", children: /* @__PURE__ */ e.jsx(G, { ns: "account", i18nKey: "gdpr.description", children: /* @__PURE__ */ e.jsx(In, {}) }) }),
      B2.map((p, f) => /* @__PURE__ */ e.jsxs(
        G,
        {
          ns: "account",
          i18nKey: p,
          children: [
            /* @__PURE__ */ e.jsx(k, { weight: "medium" }),
            /* @__PURE__ */ e.jsx(k, { size: "sm", className: "mb-4 mt-2 last-of-type:mb-0" })
          ]
        },
        `gdpr-para-${f}`
      )),
      l ? /* @__PURE__ */ e.jsx($, { className: "flex justify-end pt-3", children: /* @__PURE__ */ e.jsx(
        X,
        {
          type: "submit",
          className: "mt-4 justify-center",
          onClick: () => d(!0),
          children: t("deleteAccount.openmodal")
        }
      ) }) : /* @__PURE__ */ e.jsx($, { className: "flex justify-end pt-3", children: /* @__PURE__ */ e.jsx(
        X,
        {
          intent: "outlined",
          as: "a",
          href: h,
          className: "mb-1 mt-2",
          children: t("customerSupport.title").toUpperCase()
        }
      ) })
    ] }) }),
    l && i ? /* @__PURE__ */ e.jsx(
      R2,
      {
        onSuccess: () => {
          u();
        },
        close: () => d(!1)
      }
    ) : null
  ] });
};
function Qn() {
  const { mutateAsync: t } = fe(
    ["customer", "validate"],
    (n) => n.Customer.validate
  );
  return L(
    (n) => async (r) => {
      try {
        const a = await t(r);
        return n(a);
      } catch {
        return;
      }
    },
    [t]
  );
}
const gr = "---", br = (t, s) => `${t}${gr}${s}`, vs = (t) => {
  if (typeof t != "string")
    return "";
  if (!t.includes(gr))
    return t;
  const s = t.split(gr);
  return s.length > 0 ? s[0] : "";
};
function Xn() {
  const { mutateAsync: t } = fe(
    ["phone", "validate"],
    (n) => n.Phone.validate
  );
  return L(
    (n) => async (r) => {
      try {
        await t({
          ...r,
          phoneCode: vs(r.phoneCode)
        });
        return;
      } catch {
        return n;
      }
    },
    [t]
  );
}
const ts = (t, s) => t === s, qa = (t, s) => t == s, Vi = (t) => (s, n) => {
  for (const r in t)
    if (!t[r](s[r], n[r]))
      return !1;
  return !0;
}, Ri = (t) => (s) => (n) => t(s, n) ? null : n, _2 = Vi({
  country: ts,
  phone: ts,
  phoneCode: ts
}), W2 = Vi({
  ean: ts,
  vatno: ts
}), q2 = Ri(_2), H2 = Ri(W2), Ha = (t) => {
  var r;
  const [s, ...n] = ((r = t.attention) == null ? void 0 : r.split(
    " "
  )) ?? ["", ""];
  return {
    companyName: `${t.firstName} ${t.lastName}`,
    address: t.address,
    city: t.city,
    zipCode: t.zipCode,
    country: t.country,
    contact: {
      firstName: s,
      lastName: n.join(" "),
      phone: t.phone,
      phoneCode: t.phoneCode,
      email: t.email
    },
    phoneCode: t.phoneCode,
    phone: t.phone,
    ean: t.ean,
    vatno: t.companyNo,
    customerNo: t.customerNo
  };
}, $i = (t) => (s) => (n) => {
  for (const r in t)
    if (!t[r](s[r], n[r]))
      return n;
  return null;
}, U2 = $i({
  cpr: qa,
  email: qa
}), G2 = $i({ phone: ts, phoneCode: ts, country: ts }), K2 = (t, s) => (n) => s ? t.reduce((r, a) => {
  const o = s[a], i = n[a];
  return ts(o, i) ? { ...r, [a]: void 0 } : { ...r, [a]: i };
}, {}) : n, Z2 = (t) => (s) => [...s].sort((n, r) => {
  const a = yo(
    (i) => i.country
  ).compare(n, r);
  if (a !== 0) return a;
  const o = jo((i) => i.country)(
    t
  ).compare(n, r);
  return o !== 0 ? o : Co((i) => i.countryName).compare(n, r);
});
function Jn() {
  const { locale: t } = se(), { data: s } = ye(
    ee.PhoneCodeList({ locale: t }),
    (n) => n.Phone.phoneCodeList(t || "")
  );
  return D(() => s ? Z2(t || "")(s) : [], [s, t]);
}
const Y2 = ({
  open: t,
  onClose: s,
  defaultValues: n,
  onSubmit: r,
  onValidate: a,
  error: o,
  isLoading: i,
  namespace: d
}) => {
  const l = kt(), c = Jn(), { t: m } = O(["account", "common"], { nsMode: "fallback" }), u = Ae(null), { validate: h, handleSubmit: p, resetData: f } = he({
    namespace: d,
    onValidate: a,
    onSubmit: r
  });
  return B(
    () => () => {
      f();
    },
    [f]
  ), /* @__PURE__ */ e.jsxs(
    ht,
    {
      title: m("customerInformation.contactInformation.modal.title"),
      open: t,
      onOpenChange: s,
      children: [
        /* @__PURE__ */ e.jsx("p", { children: m("customerInformation.contactInformation.modal.info") }),
        /* @__PURE__ */ e.jsx(
          $,
          {
            as: "form",
            onSubmit: Nt(h, p),
            ref: u,
            onReset: s,
            children: /* @__PURE__ */ e.jsxs(Ue, { className: "mb-4 gap-4", children: [
              o ? o === "email" ? /* @__PURE__ */ e.jsx(ge, { color: "negative", className: "col-span-full", children: m("form.validations.email.exist") }) : /* @__PURE__ */ e.jsx(ge, { color: "negative", className: "col-span-full", children: m("errors.updateCustomer") }) : null,
              /* @__PURE__ */ e.jsx(
                el,
                {
                  disableNameChange: !0,
                  namespace: d,
                  labels: {
                    companyName: m("form.labels.companyName"),
                    country: m("form.labels.country"),
                    vatno: m("form.labels.vatno"),
                    ean: m("form.labels.ean"),
                    address: m("form.labels.address"),
                    zipCode: m("form.labels.zipCode"),
                    city: m("form.labels.city"),
                    contactPersonLabel: m("form.labels.contactPerson"),
                    contact: {
                      firstName: m("form.labels.firstName"),
                      lastName: m("form.labels.lastName"),
                      email: m("form.labels.email"),
                      phone: m("form.labels.phone"),
                      phoneCode: m("form.labels.phoneCode")
                    },
                    phone: m("form.labels.phone"),
                    phoneCode: m("form.labels.phoneCode")
                  },
                  countryOptions: l,
                  phoneCodeOptions: c,
                  defaultValues: n,
                  placeholders: {
                    country: m("form.labels.country"),
                    phoneCode: m("form.labels.phoneCode")
                  }
                }
              ),
              /* @__PURE__ */ e.jsxs($, { className: "col-span-full flex justify-self-end", children: [
                /* @__PURE__ */ e.jsx(X, { intent: "text", type: "reset", children: m("action.cancel") }),
                /* @__PURE__ */ e.jsx(
                  De,
                  {
                    intent: "solid",
                    type: "submit",
                    isLoading: i,
                    loadingLabel: m("action.loading"),
                    children: m("action.save")
                  }
                )
              ] })
            ] })
          }
        )
      ]
    }
  );
}, Q2 = ({
  labels: t,
  data: s,
  className: n
}) => {
  const r = [
    {
      key: "companyName",
      label: t.companyName,
      value: s.companyName,
      className: "col-span-full"
    },
    {
      key: "country",
      label: t.country,
      value: s.country,
      className: "col-span-full sm:col-span-4 md:col-span-6"
    },
    {
      key: "vatno",
      label: t.vatno,
      value: s.vatno,
      className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
    },
    ...s.country === "DK" ? [
      {
        key: "ean",
        label: t.ean,
        value: s.ean,
        className: "col-span-full"
      }
    ] : [],
    {
      key: "address",
      label: t.address,
      value: s.address,
      className: "col-span-full"
    },
    {
      key: "zipCode",
      label: t.zipCode,
      value: s.zipCode,
      className: "col-span-full sm:col-span-4 md:col-span-6"
    },
    {
      key: "city",
      label: t.city,
      value: s.city,
      className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
    },
    {
      key: "phoneCode",
      label: t.phoneCode,
      value: s.phoneCode,
      className: "col-span-full sm:col-span-4 md:col-span-6"
    },
    {
      key: "phone",
      label: t.phone,
      value: s.phone,
      className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
    },
    {
      key: "customerNo",
      label: t.customerNo,
      value: s.customerNo,
      className: "col-span-full sm:col-span-4 md:col-span-6"
    },
    {
      key: "contact.firstName",
      label: t.contact.firstName,
      value: s.contact.firstName,
      className: "col-span-full sm:col-span-4 md:col-span-6"
    },
    {
      key: "contact.lastName",
      label: t.contact.lastName,
      value: s.contact.lastName,
      className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
    },
    {
      key: "contact.email",
      label: t.contact.email,
      value: s.contact.email,
      className: "col-span-full"
    },
    {
      key: "contact.phoneCode",
      label: t.contact.phoneCode,
      value: s.contact.phoneCode,
      className: "col-span-full sm:col-span-4 md:col-span-6"
    },
    {
      key: "contact.phone",
      label: t.contact.phone,
      value: s.contact.phone,
      className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
    }
  ];
  return /* @__PURE__ */ e.jsxs(Ue, { className: He("mb-4 gap-4", n), children: [
    r.map(({ key: a, label: o, value: i, className: d }) => /* @__PURE__ */ e.jsx(ct, { label: o, className: d, children: i }, a)),
    /* @__PURE__ */ e.jsx(k, { className: "col-span-full mt-16", children: t.contactPersonLabel })
  ] });
}, Bi = Gt(), X2 = Gt(), Ua = Bi("ean", "vatno"), Ga = (t) => {
  const { phoneCode: s, phone: n } = X2(
    "phoneCode",
    "phone"
  )(t.contact);
  return {
    phoneCode: s,
    phone: n,
    ...Bi("country")(t)
  };
}, J2 = ({ isExternal: t }) => {
  const { t: s } = O(["account", "common"], { nsMode: "fallback" }), [n, r] = M(!1), { customerInformation: a, updateCustomer: o, isUpdating: i } = Oe(), [d, l] = M(), c = Qn(), m = Xn(), u = D(() => a ? Ha(a) : void 0, [a]), h = D(() => u ? Ua(u) : { ean: "", vatno: "" }, [u]), p = D(() => u ? Ga(u) : { phone: "", phoneCode: "", country: "" }, [u]), f = L(
    (b) => q2(p)(
      Ga(b)
    ) ? m({
      "contact.phone": s("form.validations.phone.invalid")
    })(b) : Promise.resolve([]),
    [m, s, p]
  ), x = L(
    (b) => {
      const v = {
        ean: h.ean ?? "",
        vatno: h.vatno
      }, S = Ua(b);
      return H2(v)({
        ean: S.ean ?? "",
        vatno: S.vatno
      }) ? c((w) => ({
        vatno: w.vatno ? s("form.validations.vatno.exist") : void 0
      }))(b) : Promise.resolve([]);
    },
    [c, s, h]
  ), g = L(
    async (b) => {
      if (!a) return;
      const v = await $t(
        mc.spa,
        s
      )(b), S = await f(b), y = await x(b), w = {
        ...S ?? {},
        ...y ?? {}
      };
      return {
        ...v ?? {},
        ...w
      };
    },
    [
      s,
      x,
      f,
      a
    ]
  ), N = L(
    async ({ contact: b, companyName: v, vatno: S, ...y }) => {
      if (!a) return;
      const [w, ...z] = v.split(" "), C = `${b.firstName} ${b.lastName}`, E = {
        ...a,
        ...b,
        ...y,
        attention: C,
        firstName: w,
        lastName: z.join(" "),
        companyNo: S
      }, A = await o(E);
      if (!A.success)
        return l(A.error);
      r(!1);
    },
    [r, o, l, a]
  );
  return a ? /* @__PURE__ */ e.jsx(ut, { children: /* @__PURE__ */ e.jsxs($, { as: "section", className: "mb-2", children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        as: "h3",
        intent: "title",
        weight: "medium",
        size: "md",
        className: "mb-3 mt-2",
        children: s("customerInformation.title")
      }
    ),
    /* @__PURE__ */ e.jsx(ke.Root, { rounded: !1, children: /* @__PURE__ */ e.jsxs(ke.Content, { className: "flex flex-col", children: [
      /* @__PURE__ */ e.jsx(
        Q2,
        {
          labels: {
            customerNo: s("form.labels.customerNo"),
            companyName: s("form.labels.companyName"),
            country: s("form.labels.country"),
            vatno: s("form.labels.vatno"),
            ean: s("form.labels.ean"),
            address: s("form.labels.address"),
            zipCode: s("form.labels.zipCode"),
            city: s("form.labels.city"),
            contact: {
              firstName: s("form.labels.firstName"),
              lastName: s("form.labels.lastName"),
              email: s("form.labels.email"),
              phone: s("form.labels.phone"),
              phoneCode: s("form.labels.phoneCode")
            },
            contactPersonLabel: s("form.labels.contactPerson"),
            phone: s("form.labels.phone"),
            phoneCode: s("form.labels.phoneCode")
          },
          data: Ha(a)
        }
      ),
      t ? null : /* @__PURE__ */ e.jsx(
        X,
        {
          intent: "text",
          className: "justify-end",
          onClick: () => r(!0),
          children: s("action.edit")
        }
      )
    ] }) }),
    /* @__PURE__ */ e.jsx(
      Y2,
      {
        namespace: "contactInformation",
        onClose: () => r(!1),
        open: n,
        defaultValues: u,
        onSubmit: N,
        onValidate: g,
        error: d,
        isLoading: i
      }
    )
  ] }) }) : /* @__PURE__ */ e.jsxs($, { as: "section", className: "mb-2", children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        as: "h3",
        intent: "title",
        weight: "medium",
        size: "md",
        className: "mb-3 mt-2",
        children: s("customerInformation.title")
      }
    ),
    /* @__PURE__ */ e.jsx($, { className: "my-2 rounded-[3px] bg-white px-3 py-4 sm:rounded-none sm:px-5", children: /* @__PURE__ */ e.jsx(ge, { color: "negative", children: s("errors.getCustomer") }) })
  ] });
}, e3 = ({
  labels: t,
  data: s,
  className: n
}) => {
  const r = [
    {
      key: "firstName",
      label: t.firstName,
      value: s.firstName,
      className: "col-span-full sm:col-span-4 md:col-span-6"
    },
    {
      key: "lastName",
      label: t.lastName,
      value: s.lastName,
      className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
    },
    {
      key: "country",
      label: t.country,
      value: s.country,
      className: "col-span-full sm:col-span-4 md:col-span-6"
    },
    ...s.cpr ? [
      {
        key: "cpr",
        label: t.cpr,
        value: s.cpr,
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
      }
    ] : [],
    {
      key: "address",
      label: t.address,
      value: s.address,
      className: "col-span-full"
    },
    {
      key: "zipCode",
      label: t.zipCode,
      value: s.zipCode,
      className: "col-span-full sm:col-span-4 md:col-span-6"
    },
    {
      key: "city",
      label: t.city,
      value: s.city,
      className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
    },
    {
      key: "phoneCode",
      label: t.phoneCode,
      value: s.phoneCode,
      className: "col-span-full sm:col-span-4 md:col-span-6"
    },
    {
      key: "phone",
      label: t.phone,
      value: s.phone,
      className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
    },
    {
      key: "email",
      label: t.email,
      value: s.email,
      className: "col-span-full sm:col-span-4 md:col-span-6"
    },
    {
      key: "customerNo",
      label: t.customerNo,
      value: s.customerNo,
      className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
    }
  ];
  return /* @__PURE__ */ e.jsx(Ue, { className: He("mb-4 gap-4", n), children: r.map(({ key: a, label: o, value: i, className: d }) => /* @__PURE__ */ e.jsx(ct, { label: o, className: d, children: i }, a)) });
}, t3 = ({
  open: t,
  onClose: s,
  defaultValues: n,
  onSubmit: r,
  onValidate: a,
  error: o,
  isLoading: i,
  namespace: d
}) => {
  const l = kt(), c = Jn(), { t: m } = O(["account", "common"], { nsMode: "fallback" }), u = Ae(null), { validate: h, handleSubmit: p, resetData: f } = he({
    namespace: d,
    onValidate: a,
    onSubmit: r
  });
  return B(
    () => () => {
      f();
    },
    [f]
  ), /* @__PURE__ */ e.jsxs(
    ht,
    {
      title: m("customerInformation.contactInformation.modal.title"),
      open: t,
      onOpenChange: s,
      children: [
        /* @__PURE__ */ e.jsx("p", { children: m("customerInformation.contactInformation.modal.info") }),
        /* @__PURE__ */ e.jsx(
          $,
          {
            as: "form",
            onSubmit: Nt(h, p),
            onReset: s,
            ref: u,
            children: /* @__PURE__ */ e.jsxs(Ue, { className: "mb-4 gap-4", children: [
              o ? o === "email" ? /* @__PURE__ */ e.jsx(ge, { color: "negative", className: "col-span-full", children: m("form.validations.email.exist") }) : /* @__PURE__ */ e.jsx(ge, { color: "negative", className: "col-span-full", children: m("errors.updateCustomer") }) : null,
              /* @__PURE__ */ e.jsx(
                Ui,
                {
                  disableNameChange: !0,
                  namespace: d,
                  placeholders: {
                    country: m("form.placeholders.country"),
                    phoneCode: m("form.placeholders.phoneCode")
                  },
                  labels: {
                    firstName: m("form.labels.firstName"),
                    lastName: m("form.labels.lastName"),
                    cpr: m("form.labels.cpr"),
                    city: m("form.labels.city"),
                    address: m("form.labels.address"),
                    email: m("form.labels.email"),
                    zipCode: m("form.labels.zipCode"),
                    phone: m("form.labels.phone"),
                    phoneCode: m("form.labels.phoneCode"),
                    country: m("form.labels.country")
                  },
                  countryOptions: l,
                  phoneCodeOptions: c,
                  defaultValues: n
                }
              ),
              /* @__PURE__ */ e.jsxs($, { className: "col-span-full flex justify-self-end", children: [
                /* @__PURE__ */ e.jsx(X, { intent: "text", type: "reset", children: m("action.cancel") }),
                /* @__PURE__ */ e.jsx(
                  De,
                  {
                    intent: "solid",
                    type: "submit",
                    isLoading: i,
                    loadingLabel: m("action.loading"),
                    children: m("action.save")
                  }
                )
              ] })
            ] })
          }
        )
      ]
    }
  );
}, Ii = Gt(), Ka = Ii("country", "phoneCode", "phone"), Za = Ii("cpr", "email"), s3 = ({
  isExternal: t
}) => {
  const { t: s } = O(["account", "common"], { nsMode: "fallback" }), [n, r] = M(!1), [a, o] = M(), i = se(), d = i.locale, { modal: l } = i.query, { setVerifyContactDetailsDate: c } = Fr(), { customerInformation: m, updateCustomer: u, isUpdating: h } = Oe(), p = Qn(), f = Xn();
  B(() => {
    r(l === "edit");
  }, [l]);
  const x = D(() => m ? Za(m) : { cpr: "", email: "" }, [m]), g = D(() => m ? Ka(m) : { phone: "", phoneCode: "", country: "" }, [m]), N = L(
    async (y, w) => {
      if (!dt("phone")(w)) return;
      const z = Ka(y);
      if (!G2(g)(z)) return;
      const C = await f({
        phone: s("form.validations.phone.invalid")
      })(z);
      if (C) return C;
    },
    [s, f, g]
  ), b = L(
    async (y, w) => {
      const z = Za(y);
      if (!U2(x)(z)) return;
      const C = K2(["email"], x)(z), E = await p(
        (A) => ({
          email: A.email && dt("email")(w) ? s("form.validations.email.exist") : void 0
        })
      )(C);
      if (E) return E;
    },
    [p, s, x]
  ), v = L(
    async (y) => {
      const w = await $t(
        po.spa,
        s
      )(y);
      if (!w) return;
      const [z, C] = await Promise.all([
        N(y, w),
        b(y, w)
      ]);
      return {
        ...w,
        ...z,
        ...C
      };
    },
    [s, b, N]
  ), S = L(
    async (y) => {
      if (!m) return;
      const w = await u({ ...m, ...y });
      if (!w.success)
        return o(w.error);
      await c(), r(!1);
    },
    [
      r,
      u,
      o,
      m,
      c
    ]
  );
  return m ? /* @__PURE__ */ e.jsx(ut, { children: /* @__PURE__ */ e.jsxs($, { as: "section", className: "mb-2", children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        as: "h3",
        intent: "title",
        weight: "medium",
        size: "md",
        className: "mb-3 mt-2",
        children: s("customerInformation.title")
      }
    ),
    /* @__PURE__ */ e.jsx(ke.Root, { rounded: !1, children: /* @__PURE__ */ e.jsxs(ke.Content, { className: "flex flex-col", children: [
      /* @__PURE__ */ e.jsx(
        e3,
        {
          labels: {
            firstName: s("form.labels.firstName"),
            lastName: s("form.labels.lastName"),
            cpr: s("form.labels.cpr"),
            city: s("form.labels.city"),
            address: s("form.labels.address"),
            email: s("form.labels.email"),
            zipCode: s("form.labels.zipCode"),
            phone: s("form.labels.phone"),
            phoneCode: s("form.labels.phoneCode"),
            country: s("form.labels.country"),
            customerNo: s("form.labels.customerNo")
          },
          data: m
        }
      ),
      !t && /* @__PURE__ */ e.jsx(
        X,
        {
          intent: "text",
          className: "justify-end",
          onClick: () => r(!0),
          children: s("action.edit")
        }
      )
    ] }) }),
    /* @__PURE__ */ e.jsx(
      t3,
      {
        namespace: "contactInformation",
        onClose: () => {
          i.push(`/${d}/account/customerInformation`, void 0, {
            shallow: !0
          }), r(!1);
        },
        open: n,
        defaultValues: m,
        onSubmit: S,
        onValidate: v,
        error: a,
        isLoading: h
      }
    )
  ] }) }) : /* @__PURE__ */ e.jsxs($, { as: "section", className: "mb-2", children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        as: "h3",
        intent: "title",
        weight: "medium",
        size: "md",
        className: "mb-3 mt-2",
        children: s("customerInformation.title")
      }
    ),
    /* @__PURE__ */ e.jsx($, { className: "my-2 rounded-[3px] bg-white px-3 py-4 sm:rounded-none sm:px-5", children: /* @__PURE__ */ e.jsx(ge, { color: "negative", children: s("errors.getCustomer") }) })
  ] });
};
function n3() {
  const { customerInformation: t } = Oe(), s = D(() => t && "customerNo" in t ? t.customerNo : "", [t]), { data: n, isLoading: r, error: a } = ye(
    ee.MarketingCommunication(s),
    ({ MarketingCommunication: l }) => l.getConsent()
  ), { mutateAsync: o, isLoading: i } = fe(
    ee.MarketingCommunicationMutation(s),
    ({ MarketingCommunication: l }) => l.patchConsent
  ), d = L(
    (l) => {
      try {
        o(l);
      } catch (c) {
        return { success: !1, error: c.error };
      }
    },
    [o]
  );
  return { data: n, updateConsent: d, isLoading: r, isUpdating: i };
}
const r3 = () => {
  const { t } = Cr(["account"], { nsMode: "fallback" }), s = pt(), n = D(
    () => !!(s != null && s.get("flag-marketing-communication")),
    [s]
  ), { data: r, updateConsent: a, isLoading: o, isUpdating: i } = n3(), { contract: d } = Xr(), l = (d == null ? void 0 : d.agreementType) === Z.OresundGo || (d == null ? void 0 : d.agreementType) === Z.OresundPendler || (d == null ? void 0 : d.agreementType) === Z.OresundBusiness;
  return !n || !r && !l ? null : (r == null ? void 0 : r.status) === 204 ? (console.info("Marketing Communication: No user found."), null) : /* @__PURE__ */ e.jsxs($, { as: "section", className: "mb-2", children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        as: "h3",
        intent: "title",
        weight: "medium",
        size: "md",
        className: "mb-3 pt-6",
        children: t("marketingCommunication.title")
      }
    ),
    /* @__PURE__ */ e.jsx(ke.Root, { rounded: !1, children: /* @__PURE__ */ e.jsxs(ke.Content, { className: "flex flex-col", children: [
      /* @__PURE__ */ e.jsx(k, { size: "md", className: "mb-3", children: t("marketingCommunication.description") }),
      /* @__PURE__ */ e.jsx(
        ns,
        {
          label: t("marketingCommunication.checkboxLabel"),
          defaultChecked: !(r != null && r.acceptMarketing),
          onChange: (c) => a({ acceptMarketing: !c.target.checked }),
          disabled: o || i
        }
      )
    ] }) })
  ] });
}, Hg = () => {
  const t = pt(), s = !!(t != null && t.get("mit-id")), { app: n } = Ye(), { t: r } = O(["account", "common"], { nsMode: "fallback" }), { customerType: a } = Ot(), { data: o } = Ke(), i = D(() => o ? us(o.paymentAgreement.provider) : !0, [o]), d = n === "oresundsbron.com";
  return a === "business-commuter" ? /* @__PURE__ */ e.jsx(zt, { variant: "notice", children: r("customerInformation.unauthorized") }) : /* @__PURE__ */ e.jsx($, { children: /* @__PURE__ */ e.jsx(
    Vt,
    {
      fallback: /* @__PURE__ */ e.jsx($, { className: "flex items-center justify-center p-5", children: /* @__PURE__ */ e.jsx($, { className: "w-11", children: /* @__PURE__ */ e.jsx(nn, { label: r("action.loading") }) }) }),
      children: /* @__PURE__ */ e.jsxs($, { className: "rounded-[15px] bg-neutral-100 px-4 py-3 sm:rounded-[23px] sm:px-8 sm:py-6 md:rounded-[30px]", children: [
        [
          ds.businessCustomer,
          ds.affiliatePartner
        ].includes(a) ? /* @__PURE__ */ e.jsx(J2, { isExternal: i }) : /* @__PURE__ */ e.jsx(s3, { isExternal: i }),
        /* @__PURE__ */ e.jsx(S2, {}),
        /* @__PURE__ */ e.jsx(Wa, { authConnection: "BankID" }),
        s && /* @__PURE__ */ e.jsx(Wa, { authConnection: "MitID" }),
        d && /* @__PURE__ */ e.jsx(r3, {}),
        /* @__PURE__ */ e.jsx(I2, {})
      ] })
    }
  ) });
};
var Xt = /* @__PURE__ */ ((t) => (t.error = "error", t.hide = "hide", t.newCodeSent = "newCodeSent", t))(Xt || {});
const _i = (t) => Object.keys(t).filter((s) => s !== "country" && !!t[s]).length === 0, a3 = it.fromPath()([
  "contact",
  "phoneCode"
]), o3 = it.fromPath()([
  "phoneCode"
]), i3 = it.fromPath()([
  "contactInformation",
  "phoneCode"
]), l3 = ({
  status: t,
  errorText: s,
  ns: n
}) => {
  const { t: r } = O(n, {
    nsMode: "fallback"
  }), a = (i) => {
    switch (i) {
      case Z.ACCOUNT_BLOCKED.value:
        return r("codeVerification.verificationError.accountBlocked");
      case Z.CODE_LENGTH_INVALID.value:
        return r("codeVerification.verificationError.pastedCodeInvalid");
      default:
        return r("codeVerification.verificationError.default");
    }
  };
  return (() => {
    const i = "flex items-center text-xs py-3 px-4";
    switch (t) {
      case Xt.newCodeSent:
        return /* @__PURE__ */ e.jsxs("div", { className: `${i} bg-green-100 text-green-800`, children: [
          /* @__PURE__ */ e.jsx(an, { className: "mr-4" }),
          " ",
          r("codeVerification.newCodeSent")
        ] });
      case Xt.error:
        return /* @__PURE__ */ e.jsxs("div", { className: `${i} bg-red-100 text-red-700`, children: [
          /* @__PURE__ */ e.jsx(ao, { className: "mr-4" }),
          " ",
          a(s)
        ] });
      default:
        return /* @__PURE__ */ e.jsx(e.Fragment, {});
    }
  })();
}, Wi = ({ namespace: t, titleTranslationKey: s, ns: n, isBusiness: r }) => {
  const { resetAuthentication: a } = Ot(), { mutateAsync: o } = fe(
    ["customer", "code"],
    (T) => T.Customer.verifyCodeV2,
    {
      retry: 0,
      onMutate: () => {
        a();
      }
    }
  ), i = fe(
    ["customer", "verify"],
    (T) => T.Customer.verifyCustomerV2,
    {
      retry: 0
    }
  ), { t: d } = O(n, {
    nsMode: "fallback"
  }), { getData: l } = he({
    namespace: "contactInformation"
  }), { getData: c } = he({
    namespace: "contactInformation"
  }), m = () => r ? c().contact.email : l().email, [u, h] = M(["", "", "", "", "", ""]), [p, f] = M(
    Xt.hide
  ), [x, g] = M(""), N = L(
    (T) => async (P) => {
      try {
        const V = await o(P);
        return T(V);
      } catch (V) {
        return g(V.error), T({
          token: ""
        });
      }
    },
    [o]
  ), b = async (T) => {
    f(Xt.hide);
    const V = await N((_) => ({
      code: !_.token || _.token === "" ? d("form.validations.code.invalid") : void 0
    }))({
      code: `${T.code}`,
      email: m()
    }), I = Object.values(V);
    for (const _ of I)
      if (_)
        return f(Xt.error), V;
    S("codeVerified", "true", "boolean");
  }, {
    registerField: v,
    setFieldData: S,
    getError: y,
    validate: w,
    isValid: z,
    isActive: C,
    stepNr: E
  } = he({
    namespace: t,
    onValidate: b
  }), A = () => !!(!C || !z || u.includes("")), F = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    [0, 1, 2, 3, 4, 5].map((T) => /* @__PURE__ */ e.jsx(
      "input",
      {
        value: u[T],
        id: `code-verification-input-${T}`,
        className: "h-20 w-16 rounded-3xl border-2 border-gray-500 p-2.5 text-center text-4xl",
        disabled: !C,
        onChange: (P) => {
          var I;
          const V = u.map((_, ne) => T == ne ? P.target.value : _);
          h(V), T < 5 && P.target.value !== "" && ((I = document.getElementById(`code-verification-input-${T + 1}`)) == null || I.focus());
        },
        maxLength: 1,
        onPaste: (P) => {
          P.preventDefault();
          const V = P.clipboardData.getData("text/plain");
          if (V === "") {
            f(Xt.error), g(Z.CODE_LENGTH_INVALID.value);
            return;
          }
          const I = V.trim();
          if (I.length < 6 || I.length > 7) {
            f(Xt.error), g(Z.CODE_LENGTH_INVALID.value);
            return;
          }
          h(Array.from(I));
        }
      },
      T
    )),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "hidden h-20 w-16 rounded-3xl border-2 border-gray-500 p-2.5 text-center text-4xl",
        ...v("code"),
        label: "",
        error: y("code"),
        required: !0,
        hidden: !0,
        value: u.join("")
      }
    )
  ] }), R = async () => {
    var T;
    h(["", "", "", "", "", ""]), await i.mutateAsync({ email: m() }), (T = document.getElementById("code-verification-input-0")) == null || T.focus(), f(Xt.newCodeSent);
  };
  return B(() => {
    S("code", u.join(""), "string");
  }, [u, S]), /* @__PURE__ */ e.jsxs(Bt, { nr: E, title: d(s), id: t, children: [
    /* @__PURE__ */ e.jsx($, { className: "col-span-full mb-1 mt-1", children: /* @__PURE__ */ e.jsx(k, { intent: "label", size: "lg", children: d("codeVerification.verifyText") }) }),
    F(),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full mb-1", children: /* @__PURE__ */ e.jsx(
      l3,
      {
        status: p,
        errorText: x,
        ns: n
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full mb-1", children: /* @__PURE__ */ e.jsx(
      X,
      {
        intent: "text",
        className: "pl-0 text-blue-600 underline",
        onClick: () => R(),
        children: d("codeVerification.sendNewCode")
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      Ms,
      {
        loadingLabel: d("action.loading"),
        namespace: t,
        onClick: w(),
        disabled: A()
      }
    )
  ] });
}, c3 = ({ onSuccess: t, onError: s, tokenInformation: n }) => {
  const { data: r, error: a, isError: o, isLoading: i, refetch: d } = ye(
    ee.ReepayTokenDetail(n),
    (c) => c.Reepay.token(n),
    {
      enabled: !1,
      staleTime: 0,
      refetchOnMount: !1
    }
  );
  B(() => {
    d();
  }, []), B(() => {
    a && s(a);
  }, [a, s]);
  const l = L(
    (c) => t(c, r == null ? void 0 : r.session),
    [r == null ? void 0 : r.session, t]
  );
  return !r && !o || i ? /* @__PURE__ */ e.jsx("div", { className: "item-center text-primary-400 col-span-full flex h-[600px] items-center justify-center text-5xl md:col-span-6 md:col-start-4", children: /* @__PURE__ */ e.jsx(
    "svg",
    {
      className: "animate-spin",
      fill: "currentColor",
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }
      )
    }
  ) }) : /* @__PURE__ */ e.jsx(si, { onSuccess: l, token: r == null ? void 0 : r.token });
}, Ya = (t) => (s) => t[s](), Ws = () => {
  const t = at(Vo);
  if (!t)
    throw new Error(
      "useContractsStore must be used within a ContractsStoreProvider"
    );
  const {
    getContracts: s,
    reset: n,
    setMainContract: r,
    discountMainContract: a,
    removeDiscountMainContract: o
  } = t;
  return {
    getContracts: s,
    reset: n,
    setMainContract: r,
    discountMainContract: a,
    removeDiscountMainContract: o
  };
}, yt = Ns(() => ({
  isPasswordSet: !1,
  payWithCreditCard: !1
})), zs = {
  setRequestData: (t) => yt.setState((s) => ({ ...s, data: t })),
  setResponse: (t) => yt.setState((s) => ({ ...s, resp: t, error: void 0 })),
  setError: (t) => yt.setState((s) => ({ ...s, error: t, resp: void 0 })),
  setIsPasswordSet: () => yt.setState((t) => ({ ...t, isPasswordSet: !0 })),
  setPayWithCreditCard: () => yt.setState((t) => ({ ...t, payWithCreditCard: !0 })),
  setToken: (t) => yt.setState((s) => ({ ...s, token: t })),
  resetStore: () => yt.setState(() => ({
    isPasswordSet: !1,
    payWithCreditCard: !1,
    data: void 0,
    resp: void 0,
    error: void 0,
    token: void 0
  }))
}, d3 = it.fromProp()("paymentMethod"), m3 = it.fromPath()(["termsOfAgreement", "currency"]), u3 = it.fromProp()("contactInformation"), h3 = it.fromProp()("contractType"), p3 = it.fromPath()([
  "termsOfAgreement",
  "campaignCode"
]), f3 = it.fromPath()([
  "payment",
  "paymentEntries"
]), x3 = (t) => f3.get(t).some((r) => r.weightClass === "true") ? "true" : "false", g3 = (t) => t ? x3(t) : void 0, b3 = (t) => t ? h3.get(t) : void 0, v3 = (t) => t ? m3.get(t) : void 0;
function y3(t) {
  return !!t && typeof t == "object" && "commuter" in t && !!t.commuter;
}
const j3 = (t) => {
  if (!t) return;
  const s = u3.get(t);
  if (!s || !y3(s)) return;
  const n = s;
  if (n.commuter)
    return n.commuter.startDate;
}, C3 = (t) => t ? p3.get(t) : void 0, N3 = (t, s) => (n) => {
  if (n)
    return d3.set({
      method: "card",
      card: { data: { ...t, error: "" }, session: s }
    })(n);
}, qi = () => {
  const { data: t } = yt(), [s, n] = M(!1), { getContracts: r } = Ws(), { contracts: a } = r(), { setResponse: o, setError: i, setToken: d } = zs, l = (f) => (x) => {
    const g = x;
    o(g), d(g.code);
    let N = {
      email: "",
      firstName: "",
      lastName: "",
      phone: "",
      phoneCode: ""
    };
    f.contactInformation.contact ? N = f.contactInformation.contact : N = f.contactInformation, Wr(), _r(
      {
        transaction_id: g.orderNo,
        value: `${a.map((v) => v.prices).flat().filter(
          (v) => v.currency === f.termsOfAgreement.currency
        ).reduce((v, S) => v + S.priceInclVat, 0)}`,
        currency: f.termsOfAgreement.currency,
        coupon: f.termsOfAgreement.campaignCode,
        items: a.map((b) => ({
          // See ticket 7308
          item_name: Ya({
            Oresund_Business_Pendler: () => "OresundCommuter",
            Oresund_Business: () => "OresundBusiness",
            OresundPAYBusiness: () => "OresundPay",
            OresundPendler: () => "OresundCommuter",
            OresundPAY: () => "OresundPay",
            Storebelt: () => "Storebelt"
          })(
            b.value
          ),
          item_category: Ya({
            Oresund_Business_Pendler: () => "Business",
            Oresund_Business: () => "Business",
            OresundPAYBusiness: () => "Business",
            OresundPendler: () => "Private",
            OresundPAY: () => "Private",
            Storebelt: () => "Private"
          })(
            b.value
          ),
          item_variant: "OperatorSignup",
          quantity: "1",
          price: (() => {
            var S;
            const v = (S = b.prices.find(
              (y) => y.currency === f.termsOfAgreement.currency
            )) == null ? void 0 : S.priceInclVat;
            return v ? `${v}` : "";
          })()
        }))
      },
      {
        email: N.email,
        firstName: N.firstName,
        lastName: N.lastName,
        phone: `+${f.contactInformation.phoneCode}${f.contactInformation.phone}`,
        city: f.contactInformation.city,
        address1: f.contactInformation.address,
        zipCode: f.contactInformation.zipCode,
        company: f.contactInformation.companyName ?? "",
        country: f.contactInformation.country
      }
    ), f.subscribeToClub && Tm(f.contractType);
  }, c = (f) => {
    Qr(f) && i(f);
  }, { mutateAsync: m } = fe(
    ["signup"],
    (f) => f.Customer.signup,
    {
      onError: c,
      onSuccess: l(t),
      onSettled: () => n(!1)
    }
  ), u = D(() => {
    try {
      const f = g3(t), x = v3(t), g = b3(t), N = C3(t), b = j3(t);
      if (f === void 0 || x === void 0 || g === void 0)
        throw Error("token - required prop is undefined");
      return {
        isHGV: f,
        currency: x,
        identity: g,
        campaignCode: N,
        startDate: b
      };
    } catch {
      i({ code: 500, error: "no signup data initialized" });
      return;
    }
  }, [t]), h = L((f) => f && (uc(f) ? {
    ...f,
    contactInformation: {
      ...f.contactInformation,
      ...o3.modify(vs)(
        f.contactInformation
      ),
      ...a3.modify(vs)(
        f.contactInformation
      )
    }
  } : i3.modify(vs)(f)), []), p = L(
    async (f, x) => {
      var v, S, y, w, z;
      if (!t) return;
      const g = {
        ...t,
        subscribeToClub: t.subscribeToClub || {},
        paymentAgreement: {
          bizzNumber: ((v = t.paymentAgreement) == null ? void 0 : v.bizzNumber) || "",
          country: ((S = t.paymentAgreement) == null ? void 0 : S.country) || "SE",
          licensePlate: ((y = t.paymentAgreement) == null ? void 0 : y.licensePlate) || "",
          oresundsPay: ((w = t.paymentAgreement) == null ? void 0 : w.oresundsPay) || "true",
          paymentProvider: ((z = t.paymentAgreement) == null ? void 0 : z.paymentProvider) || ""
        }
      }, N = h(g), b = N3(f, x)(N);
      b && (n(!0), await m(b));
    },
    [t, m, h]
  );
  return s ? /* @__PURE__ */ e.jsx($, { className: "item-center col-span-full flex h-[600px] items-center justify-center text-5xl md:col-span-6 md:col-start-4", children: /* @__PURE__ */ e.jsx(
    "svg",
    {
      className: "animate-spin",
      fill: "currentColor",
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }
      )
    }
  ) }) : /* @__PURE__ */ e.jsx(
    c3,
    {
      tokenInformation: u,
      onError: c,
      onSuccess: p
    }
  );
}, w3 = ({ title: t, ns: s, transKey: n, className: r, listMode: a }) => /* @__PURE__ */ e.jsxs(ge, { className: r, children: [
  /* @__PURE__ */ e.jsx(k, { children: t }),
  a && /* @__PURE__ */ e.jsx($, { as: "ul", className: "mt-2 list-disc pl-6", children: /* @__PURE__ */ e.jsxs(G, { i18nKey: n, ns: s, children: [
    /* @__PURE__ */ e.jsx(k, { as: "li" }),
    /* @__PURE__ */ e.jsx(k, { as: "li" }),
    /* @__PURE__ */ e.jsx(k, { as: "li" }),
    /* @__PURE__ */ e.jsx(k, { as: "li" })
  ] }) })
] }), k3 = ({
  icon: t,
  text: s,
  onSelect: n,
  selected: r,
  id: a
}) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    onClick: (o) => n(a),
    className: "flex h-10 flex-row items-center border-t-orange-50 [&:nth-child(n+1)]:border-t-2",
    children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex w-10/12 flex-row items-center justify-start gap-2", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flex h-10 w-10 items-center justify-center", children: t }),
        /* @__PURE__ */ e.jsx(k, { children: s })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "flex w-2/12 flex-row items-center justify-center gap-2", children: r === a ? /* @__PURE__ */ e.jsx(an, {}) : null })
    ]
  }
), P3 = ({ onChange: t, items: s }) => {
  const [n, r] = M(s[0].id), a = (o) => {
    r(o), t(o);
  };
  return /* @__PURE__ */ e.jsx("div", { className: "w-64 cursor-pointer rounded-lg border-2 border-solid md:w-96", children: s.map((o, i) => /* @__PURE__ */ e.jsx(
    k3,
    {
      icon: o.icon,
      text: o.text,
      onSelect: a,
      selected: n,
      id: o.id
    },
    o.id
  )) });
}, T3 = ({ className: t, height: s = "3em", width: n = "3em" }) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 619.2 513",
    width: n,
    height: s,
    className: t,
    children: [
      /* @__PURE__ */ e.jsxs("g", { children: [
        /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "#193E4F",
            d: "M251.3,263.4l13.2-83.2c-5.2,0-14.1,0-14.1,0c-6.6,0-15.1-3.7-17.6-10.5c-0.8-2.3-2.7-10.2,8.2-17.9   c3.9-2.7,6.4-5.7,6.9-8c0.5-2.4-0.1-4.5-1.8-6.1c-2.4-2.3-7.1-3.6-13.1-3.6c-10.1,0-17.2,5.8-17.9,10c-0.5,3.1,1.9,5.6,4,7.2   c6.3,4.7,7.8,11.5,3.9,17.9c-4,6.6-12.7,10.9-22,11c0,0-9.2,0-14.4,0c-1.2,8.1-20.8,132.3-22.3,142.1h77.8   C242.8,318,246.4,294.5,251.3,263.4L251.3,263.4z"
          }
        ),
        /* @__PURE__ */ e.jsxs("g", { children: [
          /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "#193E4F",
              d: "M160.1,351.1H192c13.6,0,16.9,6.9,15.9,13.2c-0.8,5.1-4.3,8.9-10.3,11.4c7.6,2.9,10.6,7.4,9.5,14.5    c-1.4,8.9-9.1,15.5-19.2,15.5h-36.3L160.1,351.1z M181.2,373.7c6.2,0,9.1-3.3,9.7-7.2c0.6-4.2-1.3-7.1-7.5-7.1h-5.5l-2.2,14.3    H181.2z M177.8,397.2c6.4,0,10.1-2.6,11-7.9c0.7-4.6-1.9-7.3-8.1-7.3h-6.2l-2.4,15.3H177.8z"
            }
          ),
          /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "#193E4F",
              d: "M251.8,406.1c-8.3,0.6-12.3-0.3-14.3-3.9c-4.4,2.7-9.3,4.1-14.5,4.1c-9.4,0-12.7-4.9-11.8-10.3    c0.4-2.6,1.9-5.1,4.3-7.2c5.2-4.5,18-5.1,23-8.5c0.4-3.8-1.1-5.2-5.8-5.2c-5.5,0-10.1,1.8-18,7.2l1.9-12.4    c6.8-4.9,13.4-7.2,21-7.2c9.7,0,18.3,4,16.7,14.6l-1.9,12c-0.7,4.2-0.5,5.5,4.2,5.6L251.8,406.1z M237.4,387.2    c-4.4,2.8-12.6,2.3-13.5,8.1c-0.4,2.7,1.3,4.7,4,4.7c2.6,0,5.8-1.1,8.4-2.9c-0.2-1-0.1-2,0.2-3.9L237.4,387.2z"
            }
          ),
          /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "#193E4F",
              d: "M267.3,363.4h16.6l-0.9,5.5c5.3-4.5,9.3-6.2,14.5-6.2c9.3,0,13.6,5.7,12.1,15l-4.3,27.9h-16.6l3.6-23.1    c0.7-4.2-0.6-6.2-3.8-6.2c-2.6,0-5,1.4-7.3,4.5l-3.8,24.7h-16.6L267.3,363.4z"
            }
          ),
          /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "#193E4F",
              d: "M322.6,351.1h16.6l-4.2,26.8l15.9-14.5h20.5l-20.4,18l16.4,24.2h-20.9L333.9,386h-0.2l-3,19.5h-16.6    L322.6,351.1z"
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx("path", { fill: "#193E4F", d: "M381.3,351.1h19.1l-8.4,54.5h-19.1L381.3,351.1z" }),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "#193E4F",
            d: "M409.7,351.1H437c21.1,0,27.2,15.3,25.2,28c-1.9,12.4-11.7,26.5-30.2,26.5h-30.8L409.7,351.1z M427.4,392.6   c9.3,0,14.4-4.6,15.9-14.3c1.1-7.2-1.1-14.3-11.4-14.3h-5.1l-4.4,28.6H427.4z"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "#193E4F",
            d: "M355.9,107.5h-79.5l-10.6,67.3l13.5,0c7.4,0,14.4-3.4,17.4-8.3c1-1.6,1.4-3,1.4-4.3c0-2.8-1.9-4.9-3.8-6.3   c-5.2-3.9-6.3-8-6.3-10.9c0-0.6,0-1.1,0.1-1.6c1.1-7.1,10.7-14.8,23.4-14.8c7.6,0,13.4,1.8,16.9,5.1c3.1,2.9,4.3,7,3.4,11.3   c-1.1,5.1-6.2,9.3-9.1,11.4c-7.7,5.4-6.7,10.1-6.2,11.5c1.6,4.2,7.7,6.9,12.4,6.9h20.6c0,0,0,0,0,0.1c28,0.2,43,13.1,38.3,43.1   c-4.4,27.9-25.8,39.9-51.3,40.1l-10.1,64.4h14.9c62.9,0,114.3-40.4,124.4-104.2C478.2,139.1,427.9,107.5,355.9,107.5z"
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx("rect", { fill: "none", width: "619.2", height: "513" })
    ]
  }
), S3 = ({ height: t = "3em", width: s = "3em" }) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    width: s,
    height: t,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e.jsx(
        "mask",
        {
          id: "prefix__a",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: 0,
          y: 0,
          width: 23,
          height: 24,
          children: /* @__PURE__ */ e.jsx("path", { d: "M0 0h24v24H0z" })
        }
      ),
      /* @__PURE__ */ e.jsx("g", { mask: "url(#prefix__a)", children: /* @__PURE__ */ e.jsx("path", { d: "M12 12c-1.1 0-2.042-.392-2.825-1.175C8.392 10.042 8 9.1 8 8s.392-2.042 1.175-2.825C9.958 4.392 10.9 4 12 4s2.042.392 2.825 1.175C15.608 5.958 16 6.9 16 8s-.392 2.042-1.175 2.825C14.042 11.608 13.1 12 12 12Zm6 8H6c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 4 18v-.8c0-.567.146-1.088.438-1.563A2.914 2.914 0 0 1 5.6 14.55a14.866 14.866 0 0 1 3.15-1.163A13.776 13.776 0 0 1 12 13c1.1 0 2.183.129 3.25.387 1.067.259 2.117.646 3.15 1.163.483.25.87.612 1.162 1.087.292.475.438.996.438 1.563v.8c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 18 20ZM6 18h12v-.8a.943.943 0 0 0-.137-.5.977.977 0 0 0-.363-.35c-.9-.45-1.808-.788-2.725-1.013a11.615 11.615 0 0 0-5.55 0c-.917.225-1.825.563-2.725 1.013a.97.97 0 0 0-.5.85v.8Zm6-8c.55 0 1.021-.196 1.413-.588C13.804 9.021 14 8.55 14 8c0-.55-.196-1.02-.587-1.412A1.927 1.927 0 0 0 12 6c-.55 0-1.02.196-1.412.588A1.923 1.923 0 0 0 10 8c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Z" }) })
    ]
  }
), M3 = ({ className: t, height: s = "3em", width: n = "3em" }) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 234 62",
    width: n,
    height: s,
    className: t,
    children: [
      /* @__PURE__ */ e.jsx("title", { children: "MitID identity blue" }),
      /* @__PURE__ */ e.jsx("g", { fill: "#0060E6", children: /* @__PURE__ */ e.jsx("path", { d: "M188.917 0.941h10.045C223.578 0.941 234 14.317 234 31.051c0 16.733-10.422 30.109-34.038 30.109h-11.045V0.941zM181.404 61.16h-52.597c1.499-18.569 12.62-26.346 26.298-26.346 13.678 0 24.799 7.776 26.298 26.346zM169.663 14.585c0 8.055-6.518 14.584-14.558 14.584-8.04 0-14.558-6.529-14.558-14.584C140.547 6.53 147.065 0 155.105 0c8.04 0 14.558 6.53 14.558 14.585zM28.491 48.674L11.793 23.724v37.426H0V3.12h11.227l17.547 27.408L46.227 3.12h11.038v58.03H45.378V23.724L28.869 48.674zM79.533 61.15H67.835V18.902h11.698V61.15zM92.27 28.354h-6.415V18.903h6.415V7.467h11.604v11.436h9.245v9.451h-9.245v18.524c0 3.308 1.792 4.82 4.811 4.82 1.793 0 3.774-.567 5.095-1.417v10.396c-1.604.851-4.434 1.323-7.547 1.323-8.585 0-13.962-4.253-13.962-13.61V28.354zM80.618 6.947c0 3.837-3.105 6.947-6.934 6.947-3.83 0-6.935-3.11-6.935-6.947C66.749 3.11 69.854 0 73.684 0c3.829 0 6.934 3.11 6.934 6.947z" }) })
    ]
  }
), { AuthenticationConnectionSources: Qa } = Z, Hi = ({ ns: t }) => {
  const s = pt(), n = !!(s != null && s.get("mit-id")), r = {
    BANK_ID: 1,
    MIT_ID: 2,
    PASSWORD: 3
  }, { resetAuthentication: a } = Ot(), { t: o } = O([t, "common"], { nsMode: "fallback" }), { resp: i, token: d } = yt(), { setIsPasswordSet: l } = zs, [c, m] = M(!1), [u, h] = M(r.PASSWORD), p = se();
  let f = [
    {
      text: o("authenticationMethods.usernameAndPassword"),
      icon: /* @__PURE__ */ e.jsx(S3, { height: "w-6", width: "h-6" }),
      id: r.PASSWORD
    },
    {
      text: o("authenticationMethods.bankId"),
      icon: /* @__PURE__ */ e.jsx(T3, { height: "h-10", width: "w-10" }),
      id: r.BANK_ID,
      source: Qa.BankID
    }
  ];
  n && (f = [
    ...f,
    {
      text: o("authenticationMethods.mitId"),
      icon: /* @__PURE__ */ e.jsx(M3, { height: "w-6", width: "h-6", className: "p-1" }),
      id: r.MIT_ID,
      source: Qa.MitID
    }
  ]);
  const x = u !== r.PASSWORD, { mutateAsync: g, isError: N } = fe(
    ["password", "set", "V2"],
    (C) => C.Customer.setPasswordV2(d),
    {
      onMutate: () => m(!0),
      onSettled: (C, E) => {
        x || (m(!1), E || l());
      }
    }
  ), b = (C = 20) => {
    const E = () => {
      const R = [
        { start: 48, end: 57 },
        // Numbers (0-9)
        { start: 65, end: 90 },
        // Uppercase letters (A-Z)
        { start: 97, end: 122 },
        // Lowercase letters (a-z)
        { start: 33, end: 47 },
        // Symbols (! to /)
        { start: 58, end: 64 },
        // Symbols (: to @)
        { start: 91, end: 96 },
        // Symbols ([ to `)
        { start: 123, end: 126 }
        // Symbols ({ to ~)
      ], T = R[Math.floor(Math.random() * R.length)], P = Math.floor(Math.random() * (T.end - T.start + 1)) + T.start;
      return String.fromCharCode(P);
    };
    let A = "";
    for (let R = 0; R < C; R++)
      A += E();
    return hc.safeParse({
      password: A,
      confirmPassword: A
    }).success || (A = b()), A;
  }, {
    registerField: v,
    isValid: S,
    handleSubmit: y,
    validate: w,
    getError: z
  } = he({
    namespace: "setPassword",
    onValidate: Ts(io.spa, o),
    onSubmit: async (C) => {
      const E = b(), A = await g({
        password: x ? E : C.password,
        confirmPassword: x ? E : C.confirmPassword
      });
      if (a(), x) {
        const F = f.find(
          (I) => I.id === u
        );
        if (!F)
          return;
        const { source: R } = F, { nonce: T } = A, { locale: P, asPath: V } = p;
        await p.replace(
          `/api/auth/login?locale=${P}&source=${R}&nonce=${T}&returnUrl=${V}`
        );
      }
    }
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(k, { as: "h1", intent: "headline", className: "col-span-full", children: o("form.sections.password.title") }),
    /* @__PURE__ */ e.jsx(k, { className: "col-span-full", children: o("form.sections.password.description") }),
    /* @__PURE__ */ e.jsxs(ke.Root, { as: "form", onSubmit: y, className: "col-span-8", children: [
      /* @__PURE__ */ e.jsx(ke.Content, { as: Ue, children: /* @__PURE__ */ e.jsx(
        P3,
        {
          items: f,
          onChange: (C) => h(C)
        }
      ) }),
      /* @__PURE__ */ e.jsx(ke.Content, { as: Ue, children: x ? /* @__PURE__ */ e.jsx($, { className: "col-span-full flex", children: /* @__PURE__ */ e.jsx(De, { loadingLabel: o("action.loading"), type: "submit", children: o("action.next") }) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        N && /* @__PURE__ */ e.jsx(ge, { className: "col-span-full", color: "negative", children: o("errors.savePassword") }),
        /* @__PURE__ */ e.jsx(
          ct,
          {
            label: o("form.labels.customerNo"),
            className: "col-span-full",
            children: i == null ? void 0 : i.customerNo
          }
        ),
        /* @__PURE__ */ e.jsx(
          Q,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...v("password"),
            label: o("form.labels.password"),
            error: z("password"),
            disabled: c,
            type: "password",
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          Q,
          {
            className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
            ...v("confirmPassword"),
            label: o("form.labels.repeatPassword"),
            error: z("confirmPassword"),
            disabled: c,
            type: "password",
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          w3,
          {
            listMode: !0,
            className: "col-span-full",
            title: o("passwordRequirement.title"),
            ns: "common",
            transKey: "passwordRequirement.description"
          }
        ),
        /* @__PURE__ */ e.jsx($, { className: "col-span-full flex justify-end", children: /* @__PURE__ */ e.jsx(
          De,
          {
            loadingLabel: o("action.loading"),
            type: "submit",
            disabled: !S || c || N,
            onClick: () => w()(),
            isLoading: c,
            children: o("action.savePassword")
          }
        ) })
      ] }) })
    ] })
  ] });
}, z3 = it.fromPath()(["contractType"]), A3 = (t) => (t == null ? void 0 : t.payment.paymentEntries.filter(
  (s) => !!s.licensePlate && s.paymentOptions === "bizz"
)) ?? [], O3 = (t) => (t == null ? void 0 : t.payment.paymentEntries.filter(
  (s) => !!s.licensePlate && s.paymentOptions !== "bizz"
)) ?? [], E3 = (t) => (t == null ? void 0 : t.payment.paymentEntries.filter(
  (s) => s.paymentOptions === "bizz"
).length) ?? !1, D3 = (t) => {
  if (t) {
    const s = z3.get(t), n = Ur(s);
    return n ? /* @__PURE__ */ e.jsx(Ze, { contract: n }) : "";
  } else
    return "";
}, An = ({ ns: t }) => {
  const { t: s } = O([t, "common"], { nsMode: "fallback" }), { data: n } = yt(), r = D(() => A3(n), [n]), a = D(() => O3(n), [n]), o = D(() => D3(n), [n]), i = D(() => E3(n), [n]), d = D(
    () => {
      var p;
      return ((p = n == null ? void 0 : n.paymentMethod) == null ? void 0 : p.method) === "invoice";
    },
    [n]
  ), { app: l } = Ye(), [c, m] = a, [u, h] = r;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        as: "h1",
        intent: "headline",
        className: "col-span-full md:col-start-3 md:col-end-11",
        children: n ? /* @__PURE__ */ e.jsx(G, { ns: t, i18nKey: "form.sections.confirmation.title", children: o }) : s("form.sections.confirmation.shortTitle")
      }
    ),
    /* @__PURE__ */ e.jsxs(
      kl,
      {
        className: "col-span-full md:col-start-3 md:col-end-11",
        transparent: !1,
        children: [
          n && /* @__PURE__ */ e.jsx(k, { intent: "title", className: "mb-2", children: /* @__PURE__ */ e.jsx(
            G,
            {
              ns: t,
              i18nKey: "form.sections.confirmation.readyToDrive.title",
              children: o
            }
          ) }),
          d ? /* @__PURE__ */ e.jsx(k, { className: i ? "mb-2" : "mb-4", children: s("form.sections.confirmation.readyToDrive.invoice") }) : n ? /* @__PURE__ */ e.jsx(k, { className: i ? "mb-2" : "mb-4", children: /* @__PURE__ */ e.jsx(
            G,
            {
              ns: t,
              i18nKey: "form.sections.confirmation.readyToDrive.description",
              values: {
                count: a.length,
                licensePlate: c == null ? void 0 : c.licensePlate,
                secondLicensePlate: m == null ? void 0 : m.licensePlate
              },
              children: /* @__PURE__ */ e.jsx(k, { as: "span", weight: "bold", className: "uppercase" })
            }
          ) }) : null,
          r.length ? /* @__PURE__ */ e.jsx(k, { className: "mb-4", children: /* @__PURE__ */ e.jsx(
            G,
            {
              ns: t,
              i18nKey: "form.sections.confirmation.readyToDrive.registerBizz",
              values: {
                count: r.length,
                licensePlate: u == null ? void 0 : u.licensePlate,
                secondLicensePlate: h == null ? void 0 : h.licensePlate
              },
              children: /* @__PURE__ */ e.jsx(k, { as: "span", weight: "bold", className: "mb-4 uppercase" })
            }
          ) }) : i ? /* @__PURE__ */ e.jsx(k, { className: "mb-4", children: s("form.sections.confirmation.readyToDrive.bizz") }) : null,
          l === ot.OresundPay && t === "businessSignUp" && r.length === 0 && a.length === 0 ? /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(k, { weight: "bold", className: "mb-4", children: s("form.sections.confirmation.readyToDrive.sidenote") }) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(k, { intent: "title", className: "mb-2", children: s("form.sections.confirmation.myAccount.title") }),
            /* @__PURE__ */ e.jsx(k, { className: "mb-4", children: /* @__PURE__ */ e.jsx(
              G,
              {
                ns: t,
                i18nKey: "form.sections.confirmation.myAccount.description",
                children: /* @__PURE__ */ e.jsx(mt, { href: "/account/login" })
              }
            ) })
          ] }),
          /* @__PURE__ */ e.jsx($, { className: "flex justify-end", children: /* @__PURE__ */ e.jsx(X, { as: mt, href: "/account/login", underline: !1, children: s("action.myAccount") }) })
        ]
      }
    )
  ] });
}, Ui = ({
  namespace: t,
  defaultValues: s,
  labels: n,
  countryOptions: r,
  phoneCodeOptions: a,
  placeholders: o,
  disableNameChange: i
}) => {
  const { registerField: d, getError: l, isActive: c } = he({
    namespace: t,
    defaultValues: s
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...d("firstName"),
        label: n.firstName,
        error: l("firstName"),
        disabled: i || !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...d("lastName"),
        label: n.lastName,
        error: l("lastName"),
        disabled: i || !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...d("country"),
        label: n.country,
        options: r.map((m) => ({ ...m, label: m.key })),
        placeholder: o.country,
        error: l("country"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7" }),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...d("zipCode"),
        label: n.zipCode,
        error: l("zipCode"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...d("city"),
        label: n.city,
        error: l("city"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full",
        ...d("address"),
        label: n.address,
        error: l("address"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...d("phoneCode"),
        label: n.phoneCode,
        options: a.map((m, u) => ({
          value: br(m.value, u),
          label: m.key
        })),
        placeholder: o.phoneCode,
        error: l("phoneCode"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...d("phone"),
        label: n.phone,
        error: l("phone"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full",
        ...d("email"),
        label: n.email,
        error: l("email"),
        disabled: !c,
        required: !0
      }
    )
  ] });
}, F3 = ({
  labels: t,
  namespace: s,
  title: n,
  defaultValues: r,
  countryOptions: a = [],
  phoneCodeOptions: o = [],
  onValidate: i,
  placeholders: d
}) => {
  const { validate: l, isValid: c, isActive: m, stepNr: u } = he({
    namespace: s,
    title: n,
    defaultValues: r,
    onValidate: i
  });
  return /* @__PURE__ */ e.jsxs(Bt, { nr: u, title: n, id: s, children: [
    /* @__PURE__ */ e.jsx(
      Ui,
      {
        namespace: s,
        placeholders: d,
        labels: t,
        countryOptions: a,
        phoneCodeOptions: o
      }
    ),
    /* @__PURE__ */ e.jsx(
      Ms,
      {
        loadingLabel: t.loading,
        namespace: s,
        onClick: l(),
        disabled: !m || !c
      }
    )
  ] });
};
function Gi() {
  const { mutateAsync: t } = fe(
    ["customer", "verify"],
    (n) => n.Customer.verifyCustomerV2,
    {
      retry: 0
    }
  );
  return L(
    (n) => async (r) => {
      try {
        const a = await t(r);
        return n(a);
      } catch {
        return n({
          success: !1
        });
      }
    },
    [t]
  );
}
const ta = Gt(), L3 = ta("country", "phoneCode", "phone"), V3 = ta("cpr", "email"), R3 = ta("email"), $3 = ({
  namespace: t,
  titleTranslationKey: s,
  ns: n
}) => {
  const r = Qn(), a = Xn(), o = Gi(), i = kt(), d = Jn(), { locale: l } = se(), { t: c } = O(n, {
    nsMode: "fallback"
  }), m = L(
    (g) => (N) => {
      if (N && dt("phone")(N)) {
        const b = L3(g);
        return a({
          phone: c("form.validations.phone.invalid")
        })(b);
      }
    },
    [c, a]
  ), u = L(
    (g) => async (N) => {
      const b = V3(g);
      return await r((S) => ({
        email: S.email && dt("email")(N) ? c("form.validations.email.exist") : void 0
      }))(b);
    },
    [r, c]
  ), h = L(
    (g) => async (N) => {
      const b = R3(g), S = await o(
        (w) => ({
          email: !w.success && dt("email")(N) ? c("form.validations.email.exist") : void 0
        })
      )(b), y = Object.values(S);
      for (const w of y)
        if (w)
          return S;
    },
    [o, c]
  ), p = L(
    async (g) => {
      const N = po.spa, b = await $t(N, c)(g);
      return await Un(
        async (w) => await m(g)(w),
        async (w) => await u(g)(w)
      )(b);
    },
    [c, m, u]
  ), f = L(
    async (g) => {
      const N = await p(g);
      return N || await h(g)();
    },
    [p, h]
  ), x = d.find(
    (g) => g.country === ms(l || "")
  );
  return /* @__PURE__ */ e.jsx(
    F3,
    {
      namespace: t,
      title: c(s),
      defaultValues: {
        country: ms(l || ""),
        phoneCode: x == null ? void 0 : x.value
      },
      labels: {
        firstName: c("form.labels.firstName"),
        lastName: c("form.labels.lastName"),
        cpr: c("form.labels.cpr"),
        city: c("form.labels.city"),
        address: c("form.labels.address"),
        email: c("form.labels.email"),
        zipCode: c("form.labels.zipCode"),
        phone: c("form.labels.phone"),
        phoneCode: c("form.labels.phoneCode"),
        country: c("form.labels.country"),
        loading: c("action.loading")
      },
      placeholders: {
        country: c("form.placeholders.country"),
        phoneCode: c("form.placeholders.phoneCode")
      },
      countryOptions: i,
      phoneCodeOptions: d,
      onValidate: f
    }
  );
}, B3 = {
  paymentOptions: "licensePlate"
}, I3 = ({
  labels: t,
  countryOptions: s = [],
  weightClassOptions: n = [],
  fuelTypeOptions: r = [],
  emissionClassOptions: a = [],
  onAdd: o,
  onValidate: i,
  onCancel: d,
  displayCancel: l,
  placeholders: c,
  disableForm: m,
  defaultValues: u,
  vehicleColors: h
}) => {
  const p = D(
    () => ({ ...B3, ...u }),
    [u]
  ), f = "alpr", {
    registerField: x,
    getError: g,
    getData: N,
    validate: b,
    isValid: v,
    isDirty: S,
    resetSelectedData: y,
    setPartialData: w,
    resetFieldErrors: z,
    setFieldErrors: C
  } = he({
    namespace: f,
    onValidate: i,
    defaultValues: p
  }), { t: E } = O(["privateSignUp", "businessSignUp", "common"], {
    nsMode: "fallback"
  }), [A, F, R, T] = Ee(
    f,
    "country",
    "licensePlate",
    "fuelType",
    "emissionClass"
  ), [P, V] = M(), [I, _] = M(), [ne, K] = M(), {
    data: U,
    error: re,
    isFetching: ie
  } = $n(I), le = ks();
  B(() => K(re), [re]), B(() => K(null), [F]), B(() => V(U), [U]), B(() => V(void 0), [F, A]), B(() => _(void 0), [A]), B(() => {
    R === "5" && T && w({
      emissionClass: void 0
    });
  }, [R, w, T]);
  const me = L(() => {
    y([
      "make",
      "model",
      "color",
      "weightClass",
      "hybrid",
      "fuelType",
      "emissionClass"
    ]);
  }, [y]), ce = L(() => {
    me(), z(), _(void 0);
  }, [z, me]), q = L(
    async (ae) => {
      const je = A;
      if (!je || !ae) {
        _({ licensePlate: ae, country: je });
        return;
      }
      try {
        if (await le({
          licensePlate: t.licensePlateExist
        })({
          licensePlate: ae,
          country: je
        }))
          _({ licensePlate: ae, country: je });
        else
          throw new Error("Validation failed");
      } catch (pe) {
        C(pe), me();
      }
    },
    [
      _,
      A,
      le,
      t,
      C,
      me
    ]
  );
  B(() => {
    pn(
      hn(F),
      A
    ) && q(F);
  }, [F, A, q]), B(() => ce, [A, ce]), B(
    () => ri(
      P,
      w,
      ce,
      a
    ),
    [P, w, ce]
  );
  const de = L(async () => {
    await b()() && o(N());
  }, [b, N, o]);
  return /* @__PURE__ */ e.jsx(ke.Root, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(ke.Content, { children: /* @__PURE__ */ e.jsxs(Ue, { children: [
    /* @__PURE__ */ e.jsx(
      Q,
      {
        ...x("alprName"),
        label: t.alprName,
        className: "col-span-full sm:col-span-4 md:col-span-12",
        error: g("alprName"),
        disabled: m
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...x("country"),
        label: t.country,
        groupedOptions: s.map((ae) => {
          var je;
          return {
            children: ae.children,
            group: { label: (je = ae.group) != null && je.label ? E(ae.group.label) : void 0 }
          };
        }),
        placeholder: c.country,
        error: g("country"),
        disabled: m,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        ...x("licensePlate"),
        label: t.licensePlate,
        className: "col-span-full sm:col-start-5 md:col-span-6 md:col-start-7",
        error: g("licensePlate"),
        disabled: m,
        required: !0
      }
    ),
    ne ? /* @__PURE__ */ e.jsx($, { className: "col-span-full bg-white", children: /* @__PURE__ */ e.jsx(ge, { className: "col-span-full mb-2", children: t.noVehicleInfo }) }) : null,
    /* @__PURE__ */ e.jsx($, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(k, { as: "h6", size: "lg", className: "mb-0", children: t.volVehicleInfo }) }),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        ...x("make"),
        label: t.make,
        className: "col-span-full sm:col-span-4 md:col-span-6",
        error: g("make"),
        disabled: m || !!(P != null && P.make)
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        ...x("model"),
        label: t.model,
        className: "col-span-full sm:col-span-4 md:col-span-6",
        error: g("model"),
        disabled: m || !!(P != null && P.model)
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...x("color"),
        label: t.color,
        placeholder: c.color,
        options: h,
        placeholderDisabled: !1,
        error: g("color"),
        disabled: m || !!(P != null && P.color)
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...x("weightClass"),
        label: t.weightClass,
        options: n,
        placeholder: c.weightClass,
        placeholderDisabled: !1,
        error: g("weightClass"),
        disabled: m || (P == null ? void 0 : P.isHGV) !== void 0
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...x("fuelType"),
        label: t.fuelType,
        options: r,
        placeholder: c.fuelType,
        placeholderDisabled: !1,
        error: g("fuelType"),
        disabled: m || !!(P != null && P.fuelType)
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-start-5 md:col-span-6 md:col-start-7",
        ...x("emissionClass"),
        label: t.emissionClass,
        options: a,
        error: g("emissionClass"),
        placeholder: c.emissionClass,
        placeholderDisabled: !1,
        disabled: m || !!(P != null && P.euroEmissionNorm) || R === "5"
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        ...x("hybrid", {
          type: "checkbox",
          value: "true"
        }),
        label: t.hybrid,
        className: "col-span-full sm:col-start-5 md:col-span-6",
        error: g("hybrid"),
        disabled: m || (P == null ? void 0 : P.isHybrid) !== void 0
      }
    ),
    /* @__PURE__ */ e.jsxs($, { className: "col-span-full mt-2 flex justify-end", children: [
      l ? /* @__PURE__ */ e.jsx(X, { intent: "text", onClick: d, className: "mr-auto", children: t.cancel }) : null,
      /* @__PURE__ */ e.jsx(
        X,
        {
          intent: "outlined",
          onClick: de,
          disabled: !v || !S || ie,
          children: t.add
        }
      )
    ] })
  ] }) }) });
}, Ki = ({
  labels: t,
  licensePlate: s,
  alprName: n,
  paymentOptions: r,
  onRemove: a,
  disabled: o
}) => /* @__PURE__ */ e.jsx(ke.Root, { className: "col-span-full", children: /* @__PURE__ */ e.jsxs(ke.Content, { className: "flex flex-row items-center justify-between", children: [
  /* @__PURE__ */ e.jsx($, { className: "pr-5", children: /* @__PURE__ */ e.jsx(oo, { className: "text-primary-400 text-2xl" }) }),
  /* @__PURE__ */ e.jsxs($, { className: "flex-1", children: [
    /* @__PURE__ */ e.jsx(
      ct,
      {
        label: za(n) ? t.licensePlate : t.alprName,
        children: za(n) ? s : n
      }
    ),
    r === "bizz" ? /* @__PURE__ */ e.jsx(ct, { label: t.bizz, children: t.bizzOrdered }) : null
  ] }),
  /* @__PURE__ */ e.jsx($, { className: "flex flex-row items-center", children: /* @__PURE__ */ e.jsx(
    X,
    {
      startIcon: /* @__PURE__ */ e.jsx(rn, {}),
      iconSize: "lg",
      color: "neutral",
      intent: "text",
      "aria-label": t.remove,
      onClick: a,
      disabled: o
    }
  ) })
] }) }), _3 = {
  paymentEntries: []
}, W3 = ({
  title: t,
  namespace: s,
  description: n,
  labels: r,
  countryOptions: a,
  bvSupportCountries: o,
  weightClassOptions: i,
  emissionClassOptions: d,
  fuelTypeOptions: l,
  maxEntries: c,
  onAlprValidation: m,
  onValidate: u,
  useOnOtherPlacesDisclaimer: h,
  placeholders: p,
  vehicleColors: f
}) => {
  const [x, g] = M(!0), [N, b] = M(0), {
    stepNr: v,
    setData: S,
    getData: y,
    validate: w,
    isValid: z,
    isActive: C,
    transformData: E
  } = he({
    namespace: s,
    title: t,
    defaultValues: _3,
    onValidate: u
  }), A = L(
    (P) => {
      S((V) => {
        const I = [...V.paymentEntries || []];
        return I.splice(N, 1, P), {
          paymentEntries: I
        };
      }), g(!1);
    },
    [g, S, N]
  ), F = L(
    (P) => {
      E((V) => {
        const _ = { paymentEntries: [
          ...V.paymentEntries.slice(0, P),
          ...V.paymentEntries.slice(P + 1)
        ] };
        return _.paymentEntries.length === 0 && g(!0), _;
      });
    },
    [E, g]
  ), R = L(() => {
    b((P) => P + 1), g(!0);
  }, [b, g]), T = y().paymentEntries || [];
  return /* @__PURE__ */ e.jsxs(Bt, { nr: v, title: t, id: s, children: [
    /* @__PURE__ */ e.jsx($, { className: "col-span-full", children: n }),
    T.map((P, V) => /* @__PURE__ */ e.jsx(
      Ki,
      {
        labels: r,
        ...P,
        onRemove: () => F(V),
        disabled: !C
      },
      V
    )),
    x ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx($, { className: "col-span-full bg-white", children: /* @__PURE__ */ e.jsx(da.Root, { type: "single", collapsible: !0, children: /* @__PURE__ */ e.jsx(
        da.Item,
        {
          label: r.useInNorway,
          value: "content",
          border: !1,
          className: "px-4",
          children: /* @__PURE__ */ e.jsx(ge, { className: "col-span-full mb-2", children: h })
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(ut, { children: /* @__PURE__ */ e.jsx(
        I3,
        {
          onValidate: m,
          labels: r,
          onCancel: () => g(!1),
          countryOptions: a,
          bvSupportCountries: o,
          weightClassOptions: i,
          emissionClassOptions: d,
          fuelTypeOptions: l,
          onAdd: A,
          displayCancel: T.length > 0,
          placeholders: p,
          disableForm: !C,
          vehicleColors: f
        }
      ) })
    ] }) : null,
    T.length + 1 <= c && !x ? /* @__PURE__ */ e.jsx(
      X,
      {
        startIcon: /* @__PURE__ */ e.jsx(cs, {}),
        intent: "text",
        onClick: R,
        disabled: !C,
        children: r.addMore
      }
    ) : null,
    /* @__PURE__ */ e.jsx(
      Ms,
      {
        loadingLabel: r.loading,
        namespace: s,
        onClick: w(),
        disabled: !C || !z || !T.length || x
      }
    )
  ] });
}, q3 = Gt()("licensePlate", "country"), H3 = it.fromNullableProp()("paymentEntries", []), U3 = ({
  namespace: t,
  titleTranslationKey: s,
  ns: n
}) => {
  const r = Dr(), a = wo(), o = wt(), i = ks(), { locale: d } = se(), { t: l } = O(n, {
    nsMode: "fallback"
  }), { getData: c } = he({
    namespace: t,
    title: l(s)
  }), m = L(
    (x) => async (g) => {
      if (g && !dt("licensePlate")(g))
        return;
      const N = q3(x);
      if (!(!N.country || !N.licensePlate))
        return await i({
          licensePlate: l("form.validations.licensePlate.exist")
        })(N);
    },
    [l, i]
  ), u = L(
    (x) => () => {
      if (H3.get(c()).some((b) => b.licensePlate === x.licensePlate))
        return { licensePlate: l("form.validations.licensePlate.unique") };
    },
    [c, l]
  ), h = L(
    async (x) => {
      const g = await $t(fo.spa, l)(x);
      return await Un(
        async () => u(x)(),
        async (S) => m(x)(S)
      )(g);
    },
    [m, l, u]
  ), p = Gn.map((x) => ({
    label: l(`vehicleColors.${x}`),
    value: x
  })), f = {
    namespace: t,
    title: l(s),
    description: /* @__PURE__ */ e.jsxs(G, { i18nKey: "form.sections.payment.description", ns: n, children: [
      /* @__PURE__ */ e.jsx(k, { className: "mb-4" }),
      /* @__PURE__ */ e.jsx(k, { size: "sm" })
    ] }),
    defaultCountry: ms(d || ""),
    onAlprValidation: h,
    countryOptions: a,
    bvSupportCountries: r,
    maxEntries: 2,
    labels: {
      make: l("form.labels.make"),
      model: l("form.labels.model"),
      color: l("form.labels.color"),
      alprName: l("form.labels.alprName"),
      vehicleSearch: l("action.search"),
      licensePlate: l("form.labels.licensePlate"),
      country: l("form.labels.country"),
      fuelType: l("form.labels.fuelType"),
      emissionClass: l("form.labels.emissionClass"),
      weightClass: l("form.labels.weightClass"),
      useInNorway: l("form.labels.useInNorway"),
      add: l("form.labels.add"),
      hybrid: l("form.labels.hybrid"),
      addMore: l("form.labels.addMore"),
      cancel: l("action.cancel"),
      remove: l("action.remove"),
      loading: l("action.loading"),
      volVehicleInfo: l("form.labels.vlinfo"),
      noVehicleInfo: l("form.validations.licensePlate.notfound"),
      loadingSearch: l("action.loading"),
      licensePlateExist: l("form.validations.licensePlate.exist"),
      // not used in private
      bizz: "",
      isSBF: "",
      bizzOrdered: ""
    },
    placeholders: {
      weightClass: l("form.placeholders.weightClass"),
      country: l("form.placeholders.country"),
      emissionClass: l("form.placeholders.emissionClass"),
      fuelType: l("form.placeholders.fuelType"),
      color: l("form.placeholders.color")
    },
    useOnOtherPlacesDisclaimer: l(
      "form.sections.payment.disclaimers.useInNorway"
    ),
    fuelTypeOptions: o.fuelTypes,
    weightClassOptions: [
      { label: l("weightClasses.light"), value: "false" },
      { label: l("weightClasses.heavy"), value: "true" }
    ],
    emissionClassOptions: o.emissionClasses,
    vehicleColors: p
  };
  return /* @__PURE__ */ e.jsx(W3, { ...f });
};
function Zi(t, s) {
  const { getContracts: n, setMainContract: r } = Ws(), { contracts: a, main: o } = n(), { locale: i } = se(), { data: d } = ye(
    ee.ContractTypeList({ type: t, locale: i }),
    (l) => l.Contract.contractTypeList({ type: t, locale: i || "" })
  );
  return B(() => {
    if (!d)
      return;
    const l = d.filter((m) => m.value === s);
    if (!l.length)
      return;
    const [c] = l;
    r({
      ...c,
      prices: l.map(({ currency: m, price: u, priceInclVat: h }) => ({
        currency: m,
        price: u,
        priceInclVat: h
      }))
    });
  }, [d, s]), { contracts: a, main: o };
}
const Yi = ({
  children: t,
  onSubmit: s,
  continueLabel: n,
  editLabel: r,
  submitLabel: a,
  push: o
}) => {
  const { visibleChildren: i, handleSubmit: d, setLabels: l, activeStep: c } = Nr({
    onSubmit: s,
    children: t
  }), m = Ae("");
  return B(() => {
    l(n, a, r);
  }, [n, r, l, a]), B(() => {
    (async () => {
      i.length !== 1 && m.current !== c && (o && await o(`#${c}`), m.current = c);
    })();
  }, [c, o, i.length]), /* @__PURE__ */ e.jsx($, { as: "form", onSubmit: d, children: i });
}, Qi = ({ total: t, contract: s, ns: n }) => {
  const { t: r } = O([n, "common"], { nsMode: "fallback" }), a = or(Tl.getActiveStep), o = or(ma.getAvailableSteps), i = or(ma.getSkippedSteps), d = D(() => o.findIndex(
    (m) => m.namespace === a
  ), [a, o]), l = D(() => o.map((c, m) => ({
    ...c,
    active: m <= d && !i.some((u) => u.step === c.namespace) && c.completed || m >= d && !i.some((u) => u.step === c.namespace) && c.completed || d === m,
    completed: c.completed
  })), [d, o, i]);
  return /* @__PURE__ */ e.jsxs(ke.Root, { as: "aside", className: "sticky top-[10vh] ml-auto max-w-[350px]", children: [
    /* @__PURE__ */ e.jsx(ke.Header, { className: "bg-primary-800", children: /* @__PURE__ */ e.jsx(
      k,
      {
        intent: "title",
        size: "lg",
        color: "white",
        as: "h3",
        className: "pb-1 pt-3 text-center",
        children: s ? /* @__PURE__ */ e.jsx(G, { ns: n, i18nKey: "form.sections.progress.title", children: /* @__PURE__ */ e.jsx(Ze, { contract: "oresundPay" }) }) : null
      }
    ) }),
    /* @__PURE__ */ e.jsxs(ke.Content, { children: [
      /* @__PURE__ */ e.jsx(k, { as: "h4", className: "sr-only", id: "form-progress-title", children: r("form.sections.progress.stepsTitle") }),
      /* @__PURE__ */ e.jsx(vn.Root, { "aria-labelledby": "form-progress-title", children: l.map(
        ({ namespace: c, titleTranslationKey: m, active: u, completed: h }, p) => /* @__PURE__ */ e.jsx(
          vn.Item,
          {
            nr: p + 1,
            active: u,
            completed: h,
            children: u ? /* @__PURE__ */ e.jsx(
              $,
              {
                as: "a",
                href: `#${c}`,
                "aria-current": a === c ? "page" : void 0,
                children: r(m)
              }
            ) : r(m)
          },
          c
        )
      ) })
    ] }),
    /* @__PURE__ */ e.jsxs(ke.Footer, { className: "border-t", children: [
      /* @__PURE__ */ e.jsx(k, { intent: "title", size: "sm", as: "h4", children: r("form.sections.progress.orderTitle") }),
      /* @__PURE__ */ e.jsxs($, { as: "ol", children: [
        /* @__PURE__ */ e.jsxs($, { as: "li", className: "mt-4 flex justify-between", children: [
          /* @__PURE__ */ e.jsx(k, { className: "text-primary-800", children: /* @__PURE__ */ e.jsx(Ze, { contract: "oresundPay" }) }),
          /* @__PURE__ */ e.jsx(k, { className: "text-primary-800", children: s.value })
        ] }),
        /* @__PURE__ */ e.jsxs($, { as: "li", className: "mt-4 flex justify-between border-t pt-4", children: [
          /* @__PURE__ */ e.jsx(k, { children: t.label }),
          /* @__PURE__ */ e.jsx(k, { children: t.value })
        ] })
      ] })
    ] })
  ] });
}, G3 = ({
  namespace: t,
  title: s,
  currencyOptions: n,
  labels: r,
  onValidate: a,
  defaultValues: o,
  helpText: i,
  contracts: d,
  total: l,
  placeholders: c,
  businessInfo: m
}) => {
  const [u, h] = Ee(
    t,
    "agreement",
    "campaignCode",
    "currency"
  ), p = pt(), f = !!(p != null && p.get("showAlprInSignup")), x = D(
    () => ({
      ...o,
      currency: h || (o == null ? void 0 : o.currency)
    }),
    [h, o]
  ), { stepNr: g, registerField: N, validate: b, isValid: v, isActive: S } = he({
    namespace: t,
    title: s,
    onValidate: a,
    defaultValues: x
  }), y = D(() => u === "true", [u]);
  return /* @__PURE__ */ e.jsxs(Bt, { title: s, nr: g, id: t, children: [
    /* @__PURE__ */ e.jsx(
      xe,
      {
        ...N("currency"),
        className: "col-span-full sm:col-span-4 md:col-span-6",
        label: r.currency,
        placeholder: c.currency,
        options: n,
        disabled: !S
      }
    ),
    /* @__PURE__ */ e.jsxs($, { className: "col-span-full mb-6 mt-8", children: [
      /* @__PURE__ */ e.jsx(k, { intent: "title", className: "mb-3", children: r.yourOrder }),
      /* @__PURE__ */ e.jsx(k, { intent: "label", size: "sm", children: r.contract }),
      /* @__PURE__ */ e.jsxs($, { as: "ul", children: [
        d.map(({ label: w, value: z }, C) => /* @__PURE__ */ e.jsxs($, { as: "li", className: "my-3 flex flex-row justify-between", children: [
          /* @__PURE__ */ e.jsx(k, { children: /* @__PURE__ */ e.jsx(Ze, { contract: w }) }),
          /* @__PURE__ */ e.jsx(k, { children: z })
        ] }, C)),
        /* @__PURE__ */ e.jsxs(
          $,
          {
            as: "li",
            className: "border-primary-400 flex flex-row justify-between border-t-2 py-3",
            children: [
              /* @__PURE__ */ e.jsx(k, { children: r.total }),
              /* @__PURE__ */ e.jsx(k, { children: l })
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        ...N("agreement", { type: "checkbox", value: "true" }),
        className: "col-span-full",
        label: r.agreement,
        required: !0,
        disabled: !S
      }
    ),
    /* @__PURE__ */ e.jsx(k, { size: "sm", className: "col-span-full", children: i }),
    !f && m ? m : /* @__PURE__ */ e.jsx(e.Fragment, {}),
    /* @__PURE__ */ e.jsx(
      Ms,
      {
        loadingLabel: r.loading,
        namespace: t,
        onClick: b(),
        disabled: !S || !v || !y
      }
    )
  ] });
}, Xa = (t, s, n) => {
  const r = t.find((o) => o.currency === s);
  return Bn(
    (r == null ? void 0 : r.priceInclVat) || 0,
    n,
    s
  );
}, Xi = ({ namespace: t, titleTranslationKey: s, contractType: n, ns: r }) => {
  const { locale: a } = se(), { t: o } = O(r, {
    nsMode: "fallback"
  }), { getContracts: i } = Ws(), { contracts: d, main: l } = i(), [c] = Ee("termsOfAgreement", "currency"), { app: m } = Ye(), u = D(
    () => c || ss(a || ""),
    [c, a]
  ), h = D(() => d.map((f) => {
    const x = Ur(f.value), g = Xa(f.prices, u, a);
    return {
      value: o("price.yearly", {
        price: g || ""
      }),
      label: x ?? "",
      discount: !1
    };
  }) ?? [], [d, a, u, o]);
  return /* @__PURE__ */ e.jsx(
    G3,
    {
      namespace: t,
      title: o(s),
      defaultValues: { currency: ss(a || "") },
      contracts: h,
      total: o("price.yearly", {
        price: Xa(l.prices, u, a)
      }),
      labels: {
        loading: o("action.loading"),
        campaignCode: o("action.campaignCode"),
        agreement: o("form.labels.termsOfAgreement"),
        currency: o("form.labels.currency"),
        total: o("signup.total"),
        yourOrder: o("form.sections.termsOfAgreement.subTitle"),
        contract: o("form.labels.contract")
      },
      placeholders: {
        currency: o("form.placeholders.currency")
      },
      currencyOptions: [
        { label: "SEK", value: "SEK" },
        { label: "DKK", value: "DKK" }
      ],
      helpText: /* @__PURE__ */ e.jsx(Wn, { type: n }),
      onValidate: Ts(pc.spa),
      businessInfo: m === ot.OresundPay && n === Z.OresundPAYBusiness ? /* @__PURE__ */ e.jsxs(ze, { colorMode: "information", className: "col-span-full", children: [
        /* @__PURE__ */ e.jsx("b", { children: o("form.sections.termsOfAgreement.termsInfo1") }),
        " ",
        o("form.sections.termsOfAgreement.termsInfo2")
      ] }) : /* @__PURE__ */ e.jsx(e.Fragment, {})
    }
  );
}, K3 = () => {
  const { setRequestData: t, setPayWithCreditCard: s } = zs, { locale: n } = se(), { main: r } = Zi("private", Z.OresundPAY), a = ["privateSignUp", "businessSignUp", "common"], { t: o } = O(a, {
    nsMode: "fallback"
  }), { push: i, asPath: d } = se(), l = (h) => {
    const p = {
      ...h,
      isSBF: "false",
      contactInformation: {
        ...h.contactInformation,
        phoneCode: vs(h.contactInformation.phoneCode)
      },
      contractType: r.value,
      payment: {
        paymentEntries: (h.payment.paymentEntries || []).filter(
          (f) => !_i(f)
        )
      },
      subscribeToClub: {},
      paymentAgreement: {
        ...h.paymentAgreement,
        oresundsPay: "true"
      }
    };
    t(p), s();
  }, [c] = Ee("termsOfAgreement", "currency"), m = D(
    () => c || ss(n || ""),
    [c, n]
  ), u = L(
    (h) => i(`${d.split("#")[0]}${h}`, void 0, {
      scroll: !1,
      shallow: !0
    }),
    [i, d]
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(k, { intent: "label", className: "col-span-full mb-8", children: o("form.requiredFields") }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full md:col-span-8", children: /* @__PURE__ */ e.jsxs(
      Yi,
      {
        onSubmit: l,
        continueLabel: o("action.continue"),
        submitLabel: o("action.pay"),
        editLabel: o("action.edit"),
        push: u,
        children: [
          /* @__PURE__ */ e.jsx(
            $3,
            {
              namespace: "contactInformation",
              ns: a,
              titleTranslationKey: "form.sections.contactInformation.title"
            }
          ),
          /* @__PURE__ */ e.jsx(
            Wi,
            {
              namespace: "codeVerification",
              ns: a,
              titleTranslationKey: "form.sections.codeVerification.title",
              isBusiness: !1
            }
          ),
          /* @__PURE__ */ e.jsx(
            U3,
            {
              namespace: "payment",
              titleTranslationKey: "form.sections.payment.title",
              ns: a
            }
          ),
          /* @__PURE__ */ e.jsx(
            Xi,
            {
              namespace: "termsOfAgreement",
              titleTranslationKey: "form.sections.termsOfAgreement.title",
              ns: a,
              contractType: Z.OresundPAY
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "relative hidden md:col-span-4 md:col-start-9 md:block", children: /* @__PURE__ */ e.jsx(
      Qi,
      {
        total: {
          label: o("signup.total"),
          value: o("price.yearly", {
            price: `0,00 ${m}`
          })
        },
        contract: {
          label: r.value,
          value: o("price.yearly", {
            price: `0,00 ${m}`
          })
        },
        ns: "privateSignUp"
      }
    ) })
  ] });
}, Ji = () => {
  const { t } = O(["error", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs($, { className: "col-span-full flex flex-col items-center gap-4 pb-8", children: [
    /* @__PURE__ */ e.jsx(kr, { className: "text-6xl text-red-400" }),
    /* @__PURE__ */ e.jsx(k, { intent: "headline", className: "text-center", children: t("internalError.title") }),
    /* @__PURE__ */ e.jsx(k, { intent: "body", className: "text-center", children: t("internalError.description") })
  ] });
}, Z3 = (t, s, n) => !t || !n ? null : s ? /* @__PURE__ */ e.jsx(An, { ns: "privateSignUp" }) : /* @__PURE__ */ e.jsx(Hi, { ns: "privateSignUp" }), Y3 = (t, s) => t && !s ? /* @__PURE__ */ e.jsx(qi, {}) : null, Ug = () => {
  const { error: t, resp: s, isPasswordSet: n, payWithCreditCard: r, token: a } = yt(), { resetStore: o } = zs, { reset: i } = Ws(), { query: d } = se(), l = d.complete === "1", { setBannerVisible: c } = Er(), m = D(() => {
    if (l)
      return c(!1), /* @__PURE__ */ e.jsx(An, { ns: "privateSignUp" });
    if (t)
      return /* @__PURE__ */ e.jsx(Ji, {});
    const u = Y3(r, s);
    if (u)
      return u;
    const h = Z3(s, n, a);
    return h || (c(!1), /* @__PURE__ */ e.jsx(K3, {}));
  }, [
    t,
    r,
    s,
    n,
    l,
    a,
    c
  ]);
  return B(
    () => () => {
      o(), i();
    },
    []
  ), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(ut, { children: /* @__PURE__ */ e.jsx(Ue, { className: "md:gap-x-20", children: m }) }),
    /* @__PURE__ */ e.jsx(
      Mr,
      {
        strategy: "lazyOnload",
        src: "https://checkout.reepay.com/checkout.js"
      }
    )
  ] });
}, Q3 = it.fromProp()("paymentMethod"), X3 = it.fromProp()(
  "invoice"
), J3 = it.fromProp()("ignoreEvaluation"), ex = Q3.modify((t) => (t == null ? void 0 : t.method) === "invoice" ? (X3.modify(J3.set("true")), {
  ...t,
  invoice: {
    ...t.invoice,
    ignoreEvaluation: "true"
  }
}) : t), { setError: vr, setResponse: tx, setPayWithCreditCard: sx, setToken: nx } = zs, rx = (t) => {
  Qr(t) && vr(t);
}, ax = (t) => {
  const s = t;
  tx(s), nx(s.code);
}, ox = ({ status: t }) => {
  const { reload: s } = se(), [n, r] = M(!1), { mutateAsync: a } = fe(
    ["signup"],
    (c) => c.Customer.signup,
    {
      onError: rx,
      onSuccess: ax,
      onSettled: () => r(!1)
    }
  ), { t: o } = O(["businessSignUp", "common"], {
    nsMode: "fallback"
  }), { data: i } = yt(), d = L(async () => {
    if (!i) {
      vr({ code: 500, error: "no signup data initialized" });
      return;
    }
    const c = ex(i);
    r(!0), await a(c);
  }, [i, a]), l = L(() => {
    sx(), vr(void 0);
  }, []);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        className: "col-span-full row-start-1 sm:col-span-6 sm:col-start-2 md:col-start-4",
        as: "h1",
        intent: "headline",
        children: o(t === xn ? "form.sections.creditEvaluation.yellow.title" : "form.sections.creditEvaluation.red.title")
      }
    ),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full row-start-2 sm:col-span-6 sm:col-start-2 md:col-start-4", children: /* @__PURE__ */ e.jsx(
      G,
      {
        ns: "businessSignUp",
        i18nKey: t === xn ? "form.sections.creditEvaluation.yellow.description" : "form.sections.creditEvaluation.red.description",
        children: /* @__PURE__ */ e.jsx(k, { gutter: !0 })
      }
    ) }),
    /* @__PURE__ */ e.jsxs($, { className: "col-span-full row-start-3 flex flex-col sm:col-span-6 sm:col-start-2 sm:flex-row-reverse sm:justify-end md:col-start-4", children: [
      t === xn ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          De,
          {
            isLoading: n,
            loadingLabel: o("action.loading"),
            onClick: d,
            className: "ml-auto mr-auto sm:ml-0 sm:mr-0",
            children: o("action.continueEvaluation")
          }
        ),
        /* @__PURE__ */ e.jsx(
          X,
          {
            onClick: l,
            intent: "outlined",
            className: "ml-auto mr-auto mt-4 sm:mr-8 sm:mt-0",
            children: o("action.payWithCard")
          }
        )
      ] }) : null,
      t === ai ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          X,
          {
            onClick: l,
            className: "ml-auto mr-auto sm:ml-0 sm:mr-0",
            children: o("action.payWithCard")
          }
        ),
        /* @__PURE__ */ e.jsx(
          X,
          {
            onClick: () => s(),
            color: "negative",
            className: "ml-auto mr-auto mt-4 sm:mr-8 sm:mt-0",
            children: o("action.cancel")
          }
        )
      ] }) : null
    ] })
  ] });
}, el = ({
  namespace: t,
  defaultValues: s,
  labels: n,
  countryOptions: r,
  phoneCodeOptions: a,
  placeholders: o,
  disableNameChange: i
}) => {
  const { registerField: d, getError: l, isActive: c } = he({
    namespace: t,
    defaultValues: s
  }), [m] = Ee(t, "country");
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full",
        ...d("companyName"),
        label: n.companyName,
        error: l("companyName"),
        disabled: i || !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...d("country"),
        label: n.country,
        options: r.map((u) => ({ ...u, label: u.key })),
        placeholder: o.country,
        error: l("country"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...d("vatno"),
        label: n.vatno,
        error: l("vatno"),
        disabled: i || !c,
        required: !0
      }
    ),
    m === "DK" ? /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full",
        ...d("ean"),
        label: n.ean,
        error: l("ean"),
        disabled: !c
      }
    ) : null,
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...d("zipCode"),
        label: n.zipCode,
        error: l("zipCode"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...d("city"),
        label: n.city,
        error: l("city"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full",
        ...d("address"),
        label: n.address,
        error: l("address"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...d("phoneCode"),
        label: n.phoneCode,
        options: a.map((u, h) => ({
          value: br(u.value, h),
          label: u.key
        })),
        placeholder: o.phoneCode,
        error: l("phoneCode"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...d("phone"),
        label: n.phone,
        error: l("phone"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(k, { className: "col-span-full mt-16", children: n.contactPersonLabel }),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...d("contact.firstName"),
        label: n.contact.firstName,
        error: l("contact.firstName"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...d("contact.lastName"),
        label: n.contact.lastName,
        error: l("contact.lastName"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full",
        ...d("contact.email"),
        label: n.contact.email,
        error: l("contact.email"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...d("contact.phoneCode"),
        label: n.contact.phoneCode,
        options: a.map((u, h) => ({
          value: br(u.value, h),
          label: u.key
        })),
        placeholder: o.phoneCode,
        error: l("contact.phoneCode"),
        disabled: !c,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...d("contact.phone"),
        label: n.contact.phone,
        error: l("contact.phone"),
        disabled: !c,
        required: !0
      }
    )
  ] });
}, ix = ({
  labels: t,
  namespace: s,
  title: n,
  defaultValues: r,
  countryOptions: a = [],
  phoneCodeOptions: o = [],
  onValidate: i,
  placeholders: d,
  commuter: l,
  vatnoExist: c,
  disclaimers: m
}) => {
  const {
    registerField: u,
    getError: h,
    validate: p,
    isValid: f,
    isActive: x,
    stepNr: g,
    resetFieldError: N
  } = he({
    namespace: s,
    title: n,
    defaultValues: r,
    onValidate: i
  }), [b] = Ee(s, "bypassVatno");
  B(() => {
    b !== "true" && N("vatno");
  }, [b, N]);
  const v = pt(), S = !!(v != null && v.get("showPendlareStartDate"));
  return /* @__PURE__ */ e.jsxs(Bt, { nr: g, title: n, id: s, children: [
    /* @__PURE__ */ e.jsx(
      el,
      {
        namespace: s,
        labels: t,
        countryOptions: a,
        phoneCodeOptions: o,
        placeholders: d
      }
    ),
    l ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(k, { className: "col-span-full mt-16", children: t.commuterLabel }),
      /* @__PURE__ */ e.jsx(
        Q,
        {
          className: "col-span-full sm:col-span-4 md:col-span-6",
          ...u("commuter.firstName"),
          label: t.commuter.firstName,
          error: h("commuter.firstName"),
          disabled: !x,
          required: !0
        }
      ),
      /* @__PURE__ */ e.jsx(
        Q,
        {
          className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
          ...u("commuter.lastName"),
          label: t.commuter.lastName,
          error: h("commuter.lastName"),
          disabled: !x,
          required: !0
        }
      ),
      /* @__PURE__ */ e.jsx(
        Q,
        {
          className: "col-span-full sm:col-span-4 md:col-span-6",
          ...u("commuter.email"),
          label: t.commuter.email,
          error: h("commuter.email"),
          disabled: !x,
          required: !0
        }
      ),
      S ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          Q,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...u("commuter.startDate", { type: "date" }),
            label: t.commuter.startDate,
            error: h("commuter.startDate"),
            disabled: !x,
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx("p", { className: "col-span-full mt-[-8px] text-sm sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7", children: t.startDateDescription })
      ] }) : null
    ] }) : null,
    c && !l ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(ge, { className: "col-span-full", children: m.vatno }),
      /* @__PURE__ */ e.jsx(
        Q,
        {
          className: "col-span-full",
          ...u("bypassVatno", {
            type: "checkbox",
            value: "true"
          }),
          label: t.bypassVatno,
          disabled: !x
        }
      )
    ] }) : null,
    c && l ? /* @__PURE__ */ e.jsx(ge, { className: "col-span-full", children: m.vatnoCommuter }) : null,
    /* @__PURE__ */ e.jsx(
      Ms,
      {
        loadingLabel: t.loading,
        namespace: s,
        onClick: p(),
        disabled: !x || !f
      }
    )
  ] });
}, On = Gt(), tl = Gt(), lx = On("country", "phoneCode", "phone"), cx = On("vatno"), dx = tl("email"), mx = (t) => {
  const s = On("contact")(t), n = s == null ? void 0 : s.contact;
  if (n) {
    const { phoneCode: r, phone: a } = tl("phoneCode", "phone")(n), o = On("country")(t);
    return { phoneCode: r, phone: a, ...o };
  }
}, ux = ({
  namespace: t,
  titleTranslationKey: s,
  ns: n
}) => {
  const r = Xn(), a = Qn(), o = kt(), i = Jn(), { locale: d } = se(), [l, c] = M(!1), m = Gi(), { t: u } = O(n, {
    nsMode: "fallback"
  }), h = L(
    (v) => async (S) => {
      if (S && dt("phone")(S)) {
        const y = lx(v);
        return await r({
          phone: u("form.validations.phone.invalid")
        })(y);
      }
    },
    [u, r]
  ), p = L(
    (v) => async (S) => {
      if (S && dt("contact.phone")(S)) {
        const y = mx(v);
        if (y)
          return await r({
            "contact.phone": u("form.validations.phone.invalid")
          })(y);
      }
    },
    [r, u]
  ), f = L(
    (v) => async (S) => {
      if (S && dt("contact.phone")(S)) {
        const y = cx(v);
        if (y) {
          const w = y.vatno ? u("form.validations.vatno.exist") : void 0, z = await a(() => ({
            vatno: w
          }))(y);
          if (y.vatno ? c(!0) : c(!1), z)
            return {
              ...z,
              vatno: v.bypassVatno === "true" ? void 0 : z.vatno
            };
        }
      }
    },
    [a, u]
  ), x = L(
    async (v) => {
      const S = await $t(
        fc.spa,
        u
      )(v);
      return await Un(
        async (E) => await h(v)(E),
        async (E) => await p(v)(E),
        async (E) => await f(v)(E)
      )(S);
    },
    [u, h, f]
  ), g = L(
    (v) => async (S) => {
      const y = dx(v.contact), z = await m((E) => ({
        email: !E.success && dt("email")(S) ? u("form.validations.email.exist") : void 0
      }))(y), C = Object.values(z);
      for (const E of C)
        if (E)
          return z;
    },
    [m, u]
  ), N = L(
    async (v) => {
      const S = await x(v);
      return S || await g(v)();
    },
    [x, g]
  ), b = i.find(
    (v) => v.country === ms(d || "")
  );
  return /* @__PURE__ */ e.jsx(
    ix,
    {
      namespace: t,
      title: u(s),
      defaultValues: {
        country: ms(d || ""),
        phoneCode: b == null ? void 0 : b.value,
        contact: {
          phoneCode: b == null ? void 0 : b.value
        },
        commuter: {}
      },
      vatnoExist: l,
      labels: {
        companyName: u("form.labels.companyName"),
        vatno: u("form.labels.vatno"),
        ean: u("form.labels.ean"),
        city: u("form.labels.city"),
        address: u("form.labels.address"),
        zipCode: u("form.labels.zipCode"),
        phone: u("form.labels.phone"),
        phoneCode: u("form.labels.phoneCode"),
        country: u("form.labels.country"),
        contact: {
          firstName: u("form.labels.firstName"),
          lastName: u("form.labels.lastName"),
          phoneCode: u("form.labels.phoneCode"),
          email: u("form.labels.email"),
          phone: u("form.labels.phone")
        },
        commuter: {
          email: u("form.labels.email"),
          firstName: u("form.labels.firstName"),
          lastName: u("form.labels.lastName"),
          startDate: u("form.labels.startDate")
        },
        commuterLabel: u("form.labels.commuter"),
        contactPersonLabel: u("form.labels.contactPerson"),
        loading: u("action.loading"),
        bypassVatno: u("form.labels.bypassVatno"),
        startDateDescription: u("form.descriptions.startDate")
      },
      disclaimers: {
        vatno: /* @__PURE__ */ e.jsx(
          G,
          {
            i18nKey: "form.sections.contactInformation.disclaimers.vatno",
            ns: n,
            children: /* @__PURE__ */ e.jsx(k, {})
          }
        ),
        vatnoCommuter: /* @__PURE__ */ e.jsx(
          G,
          {
            i18nKey: "form.sections.contactInformation.disclaimers.vatnoCommuter",
            ns: n,
            children: /* @__PURE__ */ e.jsx(k, {})
          }
        )
      },
      placeholders: {
        country: u("form.placeholders.country"),
        phoneCode: u("form.placeholders.phoneCode")
      },
      countryOptions: o,
      phoneCodeOptions: i,
      onValidate: N
    }
  );
}, hx = {
  paymentOptions: "licensePlate",
  weightClass: "false"
}, px = ({
  labels: t,
  countryOptions: s = [],
  bvSupportCountries: n,
  weightClassOptions: r = [],
  fuelTypeOptions: a = [],
  emissionClassOptions: o = [],
  onAdd: i,
  onValidate: d,
  onCancel: l,
  displayCancel: c,
  placeholders: m,
  disableForm: u,
  defaultValues: h,
  vehicleColors: p
}) => {
  const f = D(
    () => ({ ...hx, ...h }),
    [h]
  ), x = "alpr", {
    registerField: g,
    getError: N,
    getData: b,
    validate: v,
    isValid: S,
    isDirty: y,
    transformData: w,
    resetSelectedData: z,
    setPartialData: C,
    resetFieldErrors: E,
    setFieldErrors: A
  } = he({
    namespace: x,
    onValidate: d,
    defaultValues: f
  }), [F, R] = Ee(
    x,
    "country",
    "licensePlate"
  ), [T, P] = M(), [V, I] = M(), [_, ne] = M(), {
    data: K,
    error: U,
    isFetching: re
  } = $n(T), ie = ks();
  B(() => I(U), [U]), B(() => I(null), [R]), B(() => ne(K), [K]), B(() => ne(void 0), [R, F]), B(() => P(void 0), [F]);
  const le = L(() => {
    z([
      "make",
      "model",
      "color",
      "weightClass",
      "hybrid",
      "fuelType",
      "emissionClass"
    ]);
  }, [z]), me = L(() => {
    le(), E(), P(void 0);
  }, [E, le]);
  B(() => me, [F, me]), B(
    () => ri(
      _,
      C,
      me,
      o
    ),
    [_, C, me]
  );
  const ce = L(async () => {
    if (await v()())
      i(b());
    else
      return;
  }, [v, b, i]), q = L(
    async (de) => {
      const ae = F;
      if (!ae || !de) {
        P({ licensePlate: de, country: ae });
        return;
      }
      try {
        if (await ie({
          licensePlate: t.licensePlateExist
        })({
          licensePlate: de,
          country: ae
        }))
          P({ licensePlate: de, country: ae });
        else
          throw new Error("Validation failed");
      } catch (je) {
        A(je), le();
      }
    },
    [
      P,
      F,
      ie,
      t,
      A,
      le
    ]
  );
  return B(() => {
    pn(
      hn(R),
      F
    ) && q(R);
  }, [R, F, q]), /* @__PURE__ */ e.jsx(ke.Root, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(ke.Content, { children: /* @__PURE__ */ e.jsxs(Ue, { children: [
    /* @__PURE__ */ e.jsx(
      Q,
      {
        ...g("alprName"),
        label: t.alprName,
        className: "col-span-full sm:col-span-4 md:col-span-12",
        error: N("alprName"),
        disabled: u
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...g("country"),
        label: t.country,
        options: s.map((de) => ({
          label: de.key,
          value: de.value,
          key: de.value
        })),
        placeholder: m.country,
        error: N("country"),
        disabled: u,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        ...g("licensePlate"),
        label: t.licensePlate,
        className: "col-span-full sm:col-start-5 md:col-span-6 md:col-start-7",
        error: N("licensePlate"),
        disabled: u,
        required: !0
      }
    ),
    V ? /* @__PURE__ */ e.jsx($, { className: "col-span-full bg-white", children: /* @__PURE__ */ e.jsx(ge, { className: "col-span-full mb-2", children: t.noVehicleInfo }) }) : null,
    /* @__PURE__ */ e.jsx($, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(k, { as: "h6", size: "lg", className: "mb-0", children: t.volVehicleInfo }) }),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        ...g("make"),
        label: t.make,
        className: "col-span-full sm:col-span-4 md:col-span-6",
        error: N("make"),
        disabled: u || !!(_ != null && _.make)
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        ...g("model"),
        label: t.model,
        className: "col-span-full sm:col-span-4 md:col-span-6",
        error: N("model"),
        disabled: u || !!(_ != null && _.model)
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...g("color"),
        label: t.color,
        options: p,
        placeholderDisabled: !1,
        placeholder: m.color,
        error: N("color"),
        disabled: u || !!(_ != null && _.color)
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...g("weightClass"),
        label: t.weightClass,
        options: r,
        placeholder: m.weightClass,
        error: N("weightClass"),
        placeholderDisabled: !1,
        disabled: u || (_ == null ? void 0 : _.isHGV) !== void 0,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-start-5 md:col-span-6",
        ...g("fuelType"),
        label: t.fuelType,
        options: a,
        placeholder: m.fuelType,
        placeholderDisabled: !1,
        error: N("fuelType"),
        disabled: u || !!(_ != null && _.fuelType)
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...g("emissionClass"),
        label: t.emissionClass,
        options: o,
        error: N("emissionClass"),
        placeholderDisabled: !1,
        placeholder: m.emissionClass,
        disabled: u || !!(_ != null && _.euroEmissionNorm)
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        ...g("hybrid", {
          type: "checkbox",
          value: "true"
        }),
        label: t.hybrid,
        className: "col-span-full sm:col-start-5 md:col-span-6",
        error: N("hybrid"),
        disabled: u || (_ == null ? void 0 : _.isHybrid) !== void 0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        name: "orderBizz",
        type: "checkbox",
        value: "true",
        label: t.orderBizz,
        className: "col-span-full sm:col-start-5 md:col-span-6",
        onChange: (de) => {
          const ae = de.target.checked;
          w(ae ? (je) => ({
            ...je,
            paymentOptions: "bizz"
          }) : (je) => ({
            ...je,
            paymentOptions: "licensePlate"
          }));
        },
        disabled: u
      }
    ),
    /* @__PURE__ */ e.jsxs($, { className: "col-span-full mt-2 flex justify-end", children: [
      c ? /* @__PURE__ */ e.jsx(
        X,
        {
          intent: "text",
          onClick: l,
          className: "mr-auto",
          disabled: u,
          children: t.cancel
        }
      ) : null,
      /* @__PURE__ */ e.jsx(
        X,
        {
          intent: "outlined",
          onClick: ce,
          disabled: !S || !y || u || re,
          className: "ml-auto",
          children: t.add
        }
      )
    ] })
  ] }) }) });
}, fx = {
  paymentEntries: []
}, xx = ({
  title: t,
  namespace: s,
  description: n,
  labels: r,
  countryOptions: a,
  bvSupportCountries: o,
  weightClassOptions: i,
  emissionClassOptions: d,
  fuelTypeOptions: l,
  maxEntries: c,
  onAlprValidation: m,
  onValidate: u,
  useOnOtherPlacesDisclaimer: h,
  placeholders: p,
  defaultCountry: f,
  maxEntriesDisclaimer: x,
  skipAlprDisclaimer: g,
  vehicleColors: N
}) => {
  const [b, v] = M(""), { stepNr: S, getData: y, validate: w, isValid: z, isActive: C, transformData: E } = he({
    namespace: s,
    title: t,
    defaultValues: fx,
    onValidate: u
  }), A = y().paymentEntries || [], [F, R] = M(() => A.length === 0), [T, P] = M(0), V = L(
    (ne) => {
      E((K) => ({
        paymentEntries: (() => {
          const U = K.paymentEntries || [];
          return U.splice(T, 1, ne), U;
        })()
      })), R(!1);
    },
    // eslint-disable-next-line
    [R, T]
  ), I = L(
    (ne) => E((K) => {
      const re = [...K.paymentEntries || []];
      return re.splice(ne, 1), re.length === 0 && R(!0), {
        paymentEntries: re.length ? re : K.paymentEntries
      };
    }),
    // eslint-disable-next-line
    [R]
  ), _ = L(() => {
    P((ne) => ne + 1), R(!0);
  }, [P, R]);
  return /* @__PURE__ */ e.jsxs(Bt, { nr: S, title: t, id: s, children: [
    /* @__PURE__ */ e.jsx($, { className: "col-span-full", children: n }),
    A.map((ne, K) => /* @__PURE__ */ e.jsx(
      Ki,
      {
        labels: r,
        ...ne,
        onRemove: () => I(K),
        disabled: !C
      },
      K
    )),
    F ? /* @__PURE__ */ e.jsx(ut, { children: /* @__PURE__ */ e.jsx(
      px,
      {
        onValidate: m,
        labels: r,
        onCancel: () => R(!1),
        countryOptions: a,
        bvSupportCountries: o,
        weightClassOptions: i,
        emissionClassOptions: d,
        fuelTypeOptions: l,
        onAdd: V,
        displayCancel: A.length > 0,
        useOnOtherPlacesDisclaimer: h,
        placeholders: p,
        disableForm: !C || b === "true",
        defaultValues: { country: f },
        vehicleColors: N
      }
    ) }) : null,
    A.length + 1 <= c && !F ? /* @__PURE__ */ e.jsx(
      X,
      {
        startIcon: /* @__PURE__ */ e.jsx(cs, {}),
        intent: "text",
        onClick: _,
        disabled: !C,
        className: "w-fit",
        children: r.addMore
      }
    ) : null,
    A.length >= c ? /* @__PURE__ */ e.jsx(ge, { className: "col-span-full", children: x }) : null,
    F && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        Q,
        {
          className: "col-span-full",
          type: "checkbox",
          name: "skip-entries",
          value: "true",
          disabled: !C || A.length > 0,
          checked: b === "true",
          onChange: () => v((ne) => ne === "true" ? "false" : "true"),
          label: r.skipAlpr
        }
      ),
      b === "true" ? /* @__PURE__ */ e.jsx(ge, { className: "col-span-full ", children: /* @__PURE__ */ e.jsx(k, { size: "sm", children: g }) }) : null
    ] }),
    /* @__PURE__ */ e.jsx(
      Ms,
      {
        loadingLabel: r.loading,
        namespace: s,
        onClick: w(),
        disabled: (!C || !z || !A.length || F) && b !== "true"
      }
    )
  ] });
}, gx = Gt()("licensePlate", "country"), Ja = it.fromNullableProp()("paymentEntries", []), bx = (t) => t.find((s) => s.weightClass === "true"), vx = ({
  namespace: t,
  titleTranslationKey: s,
  ns: n
}) => {
  const r = Dr(), a = wo(), o = wt(), i = ks(), { discountMainContract: d, removeDiscountMainContract: l, getContracts: c } = Ws(), { t: m } = O(n, {
    nsMode: "fallback"
  }), { getData: u } = he({
    namespace: t,
    title: m(s)
  }), h = L(
    (N) => async (b) => {
      if (b && !dt("licensePlate")(b))
        return;
      const v = gx(N);
      if (!(!v.country || !v.licensePlate))
        return await i({
          licensePlate: m("form.validations.licensePlate.exist")
        })(v);
    },
    [m, i]
  ), p = L(
    (N) => () => {
      if (Ja.get(u()).some((S) => S.licensePlate === N.licensePlate))
        return { licensePlate: m("form.validations.licensePlate.unique") };
    },
    [u, m]
  ), f = L(
    async (N) => {
      const b = await $t(fo.spa, m)(N);
      return await Un(
        async () => p(N)(),
        async (w) => h(N)(w)
      )(b);
    },
    [h, m, p]
  );
  B(() => {
    const N = Ja.get(u());
    bx(N) ? d({
      currency: c().main.prices[0].currency,
      price: 0,
      contractType: c().main.value,
      productCode: "",
      priceInclVAT: 0
    }) : l();
  }, [u]);
  const x = Gn.map((N) => ({
    label: m(`vehicleColors.${N}`),
    value: N
  })), g = {
    namespace: t,
    title: m(s),
    description: /* @__PURE__ */ e.jsxs(G, { i18nKey: "form.sections.payment.description", ns: n, children: [
      /* @__PURE__ */ e.jsx(k, { className: "mb-4" }),
      /* @__PURE__ */ e.jsx(k, { size: "sm" })
    ] }),
    maxEntriesDisclaimer: /* @__PURE__ */ e.jsx(
      G,
      {
        i18nKey: "form.sections.payment.disclaimers.numberOfEntries",
        ns: n,
        children: /* @__PURE__ */ e.jsx(k, { as: "span", weight: "medium" })
      }
    ),
    skipAlprDisclaimer: m("form.sections.payment.disclaimers.skipAlpr"),
    onAlprValidation: f,
    countryOptions: a.flatMap((N) => N.children).map(({ key: N, value: b }) => ({ key: N, value: b })),
    bvSupportCountries: r,
    maxEntries: 2,
    commuter: !1,
    labels: {
      skipAlpr: m("form.labels.skipAlpr"),
      licensePlate: m("form.labels.licensePlate"),
      country: m("form.labels.country"),
      fuelType: m("form.labels.fuelType"),
      emissionClass: m("form.labels.emissionClass"),
      weightClass: m("form.labels.weightClass"),
      useInNorway: m("form.labels.useInNorway"),
      add: m("form.labels.add"),
      hybrid: m("form.labels.hybrid"),
      addMore: m("form.labels.addMore"),
      cancel: m("action.cancel"),
      remove: m("action.remove"),
      loading: m("action.loading"),
      orderBizz: m("form.labels.orderBizz"),
      bizzOrdered: m("form.sections.payment.disclaimers.bizzOrdered"),
      bizz: m("form.labels.bizz"),
      vehicleSearch: m("action.search"),
      make: m("form.labels.make"),
      model: m("form.labels.model"),
      color: m("form.labels.color"),
      alprName: m("form.labels.alprName"),
      volVehicleInfo: m("form.labels.vlinfo"),
      noVehicleInfo: m("form.validations.licensePlate.notfound"),
      licensePlateExist: m("form.validations.licensePlate.exist"),
      loadingSearch: m("action.loading"),
      // Not used
      isSBF: ""
    },
    placeholders: {
      weightClass: m("form.placeholders.weightClass"),
      country: m("form.placeholders.country"),
      emissionClass: m("form.placeholders.emissionClass"),
      fuelType: m("form.placeholders.fuelType"),
      color: m("form.placeholders.color")
    },
    useOnOtherPlacesDisclaimer: m(
      "form.sections.payment.disclaimers.useInNorway"
    ),
    fuelTypeOptions: o.fuelTypes,
    weightClassOptions: [
      { label: m("weightClasses.light"), value: "false" },
      { label: m("weightClasses.heavy"), value: "true" }
    ],
    emissionClassOptions: o.emissionClasses,
    vehicleColors: x
  };
  return /* @__PURE__ */ e.jsx(xx, { ...g });
}, yx = ({ namespace: t, labels: s, countryOptions: n = [], placeholders: r }) => {
  const { registerField: a, getError: o, isActive: i } = he({ namespace: t });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(k, { intent: "title", className: "col-span-full mt-2", children: s.paperInvoiceTitle }),
    /* @__PURE__ */ e.jsx(k, { intent: "label", size: "sm", className: "col-span-full", children: s.requiredFields }),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full",
        ...a("invoice.attentionName"),
        error: o("invoice.attentionName"),
        label: s.attentionName,
        required: !0,
        disabled: !i
      }
    ),
    /* @__PURE__ */ e.jsx(
      xe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...a("invoice.country"),
        label: s.country,
        options: n.map((d) => ({ ...d, label: d.key })),
        placeholder: r.country,
        error: o("invoice.country"),
        disabled: !i,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...a("invoice.address"),
        label: s.address,
        error: o("invoice.address"),
        required: !0,
        disabled: !i
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...a("invoice.zipCode"),
        error: o("invoice.zipCode"),
        label: s.zipCode,
        required: !0,
        disabled: !i
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...a("invoice.city"),
        error: o("invoice.city"),
        label: s.city,
        required: !0,
        disabled: !i
      }
    )
  ] });
}, jx = ({ labels: t, namespace: s, countryOptions: n, placeholders: r, disclaimers: a }) => {
  const { locale: o } = se(), { registerField: i, getError: d, isActive: l } = he({
    namespace: s
  }), { transformData: c } = he({
    namespace: "termsOfAgreement"
  }), [m, u] = Ee(
    s,
    "invoice.sendToEmail",
    "invoice.displayInEuro"
  ), h = D(() => m === "true" ? /* @__PURE__ */ e.jsx(
    Q,
    {
      ...i("invoice.email"),
      className: "col-span-full sm:col-span-4 md:col-span-6",
      type: "email",
      error: d("invoice.email"),
      required: !0,
      label: t.email
    }
  ) : m === "false" ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(ge, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(k, { size: "sm", children: a.paper }) }),
    /* @__PURE__ */ e.jsx(
      yx,
      {
        namespace: s,
        labels: t,
        countryOptions: n,
        placeholders: r
      }
    )
  ] }) : null, [
    t,
    i,
    m,
    s,
    n,
    r,
    d,
    a
  ]);
  return B(() => {
    c(u === "true" ? (p) => ({ ...p, currency: "DKK" }) : (p) => ({
      ...p,
      currency: ss(o || "")
    }));
  }, [u, o]), /* @__PURE__ */ e.jsxs(Ue, { children: [
    /* @__PURE__ */ e.jsx(ge, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(k, { size: "sm", children: a.invoice }) }),
    /* @__PURE__ */ e.jsxs(
      Ft.Root,
      {
        ...i("invoice.sendToEmail"),
        label: t.invoiceDelivery,
        required: !0,
        className: "col-span-full",
        children: [
          /* @__PURE__ */ e.jsx(
            Ft.Item,
            {
              label: t.sendToEmail.true,
              value: "true",
              disabled: !l
            }
          ),
          /* @__PURE__ */ e.jsx(
            Ft.Item,
            {
              label: t.sendToEmail.false,
              value: "false",
              disabled: !l
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(
      Q,
      {
        className: "col-span-full",
        ...i("invoice.displayInEuro", {
          type: "checkbox",
          value: "true"
        }),
        label: t.displayInEuro,
        error: d("invoice.displayInEuro"),
        disabled: !l
      }
    ),
    h
  ] });
}, Cx = ({
  namespace: t,
  title: s,
  defaultValues: n,
  onValidate: r,
  labels: a,
  description: o,
  countryOptions: i,
  placeholders: d,
  disclaimers: l
}) => {
  const { registerField: c, getError: m, isActive: u, isValid: h, validate: p, stepNr: f } = he({ namespace: t, title: s, defaultValues: n, onValidate: r }), [x] = Ee(t, "method");
  return /* @__PURE__ */ e.jsxs(Bt, { nr: f, title: s, id: t, children: [
    /* @__PURE__ */ e.jsx(k, { className: "col-span-full", children: o }),
    /* @__PURE__ */ e.jsxs(
      ar.Root,
      {
        ...c("method"),
        className: "col-span-full",
        direction: "col",
        label: a.chooseMethod,
        required: !0,
        children: [
          /* @__PURE__ */ e.jsx(
            ar.Expander,
            {
              label: a.method.card,
              value: "card",
              transparent: !0,
              disabled: !u
            }
          ),
          /* @__PURE__ */ e.jsx(
            ar.Expander,
            {
              label: a.method.invoice,
              value: "invoice",
              disabled: !u,
              children: /* @__PURE__ */ e.jsx(ke.Root, { className: "mt-4", children: /* @__PURE__ */ e.jsx(ke.Content, { children: /* @__PURE__ */ e.jsx(
                jx,
                {
                  labels: a,
                  namespace: t,
                  countryOptions: i,
                  placeholders: d,
                  disclaimers: l
                }
              ) }) })
            }
          )
        ]
      }
    ),
    m("method") !== void 0 ? /* @__PURE__ */ e.jsx(ge, { className: "col-span-full", color: "negative", children: m("method") }) : null,
    /* @__PURE__ */ e.jsx(
      Ms,
      {
        loadingLabel: a.loading,
        namespace: t,
        onClick: p(),
        disabled: !u || !h || !x
      }
    )
  ] });
}, Nx = ({
  namespace: t,
  titleTranslationKey: s,
  ns: n
}) => {
  const r = kt(), { t: a } = O(n, {
    nsMode: "fallback"
  }), [o, i, d, l] = Ee(
    "contactInformation",
    "address",
    "country",
    "city",
    "zipCode"
  ), c = D(
    () => ({
      address: o,
      country: i,
      city: d,
      zipCode: l,
      sendToEmail: "true",
      displayInEuro: ""
    }),
    [o, i, d, l]
  );
  return /* @__PURE__ */ e.jsx(
    Cx,
    {
      namespace: t,
      title: a(s),
      description: a("form.sections.paymentMethod.description"),
      defaultValues: {
        invoice: c
      },
      labels: {
        address: a("form.labels.address"),
        email: a("form.labels.email"),
        city: a("form.labels.city"),
        method: {
          invoice: a("form.labels.invoice"),
          card: a("form.labels.card")
        },
        country: a("form.labels.country"),
        attentionName: a("form.labels.attentionName"),
        zipCode: a("form.labels.zipCode"),
        useInvoiceAddress: a("form.labels.useInvoiceAddress"),
        displayInEuro: a("form.labels.displayInEuro"),
        sendToEmail: {
          true: a("form.labels.sendByEmail"),
          false: a("form.labels.sendByMail")
        },
        loading: a("action.loading"),
        requiredFields: a("form.requiredFields"),
        chooseMethod: a("form.labels.chooseMethod"),
        invoiceDelivery: a("form.labels.invoiceDelivery"),
        paperInvoiceTitle: a("form.sections.paymentMethod.paperInvoiceTitle")
      },
      countryOptions: r,
      disclaimers: {
        invoice: /* @__PURE__ */ e.jsx(
          G,
          {
            i18nKey: "form.sections.paymentMethod.disclaimers.invoice",
            ns: n,
            children: /* @__PURE__ */ e.jsx(k, { as: "span", weight: "medium", size: "sm" })
          }
        ),
        paper: a("form.sections.paymentMethod.disclaimers.paper")
      },
      placeholders: {
        country: a("form.placeholders.country")
      },
      onValidate: async (m) => {
        if (m.method !== "invoice")
          return;
        const u = await Ts(xc.spa)(m.invoice);
        return u ? Object.entries(
          u
        ).reduce(
          (p, [f, x]) => ({
            ...p,
            [`invoice.${f}`]: x
          }),
          {}
        ) : void 0;
      }
    }
  );
}, {
  setError: wx,
  setResponse: kx,
  setRequestData: Px,
  setPayWithCreditCard: Tx,
  setToken: Sx
} = zs, Mx = (t) => {
  if (Qr(t))
    wx(t);
  else
    return {};
}, zx = () => {
  const [t, s] = M(!1), { locale: n } = se(), { setBannerVisible: r } = Er(), { main: a } = Zi("business", Z.OresundPAYBusiness), { app: o } = Ye(), { push: i, asPath: d } = se(), l = pt(), c = !!(l != null && l.get("showAlprInSignup")), { mutateAsync: m } = fe(
    ["signup"],
    (y) => y.Customer.signup,
    {
      onMutate: () => {
        s(!0), r(!1);
      },
      onSuccess: (y) => {
        kx(y), Sx(y.code);
      },
      onError: Mx
    }
  ), u = ["businessSignUp", "common"], { t: h } = O(u, {
    nsMode: "fallback"
  }), p = L((y) => {
    if (!y)
      return y;
    const w = y.contactInformation, z = {
      ...w,
      phoneCode: vs(w.phoneCode),
      contact: {
        ...w.contact,
        phoneCode: vs(w.contact.phoneCode)
      }
    };
    return {
      ...y,
      contactInformation: {
        ...z,
        bypassVatno: w.bypassVatno === !0 ? "true" : w.bypassVatno === !1 ? "false" : void 0
      }
    };
  }, []), f = (y) => {
    var C;
    const w = {
      ...y,
      contractType: a.value,
      payment: {
        paymentEntries: (((C = y.payment) == null ? void 0 : C.paymentEntries) || []).filter(
          (E) => !_i(E)
        )
      },
      paymentMethod: !y.paymentMethod || Object.keys(y.paymentMethod).length === 0 ? void 0 : y.paymentMethod
    };
    return (async (E) => {
      var R;
      const A = {
        ...E,
        subscribeToClub: {},
        paymentAgreement: { oresundsPay: "true" }
      }, F = p(A);
      if (Px(F), ((R = E.paymentMethod) == null ? void 0 : R.method) === "card")
        Tx();
      else {
        const T = await m(p(A));
        let P = {
          email: "",
          firstName: "",
          lastName: "",
          phone: "",
          phoneCode: ""
        };
        E.contactInformation.contact ? P = E.contactInformation.contact : P = E.contactInformation, Wr(), _r(
          {
            transaction_id: T.orderNo,
            value: x(
              a.prices,
              E.termsOfAgreement.currency
            ),
            currency: E.termsOfAgreement.currency,
            coupon: void 0,
            items: [
              {
                item_name: g(a.value),
                item_category: "Business",
                item_variant: "OperatorSignup",
                quantity: "1",
                price: N(a.prices, E.termsOfAgreement.currency)
              }
            ]
          },
          {
            email: P.email,
            firstName: P.firstName,
            lastName: P.lastName,
            phone: `+${E.contactInformation.phoneCode}${E.contactInformation.phone}`,
            city: E.contactInformation.city,
            address1: E.contactInformation.address,
            zipCode: E.contactInformation.zipCode,
            company: E.contactInformation.companyName ?? "",
            country: E.contactInformation.country
          }
        );
      }
    })(w);
  }, x = (y, w) => y.filter((z) => z.currency === w).reduce((z, C) => z + C.price, 0).toString(), g = (y) => {
    switch (y) {
      case "OresundPAYBusiness":
      case "OresundPAY":
        return "OresundPay";
      default:
        return "";
    }
  }, N = (y, w) => {
    const z = y.find((C) => C.currency === w);
    return z ? `${z.price}` : "";
  }, [b] = Ee("termsOfAgreement", "currency"), v = D(
    () => b || ss(n || ""),
    [b, n]
  ), S = L(
    (y) => i(`${d.split("#")[0]}${y}`, void 0, {
      scroll: !1,
      shallow: !0
    }),
    [i, d]
  );
  return t ? /* @__PURE__ */ e.jsx($, { className: "item-center col-span-full flex h-[600px] items-center justify-center text-5xl md:col-span-6 md:col-start-4", children: /* @__PURE__ */ e.jsx(nn, { label: h("action.loading") }) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(k, { intent: "label", className: "col-span-full mb-8", children: h("form.requiredFields") }),
    /* @__PURE__ */ e.jsx($, { className: "col-span-full md:col-span-8 ", children: /* @__PURE__ */ e.jsxs(
      Yi,
      {
        onSubmit: f,
        continueLabel: h("action.continue"),
        submitLabel: h("action.pay"),
        editLabel: h("action.edit"),
        push: S,
        children: [
          /* @__PURE__ */ e.jsx(
            ux,
            {
              namespace: "contactInformation",
              titleTranslationKey: "form.sections.contactInformation.title",
              ns: u
            }
          ),
          /* @__PURE__ */ e.jsx(
            Wi,
            {
              namespace: "codeVerification",
              ns: u,
              titleTranslationKey: "form.sections.codeVerification.title",
              isBusiness: !0
            }
          ),
          c || o === ot.Oresundsbron ? /* @__PURE__ */ e.jsx(
            vx,
            {
              namespace: "payment",
              titleTranslationKey: "form.sections.payment.title",
              ns: u
            }
          ) : /* @__PURE__ */ e.jsx(e.Fragment, {}),
          /* @__PURE__ */ e.jsx(
            Nx,
            {
              namespace: "paymentMethod",
              titleTranslationKey: "form.sections.paymentMethod.title",
              ns: u
            }
          ),
          /* @__PURE__ */ e.jsx(
            Xi,
            {
              namespace: "termsOfAgreement",
              titleTranslationKey: "form.sections.termsOfAgreement.title",
              contractType: Z.OresundPAYBusiness,
              ns: u
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx($, { className: "hidden md:col-span-4 md:col-start-9 md:block", children: /* @__PURE__ */ e.jsx(
      Qi,
      {
        total: {
          label: h("signup.total"),
          value: h("price.yearly", {
            price: (() => {
              const w = (a.prices || []).find(
                (z) => z.currency === v
              );
              return w ? Bn(
                w.price || 0,
                n,
                v
              ) : "";
            })()
          })
        },
        contract: {
          label: a.value,
          value: h("price.yearly", {
            price: `0,00 ${v}`
          })
        },
        ns: "businessSignUp"
      }
    ) })
  ] });
}, { resetStore: Ax } = zs, Gg = () => {
  const { error: t, resp: s, isPasswordSet: n, payWithCreditCard: r, token: a } = yt(), { reset: o } = Ws(), { query: i } = se(), { setBannerVisible: d } = Er(), l = i.complete === "1", c = D(() => {
    if (l)
      return d(!1), /* @__PURE__ */ e.jsx(An, { ns: "privateSignUp" });
    if (t) {
      const m = t.error && i1(t.error) ? /* @__PURE__ */ e.jsx(ox, { status: t.error }) : /* @__PURE__ */ e.jsx(Ji, {});
      if (m) return m;
    }
    return r && !s ? /* @__PURE__ */ e.jsx(qi, {}) : s && a ? n ? /* @__PURE__ */ e.jsx(An, { ns: "businessSignUp" }) : /* @__PURE__ */ e.jsx(Hi, { ns: "businessSignUp" }) : (d(!1), /* @__PURE__ */ e.jsx(zx, {}));
  }, [
    t,
    s,
    n,
    r,
    a,
    l,
    d
  ]);
  return B(
    () => () => {
      Ax(), o();
    },
    []
  ), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(ut, { children: /* @__PURE__ */ e.jsx(Ue, { className: "md:gap-x-20", children: c }) }),
    /* @__PURE__ */ e.jsx(
      Mr,
      {
        strategy: "lazyOnload",
        src: "https://checkout.reepay.com/checkout.js"
      }
    )
  ] });
}, As = ({ className: t }) => /* @__PURE__ */ e.jsx(
  "span",
  {
    className: He(
      "border-b-primary-600 inline-block h-24 w-24 animate-spin rounded-full border-8 border-solid border-neutral-200",
      t
    )
  }
);
function Ox() {
  const { data: t, isLoading: s } = ye(
    ee.BizzStatuses(),
    ({ Recognitions: n }) => n.bizzStatuses(),
    { keepPreviousData: !0 }
  );
  return {
    data: t,
    isLoading: s
  };
}
const Ex = 20, sl = ({
  actions: t,
  productType: s,
  pageType: n,
  hideCommuter: r = !0,
  shouldTriggerModal: a = !0
}) => {
  var ne;
  const [o, i] = M(""), { t: d } = O(["account", "common", "recognitions"], {
    nsMode: "fallback"
  }), { data: l } = Ox(), [c, m] = M([]), [u, h] = M([]), [p, f] = M(!1), [x, g] = M(null), {
    query: { contract: N }
  } = se(), { data: b } = Ke(), v = (ne = b == null ? void 0 : b.paymentAgreement) != null && ne.provider ? us(b.paymentAgreement.provider) : !0, S = () => {
    f(!1);
  }, y = () => {
    x && x(), f(!1);
  }, { recognitions: w, totalRecognitions: z, loading: C, page: E, pages: A, setPage: F } = Lr(Ex, {
    searchText: o,
    status: c,
    agreements: N ? [N] : u,
    productType: s
  }), R = (K) => {
    K !== o && (i(K), F(1));
  }, T = o !== "" || c.length > 0 || u.length > 0, P = (l == null ? void 0 : l.map(({ label: K, value: U }) => ({
    value: U,
    label: d(`kmtoll.landing.bizzList.bizzStatus.${K}`)
  }))) || [], V = Yc(
    C,
    w.length,
    T,
    n
  ), I = (b == null ? void 0 : b.paymentAgreement.agreementType) !== "OresundGO", _ = (K) => {
    switch (K) {
      case "loading":
        return /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsx(As, {}) });
      case "newBizz":
        return /* @__PURE__ */ e.jsx(ga, { mode: "newBizz", pageType: n });
      case "emptyBizzList":
        return /* @__PURE__ */ e.jsx(ga, { mode: "emptyBizzList", pageType: n });
      case "displayBizzList":
        return /* @__PURE__ */ e.jsx(
          Iu,
          {
            recognitions: w,
            currentPage: E,
            totalPages: A,
            setPage: F
          }
        );
    }
  };
  return B(() => {
    F(1);
  }, [F, z]), /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs("div", { className: `${I ? "mt-8 md:mt-12" : ""} rounded-xl`, children: [
    (V === "displayBizzList" || V === "emptyBizzList") && /* @__PURE__ */ e.jsxs("div", { children: [
      l && I && /* @__PURE__ */ e.jsx(
        Kr,
        {
          hits: z,
          labelKey: "recognitions.label",
          hideCommuter: r,
          search: {
            query: o,
            setSearch: R,
            labelKey: "action.search",
            descriptionKey: "form.labels.searchDescription"
          },
          setAgreements: h,
          otherFilters: [
            {
              labelKey: "form.labels.filterOrderStatus",
              multiSelect: !0,
              options: P,
              setValue: m,
              mode: "bizzStatus"
            }
          ]
        }
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "mb-2 mt-6 flex flex-col items-end justify-end sm:mb-2 sm:mt-4 md:flex-row md:justify-end", children: [
        !v && (t == null ? void 0 : t.map((K) => /* @__PURE__ */ e.jsx(
          X,
          {
            startIcon: K.icon,
            type: "button",
            intent: "text",
            className: "font-medium underline",
            onClick: () => {
              var U;
              a ? (f(!0), g(() => K.action || null)) : (U = K.action) == null || U.call(K);
            },
            children: d(K.labelKey)
          },
          K.labelKey
        ))),
        a && /* @__PURE__ */ e.jsx(
          Xo,
          {
            isOpen: p,
            onClose: S,
            onContinue: y
          }
        ),
        /* @__PURE__ */ e.jsx(Eu, { activeAgreements: u })
      ] })
    ] }),
    _(V)
  ] }) });
}, nl = Ct(
  void 0
), rl = ({
  children: t,
  value: s
}) => /* @__PURE__ */ e.jsx(nl.Provider, { value: s, children: t }), Dx = () => {
  const t = at(nl);
  if (t === void 0)
    throw new Error("useRecognition must be used within a RecognitionProvider");
  return t;
}, Fx = [
  "relative",
  "isolate",
  "inline-flex",
  "cursor-pointer",
  "items-center",
  "justify-center",
  "gap-2",
  "border-2",
  "text-sm",
  "font-bold",
  "w-max-content",
  "text-center",
  "break-words",
  "overflow-hidden",
  "aria-disabled:pointer-events-none",
  "aria-disabled:select-none",
  "aria-disabled:opacity-60",
  "rounded-full",
  "overflow-hidden",
  "leading-5",
  "focus-visible:outline",
  "focus-visible:border-black",
  "focus-visible:outline-8",
  "focus-visible:outline-offset-4"
], Lx = Ht([...Fx], {
  variants: {
    intent: {
      primary: "bg-primary-700 border-primary-700 text-white hover:bg-primary-900 hover:border-primary-900 focus-visible:outline-primary-700/30",
      outline: "border-primary-700 text-primary-700 hover:bg-primary-700 hover:text-white",
      ghost: "bg-transparent border-transparent text-primary-700 underline hover:text-primary-900 hover:bg-neutral-100 focus-visible:text-primary-900 focus-visible:outline-neutral-200",
      danger: "border-red-600 text-red-600 hover:bg-red-600 hover:text-white focus-visible:bg-red-600 focus-visible:text-white focus-visible:outline-red-100"
    },
    disabled: {
      true: "opacity-30 pointer-events-none"
    },
    size: {
      default: "font-semibold text-sm py-3 px-6",
      sm: "font-semibold text-xs py-2 px-4",
      lg: "font-bold text-lg py-6 px-8"
    }
  }
}), Vx = (...t) => Nl(Cl(...t)), Rx = ({
  intent: t,
  size: s,
  children: n,
  disabled: r,
  startIcon: a,
  endIcon: o,
  loading: i,
  className: d,
  ...l
}) => /* @__PURE__ */ e.jsxs(
  "button",
  {
    className: Vx(
      "p-4",
      Lx({ intent: t, size: s, disabled: r }),
      d
    ),
    disabled: r || i,
    ...l,
    children: [
      i ? /* @__PURE__ */ e.jsx(As, { className: "absolute h-5 w-5" }) : null,
      a ? /* @__PURE__ */ e.jsx("span", { children: a }) : null,
      /* @__PURE__ */ e.jsx("span", { className: i ? "invisible" : "", children: n }),
      o ? /* @__PURE__ */ e.jsx("span", { children: o }) : null
    ]
  }
), ns = Bs.forwardRef(
  ({
    label: t,
    heading: s,
    disabled: n,
    error: r,
    className: a,
    onChange: o,
    defaultChecked: i,
    ...d
  }, l) => {
    const c = `cb-${Math.random().toString(36).substring(2, 9)}`;
    return /* @__PURE__ */ e.jsx("div", { className: He(a, n ? "opacity-30" : void 0), children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3 pr-3", children: [
      /* @__PURE__ */ e.jsx("span", { className: "block text-sm font-medium text-neutral-950", children: s }),
      /* @__PURE__ */ e.jsxs("div", { className: "flex items-center", children: [
        /* @__PURE__ */ e.jsx(
          "input",
          {
            id: c,
            ref: l,
            onChange: o,
            disabled: n,
            ...d,
            className: "border-1 hover:ring-inset-2 hover:border-1 checked:bg-primary-800 checked:ring-primary-400 hover:border-primary-500 h-4 w-4 flex-shrink-0 cursor-pointer appearance-none rounded border border-neutral-500 checked:border-2 checked:border-white checked:ring-2 hover:checked:border-white",
            type: "checkbox",
            defaultChecked: i
          }
        ),
        /* @__PURE__ */ e.jsx(
          "label",
          {
            htmlFor: c,
            className: "ml-3 flex gap-3 text-sm text-neutral-900",
            children: t && /* @__PURE__ */ e.jsx("p", { children: t })
          }
        )
      ] }),
      r && /* @__PURE__ */ e.jsx("span", { className: "w-fit rounded-md bg-red-50 px-4 py-2 text-sm text-red-600", children: r })
    ] }) });
  }
);
ns.displayName = "Checkbox";
const Kg = ({ text: t, onClick: s }) => /* @__PURE__ */ e.jsx(
  "button",
  {
    className: `
        bg-primary-500
        hover:bg-primary-700 
        rounded 
        px-4 py-2 
        font-bold 
        text-white
      `,
    onClick: s,
    children: t
  }
), Zg = () => {
  const { t } = O(["account"], { fallbackLng: "en" });
  return /* @__PURE__ */ e.jsx("p", { children: t("agreement.action.add") });
}, sa = () => /* @__PURE__ */ e.jsx("div", { className: "flex h-dvh items-center justify-center bg-white p-20 opacity-50", children: /* @__PURE__ */ e.jsx(As, { className: "m-auto" }) }), Yg = () => {
  const { t } = Cr("account");
  return /* @__PURE__ */ e.jsx(
    $,
    {
      className: "rounded bg-blue-100 px-4 py-4 text-blue-800 sm:px-6 sm:py-6",
      children: /* @__PURE__ */ e.jsxs($, { className: "flex gap-8 sm:flex", children: [
        /* @__PURE__ */ e.jsx($, { className: "flex flex-none gap-2", children: /* @__PURE__ */ e.jsx(to, { width: 48, height: 48 }) }),
        /* @__PURE__ */ e.jsxs($, { className: "hidden flex-auto flex-col gap-4 sm:flex", children: [
          /* @__PURE__ */ e.jsxs($, { className: "gap-1", children: [
            /* @__PURE__ */ e.jsx(k, { intent: "body", weight: "semibold", className: "uppercase", children: /* @__PURE__ */ e.jsx(
              nr,
              {
                ns: "account",
                i18nKey: "dashboard.noRecognitionBanner.pretitle"
              }
            ) }),
            /* @__PURE__ */ e.jsx(k, { intent: "title", weight: "semibold", className: "!text-3xl", children: /* @__PURE__ */ e.jsx(
              nr,
              {
                ns: "account",
                i18nKey: "dashboard.noRecognitionBanner.title"
              }
            ) })
          ] }),
          /* @__PURE__ */ e.jsx(k, { intent: "body", weight: "normal", children: t("dashboard.noRecognitionBanner.description") }),
          /* @__PURE__ */ e.jsx($, { className: "flex gap-4", children: /* @__PURE__ */ e.jsx(
            mt,
            {
              className: "bg-primary-700 flex-none rounded-full px-6 py-3 text-white no-underline hover:text-white",
              href: "/account/vehicles",
              weight: "bold",
              intent: "button",
              as: "a",
              children: /* @__PURE__ */ e.jsx(
                nr,
                {
                  ns: "account",
                  i18nKey: "dashboard.noRecognitionBanner.recognitionButton"
                }
              )
            }
          ) })
        ] })
      ] })
    }
  );
}, al = ({
  label: t,
  description: s,
  placeholder: n,
  className: r,
  disabled: a,
  setQuery: o,
  query: i,
  ...d
}) => /* @__PURE__ */ e.jsx("div", { className: `${r} ${a ? "opacity-32" : ""}`, children: /* @__PURE__ */ e.jsxs("label", { className: "block text-sm font-medium text-neutral-950", children: [
  t,
  s && /* @__PURE__ */ e.jsx("p", { className: "mt-2 text-sm font-normal text-neutral-800", children: s }),
  /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ e.jsx(
      "input",
      {
        ...d,
        value: i,
        onChange: (l) => o(l.target.value),
        className: "border-1 search-cancel:appearance-none relative mt-2 flex h-[48px] w-full appearance-none items-center justify-end rounded-[4px] border border-neutral-500 bg-white px-3 py-4 focus:border-0 focus:border-none focus:border-neutral-950 focus:outline-neutral-900 focus:ring-offset-1 focus-visible:ring [&::-webkit-search-cancel-button]:hidden",
        type: "search",
        disabled: a,
        tabIndex: 0,
        placeholder: n
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "absolute right-0 top-4 pr-3", children: /* @__PURE__ */ e.jsx(Gl, { className: "h-4 w-4" }) })
  ] })
] }) }), nt = ps(
  ({
    label: t,
    description: s,
    options: n,
    className: r,
    classNames: a,
    placeholder: o,
    onChange: i,
    required: d = !1,
    disabled: l = !1,
    error: c,
    initialValue: m,
    resetValueOnOptionsChange: u
  }, h) => {
    const [p, f] = M(!1), x = Ae(!1), [g, N] = M(m), b = n.find((C) => C.value === g), v = Ae(null), S = () => {
      l || f(!p);
    }, y = (C) => {
      l || (N(C.value), f(!1), i == null || i(C.value));
    }, w = (C) => {
      v.current && !v.current.contains(C.target) && f(!1);
    }, z = (C, E) => {
      (C.key === "Enter" || C.key === " ") && y(E);
    };
    return yr(h, () => v.current), B(() => {
      N(m);
    }, [m]), B(() => (document.addEventListener("mousedown", w), () => {
      document.removeEventListener("mousedown", w);
    }), []), B(() => {
      x.current && u ? N(void 0) : x.current = !0;
    }, [n, u]), /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `${(a == null ? void 0 : a.wrapper) || ""} ${r} ${l ? "opacity-32" : ""}`,
        ref: v,
        children: [
          t && /* @__PURE__ */ e.jsxs(
            "label",
            {
              className: `block text-sm font-medium text-neutral-950 ${(a == null ? void 0 : a.label) || ""}
            ${c ? "text-red-500" : "text-neutral-950"} ${l ? "text-neutral-400" : ""} `,
              children: [
                t,
                d && /* @__PURE__ */ e.jsx("span", { children: " *" }),
                s && /* @__PURE__ */ e.jsx(
                  "p",
                  {
                    className: `mt-2 text-sm font-normal text-neutral-800 ${l ? "text-neutral-300" : ""}`,
                    children: s
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
            /* @__PURE__ */ e.jsxs(
              "button",
              {
                type: "button",
                tabIndex: 0,
                className: `active-visible:z-10 border-1 active-visible:ring relative mt-2 flex h-[48px] w-full items-center justify-between rounded-[4px] border border-neutral-500 bg-white py-2 pl-3 focus:z-10 focus:border-neutral-950 focus:outline-neutral-900 focus:ring-offset-2 focus-visible:z-10 focus-visible:ring active:border-neutral-500 active:outline-neutral-900 active:ring-offset-2 ${(a == null ? void 0 : a.button) || ""} ${l ? "cursor-not-allowed border-neutral-300 bg-neutral-200" : "cursor-pointer"} ${p ? "z-10 border-2 border-neutral-950 outline-neutral-950 ring ring-offset-2" : ""}
            } ${c ? " border-1 border-red-500 " : ""}
               `,
                onClick: S,
                disabled: l,
                children: [
                  /* @__PURE__ */ e.jsx(
                    "div",
                    {
                      className: `flex items-center truncate ${l ? "text-neutral-400" : ""}
                `,
                      children: b ? b.label : o
                    }
                  ),
                  /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
                    so,
                    {
                      role: "button",
                      className: `pointer-events-none flex h-6 w-6 items-center pr-3 align-middle ${l ? "text-neutral-200" : "text-neutral-500"}`
                    }
                  ) })
                ]
              }
            ),
            p && /* @__PURE__ */ e.jsx(
              "div",
              {
                role: "listbox",
                "aria-activedescendant": b != null && b.value ? `option-${b.value}` : void 0,
                className: `absolute left-0 top-12 z-10 mt-1 max-h-60 w-full overflow-y-auto rounded-md border-2 border-neutral-950 bg-white ${(a == null ? void 0 : a.dropdown) || ""}`,
                children: n == null ? void 0 : n.map((C, E) => /* @__PURE__ */ e.jsx(
                  "div",
                  {
                    tabIndex: 0,
                    role: "option",
                    "aria-selected": (b == null ? void 0 : b.value) === C.value,
                    className: `cursor-pointer p-2 hover:bg-neutral-50 ${(a == null ? void 0 : a.option) || ""} ${(b == null ? void 0 : b.value) === C.value ? "bg-neutral-100" : ""}`,
                    onClick: () => y(C),
                    onKeyDown: (A) => z(A, C),
                    children: C.label
                  },
                  E
                ))
              }
            ),
            c && /* @__PURE__ */ e.jsx("p", { className: "mt-2 rounded-[4px] bg-red-50 p-2 font-normal text-red-600", children: c })
          ] })
        ]
      }
    );
  }
);
nt.displayName = "Select";
const $x = ({ oldPlate: t, newPlate: s }) => {
  const { t: n } = O("account");
  return /* @__PURE__ */ e.jsxs("div", { className: "mt-16", children: [
    /* @__PURE__ */ e.jsx("h1", { className: "mb-2 text-2xl font-medium", children: n("singleOrderBizzFlow.vehicleChangeSummary.title") }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-wrap items-center gap-4", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "rounded bg-red-50 p-8", children: [
        /* @__PURE__ */ e.jsx("p", { className: "text-sm", children: n("singleOrderBizzFlow.vehicleChangeSummary.oldPlateHeader") }),
        /* @__PURE__ */ e.jsx("p", { className: "text-sm font-bold", children: t })
      ] }),
      /* @__PURE__ */ e.jsx(Kl, { className: "h-8 w-8" }),
      /* @__PURE__ */ e.jsxs("div", { className: "rounded bg-green-50 p-8", children: [
        /* @__PURE__ */ e.jsx("p", { className: "text-sm", children: n("singleOrderBizzFlow.vehicleChangeSummary.newPlateHeader") }),
        /* @__PURE__ */ e.jsx("p", { className: "text-sm font-bold", children: s })
      ] })
    ] })
  ] });
}, Bx = ({
  customerInformation: t
}) => {
  const { t: s } = O(["common", "account"], {
    nsMode: "fallback"
  }), n = se(), { locale: r } = n, [a, o] = M(null), [i, d] = M(!0), { setVerifyContactDetailsDate: l } = Fr();
  B(() => {
    o({
      phone: t && "phone" in t ? t.phone : "",
      email: (t == null ? void 0 : t.email) || "",
      address: t && "address" in t ? t.address : "",
      zipCode: t && "zipCode" in t ? t.zipCode : "",
      city: t && "city" in t ? t.city : ""
    });
  }, [t]);
  const c = async (u) => {
    d(!1), u ? await l() : n.push(`/${r}/account/customerInformation?modal=edit`);
  }, m = a ? /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs("address", { className: "text-type-secondary not-italic leading-loose", children: [
    /* @__PURE__ */ e.jsxs("p", { children: [
      /* @__PURE__ */ e.jsxs("span", { className: "font-semibold", children: [
        s("form.labels.phone"),
        ": "
      ] }),
      a.phone
    ] }),
    /* @__PURE__ */ e.jsxs("p", { children: [
      /* @__PURE__ */ e.jsxs("span", { className: "font-semibold", children: [
        s("form.labels.email"),
        ": "
      ] }),
      a.email
    ] }),
    /* @__PURE__ */ e.jsxs("p", { children: [
      /* @__PURE__ */ e.jsxs("span", { className: "font-semibold", children: [
        s("form.labels.address"),
        ": "
      ] }),
      `${a.address} ${a.zipCode} ${a.city}`
    ] })
  ] }) }) : (
    // Skeleton loader
    /* @__PURE__ */ e.jsxs("div", { className: "text-type-secondary flex animate-pulse flex-col gap-[18px]", children: [
      /* @__PURE__ */ e.jsx("div", { className: "h-5 w-1/2 rounded bg-gray-200" }),
      /* @__PURE__ */ e.jsx("div", { className: "h-5 w-2/5 rounded bg-gray-200" }),
      /* @__PURE__ */ e.jsx("div", { className: "h-5 w-3/4 rounded bg-gray-200" })
    ] })
  );
  return /* @__PURE__ */ e.jsx(
    Br,
    {
      cancelText: s("confirmContactDetails.buttons.update"),
      confirmText: s("confirmContactDetails.buttons.confirm"),
      content: m,
      confirmColor: "primary",
      title: s("confirmContactDetails.title"),
      onAction: c,
      open: i,
      titleWrapperClassName: "px-6 pt-6"
    }
  );
}, Qg = () => {
  const { contactDetailsNeedsValidation: t } = Fr(), { customerInformation: s } = Oe({ suspense: !1 }), n = (s == null ? void 0 : s.customerType) === ds.privateCustomer;
  return t && n ? /* @__PURE__ */ e.jsx(Bx, { customerInformation: s }) : null;
}, Ix = ({ plate: t }) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs("span", { className: "rounded bg-red-300 px-2 py-1 font-semibold ", children: [
    t,
    " - ",
    s("priceAndProduct.fullPriceBadge.label")
  ] });
}, eo = ({
  content: t,
  children: s,
  position: n = "top"
}) => {
  const [r, a] = M(!1), o = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2"
  };
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "relative inline-block",
      onMouseEnter: () => a(!0),
      onMouseLeave: () => a(!1),
      children: [
        s,
        r && /* @__PURE__ */ e.jsx(
          "div",
          {
            className: `absolute z-50 whitespace-nowrap rounded bg-neutral-950 p-2  text-xs text-white shadow-lg ${o[n]}`,
            children: t
          }
        )
      ]
    }
  );
}, _x = ({ passages: t }) => {
  const { t: s } = O(["account", "common"], {
    nsMode: "fallback"
  }), n = D(() => [...t].sort((r, a) => r.chargedFullPrice === a.chargedFullPrice ? 0 : r.chargedFullPrice ? 1 : -1), [t]);
  return /* @__PURE__ */ e.jsxs("div", { className: "inline-block rounded-xl bg-neutral-50 px-3 py-3 text-sm sm:pb-3 sm:pt-6", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "font-semibold", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex justify-between gap-12 pb-3", children: [
        /* @__PURE__ */ e.jsx("span", { children: s("priceAndProduct.vehicleCounter.table.heading.plate") }),
        /* @__PURE__ */ e.jsx("span", { children: s("priceAndProduct.vehicleCounter.table.heading.identifiedBy") })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "border-b-2 border-neutral-200" })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "", children: n.map((r) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "flex justify-between gap-6 border-b-2 border-neutral-200 py-3 last:border-none",
        children: [
          /* @__PURE__ */ e.jsx("div", { className: "whitespace-nowrap text-right font-semibold", children: r.chargedFullPrice ? /* @__PURE__ */ e.jsx(Ix, { plate: r.licensePlate }) : r.identifiedBy === "licensePlate" && r.reference ? /* @__PURE__ */ e.jsx(eo, { position: "right", content: r.reference, children: /* @__PURE__ */ e.jsx("span", { className: "cursor-pointer underline decoration-dotted underline-offset-2", children: r.licensePlate }) }) : /* @__PURE__ */ e.jsx(e.Fragment, { children: r.licensePlate }) }),
          /* @__PURE__ */ e.jsx("div", { className: "whitespace-nowrap text-left", children: r.identifiedBy === "bizz" ? /* @__PURE__ */ e.jsx(
            eo,
            {
              position: "left",
              content: r.reference ? `${r.serialNo} (${r.reference})` : r.serialNo,
              children: /* @__PURE__ */ e.jsx("span", { className: "cursor-pointer underline decoration-dotted underline-offset-2", children: s(
                `priceAndProduct.vehicleCounter.table.identifier.${r.identifiedBy}`
              ) })
            }
          ) : s(
            `priceAndProduct.vehicleCounter.table.identifier.${r.identifiedBy}`
          ) })
        ]
      },
      r.licensePlate
    )) })
  ] });
}, Wx = (t, s) => t.map((n) => ({
  contractNo: s,
  id: n.id,
  customerNo: n.customerNo,
  licensePlate: qx(n.licensePlate),
  identifiedBy: Hx(n.identifiedBy),
  chargedFullPrice: n.chargedFullPrice,
  serialNo: n.serialNo,
  reference: n.reference
})), qx = (t) => t.replace(/^[A-Z]{2}-/, ""), Hx = (t) => {
  const s = t == null ? void 0 : t.toLowerCase();
  return s === "license plate" ? "licensePlate" : s === "bizz" ? "bizz" : "unknown";
}, Ux = () => {
  const { t } = O(["account", "common"], {
    nsMode: "fallback"
  }), s = as(), { data: n, isLoading: r } = Kc(s), { data: a } = Ke(), o = Wx(
    (n == null ? void 0 : n.usedPassageLicensePlates) || [],
    s
  ), i = o.length, d = 4, l = 5, c = (a == null ? void 0 : a.paymentAgreement.agreementType) ?? "", m = t("singleOrderBizzFlow.order.summary.Obus.info.and"), u = D(
    () => o.filter((p) => p.chargedFullPrice).map((p) => p.licensePlate).filter(Boolean),
    [o]
  ), h = D(() => ((f) => {
    switch (f.length) {
      case 0:
        return "";
      case 1:
        return f[0];
      case 2:
        return `${f[0]} ${m} ${f[1]}`;
      default:
        return `${f.slice(0, -1).join(", ")} ${m} ${f[f.length - 1]}`;
    }
  })(u), [u, m]);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-medium", children: t("priceAndProduct.discountStatus.heading") }),
    i === d && /* @__PURE__ */ e.jsx(
      ze,
      {
        dismiss: !0,
        id: "discount-limit-warning",
        title: /* @__PURE__ */ e.jsx(
          G,
          {
            i18nKey: "priceAndProduct.userFeedback.information.amountOfVehicles.title",
            components: [/* @__PURE__ */ e.jsx("br", {})],
            ns: "account"
          }
        ),
        colorMode: "information",
        children: /* @__PURE__ */ e.jsx(
          G,
          {
            i18nKey: "priceAndProduct.userFeedback.information.amountOfVehicles.description",
            values: { amount: i, maxAmount: l },
            components: [/* @__PURE__ */ e.jsx("span", { className: "font-bold" })],
            ns: "account"
          }
        )
      }
    ),
    i === l && /* @__PURE__ */ e.jsx(
      ze,
      {
        dismiss: !0,
        id: "discount-limit-reached",
        title: /* @__PURE__ */ e.jsx(
          G,
          {
            i18nKey: "priceAndProduct.userFeedback.information.amountOfVehicles.title",
            components: [/* @__PURE__ */ e.jsx("br", {})],
            ns: "account"
          }
        ),
        colorMode: "information",
        children: /* @__PURE__ */ e.jsx(
          G,
          {
            i18nKey: "priceAndProduct.userFeedback.information.amountOfVehicles.description",
            values: { amount: i, maxAmount: l },
            components: [/* @__PURE__ */ e.jsx("span", { className: "font-bold" })],
            ns: "account"
          }
        )
      }
    ),
    i > l && /* @__PURE__ */ e.jsx(
      ze,
      {
        dismiss: !0,
        id: "discount-limit-exceeded",
        title: /* @__PURE__ */ e.jsx(
          G,
          {
            i18nKey: "priceAndProduct.userFeedback.error.limitExceeded.title",
            components: [/* @__PURE__ */ e.jsx("br", {})],
            ns: "account"
          }
        ),
        colorMode: "error",
        children: /* @__PURE__ */ e.jsx(
          G,
          {
            i18nKey: "priceAndProduct.userFeedback.error.limitExceeded.description",
            values: { plate: h },
            components: [/* @__PURE__ */ e.jsx("span", { className: "font-bold" })],
            ns: "account"
          }
        )
      }
    ),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `mt-2 grid gap-6 rounded-xl border-2 border-neutral-200 p-6 md:mt-4 ${i > 0 ? "grid-cols-1 sm:grid-cols-[auto_auto]" : "grid-cols-1"}`,
        children: [
          /* @__PURE__ */ e.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ e.jsxs("div", { children: [
            /* @__PURE__ */ e.jsx("h2", { className: "pb-1 text-xl font-semibold", children: t("priceAndProduct.discountStatus.title") }),
            /* @__PURE__ */ e.jsx("p", { className: "text-type-secondary max-w-prose text-base", children: /* @__PURE__ */ e.jsx(
              G,
              {
                i18nKey: "priceAndProduct.discountStatus.description",
                values: {
                  amount: Math.min(i, l),
                  maxAmount: l,
                  agreementType: c
                },
                components: [/* @__PURE__ */ e.jsx("span", { className: "font-semibold" })],
                ns: "account"
              }
            ) })
          ] }) }),
          r ? /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsx(As, {}) }) : i > 0 ? /* @__PURE__ */ e.jsx(_x, { passages: o }) : null
        ]
      }
    )
  ] });
}, Xg = ({
  open: t,
  onClose: s
}) => {
  const { t: n } = O(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx(
    Br,
    {
      open: t,
      onOpenChange: s,
      titleWrapperClassName: "bg-blue-950 px-6 py-4",
      title: /* @__PURE__ */ e.jsx("p", { className: "text-lg font-semibold text-white", children: n("priceAndProduct.modal.title") }),
      cancelText: "",
      confirmText: n("priceAndProduct.modal.buttonText"),
      confirmColor: "primary",
      onAction: () => s(),
      content: /* @__PURE__ */ e.jsxs("div", { className: "space-y-4 ", children: [
        /* @__PURE__ */ e.jsx("p", { className: "text-3xl font-normal", children: n("priceAndProduct.modal.heading") }),
        /* @__PURE__ */ e.jsx("p", { className: "text-type-secondary", children: n("priceAndProduct.modal.subHeading") }),
        /* @__PURE__ */ e.jsxs("ol", { className: "list-inside list-decimal space-y-1", children: [
          /* @__PURE__ */ e.jsx("li", { children: n("priceAndProduct.modal.list.item1") }),
          /* @__PURE__ */ e.jsx("li", { children: n("priceAndProduct.modal.list.item2") })
        ] })
      ] })
    }
  );
}, Jg = ({
  namespace: t,
  className: s,
  queryNamespace: n
}) => {
  const { t: r } = O([t, "account", "common"], {
    nsMode: "fallback"
  }), { query: a, locale: o } = se(), { data: i } = Ke(), d = pt(), { baseURL: l, app: c } = Ye(), m = t === "recognitions", u = (i == null ? void 0 : i.paymentAgreement.agreementType) === "OresundGO", h = {
    sv: "https://www.oresundsbron.com/sv/kundservice/faq/oresundgo/hur-fungerar-oresundgo",
    en: "https://www.oresundsbron.com/en/customerservice/faq/oresundgo/how-does-oresundgo-work",
    da: "https://www.oresundsbron.com/da/kundeservice/faq/oresundgo/hvordan-fungerer-oresundgo"
  }, x = c === ot.OresundPay ? h[o] ?? h["en"] : kn(o, "howOresundGoWorks", l), g = D(
    () => r(`${t}.layout.preTitle`) !== `${t}.layout.preTitle`,
    [t, r]
  ), N = D(
    () => r(`${t}.layout.title`) !== `${t}.layout.title`,
    [t, r]
  ), b = D(
    () => r(`${t}.layout.description`) !== `${t}.layout.description`,
    [t, r]
  ), v = !!(d != null && d.get("price-and-product")), S = b && !(m && u && v), y = m && u && v;
  return /* @__PURE__ */ e.jsxs($, { className: He(["pb-12 pt-9", s]), children: [
    /* @__PURE__ */ e.jsx(
      k,
      {
        intent: "title",
        as: "p",
        size: "sm",
        className: g ? "uppercase text-neutral-500" : "hidden",
        children: r(`${t}.layout.preTitle`)
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex items-start justify-between", children: [
      /* @__PURE__ */ e.jsxs("h2", { className: "mb-4 text-xl font-semibold leading-tight text-blue-950 sm:text-4xl", children: [
        N ? r(`${t}.layout.title`) : "",
        n ? a[t] : ""
      ] }),
      y && /* @__PURE__ */ e.jsx("a", { href: x, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ e.jsx(Rx, { intent: "outline", size: "default", endIcon: /* @__PURE__ */ e.jsx(Zl, {}), children: r("priceAndProduct.modal.openModalButtonText") }) })
    ] }),
    S && /* @__PURE__ */ e.jsx(k, { intent: "body", className: "text-neutral-600", children: r(`${t}.layout.description`) })
  ] });
};
export {
  Hr as AgreementCardTitle,
  fr as AgreementDetails,
  Cd as AgreementFilter,
  qn as AgreementSelector,
  lu as AgreementView,
  zg as Agreements,
  wg as AppCommonProvider,
  vo as BannerContext,
  Ng as BannerVisibilityProvider,
  sl as BizzList,
  qg as BizzOrder,
  Wg as BizzOrderLanding,
  Lg as BusinessCommuters,
  el as BusinessContactInformationCommonFields,
  Gg as BusinessSignUp,
  Rx as Button,
  ns as Checkbox,
  Wi as CodeVerification,
  l3 as CodeVerificationResponseBanner,
  j1 as CommuterList,
  Wa as ConnectAuthentication,
  Ze as ContractName,
  Dg as CorporateGroupSideMenu,
  Hg as CustomerInformation,
  Fg as DebitCard,
  Kg as DemoButton,
  Zg as DemoWelcome,
  Ux as DiscountStatus,
  Xg as DiscountStatusModal,
  T2 as EditForm,
  Kr as FiltersComponent,
  qe as InputField,
  Eg as Invoices,
  sa as LoadingScreen,
  As as LoadingSpinner,
  ht as Modal,
  Rr as MultiSelect,
  um as MultiStepModal,
  ot as NextApp,
  Vn as NextRouterContext,
  Yg as NoRecognitionInfo,
  C2 as OrderForm,
  Jg as PageMetadata,
  Ui as PrivateContactInformationFields,
  Ug as PrivateSignUp,
  k2 as ProgressBar,
  Ig as RecognitionLanding,
  rl as RecognitionListContextProvider,
  al as SearchInput,
  nt as Select,
  Hi as SetPassword,
  ii as Toast,
  _g as TollCollect,
  Fi as TollCollectComponent,
  eo as ToolTip,
  G as Trans,
  zr as TranslationContext,
  Og as TripsView,
  ze as UserFeedback,
  $x as VehicleChangeSummary,
  Xt as VerificationCodeResponseStatus,
  Qg as VerifyContactDetails,
  Pa as acceptReplaceBizz,
  a3 as businessPhoneCode,
  o3 as businessPrivatePhoneCode,
  jo as byCountryLocale,
  yo as byPromotedCountries,
  Co as byString,
  Ta as choiceReplaceBizz,
  lr as clickReplaceBizz,
  Sm as confirmReplaceBizz,
  Ag as convertContractToContractListItem,
  Nm as createAvailableSBF,
  Rg as createText,
  fu as filterCommuters,
  gu as filterPaymentType,
  xu as filterProviders,
  bu as formatAgreementOption,
  Js as formatPrice,
  kn as getBridgeLinks,
  Ur as getContractTranslationKey,
  hr as getDateOrToday,
  ms as getDefaultCountry,
  ss as getDefaultCurrency,
  vu as getFilteredAgreementOptions,
  Jt as getLink,
  E1 as getLocale,
  Cm as getPeriodCardStatus,
  Bg as getRedirectPath,
  sm as getRequiredFields,
  $g as isBvSupportCountry,
  _i as isEntryEmpty,
  jm as isInvoicePaymentType,
  Vg as isServer,
  qd as links,
  kg as pageView,
  Gt as pick,
  i3 as privatePhoneCode,
  _r as purchase,
  mi as removeQueryParam,
  Ko as renderBanner,
  Wr as resetPurchase,
  hn as sanitizeLicenseplate,
  Tg as sendContactForm,
  Sg as sendCorporateForm,
  Mg as sendOpenClubVoucherModal,
  zs as signUpStoreActions,
  Tm as subscribeToNewsLetterOnPurchase,
  Bn as toCurrency,
  rd as toDateTime,
  ad as toSafeTime,
  Wt as translationMap,
  Xr as useActiveRecognitions,
  Ke as useAgreementGroup,
  Or as useAgreementGroupList,
  Ye as useAppCommon,
  Er as useBannerVisibility,
  as as useContractNo,
  Hu as useCorporateGroup,
  kt as useCountries,
  Dr as useCountriesBvSupport,
  wo as useCountriesOptGroups,
  bo as useCountryName,
  Oe as useCustomerInformation,
  wt as useEmissionClasses,
  Gc as useInvoiceStatuses,
  Zc as useLogout,
  Rn as usePaymentAgreementList,
  dn as usePeriodCard,
  Ar as usePeriodCardByContract,
  Kc as useRecognitionHistory,
  Dx as useRecognitionListContext,
  se as useRouter,
  yt as useSignUpStore,
  O as useTranslation,
  ks as useValidateAlpr,
  $n as useVehicleInformation,
  Fr as useVerifyContactDetailsDate,
  Po as useWindowSize,
  Ts as validate,
  pn as validateLicenseplateFormat,
  $t as validateT,
  Gn as veColorList,
  Pg as webMetric
};
